import { openBlock as u, createElementBlock as c, withModifiers as ve, renderSlot as j, normalizeClass as G, createCommentVNode as b, createElementVNode as p, toDisplayString as E, resolveComponent as K, createBlock as k, withCtx as w, createVNode as O, defineComponent as Se, Fragment as ie, renderList as se, createTextVNode as N, withDirectives as tt, vModelCheckbox as ea, reactive as Au, vShow as Bi, resolveDynamicComponent as Pt, createSlots as gu, normalizeProps as Zo, mergeProps as Jn, vModelRadio as yu, nextTick as Ti, h as ta, vModelText as er, resolveDirective as zn, ref as fe, computed as xe, defineAsyncComponent as na, isRef as Ii, unref as re, toRaw as To, normalizeStyle as xi, guardReactiveProps as ia, useModel as Ku, mergeModels as bu, toRefs as Wn, onMounted as oa, Teleport as vu, getCurrentScope as wu, onScopeDispose as Cu, toRef as Ru, readonly as Fu, customRef as ku, watch as Xt, createStaticVNode as Uu, onBeforeMount as Eu, onBeforeUnmount as Su } from "vue";
import { RouterLink as Tu } from "vue-router";
function ra(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: Iu } = Object.prototype, { getPrototypeOf: qt } = Object, { iterator: Yn, toStringTag: sa } = Symbol, Vn = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), aa = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), la = (e, n, t) => e === Object.prototype || !t && n === null, Du = (e) => {
  if (!Object.isExtensible(e))
    return !1;
  const n = Object.getOwnPropertyNames(e);
  return Object.getOwnPropertySymbols && n.push(...Object.getOwnPropertySymbols(e)), n.every((t) => {
    if (aa(t))
      return !1;
    const i = Object.getOwnPropertyDescriptor(e, t);
    return !!i && i.configurable && i.writable === !0;
  });
}, jn = (e, n) => {
  let t = e;
  const i = [];
  for (; t != null; ) {
    if (i.indexOf(t) !== -1)
      return !1;
    i.push(t);
    const o = qt(t);
    if (la(t, o, t === e))
      return !1;
    if (Vn(t, n))
      return !0;
    t = o;
  }
  return !1;
}, Ou = (e, n) => e != null && jn(e, n) ? e[n] : void 0, _u = (e) => {
  if (e == null || typeof e != "object" && typeof e != "function")
    return e;
  const n = qt(e);
  if (n === null && Du(e))
    return e;
  const t = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), o = [];
  let r = e;
  for (; r != null && o.indexOf(r) === -1; ) {
    o.push(r);
    const s = r === e ? n : qt(r);
    if (la(r, s, r === e))
      break;
    const a = Object.getOwnPropertyNames(r);
    Object.getOwnPropertySymbols && a.push(...Object.getOwnPropertySymbols(r));
    for (const l of a)
      aa(l) || Vn(i, l) || (t[l] = e[l], i[l] = !0);
    r = s;
  }
  return t;
}, tr = /* @__PURE__ */ ((e) => (n) => {
  const t = Iu.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ct = (e) => (e = e.toLowerCase(), (n) => tr(n) === e), qi = (e) => (n) => typeof n === e, { isArray: Zt } = Array, en = qi("undefined");
function wn(e) {
  return e !== null && !en(e) && e.constructor !== null && !en(e.constructor) && st(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ua = Ct("ArrayBuffer");
function Pu(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && ua(e.buffer), n;
}
const Mu = qi("string"), st = qi("function"), da = qi("number"), Cn = (e) => e !== null && typeof e == "object", Lu = (e) => e === !0 || e === !1, yi = (e) => {
  if (!Cn(e))
    return !1;
  const n = qt(e);
  return (n === null || n === Object.prototype || qt(n) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
  // evidence the value is tagged/iterable, while ignoring members reachable
  // only through shared or terminal prototype boundaries.
  !jn(e, sa) && !jn(e, Yn);
}, Nu = (e) => {
  if (!Cn(e) || wn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Bu = Ct("Date"), xu = Ct("File"), qu = (e) => !!(e && typeof e.uri < "u"), Vu = (e) => e && typeof e.getParts < "u", ju = Ct("Blob"), Hu = Ct("FileList"), Gu = Ct("Set"), Qu = (e) => Cn(e) && st(e.pipe);
function $u() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const jr = $u(), Hr = typeof jr.FormData < "u" ? jr.FormData : void 0, Ju = (e) => {
  if (!e) return !1;
  if (Hr && e instanceof Hr) return !0;
  const n = qt(e);
  if (!n || n === Object.prototype || !st(e.append)) return !1;
  const t = tr(e);
  return t === "formdata" || // detect form-data instance
  t === "object" && st(e.toString) && e.toString() === "[object FormData]";
}, zu = Ct("URLSearchParams"), [Wu, Yu, Xu, Zu] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Ct), ed = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Xn(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, o;
  if (typeof e != "object" && (e = [e]), Zt(e))
    for (i = 0, o = e.length; i < o; i++)
      n.call(null, e[i], i, e);
  else {
    if (wn(e))
      return;
    const r = t ? Object.getOwnPropertyNames(e) : Object.keys(e), s = r.length;
    let a;
    for (i = 0; i < s; i++)
      a = r[i], n.call(null, e[a], a, e);
  }
}
function ca(e, n) {
  if (wn(e))
    return null;
  n = n.toLowerCase();
  const t = Object.keys(e);
  let i = t.length, o;
  for (; i-- > 0; )
    if (o = t[i], n === o.toLowerCase())
      return o;
  return null;
}
const Jt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, fa = (e) => !en(e) && e !== Jt;
function Io(...e) {
  const { caseless: n, skipUndefined: t } = fa(this) && this || {}, i = {}, o = (r, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const a = n && typeof s == "string" && ca(i, s) || s, l = Vn(i, a) ? i[a] : void 0;
    yi(l) && yi(r) ? i[a] = Io(l, r) : yi(r) ? i[a] = Io({}, r) : Zt(r) ? i[a] = r.slice() : (!t || !en(r)) && (i[a] = r);
  };
  for (let r = 0, s = e.length; r < s; r++) {
    const a = e[r];
    if (!a || wn(a) || (Xn(a, o), typeof a != "object" || Zt(a)))
      continue;
    const l = Object.getOwnPropertySymbols(a);
    for (let d = 0; d < l.length; d++) {
      const f = l[d];
      fd.call(a, f) && o(a[f], f);
    }
  }
  return i;
}
const td = (e, n, t, { allOwnKeys: i } = {}) => (Xn(
  n,
  (o, r) => {
    t && st(o) ? Object.defineProperty(e, r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: ra(o, t),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, r, {
      __proto__: null,
      value: o,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), nd = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), id = (e, n, t, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, od = (e, n, t, i) => {
  let o, r, s;
  const a = {};
  if (n = n || {}, e == null) return n;
  do {
    for (o = Object.getOwnPropertyNames(e), r = o.length; r-- > 0; )
      s = o[r], (!i || i(s, e, n)) && !a[s] && (n[s] = e[s], a[s] = !0);
    e = t !== !1 && qt(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, rd = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const i = e.indexOf(n, t);
  return i !== -1 && i === t;
}, sd = (e) => {
  if (!e) return null;
  if (Zt(e)) return e;
  let n = e.length;
  if (!da(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, ad = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && qt(Uint8Array)), ld = (e, n) => {
  const i = (e && e[Yn]).call(e);
  let o;
  for (; (o = i.next()) && !o.done; ) {
    const r = o.value;
    n.call(e, r[0], r[1]);
  }
}, ud = (e, n) => {
  let t;
  const i = [];
  for (; (t = e.exec(n)) !== null; )
    i.push(t);
  return i;
}, dd = Ct("HTMLFormElement"), cd = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, i, o) {
  return i.toUpperCase() + o;
}), { propertyIsEnumerable: fd } = Object.prototype, pd = Ct("RegExp"), pa = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), i = {};
  Xn(t, (o, r) => {
    let s;
    (s = n(o, r, e)) !== !1 && (i[r] = s || o);
  }), Object.defineProperties(e, i);
}, hd = (e) => {
  pa(e, (n, t) => {
    if (st(e) && ["arguments", "caller", "callee"].includes(t))
      return !1;
    const i = e[t];
    if (st(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, md = (e, n) => {
  const t = {}, i = (o) => {
    o.forEach((r) => {
      t[r] = !0;
    });
  };
  return Zt(e) ? i(e) : i(String(e).split(n)), t;
}, Ad = () => {
}, gd = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function yd(e) {
  return !!(e && st(e.append) && e[sa] === "FormData" && e[Yn]);
}
const Kd = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), t = (i) => {
    if (Cn(i)) {
      if (n.has(i))
        return;
      if (wn(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        let o;
        if (Gu(i)) {
          o = [];
          for (const r of i) {
            const s = t(r);
            !en(s) && o.push(s);
          }
        } else
          o = Zt(i) ? [] : {}, Xn(i, (r, s) => {
            const a = t(r);
            !en(a) && (o[s] = a);
          });
        return n.delete(i), o;
      }
    }
    return i;
  };
  return t(e);
}, bd = Ct("AsyncFunction"), vd = (e) => e && (Cn(e) || st(e)) && st(e.then) && st(e.catch), ha = ((e, n) => e ? setImmediate : n ? ((t, i) => (Jt.addEventListener(
  "message",
  ({ source: o, data: r }) => {
    o === Jt && r === t && i.length && i.shift()();
  },
  !1
), (o) => {
  i.push(o), Jt.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(typeof setImmediate == "function", st(Jt.postMessage)), wd = typeof queueMicrotask < "u" ? queueMicrotask.bind(Jt) : typeof process < "u" && process.nextTick || ha, ma = (e) => e != null && st(e[Yn]), Cd = (e) => e != null && jn(e, Yn) && ma(e), C = {
  isArray: Zt,
  isArrayBuffer: ua,
  isBuffer: wn,
  isFormData: Ju,
  isArrayBufferView: Pu,
  isString: Mu,
  isNumber: da,
  isBoolean: Lu,
  isObject: Cn,
  isPlainObject: yi,
  isEmptyObject: Nu,
  isReadableStream: Wu,
  isRequest: Yu,
  isResponse: Xu,
  isHeaders: Zu,
  isUndefined: en,
  isDate: Bu,
  isFile: xu,
  isReactNativeBlob: qu,
  isReactNative: Vu,
  isBlob: ju,
  isRegExp: pd,
  isFunction: st,
  isStream: Qu,
  isURLSearchParams: zu,
  isTypedArray: ad,
  isFileList: Hu,
  forEach: Xn,
  merge: Io,
  extend: td,
  trim: ed,
  stripBOM: nd,
  inherits: id,
  toFlatObject: od,
  kindOf: tr,
  kindOfTest: Ct,
  endsWith: rd,
  toArray: sd,
  forEachEntry: ld,
  matchAll: ud,
  isHTMLForm: dd,
  hasOwnProperty: Vn,
  hasOwnProp: Vn,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: jn,
  getSafeProp: Ou,
  toSafeFlatObject: _u,
  reduceDescriptors: pa,
  freezeMethods: hd,
  toObjectSet: md,
  toCamelCase: cd,
  noop: Ad,
  toFiniteNumber: gd,
  findKey: ca,
  global: Jt,
  isContextDefined: fa,
  isSpecCompliantForm: yd,
  toJSONObject: Kd,
  isAsyncFn: bd,
  isThenable: vd,
  setImmediate: ha,
  asap: wd,
  isIterable: ma,
  isSafeIterable: Cd
}, Rd = C.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Fd = (e) => {
  const n = {};
  let t, i, o;
  return e && e.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), t = s.substring(0, o).trim().toLowerCase(), i = s.substring(o + 1).trim();
    const a = C.hasOwnProp(n, t);
    !t || a && C.hasOwnProp(Rd, t) || (t === "set-cookie" ? a ? n[t].push(i) : n[t] = [i] : n[t] = a ? n[t] + ", " + i : i);
  }), n;
};
function kd(e) {
  let n = 0, t = e.length;
  for (; n < t; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; t > n; ) {
    const i = e.charCodeAt(t - 1);
    if (i !== 9 && i !== 32)
      break;
    t -= 1;
  }
  return n === 0 && t === e.length ? e : e.slice(n, t);
}
const Ud = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Ed = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function nr(e, n) {
  return C.isArray(e) ? e.map((t) => nr(t, n)) : kd(String(e).replace(n, ""));
}
const Sd = (e) => nr(e, Ud), Td = (e) => nr(e, Ed);
function Aa(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return C.forEach(e.toJSON(), (t, i) => {
    n[i] = Td(t);
  }), n;
}
const Gr = /* @__PURE__ */ Symbol("internals");
function En(e) {
  return e && String(e).trim().toLowerCase();
}
function Ki(e) {
  return e === !1 || e == null ? e : C.isArray(e) ? e.map(Ki) : Sd(String(e));
}
function Id(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = t.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const Dd = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function io(e) {
  let n = 0, t = e.length;
  for (; n < t; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; t > n; ) {
    const i = e.charCodeAt(t - 1);
    if (i !== 9 && i !== 32)
      break;
    t -= 1;
  }
  return n === 0 && t === e.length ? e : e.slice(n, t);
}
function Od(e) {
  const n = e.length - 1;
  if (n < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(n) !== 34)
    return e;
  let t = "";
  for (let i = 1; i < n; i++) {
    const o = e.charCodeAt(i);
    if (o === 34 || o === 92 && (i += 1, i >= n))
      return e;
    t += e[i];
  }
  return t;
}
function _d(e) {
  const n = /* @__PURE__ */ Object.create(null), t = String(e);
  let i = 0, o = !1, r = !1;
  function s(a) {
    const l = io(t.slice(i, a)), d = l.indexOf("=");
    if (d < 1)
      return;
    const f = io(l.slice(0, d));
    if (!Dd.test(f))
      return;
    const g = f.toLowerCase();
    if (g === "__proto__" || g === "constructor" || g === "prototype")
      return;
    const A = io(l.slice(d + 1));
    n[g] = Od(A);
  }
  for (let a = 0; a < t.length; a++) {
    const l = t.charCodeAt(a);
    o ? r ? r = !1 : l === 92 ? r = !0 : l === 34 && (o = !1) : l === 34 ? o = !0 : (l === 44 || l === 59) && (s(a), i = a + 1);
  }
  return s(t.length), n;
}
const Pd = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function oo(e, n, t, i, o) {
  if (C.isFunction(i))
    return i.call(this, n, t);
  if (o && (n = t), !!C.isString(n)) {
    if (C.isString(i))
      return n.indexOf(i) !== -1;
    if (C.isRegExp(i))
      return i.test(n);
  }
}
function Md(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, i) => t.toUpperCase() + i);
}
function Ld(e, n) {
  const t = C.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + t, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(o, r, s) {
        return this[i].call(this, n, o, r, s);
      },
      configurable: !0
    });
  });
}
let ze = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, i) {
    const o = this;
    function r(a, l, d) {
      const f = En(l);
      if (!f)
        return;
      const g = C.findKey(o, f);
      (!g || o[g] === void 0 || d === !0 || d === void 0 && o[g] !== !1) && (o[g || l] = Ki(a));
    }
    const s = (a, l) => C.forEach(a, (d, f) => r(d, f, l));
    if (C.isPlainObject(n) || n instanceof this.constructor)
      s(n, t);
    else if (C.isString(n) && (n = n.trim()) && !Pd(n))
      s(Fd(n), t);
    else if (C.isObject(n) && C.isSafeIterable(n)) {
      let a = /* @__PURE__ */ Object.create(null), l, d;
      for (const f of n) {
        if (!C.isArray(f))
          throw new TypeError("Object iterator must return a key-value pair");
        d = f[0], C.hasOwnProp(a, d) ? (l = a[d], a[d] = C.isArray(l) ? [...l, f[1]] : [l, f[1]]) : a[d] = f[1];
      }
      s(a, t);
    } else
      n != null && r(t, n, i);
    return this;
  }
  get(n, t) {
    if (n = En(n), n) {
      const i = C.findKey(this, n);
      if (i) {
        const o = this[i];
        if (!t)
          return o;
        if (t === !0)
          return Id(o);
        if (C.isFunction(t))
          return t.call(this, o, i);
        if (C.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = En(n), n) {
      const i = C.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!t || oo(this, this[i], i, t)));
    }
    return !1;
  }
  delete(n, t) {
    const i = this;
    let o = !1;
    function r(s) {
      if (s = En(s), s) {
        const a = C.findKey(i, s);
        a && (!t || oo(i, i[a], a, t)) && (delete i[a], o = !0);
      }
    }
    return C.isArray(n) ? n.forEach(r) : r(n), o;
  }
  clear(n) {
    const t = Object.keys(this);
    let i = t.length, o = !1;
    for (; i--; ) {
      const r = t[i];
      (!n || oo(this, this[r], r, n, !0)) && (delete this[r], o = !0);
    }
    return o;
  }
  normalize(n) {
    const t = this, i = {};
    return C.forEach(this, (o, r) => {
      const s = C.findKey(i, r);
      if (s) {
        t[s] = Ki(o), delete t[r];
        return;
      }
      const a = n ? Md(r) : String(r).trim();
      a !== r && delete t[r], t[a] = Ki(o), i[a] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return C.forEach(this, (i, o) => {
      i != null && i !== !1 && (t[o] = n && C.isArray(i) ? i.join(", ") : i);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  getSetCookie() {
    const n = this.get("set-cookie");
    return C.isArray(n) ? n : n == null || n === !1 ? [] : [n];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static parseParameters(n) {
    return _d(n);
  }
  static concat(n, ...t) {
    const i = new this(n);
    return t.forEach((o) => i.set(o)), i;
  }
  static accessor(n) {
    const i = (this[Gr] = this[Gr] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function r(s) {
      const a = En(s);
      i[a] || (Ld(o, s), i[a] = !0);
    }
    return C.isArray(n) ? n.forEach(r) : r(n), this;
  }
};
ze.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
C.reduceDescriptors(ze.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[t] = i;
    }
  };
});
C.freezeMethods(ze);
const Di = "[REDACTED ****]";
function Nd(e) {
  if (C.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (C.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function Bd(e, n) {
  const t = new Set(n.map((r) => String(r).toLowerCase())), i = [], o = (r) => {
    if (r === null || typeof r != "object" || C.isBuffer(r)) return r;
    if (i.indexOf(r) !== -1) return;
    r instanceof ze && (r = r.toJSON()), i.push(r);
    let s;
    if (C.isArray(r))
      s = [], r.forEach((a, l) => {
        const d = o(a);
        C.isUndefined(d) || (s[l] = d);
      });
    else {
      if (!C.isPlainObject(r) && Nd(r))
        return i.pop(), r;
      s = /* @__PURE__ */ Object.create(null);
      for (const [a, l] of Object.entries(r)) {
        const d = t.has(a.toLowerCase()) ? Di : o(l);
        C.isUndefined(d) || (s[a] = d);
      }
    }
    return i.pop(), s;
  };
  return o(e);
}
function Qr(e) {
  try {
    return String(e);
  } catch {
    return "";
  }
}
function xd(e) {
  return e.errors.map((t) => {
    try {
      return t && t.message ? Qr(t.message) : Qr(t);
    } catch {
      return "";
    }
  }).filter(Boolean).join("; ") || e.name || "AggregateError";
}
let J = class ga extends Error {
  static from(n, t, i, o, r, s) {
    let a = n.message;
    !a && C.isArray(n.errors) && n.errors.length && (a = xd(n));
    const l = new ga(a, t || n.code, i, o, r);
    return Object.defineProperty(l, "cause", {
      __proto__: null,
      value: n,
      writable: !0,
      enumerable: !1,
      configurable: !0
    }), l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, t, i, o, r) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), i && (this.config = i), o && (this.request = o), r && (this.response = r, this.status = r.status);
  }
  toJSON() {
    const n = this.config, t = n && C.hasOwnProp(n, "redact") ? n.redact : void 0, i = C.isArray(t) && t.length > 0 ? Bd(n, t) : C.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
J.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
J.ERR_BAD_OPTION = "ERR_BAD_OPTION";
J.ECONNABORTED = "ECONNABORTED";
J.ETIMEDOUT = "ETIMEDOUT";
J.ECONNREFUSED = "ECONNREFUSED";
J.ERR_NETWORK = "ERR_NETWORK";
J.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
J.ERR_DEPRECATED = "ERR_DEPRECATED";
J.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
J.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
J.ERR_CANCELED = "ERR_CANCELED";
J.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
J.ERR_INVALID_URL = "ERR_INVALID_URL";
J.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const qd = null, ya = 100;
function Do(e) {
  return C.isPlainObject(e) || C.isArray(e);
}
function Ka(e) {
  return C.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ro(e, n, t) {
  return e ? e.concat(n).map(function(o, r) {
    return o = Ka(o), !t && r ? "[" + o + "]" : o;
  }).join(t ? "." : "") : n;
}
function Vd(e) {
  return C.isArray(e) && !e.some(Do);
}
const jd = C.toFlatObject(C, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Vi(e, n, t) {
  if (!C.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData();
  const i = (I, M) => {
    const D = C.getSafeProp(t, I);
    return C.isUndefined(D) ? M : D;
  }, o = i("metaTokens", !0), r = i("visitor") || y, s = i("dots", !1), a = i("indexes", !1), l = i("Blob") || typeof Blob < "u" && Blob, d = i("maxDepth", ya), f = l && C.isSpecCompliantForm(n), g = [];
  if (!C.isFunction(r))
    throw new TypeError("visitor must be a function");
  function A(I) {
    if (I === null) return "";
    if (C.isDate(I))
      return I.toISOString();
    if (C.isBoolean(I))
      return I.toString();
    if (!f && C.isBlob(I))
      throw new J("Blob is not supported. Use a Buffer instead.");
    if (C.isArrayBuffer(I) || C.isTypedArray(I)) {
      if (f && typeof l == "function")
        return new l([I]);
      throw new J(
        "Blob is not supported. Use a Buffer instead.",
        J.ERR_NOT_SUPPORT
      );
    }
    return I;
  }
  function R(I) {
    if (I > d)
      throw new J(
        "Object is too deeply nested (" + I + " levels). Max depth: " + d,
        J.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function F(I, M) {
    if (d === 1 / 0)
      return JSON.stringify(I);
    const D = [];
    return JSON.stringify(I, function(q, x) {
      if (!C.isObject(x))
        return x;
      for (; D.length && D[D.length - 1] !== this; )
        D.pop();
      return D.push(x), R(M + D.length - 1), x;
    });
  }
  function y(I, M, D) {
    let V = I;
    if (C.isReactNative(n) && C.isReactNativeBlob(I))
      return n.append(ro(D, M, s), A(I)), !1;
    if (I && !D && typeof I == "object") {
      if (C.endsWith(M, "{}"))
        M = o ? M : M.slice(0, -2), I = F(I, 1);
      else if (C.isArray(I) && Vd(I) || (C.isFileList(I) || C.endsWith(M, "[]")) && (V = C.toArray(I)))
        return M = Ka(M), V.forEach(function(x, $) {
          !(C.isUndefined(x) || x === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? ro([M], $, s) : a === null ? M : M + "[]",
            A(x)
          );
        }), !1;
    }
    return Do(I) ? !0 : (n.append(ro(D, M, s), A(I)), !1);
  }
  const T = Object.assign(jd, {
    defaultVisitor: y,
    convertValue: A,
    isVisitable: Do
  });
  function v(I, M, D = 0) {
    if (!C.isUndefined(I)) {
      if (R(D), g.indexOf(I) !== -1)
        throw new Error("Circular reference detected in " + M.join("."));
      g.push(I), C.forEach(I, function(q, x) {
        (!(C.isUndefined(q) || q === null) && r.call(n, q, C.isString(x) ? x.trim() : x, M, T)) === !0 && v(q, M ? M.concat(x) : [x], D + 1);
      }), g.pop();
    }
  }
  if (!C.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), n;
}
function $r(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function ir(e, n) {
  this._pairs = [], e && Vi(e, this, n);
}
const ba = ir.prototype;
ba.append = function(n, t) {
  this._pairs.push([n, t]);
};
ba.toString = function(n) {
  const t = n ? (i) => n.call(this, i, $r) : $r;
  return this._pairs.map(function(o) {
    return t(o[0]) + "=" + t(o[1]);
  }, "").join("&");
};
function Hd(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function va(e, n, t) {
  if (!n)
    return e;
  e = e || "";
  const i = C.isFunction(t) ? {
    serialize: t
  } : t, o = C.getSafeProp(i, "encode") || Hd, r = C.getSafeProp(i, "serialize");
  let s;
  if (r ? s = r(n, i) : s = C.isURLSearchParams(n) ? n.toString() : new ir(n, i).toString(o), s) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
const Sn = /* @__PURE__ */ Symbol("internals");
function wa(e) {
  return e ? e.length : 0;
}
function Jr(e) {
  if (e)
    for (; e.length && e[e.length - 1] === null; )
      e.pop();
}
function Tn(e, n) {
  const t = e.handlers, i = wa(t);
  t !== n.handlersRef ? (n.handlersRef = t, n.handlerEntries.clear()) : i !== n.handlersLength && (i ? n.handlerEntries.forEach(function(r, s) {
    t[r.index] !== r.handler && n.handlerEntries.delete(s);
  }) : n.handlerEntries.clear()), n.handlersLength = i;
}
class zr {
  constructor() {
    this.handlers = [], this[Sn] = {
      handlersRef: this.handlers,
      handlersLength: this.handlers.length,
      handlerEntries: /* @__PURE__ */ new Map(),
      iterationDepth: 0,
      nextId: 0
    };
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, i) {
    const o = {
      fulfilled: n,
      rejected: t,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }, r = this[Sn];
    this.handlers == null && (this.handlers = []), Tn(this, r);
    const s = r.nextId++;
    return this.handlers.push(o), r.handlerEntries.set(s, {
      handler: o,
      index: this.handlers.length - 1
    }), r.handlersLength = this.handlers.length, s;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    const t = this[Sn];
    Tn(this, t);
    const i = t.handlerEntries.get(n);
    if (i) {
      if (t.handlerEntries.delete(n), this.handlers[i.index] !== i.handler)
        return;
      this.handlers[i.index] = null, t.iterationDepth || (Jr(this.handlers), t.handlersLength = this.handlers.length);
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = [], Tn(this, this[Sn]));
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    const t = this[Sn];
    Tn(this, t), t.iterationDepth++;
    try {
      C.forEach(this.handlers, function(o) {
        o !== null && n(o);
      });
    } finally {
      --t.iterationDepth || (Tn(this, t), Jr(this.handlers), t.handlersLength = wa(this.handlers));
    }
  }
}
const or = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, Gd = typeof URLSearchParams < "u" ? URLSearchParams : ir, Qd = typeof FormData < "u" ? FormData : null, $d = typeof Blob < "u" ? Blob : null, Jd = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Gd,
    FormData: Qd,
    Blob: $d
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, rr = typeof window < "u" && typeof document < "u", Oo = typeof navigator == "object" && navigator || void 0, zd = rr && (!Oo || ["ReactNative", "NativeScript", "NS"].indexOf(Oo.product) < 0), Wd = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Yd = rr && window.location.href || "http://localhost", Xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: rr,
  hasStandardBrowserEnv: zd,
  hasStandardBrowserWebWorkerEnv: Wd,
  navigator: Oo,
  origin: Yd
}, Symbol.toStringTag, { value: "Module" })), He = {
  ...Xd,
  ...Jd
};
function Zd(e, n) {
  return Vi(e, new He.classes.URLSearchParams(), {
    visitor: function(t, i, o, r) {
      return He.isNode && C.isBuffer(t) ? (this.append(i, t.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const Wr = ya;
function Ca(e) {
  if (e > Wr)
    throw new J(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + Wr,
      J.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function ec(e) {
  const n = [], t = /[^.[\]]+|\[([^.[\]]*)]/g;
  let i;
  for (; (i = t.exec(e)) !== null; )
    Ca(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function tc(e) {
  const n = {}, t = Object.keys(e);
  let i;
  const o = t.length;
  let r;
  for (i = 0; i < o; i++)
    r = t[i], n[r] = e[r];
  return n;
}
function Ra(e) {
  function n(t, i, o, r) {
    Ca(r);
    let s = t[r++];
    if (s === "__proto__") return !0;
    const a = Number.isFinite(+s), l = r >= t.length;
    return s = !s && C.isArray(o) ? o.length : s, l ? (C.hasOwnProp(o, s) ? o[s] = C.isArray(o[s]) ? o[s].concat(i) : [o[s], i] : o[s] = i, !a) : ((!C.hasOwnProp(o, s) || !C.isObject(o[s])) && (o[s] = []), n(t, i, o[s], r) && C.isArray(o[s]) && (o[s] = tc(o[s])), !a);
  }
  if (C.isFormData(e) && C.isFunction(e.entries)) {
    const t = {};
    return C.forEachEntry(e, (i, o) => {
      n(ec(i), o, t, 0);
    }), t;
  }
  return null;
}
const Fa = Object.freeze([
  "get",
  "delete",
  "head",
  "options",
  "post",
  "put",
  "patch",
  "purge",
  "link",
  "unlink",
  "query"
]), ln = (e, n) => e != null && C.hasOwnProp(e, n) ? e[n] : void 0;
function nc(e, n, t) {
  if (C.isString(e))
    try {
      return (n || JSON.parse)(e), C.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (t || JSON.stringify)(e);
}
const Zn = {
  transitional: or,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, t) {
      const i = t.getContentType() || "", o = i.indexOf("application/json") > -1, r = C.isObject(n);
      if (r && C.isHTMLForm(n) && (n = new FormData(n)), C.isFormData(n))
        return o ? JSON.stringify(Ra(n)) : n;
      if (C.isArrayBuffer(n) || C.isBuffer(n) || C.isStream(n) || C.isFile(n) || C.isBlob(n) || C.isReadableStream(n))
        return n;
      if (C.isArrayBufferView(n))
        return n.buffer;
      if (C.isURLSearchParams(n))
        return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let a;
      if (r) {
        const l = ln(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return Zd(n, l).toString();
        if ((a = C.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const d = ln(this, "env"), f = d && d.FormData;
          return Vi(
            a ? { "files[]": n } : n,
            f && new f(),
            l
          );
        }
      }
      return r || o ? (t.setContentType("application/json", !1), nc(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const t = ln(this, "transitional") || Zn.transitional, i = t && t.forcedJSONParsing, o = ln(this, "responseType"), r = o === "json";
      if (C.isResponse(n) || C.isReadableStream(n))
        return n;
      if (n && C.isString(n) && (i && !o || r)) {
        const a = !(t && t.silentJSONParsing) && r;
        try {
          return JSON.parse(n, ln(this, "parseReviver"));
        } catch (l) {
          if (a)
            throw l.name === "SyntaxError" ? J.from(l, J.ERR_BAD_RESPONSE, this, null, ln(this, "response")) : l;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: He.classes.FormData,
    Blob: He.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
C.forEach(Fa, (e) => {
  Zn.headers[e] = {};
});
function so(e, n) {
  const t = this || Zn, i = n || t, o = ze.from(i.headers);
  let r = i.data;
  return C.forEach(e, function(a) {
    r = a.call(t, r, o.normalize(), n ? n.status : void 0);
  }), o.normalize(), r;
}
function ka(e) {
  return !!(e && e.__CANCEL__);
}
let ei = class extends J {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, t, i) {
    super(n ?? "canceled", J.ERR_CANCELED, t, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Ua(e, n, t) {
  const i = t.config.validateStatus;
  !t.status || !i || i(t.status) ? e(t) : n(new J(
    "Request failed with status code " + t.status,
    t.status >= 400 && t.status < 500 ? J.ERR_BAD_REQUEST : J.ERR_BAD_RESPONSE,
    t.config,
    t.request,
    t
  ));
}
const ic = /[\t\n\r]/g;
function Ea(e) {
  if (typeof e != "string")
    return e;
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n).replace(ic, "");
}
function ao(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function oc(e, n) {
  e = e || 10;
  const t = new Array(e), i = new Array(e);
  let o = 0, r = 0, s;
  return n = n !== void 0 ? n : 1e3, function(l) {
    const d = Date.now(), f = i[r];
    s || (s = d), t[o] = l, i[o] = d;
    let g = r, A = 0;
    for (; g !== o; )
      A += t[g++], g = g % e;
    if (o = (o + 1) % e, o === r && (r = (r + 1) % e), d - s < n)
      return;
    const R = f && d - f;
    return R ? Math.round(A * 1e3 / R) : void 0;
  };
}
function rc(e, n) {
  let t = 0, i = 1e3 / n, o, r;
  const s = (f, g = Date.now()) => {
    t = g, o = null, r && (clearTimeout(r), r = null), e(...f);
  };
  return [(...f) => {
    const g = Date.now(), A = g - t;
    A >= i ? s(f, g) : (o = f, r || (r = setTimeout(() => {
      r = null, s(o);
    }, i - A)));
  }, () => o && s(o), (...f) => s(f)];
}
const Oi = (e, n, t = 3) => {
  let i = 0;
  const o = oc(50, 250);
  return rc((r) => {
    if (!r || !C.isNumber(r.loaded))
      return;
    const s = r.loaded, a = r.lengthComputable ? r.total : void 0, l = Math.max(0, a != null ? Math.min(s, a) : s), d = Math.max(0, l - i), f = o(d);
    i = Math.max(i, l);
    const g = {
      loaded: l,
      total: a,
      progress: a ? l / a : void 0,
      bytes: d,
      rate: f || void 0,
      estimated: f && a ? (a - l) / f : void 0,
      event: r,
      lengthComputable: a != null,
      [n ? "download" : "upload"]: !0
    };
    e(g);
  }, t);
}, Yr = (e, n) => {
  const t = e != null;
  return [
    (i) => n[0]({
      lengthComputable: t,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, Xr = (e, n = C.asap) => (...t) => n(() => e(...t)), sc = He.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, He.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(He.origin),
  He.navigator && /(msie|trident)/i.test(He.navigator.userAgent)
) : () => !0, ac = He.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, i, o, r, s) {
      if (typeof document > "u") return;
      const a = [`${e}=${encodeURIComponent(n)}`];
      C.isNumber(t) && a.push(`expires=${new Date(t).toUTCString()}`), C.isString(i) && a.push(`path=${i}`), C.isString(o) && a.push(`domain=${o}`), r === !0 && a.push("secure"), C.isString(s) && a.push(`SameSite=${s}`), document.cookie = a.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let t = 0; t < n.length; t++) {
        const i = n[t].replace(/^\s+/, ""), o = i.indexOf("=");
        if (o !== -1 && i.slice(0, o) === e)
          try {
            return decodeURIComponent(i.slice(o + 1));
          } catch {
            return i.slice(o + 1);
          }
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function lc(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function uc(e, n) {
  if (!n)
    return e;
  let t = e.length;
  for (; t > 0 && e.charCodeAt(t - 1) === 47; )
    t--;
  return e.slice(0, t) + "/" + n.replace(/^\/+/, "");
}
const dc = /^https?:(?!\/\/)/i;
function cc(e) {
  return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (n, t, i = "") => `${t}${i}${Di}`);
}
function fc(e) {
  const n = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${Di}@`), t = n.indexOf("#"), o = (t === -1 ? n : n.slice(0, t)).replace(
    /([?&][^=&#]*=)[^&#]*/g,
    `$1${Di}`
  );
  return t === -1 ? o : `${o}#${cc(n.slice(t + 1))}`;
}
function Zr(e, n) {
  if (typeof e == "string") {
    const t = Ea(e);
    if (dc.test(t))
      throw new J(
        `Invalid URL ${JSON.stringify(fc(t))}: missing "//" after protocol`,
        J.ERR_INVALID_URL,
        n
      );
  }
}
function Sa(e, n, t, i) {
  Zr(n, i);
  let o = !lc(n);
  return e && (o || t === !1) ? (Zr(e, i), uc(e, n)) : n;
}
const es = (e) => e instanceof ze ? { ...e } : e, pc = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(
  Object.getOwnPropertySymbols(e).filter(
    (n) => Object.getOwnPropertyDescriptor(e, n).enumerable
  )
) : Object.keys(e);
function tn(e, n) {
  e = e || {}, n = n || {};
  const t = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(t, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(f, g, A, R) {
    return C.isPlainObject(f) && C.isPlainObject(g) ? C.merge.call({ caseless: R }, f, g) : C.isPlainObject(g) ? C.merge({}, g) : C.isArray(g) ? g.slice() : g;
  }
  function o(f, g, A, R) {
    if (C.isUndefined(g)) {
      if (!C.isUndefined(f))
        return i(void 0, f, A, R);
    } else return i(f, g, A, R);
  }
  function r(f, g) {
    if (!C.isUndefined(g))
      return i(void 0, g);
  }
  function s(f, g) {
    if (C.isUndefined(g)) {
      if (!C.isUndefined(f))
        return i(void 0, f);
    } else return i(void 0, g);
  }
  function a(f) {
    const g = C.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!C.isUndefined(g))
      if (C.isPlainObject(g)) {
        if (C.hasOwnProp(g, f))
          return g[f];
      } else
        return;
    const A = C.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (C.isPlainObject(A) && C.hasOwnProp(A, f))
      return A[f];
  }
  function l(f, g, A) {
    if (C.hasOwnProp(n, A))
      return i(f, g);
    if (C.hasOwnProp(e, A))
      return i(void 0, f);
  }
  const d = {
    url: r,
    method: r,
    data: r,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutErrorMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (f, g, A) => o(es(f), es(g), A, !0)
  };
  return C.forEach(pc({ ...e, ...n }), function(g) {
    if (g === "__proto__" || g === "constructor" || g === "prototype") return;
    const A = C.hasOwnProp(d, g) ? d[g] : o, R = C.hasOwnProp(e, g) ? e[g] : void 0, F = C.hasOwnProp(n, g) ? n[g] : void 0, y = A(R, F, g);
    C.isUndefined(y) && A !== l || (t[g] = y);
  }), C.hasOwnProp(n, "validateStatus") && C.isUndefined(n.validateStatus) && a("validateStatusUndefinedResolves") === !1 && (C.hasOwnProp(e, "validateStatus") ? t.validateStatus = i(void 0, e.validateStatus) : delete t.validateStatus), t;
}
const hc = ["content-type", "content-length"];
function mc(e, n, t) {
  if (t !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n || {}).forEach(([i, o]) => {
    hc.includes(i.toLowerCase()) && e.set(i, o);
  });
}
const Ac = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, t) => String.fromCharCode(parseInt(t, 16))
);
function Ta(e) {
  const n = tn({}, e), t = (A) => C.hasOwnProp(n, A) ? n[A] : void 0, i = t("data");
  let o = t("withXSRFToken");
  const r = t("xsrfHeaderName"), s = t("xsrfCookieName");
  let a = t("headers");
  const l = t("auth"), d = t("baseURL"), f = t("allowAbsoluteUrls"), g = t("url");
  if (n.headers = a = ze.from(a), n.url = va(
    Sa(d, g, f, n),
    t("params"),
    t("paramsSerializer")
  ), l) {
    const A = C.getSafeProp(l, "username") || "", R = C.getSafeProp(l, "password") || "";
    try {
      a.set(
        "Authorization",
        "Basic " + btoa(A + ":" + (R ? Ac(R) : ""))
      );
    } catch (F) {
      throw J.from(F, J.ERR_BAD_OPTION_VALUE, e);
    }
  }
  if (C.isFormData(i)) {
    const A = C.getSafeProp(i, "getHeaders");
    He.hasStandardBrowserEnv || He.hasStandardBrowserWebWorkerEnv || C.isReactNative(i) ? a.setContentType(void 0) : C.isFunction(A) && mc(a, A.call(i), t("formDataHeaderPolicy"));
  }
  if (He.hasStandardBrowserEnv && (C.isFunction(o) && (o = o(n)), o === !0 || o == null && sc(n.url))) {
    const R = r && s && ac.read(s);
    R && a.set(r, R);
  }
  return n;
}
const gc = typeof XMLHttpRequest < "u", yc = gc && function(e) {
  return new Promise(function(t, i) {
    const o = Ta(e);
    let r = o.data;
    const s = ze.from(o.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: d } = o, f, g, A, R, F, y;
    function T() {
      R && R(), F && F(), o.cancelToken && o.cancelToken.unsubscribe(f), o.signal && o.signal.removeEventListener("abort", f);
    }
    let v = new XMLHttpRequest();
    v.open(o.method.toUpperCase(), o.url, !0), v.timeout = o.timeout;
    function I(D) {
      if (!v)
        return;
      if (v.status === 0 && (ao(Ea(o.url)) || ao(He.origin)) !== "file" && !(v.responseURL && v.responseURL.startsWith("file:"))) {
        i(new J("Request aborted", J.ECONNABORTED, e, v)), T(), v = null;
        return;
      }
      try {
        D ? y && y(D) : F && F();
      } catch ($) {
        setTimeout(() => {
          throw $;
        });
      }
      if (!v)
        return;
      const V = ze.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), x = {
        data: !a || a === "text" || a === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: V,
        config: e,
        request: v
      };
      Ua(
        function(z) {
          t(z), T();
        },
        function(z) {
          i(z), T();
        },
        x
      ), v = null;
    }
    "onloadend" in v ? v.onloadend = I : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.startsWith("file:")) || setTimeout(I);
    }, v.onabort = function() {
      v && (i(new J("Request aborted", J.ECONNABORTED, e, v)), T(), v = null);
    }, v.onerror = function(V) {
      const q = V && V.message ? V.message : "Network Error", x = new J(q, J.ERR_NETWORK, e, v);
      x.event = V || null, i(x), T(), v = null;
    }, v.ontimeout = function() {
      let V = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const q = o.transitional || or;
      o.timeoutErrorMessage && (V = o.timeoutErrorMessage), i(
        new J(
          V,
          q.clarifyTimeoutError ? J.ETIMEDOUT : J.ECONNABORTED,
          e,
          v
        )
      ), T(), v = null;
    }, r === void 0 && s.setContentType(null), "setRequestHeader" in v && C.forEach(Aa(s), function(V, q) {
      v.setRequestHeader(q, V);
    }), C.isUndefined(o.withCredentials) || (v.withCredentials = !!o.withCredentials), a && a !== "json" && (v.responseType = o.responseType), d && ([A, F, y] = Oi(
      d,
      !0
    ), v.addEventListener("progress", A)), l && v.upload && ([g, R] = Oi(l), v.upload.addEventListener("progress", g), v.upload.addEventListener("loadend", R)), (o.cancelToken || o.signal) && (f = (D) => {
      v && (i(!D || D.type ? new ei(null, e, v) : D), v.abort(), T(), v = null);
    }, o.cancelToken && o.cancelToken.subscribe(f), o.signal && (o.signal.aborted ? f() : o.signal.addEventListener("abort", f)));
    const M = ao(o.url);
    if (M && !He.protocols.includes(M)) {
      i(
        new J(
          "Unsupported protocol " + M + ":",
          J.ERR_BAD_REQUEST,
          e
        )
      ), T();
      return;
    }
    v.send(r || null);
  });
}, Kc = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const t = new AbortController();
  let i = !1;
  const o = function(l) {
    if (!i) {
      i = !0, s();
      const d = l instanceof Error ? l : this.reason;
      t.abort(
        d instanceof J ? d : new ei(d instanceof Error ? d.message : d)
      );
    }
  };
  let r = n && setTimeout(() => {
    r = null, o(new J(`timeout of ${n}ms exceeded`, J.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (r && clearTimeout(r), r = null, e.forEach((l) => {
      l.unsubscribe ? l.unsubscribe(o) : l.removeEventListener("abort", o);
    }), e = null);
  };
  e.forEach((l) => {
    if (!i) {
      if (l.aborted) {
        o.call(l);
        return;
      }
      l.addEventListener("abort", o, { once: !0 });
    }
  });
  const { signal: a } = t;
  return a.unsubscribe = () => C.asap(s), a;
}, bc = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let i = 0, o;
  for (; i < t; )
    o = i + n, yield e.slice(i, o), i = o;
}, vc = async function* (e, n) {
  for await (const t of wc(e))
    yield* bc(t, n);
}, wc = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: i } = await n.read();
      if (t)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, ts = (e, n, t, i) => {
  const o = vc(e, n);
  let r = 0, s, a = (l) => {
    s || (s = !0, i && i(l));
  };
  return new ReadableStream(
    {
      async pull(l) {
        try {
          const { done: d, value: f } = await o.next();
          if (d) {
            a(), l.close();
            return;
          }
          let g = f.byteLength;
          if (t) {
            let A = r += g;
            t(A);
          }
          l.enqueue(new Uint8Array(f));
        } catch (d) {
          throw a(d), d;
        }
      },
      cancel(l) {
        return a(l), o.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, ns = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Ia = (e, n, t) => n + 2 < t && ns(e.charCodeAt(n + 1)) && ns(e.charCodeAt(n + 2)), is = (e) => e <= 57 ? e - 48 : (e & 223) - 55, Cc = (e) => e >= 65 && e <= 90 || // A-Z
e >= 97 && e <= 122 || // a-z
e >= 48 && e <= 57 || // 0-9
e === 43 || // +
e === 47 || // /
e === 45 || // - (base64url)
e === 95, Rc = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, Fc = (e) => {
  const n = Math.floor(e / 4), t = e % 4;
  return n * 3 + (t === 2 ? 1 : t === 3 ? 2 : 0);
}, kc = (e) => {
  const n = e.length;
  let t = 0;
  return n > 0 && e.charCodeAt(n - 1) === 61 && (t++, n > 1 && e.charCodeAt(n - 2) === 61 && t++), Math.floor((n - t) * 3 / 4);
}, Uc = (e) => {
  const n = e.length;
  let t = 0, i = 0, o = !1;
  for (let r = 0; r < n; r++) {
    let s = e.charCodeAt(r);
    if (s === 37 && Ia(e, r, n) && (s = is(e.charCodeAt(r + 1)) * 16 + is(e.charCodeAt(r + 2)), r += 2), !Rc(s)) {
      if (s === 61) {
        i++;
        continue;
      }
      if (!Cc(s) || i > 0) {
        o = !0;
        continue;
      }
      t++;
    }
  }
  return o || i > 2 || i > 0 && (t + i) % 4 !== 0 || t % 4 === 1 ? kc(e) : Fc(t);
}, Ec = (e, n) => {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const t = e.indexOf(",");
  if (t < 0) return 0;
  const i = e.slice(5, t), o = e.slice(t + 1);
  if (/;base64/i.test(i))
    return n(o);
  let s = 0;
  for (let a = 0, l = o.length; a < l; a++) {
    const d = o.charCodeAt(a);
    if (d === 37 && Ia(o, a, l))
      s += 1, a += 2;
    else if (d < 128)
      s += 1;
    else if (d < 2048)
      s += 2;
    else if (d >= 55296 && d <= 56319 && a + 1 < l) {
      const f = o.charCodeAt(a + 1);
      f >= 56320 && f <= 57343 ? (s += 4, a++) : s += 3;
    } else
      s += 3;
  }
  return s;
};
function Sc(e) {
  const n = typeof e == "string" ? e.indexOf("#") : -1;
  return Ec(
    n === -1 ? e : e.slice(0, n),
    Uc
  );
}
const sr = "1.20.0", os = 64 * 1024, Tc = {
  cache: "default",
  redirect: "follow",
  referrer: "about:client",
  referrerPolicy: "",
  mode: "cors",
  integrity: "",
  keepalive: !1,
  priority: "auto",
  window: null
}, { isFunction: di } = C, Ic = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, t) => String.fromCharCode(parseInt(t, 16))
), rs = (e) => {
  if (!C.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, ss = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, Dc = (e) => {
  const n = e.indexOf("://");
  let t = e;
  return n !== -1 && (t = t.slice(n + 3)), t.includes("@") || t.includes(":");
}, Oc = (e) => {
  const n = C.global !== void 0 && C.global !== null ? C.global : globalThis, { ReadableStream: t, TextEncoder: i } = n;
  e = C.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: o, Request: r, Response: s } = e, a = o ? di(o) : typeof fetch == "function", l = di(r), d = di(s);
  if (!a)
    return !1;
  const f = a && di(t), g = a && (typeof i == "function" ? /* @__PURE__ */ ((v) => (I) => v.encode(I))(new i()) : async (v) => new Uint8Array(await new r(v).arrayBuffer())), A = l && f && ss(() => {
    let v = !1;
    const I = new r(He.origin, {
      body: new t(),
      method: "POST",
      get duplex() {
        return v = !0, "half";
      }
    }), M = I.headers.has("Content-Type");
    return I.body != null && I.body.cancel(), v && !M;
  }), R = d && f && ss(() => C.isReadableStream(new s("").body)), F = {
    stream: R && ((v) => v.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((v) => {
    !F[v] && (F[v] = (I, M) => {
      let D = I && I[v];
      if (D)
        return D.call(I);
      throw new J(
        `Response type '${v}' is not supported`,
        J.ERR_NOT_SUPPORT,
        M
      );
    });
  });
  const y = async (v) => {
    if (v == null)
      return 0;
    if (C.isBlob(v))
      return v.size;
    if (C.isSpecCompliantForm(v))
      return (await new r(He.origin, {
        method: "POST",
        body: v
      }).arrayBuffer()).byteLength;
    if (C.isArrayBufferView(v) || C.isArrayBuffer(v))
      return v.byteLength;
    if (C.isURLSearchParams(v) && (v = v + ""), C.isString(v))
      return (await g(v)).byteLength;
  }, T = async (v, I) => {
    const M = C.toFiniteNumber(v.getContentLength());
    return M ?? y(I);
  };
  return async (v) => {
    let {
      url: I,
      method: M,
      data: D,
      signal: V,
      cancelToken: q,
      timeout: x,
      onDownloadProgress: $,
      onUploadProgress: z,
      responseType: X,
      headers: he,
      withCredentials: Ae = "same-origin",
      fetchOptions: H,
      maxContentLength: we,
      maxBodyLength: S,
      maxRedirects: B
    } = Ta(v);
    const ee = C.isNumber(we) && we > -1, pe = C.isNumber(S) && S > -1, ye = (ge) => C.hasOwnProp(v, ge) ? v[ge] : void 0;
    let de = o || fetch;
    X = X ? (X + "").toLowerCase() : "text";
    let De = Kc(
      [V, q && q.toAbortSignal()],
      x
    ), Re = null;
    const Le = De && De.unsubscribe && (() => {
      De.unsubscribe();
    });
    let be, Ce = null;
    const Ye = () => new J(
      "Request body larger than maxBodyLength limit",
      J.ERR_BAD_REQUEST,
      v,
      Re
    );
    try {
      let ge;
      const ne = ye("auth");
      if (ne) {
        const le = C.getSafeProp(ne, "username") || "", Oe = C.getSafeProp(ne, "password") || "";
        ge = {
          username: le,
          password: Oe
        };
      }
      if (Dc(I)) {
        const le = new URL(I, He.origin);
        if (!ge && (le.username || le.password)) {
          const Oe = rs(le.username), je = rs(le.password);
          ge = {
            username: Oe,
            password: je
          };
        }
        (le.username || le.password) && (le.username = "", le.password = "", I = le.href);
      }
      if (ge && (he.delete("authorization"), he.set(
        "Authorization",
        "Basic " + btoa(Ic((ge.username || "") + ":" + (ge.password || "")))
      )), ee && typeof I == "string" && I.startsWith("data:") && Sc(I) > we)
        throw new J(
          "maxContentLength size of " + we + " exceeded",
          J.ERR_BAD_RESPONSE,
          v,
          Re
        );
      if (pe && M !== "get" && M !== "head") {
        const le = await y(D);
        if (typeof le == "number" && isFinite(le) && (be = le, le > S))
          throw Ye();
      }
      const ae = pe && (C.isReadableStream(D) || C.isStream(D)), Ie = (le, Oe, je) => ts(
        le,
        os,
        (ot) => {
          if (pe && ot > S)
            throw Ce = Ye();
          Oe && Oe(ot);
        },
        je
      );
      if (A && M !== "get" && M !== "head" && (z || ae)) {
        if (be = be ?? await T(he, D), be !== 0 || ae) {
          let le = new r(I, {
            method: "POST",
            body: D,
            duplex: "half"
          }), Oe;
          if (C.isFormData(D) && (Oe = le.headers.get("content-type")) && he.setContentType(Oe), le.body) {
            const [je, ot] = z && Yr(
              be,
              Oi(Xr(z))
            ) || [];
            D = Ie(le.body, je, ot);
          }
        }
      } else if (ae && !l && f && M !== "get" && M !== "head")
        D = Ie(D);
      else if (ae && l && !A && M !== "get" && M !== "head")
        throw new J(
          "Stream request bodies are not supported by the current fetch implementation",
          J.ERR_NOT_SUPPORT,
          v,
          Re
        );
      C.isString(Ae) || (Ae = Ae ? "include" : "omit");
      const Ve = l && "credentials" in r.prototype;
      if (C.isFormData(D)) {
        const le = he.getContentType();
        le && /^multipart\/form-data/i.test(le) && !/boundary=/i.test(le) && he.delete("content-type");
      }
      he.set("User-Agent", "axios/" + sr, !1);
      const Ne = H == null ? H : Object.assign(/* @__PURE__ */ Object.create(null), H);
      Ne && (delete Ne.body, delete Ne.headers, delete Ne.method, delete Ne.signal, delete Ne.duplex, delete Ne.credentials);
      const Pe = Object.assign(/* @__PURE__ */ Object.create(null), Ne, {
        signal: De,
        method: M.toUpperCase(),
        headers: Aa(he.normalize()),
        body: D,
        duplex: "half",
        credentials: Ve ? Ae : void 0
      });
      l && (C.forEach(Tc, (le, Oe) => {
        Pe[Oe] === void 0 && (Pe[Oe] = le);
      }), Pe.signal === void 0 && (Pe.signal = null), Pe.body === void 0 && (Pe.body = null)), B === 0 && (Pe.redirect = "manual", Ne && (Ne.redirect = "manual")), Re = l && new r(I, Pe);
      let Xe = await (l ? de(Re, Ne) : de(I, Pe));
      const jt = ze.from(Xe.headers);
      if (ee) {
        const le = C.toFiniteNumber(jt.getContentLength());
        if (le != null && le > we)
          throw new J(
            "maxContentLength size of " + we + " exceeded",
            J.ERR_BAD_RESPONSE,
            v,
            Re
          );
      }
      const Nt = R && (X === "stream" || X === "response");
      if (R && Xe.body && ($ || ee || Nt && Le)) {
        const le = {};
        ["status", "statusText", "headers"].forEach((gt) => {
          le[gt] = Xe[gt];
        });
        const Oe = C.toFiniteNumber(jt.getContentLength()), [je, ot] = $ && Yr(
          Oe,
          Oi(Xr($), !0)
        ) || [];
        let Bt = 0;
        const xt = (gt) => {
          if (ee && (Bt = gt, Bt > we))
            throw new J(
              "maxContentLength size of " + we + " exceeded",
              J.ERR_BAD_RESPONSE,
              v,
              Re
            );
          je && je(gt);
        };
        Xe = new s(
          ts(Xe.body, os, xt, () => {
            ot && ot(), Le && Le();
          }),
          le
        );
      }
      X = X || "text";
      let Ze = await F[C.findKey(F, X) || "text"](
        Xe,
        v
      );
      if (ee && !R && !Nt) {
        let le;
        if (Ze != null && (typeof Ze.byteLength == "number" ? le = Ze.byteLength : typeof Ze.size == "number" ? le = Ze.size : typeof Ze == "string" && (le = typeof i == "function" ? new i().encode(Ze).byteLength : Ze.length)), typeof le == "number" && le > we)
          throw new J(
            "maxContentLength size of " + we + " exceeded",
            J.ERR_BAD_RESPONSE,
            v,
            Re
          );
      }
      return !Nt && Le && Le(), await new Promise((le, Oe) => {
        Ua(le, Oe, {
          data: Ze,
          headers: ze.from(Xe.headers),
          status: Xe.status,
          statusText: Xe.statusText,
          config: v,
          request: Re
        });
      });
    } catch (ge) {
      if (Le && Le(), De && De.aborted && De.reason instanceof J) {
        const ne = De.reason;
        throw ne.config = v, Re && (ne.request = Re), ge !== ne && Object.defineProperty(ne, "cause", {
          __proto__: null,
          value: ge,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), ne;
      }
      if (Ce)
        throw Re && !Ce.request && (Ce.request = Re), Ce;
      if (ge instanceof J)
        throw Re && !ge.request && (ge.request = Re), ge;
      if (ge && ge.name === "TypeError" && /Load failed|fetch/i.test(ge.message)) {
        const ne = new J(
          "Network Error",
          J.ERR_NETWORK,
          v,
          Re,
          ge && ge.response
        );
        throw Object.defineProperty(ne, "cause", {
          __proto__: null,
          value: ge.cause || ge,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), ne;
      }
      throw J.from(ge, ge && ge.code, v, Re, ge && ge.response);
    }
  };
}, _c = /* @__PURE__ */ new Map(), Da = (e) => {
  let n = e && e.env || {};
  const { fetch: t, Request: i, Response: o } = n, r = [i, o, t];
  let s = r.length, a = s, l, d, f = _c;
  for (; a--; )
    l = r[a], d = f.get(l), d === void 0 && f.set(l, d = a ? /* @__PURE__ */ new Map() : Oc(n)), f = d;
  return d;
};
Da();
const ar = {
  http: qd,
  xhr: yc,
  fetch: {
    get: Da
  }
};
C.forEach(ar, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const as = (e) => `- ${e}`, Pc = (e) => C.isFunction(e) || e === null || e === !1;
function Mc(e, n) {
  e = C.isArray(e) ? e : [e];
  const { length: t } = e;
  let i, o;
  const r = {};
  for (let s = 0; s < t; s++) {
    i = e[s];
    let a;
    if (o = i, !Pc(i) && (o = ar[(a = String(i)).toLowerCase()], o === void 0))
      throw new J(`Unknown adapter '${a}'`);
    if (o && (C.isFunction(o) || (o = o.get(n))))
      break;
    r[a || "#" + s] = o;
  }
  if (!o) {
    const s = Object.entries(r).map(
      ([l, d]) => `adapter ${l} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let a = t ? s.length > 1 ? `since :
` + s.map(as).join(`
`) : " " + as(s[0]) : "as no adapter specified";
    throw new J(
      "There is no suitable adapter to dispatch the request " + a,
      J.ERR_NOT_SUPPORT
    );
  }
  return o;
}
const Oa = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Mc,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: ar
};
function lo(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ei(null, e);
}
function uo(e) {
  const n = C.toSafeFlatObject(e);
  return lo(n), n.headers = ze.from(C.getSafeProp(n, "headers")), n.data = so.call(n, n.transformRequest), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), Oa.getAdapter(n.adapter || Zn.adapter, n)(n).then(
    function(o) {
      lo(n), n.response = o;
      try {
        o.data = so.call(n, n.transformResponse, o);
      } finally {
        delete n.response;
      }
      return o.headers = ze.from(o.headers), o;
    },
    function(o) {
      if (!ka(o) && (lo(n), o && o.response)) {
        n.response = o.response;
        try {
          o.response.data = so.call(
            n,
            n.transformResponse,
            o.response
          );
        } finally {
          delete n.response;
        }
        o.response.headers = ze.from(o.response.headers);
      }
      return Promise.reject(o);
    }
  );
}
const ji = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  ji[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const ls = {};
ji.transitional = function(n, t, i) {
  function o(r, s) {
    return "[Axios v" + sr + "] Transitional option '" + r + "'" + s + (i ? ". " + i : "");
  }
  return (r, s, a) => {
    if (n === !1)
      throw new J(
        o(s, " has been removed" + (t ? " in " + t : "")),
        J.ERR_DEPRECATED
      );
    return t && !ls[s] && (ls[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(r, s, a) : !0;
  };
};
ji.spelling = function(n) {
  return (t, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function Lc(e, n, t) {
  if (typeof e != "object" || e === null)
    throw new J("options must be an object", J.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let o = i.length;
  for (; o-- > 0; ) {
    const r = i[o], s = Object.prototype.hasOwnProperty.call(n, r) ? n[r] : void 0;
    if (s) {
      const a = e[r], l = a === void 0 || s(a, r, e);
      if (l !== !0)
        throw new J(
          "option " + r + " must be " + l,
          J.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (t !== !0)
      throw new J("Unknown option " + r, J.ERR_BAD_OPTION);
  }
}
const bi = {
  assertOptions: Lc,
  validators: ji
}, $e = bi.validators;
let Wt = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new zr(),
      response: new zr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (i) {
      if (i instanceof Error)
        try {
          let o = {};
          Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
          const r = o.stack;
          let s = "";
          if (typeof r == "string") {
            const a = r.indexOf(`
`);
            s = a === -1 ? "" : r.slice(a + 1);
          }
          if (!i.stack)
            i.stack = s;
          else if (s) {
            const a = s.indexOf(`
`), l = a === -1 ? -1 : s.indexOf(`
`, a + 1), d = l === -1 ? "" : s.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + s);
          }
        } catch {
        }
      throw i;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = tn(this.defaults, t);
    const { transitional: i, paramsSerializer: o, headers: r } = t;
    i !== void 0 && bi.assertOptions(
      i,
      {
        silentJSONParsing: $e.transitional($e.boolean),
        forcedJSONParsing: $e.transitional($e.boolean),
        clarifyTimeoutError: $e.transitional($e.boolean),
        legacyInterceptorReqResOrdering: $e.transitional($e.boolean),
        advertiseZstdAcceptEncoding: $e.transitional($e.boolean),
        validateStatusUndefinedResolves: $e.transitional($e.boolean)
      },
      !1
    ), o != null && (C.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : bi.assertOptions(
      o,
      {
        encode: $e.function,
        serialize: $e.function
      },
      !0
    )), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), bi.assertOptions(
      t,
      {
        baseUrl: $e.spelling("baseURL"),
        withXsrfToken: $e.spelling("withXSRFToken")
      },
      !0
    ), t.method = (C.getSafeProp(t, "method") || C.getSafeProp(this.defaults, "method") || "get").toLowerCase();
    let s = r && C.merge(r.common, r[t.method]);
    r && C.forEach(Fa.concat("common"), (F) => {
      delete r[F];
    }), t.headers = ze.concat(s, r);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(y) {
      if (typeof y.runWhen == "function" && y.runWhen(t) === !1)
        return;
      l = l && y.synchronous;
      const T = t.transitional || or;
      T && T.legacyInterceptorReqResOrdering ? a.unshift(y.fulfilled, y.rejected) : a.push(y.fulfilled, y.rejected);
    });
    const d = [];
    this.interceptors.response.forEach(function(y) {
      d.push(y.fulfilled, y.rejected);
    });
    let f, g = 0, A;
    if (!l) {
      const F = [uo.bind(this), void 0];
      for (F.unshift(...a), F.push(...d), A = F.length, f = Promise.resolve(t); g < A; )
        f = f.then(F[g++], F[g++]);
      return f;
    }
    A = a.length;
    let R = t;
    for (; g < A; ) {
      const F = a[g++], y = a[g++];
      try {
        R = F ? F(R) : R;
      } catch (T) {
        if (!y) {
          f = Promise.reject(T);
          break;
        }
        try {
          const v = y.call(this, T);
          C.isThenable(v) && (f = Promise.resolve(v).then(
            () => uo.call(this, R)
          ));
        } catch (v) {
          f = Promise.reject(v);
        }
        break;
      }
    }
    if (!f)
      try {
        f = uo.call(this, R);
      } catch (F) {
        f = Promise.reject(F);
      }
    for (g = 0, A = d.length; g < A; )
      f = f.then(d[g++], d[g++]);
    return f;
  }
  getUri(n) {
    n = tn(this.defaults, n);
    const t = Sa(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return va(t, n.params, n.paramsSerializer);
  }
};
C.forEach(["delete", "get", "head", "options"], function(n) {
  Wt.prototype[n] = function(t, i) {
    return this.request(
      tn(i || {}, {
        method: n,
        url: t,
        data: i && C.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
C.forEach(["post", "put", "patch", "query"], function(n) {
  function t(i) {
    return function(r, s, a) {
      return this.request(
        tn(a || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: r,
          data: s
        })
      );
    };
  }
  Wt.prototype[n] = t(), n !== "query" && (Wt.prototype[n + "Form"] = t(!0));
});
let Nc = class _a {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(r) {
      t = r;
    });
    const i = this;
    this.promise.then((o) => {
      if (!i._listeners) return;
      let r = i._listeners.length;
      for (; r-- > 0; )
        i._listeners[r](o);
      i._listeners = null;
    }), this.promise.then = (o) => {
      let r;
      const s = new Promise((a) => {
        i.subscribe(a), r = a;
      }).then(o);
      return s.cancel = function() {
        i.unsubscribe(r);
      }, s;
    }, n(function(r, s, a) {
      i.reason || (i.reason = new ei(r, s, a), t(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (i) => {
      n.abort(i);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new _a(function(o) {
        n = o;
      }),
      cancel: n
    };
  }
};
function Bc(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function xc(e) {
  return C.isObject(e) && e.isAxiosError === !0;
}
const vi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  /**
   * @deprecated Use `ContentTooLarge` instead.
   */
  PayloadTooLarge: 413,
  ContentTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  /**
   * @deprecated Use `UnprocessableContent` instead.
   */
  UnprocessableEntity: 422,
  UnprocessableContent: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerReturnsAnUnknownError: 520,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(vi).forEach(([e, n]) => {
  vi[n] === void 0 && (vi[n] = e);
});
function Pa(e) {
  const n = new Wt(e), t = ra(Wt.prototype.request, n);
  return C.extend(t, Wt.prototype, n, { allOwnKeys: !0 }), C.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(o) {
    return Pa(tn(e, o));
  }, t;
}
const Ue = Pa(Zn);
Ue.Axios = Wt;
Ue.CanceledError = ei;
Ue.CancelToken = Nc;
Ue.isCancel = ka;
Ue.VERSION = sr;
Ue.toFormData = Vi;
Ue.AxiosError = J;
Ue.Cancel = Ue.CanceledError;
Ue.all = function(n) {
  return Promise.all(n);
};
Ue.spread = Bc;
Ue.isAxiosError = xc;
Ue.mergeConfig = tn;
Ue.AxiosHeaders = ze;
Ue.formToJSON = (e) => Ra(C.isHTMLForm(e) ? new FormData(e) : e);
Ue.getAdapter = Oa.getAdapter;
Ue.HttpStatusCode = vi;
Ue.default = Ue;
const {
  Axios: I1,
  AxiosError: D1,
  CanceledError: O1,
  isCancel: _1,
  CancelToken: P1,
  VERSION: M1,
  all: L1,
  Cancel: N1,
  isAxiosError: B1,
  spread: x1,
  toFormData: q1,
  AxiosHeaders: V1,
  HttpStatusCode: j1,
  formToJSON: H1,
  getAdapter: G1,
  mergeConfig: Q1,
  create: $1
} = Ue, Lt = {
  CODE_0: 48,
  CODE_9: 57,
  CODE_COMMA: 44,
  CODE_PERIOD: 46,
  CODE_MINUS: 45,
  SCHEMA_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][-a-zA-Z0-9 _]{0,62}$/,
  TABLE_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][a-zA-Z0-9 _]{0,30}$/,
  COLUMN_NAME_REGEX: /^(?!.* _|.*_ )[a-zA-Z][a-zA-Z0-9 _]{0,62}$/,
  EMAIL_REGEX: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^$/,
  HYPERLINK_REGEX: /^((https?):\/\/)(www.)?[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%._\\+~#?&//=()]*)\/?$|^$/,
  PERIOD_REGEX: /^P(?=\d+Y|\d+M|\d+D)(\d+Y)?(\d+M)?(\d+D)?$/,
  UUID_REGEX: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  SELECT_QUOTED_REGEX: /'(?:[^'\\]|\\')*'/g,
  MAX_INT: 2147483647,
  MIN_INT: -2147483648,
  MIN_NON_NEGATIVE_INT: 0,
  MAX_LONG: "9223372036854775807",
  MIN_LONG: "-9223372036854775807",
  IS_CHAPTERS_ENABLED_FIELD_NAME: "isChaptersEnabled",
  AUTO_ID: "AUTO_ID",
  HEADING: "HEADING",
  SECTION: "SECTION"
}, Ma = "Level 1", La = "Level 2", Na = "Level 3", Ba = "Level 4", xa = "Custom", qc = "PrivacyPolicyLevel", Vc = "PrivacyPolicyText", jc = {
  [Ma]: "No privacy data",
  [La]: "Pseudomized data",
  [Na]: "Privacy data",
  [Ba]: "Privacy data + medical",
  [xa]: ""
}, Hc = {
  LEVEL_1: Ma,
  LEVEL_2: La,
  LEVEL_3: Na,
  LEVEL_4: Ba,
  CUSTOM: xa,
  POLICY_LEVEL_KEY: qc,
  POLICY_TEXT_KEY: Vc,
  PREFABS: jc
}, {
  EMAIL_REGEX: Gc,
  HYPERLINK_REGEX: Qc,
  PERIOD_REGEX: $c,
  UUID_REGEX: Jc,
  AUTO_ID: zc,
  HEADING: Wc,
  SECTION: Yc,
  MIN_INT: qa,
  MIN_NON_NEGATIVE_INT: Va,
  MAX_INT: Hi,
  MIN_LONG: ja,
  MAX_LONG: Ha
} = Lt, us = `Invalid long: must be value from ${ja} to ${Ha}`, ds = `Invalid integer: must be value from ${qa} to ${Hi}`, co = 'must start with a P and should contain at least a Y(year), M(month) or D(day): e.g. "P1Y3M14D"', fo = 'must use a valid UUID format (rfc9562): e.g. "123e4567-e89b-12d3-a456-426614174000"', Ga = `Invalid non negative integer: must be value from ${Va} to ${Hi}`;
function Xc(e, n) {
  return e.columns.reduce(
    (t, i) => {
      const o = Zc(i, n, e);
      return o && (t[i.id] = o), t;
    },
    {}
  );
}
function Zc(e, n, t) {
  const i = n?.[e.id], o = e.columnType, r = $a(i);
  try {
    if (!ur(e, n, t))
      return;
  } catch (s) {
    return s;
  }
  if (!(e.columnType === zc || e.columnType === Wc || e.columnType === Yc)) {
    if (e.required)
      if (ti(e.required)) {
        const s = ef(o, i);
        if (r || s)
          return e.label + " is required";
      } else {
        const s = tf(
          e.required,
          n,
          t
        );
        if (s && r)
          return s;
      }
    if (!(i === void 0 || !o.includes("_ARRAY") && r)) {
      if (o === "EMAIL" && za(i))
        return "Invalid email address";
      if (o === "EMAIL_ARRAY") {
        const s = sf(i);
        return In(
          s,
          " is an invalid email address",
          " are invalid email addresses"
        );
      }
      if (o === "HYPERLINK" && Ja(i))
        return "Invalid hyperlink";
      if (o === "HYPERLINK_ARRAY") {
        const s = of(i);
        return In(
          s,
          " is an invalid hyperlink",
          " are invalid hyperlinks"
        );
      }
      if (o === "PERIOD" && Wa(i))
        return "Invalid Period: " + co;
      if (o === "PERIOD_ARRAY") {
        const s = af(i);
        return In(
          s,
          " is an invalid Period: " + co,
          " are invalid Periods: " + co
        );
      }
      if (o === "UUID" && Ya(i))
        return "Invalid UUID: " + fo;
      if (o === "UUID_ARRAY") {
        const s = lf(i);
        return In(
          s,
          " is an invalid UUID: " + fo,
          " are invalid UUIDs: " + fo
        );
      }
      if (o === "JSON")
        try {
          if (typeof i == "string" && !Xa(JSON.parse(i)))
            return "Root element must be an object or array";
        } catch {
          return "Please enter valid JSON";
        }
      if (o === "LONG" && i !== null && cs(i) || o === "LONG_ARRAY" && Array.isArray(i) && i?.length && i?.some(cs))
        return us;
      if (o === "DECIMAL" && isNaN(parseFloat(i)) || o === "DECIMAL_ARRAY" && i?.some(
        (s) => s && isNaN(parseFloat(s))
      ))
        return "Invalid number";
      if (o === "INT" && fs(i) || o === "INT_ARRAY" && i?.some(fs))
        return ds;
      if (o === "NON_NEGATIVE_INT" && lr(i))
        return Ga;
      if (o === "NON_NEGATIVE_INT_ARRAY") {
        const s = rf(i);
        return In(
          s.map(
            (a) => a?.toString() ?? "[non-parsable value]"
          ),
          " is an invalid non negative integer",
          " are invalid non negative integers"
        );
      }
      if (e.validation)
        return nf(e.validation, n, t);
    }
  }
}
function In(e, n, t) {
  const i = e.map(
    (o) => typeof o == "string" ? o.toString().replaceAll("'", "\\'") : o?.toString() ?? "[non-parsable value]"
  );
  return i.length === 0 ? "" : i.length === 1 ? `'${i[0]}' ${n}` : `'${i.slice(0, i.length - 1).join("', '")}' and '${i[i.length - 1]}' ${t}`;
}
function cs(e) {
  const n = /^-?\d+$/;
  return e && n.test(e) ? BigInt(e) > BigInt(Ha) || BigInt(e) < BigInt(ja) : !0;
}
function Qa(e, n, t) {
  return typeof e != "number" || isNaN(e) || e < n || e > t;
}
function fs(e) {
  return Qa(e, qa, Hi);
}
function lr(e) {
  return Qa(e, Va, Hi);
}
function $a(e) {
  return Array.isArray(e) ? !e.length || e.some((n) => $a(n)) : e == null || e === "";
}
function ti(e) {
  return typeof e == "string" ? e.toLowerCase() === "true" : e === !0;
}
function ef(e, n) {
  return ["DECIMAL", "INT"].includes(e) ? n === void 0 || typeof n == "number" && isNaN(n) : !1;
}
function tf(e, n, t) {
  try {
    const i = mn(e, n, t);
    return i === !0 ? `Field is required when: ${e}` : i === !1 || i === void 0 ? void 0 : i;
  } catch (i) {
    return `Invalid expression '${e}', reason: ${i}`;
  }
}
function nf(e, n, t) {
  try {
    const i = mn(e, n, t);
    return i === !1 ? e : i === !0 || i === void 0 ? void 0 : i;
  } catch (i) {
    return `Invalid validation expression '${e}', reason: ${i}`;
  }
}
function mn(e, n, t) {
  const i = We(n);
  t.columns.forEach((s) => {
    i.hasOwnProperty(s.id) || (i[s.id] = null);
  }), i.mg_tableclass || (i.mg_tableclass = `${t.id}.${t.label}`);
  let o = function(s, a, l) {
    let d = new XMLHttpRequest();
    return d.open(
      "POST",
      l ? "/" + l + "/graphql" : "graphql",
      !1
    ), d.send(
      `{"query":"${s}", "variables":${JSON.stringify(a)}}`
    ), JSON.parse(d.responseText).data;
  };
  return new Function(
    "simplePostClient",
    //@ts-ignore
    Object.keys(i),
    "return eval(`" + e.replaceAll("`", "\\`") + "`)"
  )(o, ...Object.values(i));
}
function Ja(e) {
  return e && (typeof e != "string" || !Qc.test(e));
}
function of(e) {
  return Array.isArray(e) ? e.filter(
    (n) => Ja(n)
  ) : [];
}
function rf(e) {
  return Array.isArray(e) ? e.filter((n) => lr(n)) : [];
}
function za(e) {
  return typeof e != "string" || !Gc.test(e);
}
function sf(e) {
  return Array.isArray(e) ? e.filter((n) => za(n)) : [];
}
function Wa(e) {
  return e == null || e === "" ? !1 : typeof e != "string" || !$c.test(e);
}
function af(e) {
  return Array.isArray(e) ? e.filter((n) => Wa(n)) : [];
}
function Ya(e) {
  return e == null || e === "" ? !1 : typeof e != "string" || !Jc.test(e);
}
function lf(e) {
  return Array.isArray(e) ? e.filter((n) => Ya(n)) : [];
}
function Xa(e) {
  return typeof e == "object" && e !== null;
}
function uf(e, n) {
  const t = e?.columns?.filter((i) => i.key === 1).map((i) => i.id);
  return Kf(n, (i) => !t?.includes(i));
}
function df(e, n) {
  return n ? e.filter((t) => n.includes(t.id)) : e;
}
function ur(e, n, t) {
  const i = e.visible;
  if (i !== void 0)
    try {
      return mn(i, n || {}, t);
    } catch (o) {
      throw `Invalid visibility expression, reason: ${o}`;
    }
  else
    return !0;
}
function cf(e) {
  return e.reduce((n, t) => (t.columnType === "HEADING" ? n.push([t.id]) : (n.length === 0 && n.push([]), n[n.length - 1]?.push(t.id)), n), []);
}
function ff(e, n) {
  return e.filter(
    (i) => !!n[i]
  ).length ? { color: "red" } : {};
}
function pf(e) {
  const n = Object.values(e).filter(
    (t) => t
  ).length;
  return n > 0 ? `There are ${n} error(s) preventing saving` : "";
}
function hf(e, n, t) {
  let i = We(e);
  return n && n.forEach((o) => {
    const r = o.conditions ? o.conditions.filter(
      (s) => s !== "" && s !== void 0
    ) : [];
    r.length && (o.columnType.startsWith("AUTO_ID") || o.columnType.startsWith("STRING") || o.columnType.startsWith("TEXT") || o.columnType.startsWith("JSON") ? i[o.id] = { like: r } : o.columnType.startsWith("BOOL") || o.columnType.startsWith("CHECKBOX") || o.columnType.startsWith("REF") || o.columnType.startsWith("ONTOLOGY") || o.columnType.startsWith("RADIO") || o.columnType.startsWith("MULTISELECT") || o.columnType.startsWith("SELECT") ? i[o.id] = { equals: r.flat() } : ["DECIMAL", "DECIMAL_ARRAY", "INT", "INT_ARRAY"].includes(
      o.columnType
    ) ? i[o.id] = {
      between: r.flat().map((s) => parseFloat(s))
    } : [
      "LONG",
      "LONG_ARRAY",
      "DATE",
      "DATE_ARRAY",
      "DATETIME",
      "DATETIME_ARRAY"
    ].includes(o.columnType) ? i[o.id] = {
      between: r.flat()
    } : t(
      `filter unsupported for column type ${o.columnType} (please report a bug)`
    ));
  }), i;
}
const { CODE_0: mf, CODE_9: Af, CODE_PERIOD: gf, AUTO_ID: yf } = Lt;
function _i(e) {
  return [
    "REF",
    "REF_ARRAY",
    "REFBACK",
    "ONTOLOGY",
    "ONTOLOGY_ARRAY",
    "RADIO",
    "SELECT",
    "CHECKBOX",
    "MULTISELECT"
  ].includes(e);
}
function dr(e) {
  const n = e.which ?? e.keyCode;
  return n >= mf && n <= Af || n === gf;
}
function An(e) {
  if (typeof e == "object") {
    let n = "";
    return Object.keys(e).forEach((t) => {
      e[t] !== null && (typeof e[t] == "object" ? n += An(e[t]) : n += " " + e[t]);
    }), n;
  } else
    return e;
}
async function dn(e, n, t) {
  const o = await nt.newClient(t).fetchTableMetaData(n);
  if (o?.columns)
    return await o.columns.reduce(
      async (r, s) => {
        let a = await r;
        const l = e[s.id];
        return s.key === 1 && (l || l === 0) && (a[s.id] = await Za(
          l,
          s,
          s.refSchemaId || t
        )), a;
      },
      Promise.resolve({})
    );
  throw new Error("Empty columns in metadata");
}
async function Za(e, n, t) {
  if (typeof e == "string" || typeof e == "number")
    return e;
  if (n.refTableId)
    return await dn(
      e,
      n.refTableId,
      t
    );
  throw new Error("Unexpected key type");
}
function We(e) {
  return JSON.parse(JSON.stringify(e));
}
function Kf(e, n) {
  return Object.keys(e).reduce(
    (t, i) => (n(i) && (t[i] = e[i]), t),
    {}
  );
}
function cr(e) {
  switch (e) {
    case "-":
      return "";
    case null:
      return "-";
    default:
      return e.charAt(0) === "-" ? e.substring(1) : "-" + e;
  }
}
function nn(e, n) {
  if (e == null)
    return "";
  const t = Object.keys(e), i = Object.values(e);
  try {
    const o = new Function(...t, "return `" + n + "`;")(
      ...i
    );
    if (o)
      return o;
  } catch (o) {
    console.log(
      o.message + " we got keys:" + JSON.stringify(t) + " vals:" + JSON.stringify(i) + " and template: " + n
    );
  }
  return e.hasOwnProperty("primaryKey") ? An(e.primaryKey) : e.hasOwnProperty("name") ? e.name : e.hasOwnProperty("id") ? e.id : An(e);
}
function fn(e, n) {
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const o of t) {
    const r = e[o], s = n[o], a = ps(r) && ps(s);
    if (a && !fn(r, s) || !a && r !== s)
      return !1;
  }
  return !0;
}
function ps(e) {
  return e !== null && typeof e == "object";
}
function el(e, n) {
  return e?.map((t) => n.columns.reduce((i, o) => {
    if (o.computed && o.columnType !== yf)
      try {
        i[o.id] = mn(
          o.computed,
          t,
          n
        );
      } catch (r) {
        console.log("Computed expression failed: ", r), i[o.id] = "error: could not compute value: " + r;
      }
    else t.hasOwnProperty(o.id) && (i[o.id] = t[o.id]);
    return i;
  }, {}));
}
const tl = async (e, n, t, i = !0) => {
  const o = await _t(e);
  let r = "";
  for (const s of bf(e, n, o.tables))
    if (t > 0 || s.key) {
      if (!i && [
        "REF_ARRAY",
        "REFBACK",
        "ONTOLOGY_ARRAY",
        "CHECKBOX",
        "MULTISELECT"
      ].includes(s.columnType))
        continue;
      [
        "REF",
        "REF_ARRAY",
        "REFBACK",
        "CHECKBOX",
        "MULTISELECT",
        "SELECT",
        "RADIO"
      ].includes(s.columnType) ? r = r + " " + s.id + " {" + await tl(
        s.refSchemaId || e,
        s.refTableId || n,
        //indicate that sub queries should not be expanded on ref_array, refback, ontology_array
        t - 1,
        !1
      ) + " }" : ["ONTOLOGY", "ONTOLOGY_ARRAY"].includes(s.columnType) ? r = r + " " + s.id + " {name, label}" : s.columnType === "FILE" ? r += ` ${s.id} { id, size, filename, extension, url }` : ["HEADING", "SECTION"].includes(s.columnType) || (r += ` ${s.id}`);
    }
  return r;
}, bf = (e, n, t) => t.find((o) => o.id === n)?.columns || [], nl = (e, n = !0) => {
  if (n && (delete e.mg_insertedBy, delete e.mg_insertedOn, delete e.mg_updatedBy, delete e.mg_updatedOn), !FormData)
    throw "Files can only be uploaded via a browser client";
  const t = new FormData(), i = {}, o = {};
  for (const [r, s] of Object.entries(e))
    vf(s) ? o[r] = s : i[r] = s;
  for (const [r, s] of Object.entries(o)) {
    const a = Math.random().toString(36);
    t.append(a, s), i[r] = a;
  }
  return t.append("variables", JSON.stringify({ value: [i] })), t;
}, vf = (e) => {
  if (window && "File" in window)
    return e instanceof File;
  throw "Files can only be uploaded via a browser client";
}, On = /* @__PURE__ */ new Map(), nt = {
  newClient: (e) => ({
    insertDataRow: Rf,
    updateDataRow: Ff,
    deleteRow: async (n, t) => kf(n, t, e),
    deleteAllTableData: async (n) => Uf(n, e),
    fetchSchemaMetaData: async () => _t(e),
    fetchTableMetaData: async (n) => {
      const t = await _t(e);
      return We(t).tables.find(
        (i) => i.id === n
      );
    },
    fetchCascadeDeleteMsg: async (n) => {
      const t = await _t(e);
      function i(s, a) {
        t.tables.filter((d) => d.id !== s && !a[d.id]).filter((d) => d.columns.find(
          (f) => f.refTableId === s && (f.columnType === "REF" || f.columnType === "SELECT" || f.columnType === "RADIO") && f.cascadeDelete
        )).forEach((d) => {
          a[d.id] = d, i(d.id, a);
        });
      }
      const o = {};
      i(n, o);
      const r = Object.values(o);
      return r.length ? "Removing this row will also remove any rows in the following tables that reference this row: " + r.map((s) => s.name).join(", ") : "";
    },
    fetchTableData: async (n, t = {}) => {
      const i = await _t(e);
      return po(n, t, i);
    },
    fetchTableDataValues: async (n, t = {}) => {
      const i = await _t(e);
      return (await po(
        n,
        t,
        i
      ))[n];
    },
    fetchRowData: async (n, t, i = 2) => {
      const o = await _t(e), s = o.tables.find(
        (l) => l.id === n
      )?.columns?.filter((l) => l.key === 1).reduce((l, d) => (l[d.id] = { equals: t[d.id] }, l), {}), a = (await po(
        n,
        {
          filter: s,
          expandLevel: i
        },
        o
      ))[n];
      if (!(!a.length || a.length !== 1))
        return a[0];
    },
    fetchAggregateData: async (n, t, i, o, r, s) => {
      const a = `
        query ${n}_groupBy($filter: ${n}Filter){
          ${n}_groupBy(filter: $filter) {
            ${r} ${r === "_sum" ? `{ ${s} }` : ""},
            ${t.id} {
              ${t.column}
            },
            ${i.id} {
              ${i.column}
            }
          }
        }`;
      return Ge(Kt(e), a, { filter: o });
    },
    saveTableSettings: async (n) => Ge(
      Kt(e),
      "mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}",
      { settings: n }
    ),
    fetchSettings: async () => hs(e),
    fetchSettingValue: async (n) => {
      const i = (await hs(e)).find(
        (o) => o.key === n
      );
      if (i)
        return JSON.parse(i.value);
    },
    saveSetting: async (n, t) => {
      const i = `mutation change($settings: [MolgenisSettingsInput]) {
            change(settings: $settings) {
              message
            }
          }`, o = {
        settings: {
          key: n,
          value: JSON.stringify(t)
        }
      };
      await Ge(Kt(e), i, o).catch(
        (r) => {
          console.error(r);
        }
      );
    },
    clearCache: () => {
      On.clear();
    },
    convertRowToPrimaryKey: async (n, t) => ni(n, t, e),
    fetchOntologyOptions: async (n) => Ef(n, e),
    getPrimaryKeyFields: wf
  })
};
async function wf(e, n) {
  return _t(e).then((t) => {
    const i = t.tables.find((r) => r.id === n);
    if (!i)
      throw new Error(`Table ${n} not found in schema ${e}`);
    return i.columns.filter((r) => r.key === 1).map((r) => r.id);
  });
}
const Cf = `{
  _schema {
    id,
    tables {
      id,
      name,
      label, 
      description,
      tableType,
      semantics,
      columns {
        id,
        name,
        label,
        formLabel,
        description,
        columnType,
        key,
        refTableId,
        refSchemaId,
        cascadeDelete,
        refLinkId,
        refLabel,
        refLabelDefault,
        refBackId,
        required,
        defaultValue,
        readonly,
        semantics,
        position,
        computed,
        visible,
        validation
      }
      settings { 
        key,
        value 
      }
    }
  }
}`, Kt = (e) => e ? "/" + e + "/graphql" : "graphql", Rf = (e, n, t) => {
  const i = nl(e), o = `mutation insert($value:[${n}Input]){insert(${n}:$value){message}}`;
  return i.append("query", o), Ue.post(Kt(t), i);
}, Ff = (e, n, t) => {
  const i = nl(e), o = `mutation update($value:[${n}Input]){update(${n}:$value){message}}`;
  return i.append("query", o), Ue.post(Kt(t), i);
}, kf = async (e, n, t) => {
  const i = `mutation delete($pkey:[${n}Input]){delete(${n}:$pkey){message}}`, r = { pkey: [await ni(e, n, t)] };
  return Ue.post(Kt(t), { query: i, variables: r });
}, Uf = (e, n) => {
  const t = `mutation {truncate(tables:"${e}" async:true){taskId message}}`;
  return Ue.post(Kt(n), { query: t });
}, _t = async (e) => {
  const n = e || "CACHE_OF_CURRENT_SCHEMA";
  if (On.has(n))
    return On.get(n);
  const t = Ue.post(Kt(e), { query: Cf }).then((i) => {
    const o = i.data.data._schema;
    return We(o);
  }).catch((i) => {
    throw console.log(i), On.delete(n), i;
  });
  return On.set(n, t), t;
}, po = async (e, n, t) => {
  const i = n.limit ? n.limit : 20, o = n.offset ? n.offset : 0, r = n.expandLevel ?? 2, s = n.searchTerms ? ',search:"' + n.searchTerms.trim() + '"' : "", a = t.id, l = await tl(a, e, r), d = `query ${e}( $filter:${e}Filter, $orderby:[${e}orderby] ) {
        ${e}(
          filter:$filter,
          limit:${i}, 
          offset:${o}${s},
          orderby:$orderby
          )
          {
            ${l}
          }
          ${e}_agg( filter:$filter${s} ) {
            count
          }
        }`, f = n.filter ? n.filter : {}, g = n.orderby ? [n.orderby] : [];
  return (await Ue.post(Kt(a), {
    query: d,
    variables: { filter: f, orderby: g }
  }).catch((R) => {
    throw console.log(R), R;
  }))?.data.data;
}, Ef = async (e, n) => {
  const t = `query ${e} {
        ${e}(
          limit:100000
          orderby: { order: ASC }
          )
          {
          	order 
            name 
            label 
            parent { order name label } 
            children { order name label parent { name } } 
          }
        }`;
  return (await Ue.post(Kt(n), {
    query: t
  }).catch((o) => {
    throw console.log(o), o;
  }))?.data.data[e];
}, hs = async (e) => (await Ge(Kt(e), "{_settings{key, value}}"))._settings, ho = /* @__PURE__ */ new Map(), Sf = (e) => (ho.has(e) || ho.set(
  e,
  Ge(
    Kt(e),
    "{_session{tablePermissions{id,name,canView,canInsert,canUpdate,canDelete,isRowLevel}}}"
  ).then((n) => n?._session?.tablePermissions ?? [])
), ho.get(e)), fr = async (e, n, t = []) => {
  const i = (o) => o.id === n || o.name === n;
  return t.find(i) ?? (e ? (await Sf(e)).find(i) : void 0);
}, Ge = async (e, n, t) => {
  const i = { query: n };
  return t && (i.variables = t), Ue.post(e, i).then((o) => o?.data?.data).catch((o) => {
    throw o.response?.data?.errors?.map((s) => s.message).join(". ") || o.message;
  });
};
async function ni(e, n, t) {
  const i = await _t(t), o = i.tables.find(
    (r) => r.id === n
  );
  if (o?.columns)
    return await o.columns.reduce(
      async (r, s) => {
        let a = await r;
        const l = e[s.id];
        return s.key === 1 && (l || l === 0) && (a[s.id] = await Za(
          l,
          s,
          s.refSchemaId || i.id
        )), a;
      },
      Promise.resolve({})
    );
  throw new Error("Empty columns in metadata");
}
const pr = JSON, Tf = (e) => e.toUpperCase(), If = (e) => {
  const n = {};
  return e.forEach((t, i) => {
    n[i] = t;
  }), n;
}, Df = (e, n, t) => e.document ? e : {
  document: e,
  variables: n,
  requestHeaders: t,
  signal: void 0
}, Of = (e, n, t) => e.query ? e : {
  query: e,
  variables: n,
  requestHeaders: t,
  signal: void 0
}, _f = (e, n) => e.documents ? e : {
  documents: e,
  requestHeaders: n,
  signal: void 0
}, Pf = (e, n, ...t) => {
  const [i, o] = t;
  return e.document ? e : {
    url: e,
    document: n,
    variables: i,
    requestHeaders: o,
    signal: void 0
  };
};
function wi(e, n) {
  if (!!!e)
    throw new Error(n);
}
function Mf(e) {
  return typeof e == "object" && e !== null;
}
function Lf(e, n) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Nf = /\r\n|[\n\r]/g;
function _o(e, n) {
  let t = 0, i = 1;
  for (const o of e.body.matchAll(Nf)) {
    if (typeof o.index == "number" || Lf(!1), o.index >= n)
      break;
    t = o.index + o[0].length, i += 1;
  }
  return {
    line: i,
    column: n + 1 - t
  };
}
function Bf(e) {
  return il(
    e.source,
    _o(e.source, e.start)
  );
}
function il(e, n) {
  const t = e.locationOffset.column - 1, i = "".padStart(t) + e.body, o = n.line - 1, r = e.locationOffset.line - 1, s = n.line + r, a = n.line === 1 ? t : 0, l = n.column + a, d = `${e.name}:${s}:${l}
`, f = i.split(/\r\n|[\n\r]/g), g = f[o];
  if (g.length > 120) {
    const A = Math.floor(l / 80), R = l % 80, F = [];
    for (let y = 0; y < g.length; y += 80)
      F.push(g.slice(y, y + 80));
    return d + ms([
      [`${s} |`, F[0]],
      ...F.slice(1, A + 1).map((y) => ["|", y]),
      ["|", "^".padStart(R)],
      ["|", F[A + 1]]
    ]);
  }
  return d + ms([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, f[o - 1]],
    [`${s} |`, g],
    ["|", "^".padStart(l)],
    [`${s + 1} |`, f[o + 1]]
  ]);
}
function ms(e) {
  const n = e.filter(([i, o]) => o !== void 0), t = Math.max(...n.map(([i]) => i.length));
  return n.map(([i, o]) => i.padStart(t) + (o ? " " + o : "")).join(`
`);
}
function xf(e) {
  const n = e[0];
  return n == null || "kind" in n || "length" in n ? {
    nodes: n,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : n;
}
class hr extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(n, ...t) {
    var i, o, r;
    const { nodes: s, source: a, positions: l, path: d, originalError: f, extensions: g } = xf(t);
    super(n), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = f ?? void 0, this.nodes = As(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const A = As(
      (i = this.nodes) === null || i === void 0 ? void 0 : i.map((F) => F.loc).filter((F) => F != null)
    );
    this.source = a ?? (A == null || (o = A[0]) === null || o === void 0 ? void 0 : o.source), this.positions = l ?? A?.map((F) => F.start), this.locations = l && a ? l.map((F) => _o(a, F)) : A?.map((F) => _o(F.source, F.start));
    const R = Mf(
      f?.extensions
    ) ? f?.extensions : void 0;
    this.extensions = (r = g ?? R) !== null && r !== void 0 ? r : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), f != null && f.stack ? Object.defineProperty(this, "stack", {
      value: f.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, hr) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let n = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (n += `

` + Bf(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        n += `

` + il(this.source, t);
    return n;
  }
  toJSON() {
    const n = {
      message: this.message
    };
    return this.locations != null && (n.locations = this.locations), this.path != null && (n.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (n.extensions = this.extensions), n;
  }
}
function As(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function qe(e, n, t) {
  return new hr(`Syntax Error: ${t}`, {
    source: e,
    positions: [n]
  });
}
class qf {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(n, t, i) {
    this.start = n.start, this.end = t.end, this.startToken = n, this.endToken = t, this.source = i;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class ol {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(n, t, i, o, r, s) {
    this.kind = n, this.start = t, this.end = i, this.line = o, this.column = r, this.value = s, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const rl = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "description",
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: [
    "description",
    "variable",
    "type",
    "defaultValue",
    "directives"
  ],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "description",
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"],
  TypeCoordinate: ["name"],
  MemberCoordinate: ["name", "memberName"],
  ArgumentCoordinate: ["name", "fieldName", "argumentName"],
  DirectiveCoordinate: ["name"],
  DirectiveArgumentCoordinate: ["name", "argumentName"]
}, Vf = new Set(Object.keys(rl));
function gs(e) {
  const n = e?.kind;
  return typeof n == "string" && Vf.has(n);
}
var cn;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(cn || (cn = {}));
var Po;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Po || (Po = {}));
var oe;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension", e.TYPE_COORDINATE = "TypeCoordinate", e.MEMBER_COORDINATE = "MemberCoordinate", e.ARGUMENT_COORDINATE = "ArgumentCoordinate", e.DIRECTIVE_COORDINATE = "DirectiveCoordinate", e.DIRECTIVE_ARGUMENT_COORDINATE = "DirectiveArgumentCoordinate";
})(oe || (oe = {}));
function Mo(e) {
  return e === 9 || e === 32;
}
function Hn(e) {
  return e >= 48 && e <= 57;
}
function sl(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function al(e) {
  return sl(e) || e === 95;
}
function jf(e) {
  return sl(e) || Hn(e) || e === 95;
}
function Hf(e) {
  var n;
  let t = Number.MAX_SAFE_INTEGER, i = null, o = -1;
  for (let s = 0; s < e.length; ++s) {
    var r;
    const a = e[s], l = Gf(a);
    l !== a.length && (i = (r = i) !== null && r !== void 0 ? r : s, o = s, s !== 0 && l < t && (t = l));
  }
  return e.map((s, a) => a === 0 ? s : s.slice(t)).slice(
    (n = i) !== null && n !== void 0 ? n : 0,
    o + 1
  );
}
function Gf(e) {
  let n = 0;
  for (; n < e.length && Mo(e.charCodeAt(n)); )
    ++n;
  return n;
}
function Qf(e, n) {
  const t = e.replace(/"""/g, '\\"""'), i = t.split(/\r\n|[\n\r]/g), o = i.length === 1, r = i.length > 1 && i.slice(1).every((R) => R.length === 0 || Mo(R.charCodeAt(0))), s = t.endsWith('\\"""'), a = e.endsWith('"') && !s, l = e.endsWith("\\"), d = a || l, f = (
    // add leading and trailing new lines only if it improves readability
    !o || e.length > 70 || d || r || s
  );
  let g = "";
  const A = o && Mo(e.charCodeAt(0));
  return (f && !A || r) && (g += `
`), g += t, (f || d) && (g += `
`), '"""' + g + '"""';
}
var L;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.DOT = ".", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(L || (L = {}));
class $f {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(n) {
    const t = new ol(L.SOF, 0, 0, 0, 0);
    this.source = n, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let n = this.token;
    if (n.kind !== L.EOF)
      do
        if (n.next)
          n = n.next;
        else {
          const t = zf(this, n.end);
          n.next = t, t.prev = n, n = t;
        }
      while (n.kind === L.COMMENT);
    return n;
  }
}
function Jf(e) {
  return e === L.BANG || e === L.DOLLAR || e === L.AMP || e === L.PAREN_L || e === L.PAREN_R || e === L.DOT || e === L.SPREAD || e === L.COLON || e === L.EQUALS || e === L.AT || e === L.BRACKET_L || e === L.BRACKET_R || e === L.BRACE_L || e === L.PIPE || e === L.BRACE_R;
}
function Rn(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Gi(e, n) {
  return ll(e.charCodeAt(n)) && ul(e.charCodeAt(n + 1));
}
function ll(e) {
  return e >= 55296 && e <= 56319;
}
function ul(e) {
  return e >= 56320 && e <= 57343;
}
function on(e, n) {
  const t = e.source.body.codePointAt(n);
  if (t === void 0)
    return L.EOF;
  if (t >= 32 && t <= 126) {
    const i = String.fromCodePoint(t);
    return i === '"' ? `'"'` : `"${i}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function Be(e, n, t, i, o) {
  const r = e.line, s = 1 + t - e.lineStart;
  return new ol(n, t, i, r, s, o);
}
function zf(e, n) {
  const t = e.source.body, i = t.length;
  let o = n;
  for (; o < i; ) {
    const r = t.charCodeAt(o);
    switch (r) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 65279:
      // <BOM>
      case 9:
      // \t
      case 32:
      // <space>
      case 44:
        ++o;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"
      case 10:
        ++o, ++e.line, e.lineStart = o;
        continue;
      case 13:
        t.charCodeAt(o + 1) === 10 ? o += 2 : ++o, ++e.line, e.lineStart = o;
        continue;
      // Comment
      case 35:
        return Wf(e, o);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
      case 33:
        return Be(e, L.BANG, o, o + 1);
      case 36:
        return Be(e, L.DOLLAR, o, o + 1);
      case 38:
        return Be(e, L.AMP, o, o + 1);
      case 40:
        return Be(e, L.PAREN_L, o, o + 1);
      case 41:
        return Be(e, L.PAREN_R, o, o + 1);
      case 46:
        if (t.charCodeAt(o + 1) === 46 && t.charCodeAt(o + 2) === 46)
          return Be(e, L.SPREAD, o, o + 3);
        break;
      case 58:
        return Be(e, L.COLON, o, o + 1);
      case 61:
        return Be(e, L.EQUALS, o, o + 1);
      case 64:
        return Be(e, L.AT, o, o + 1);
      case 91:
        return Be(e, L.BRACKET_L, o, o + 1);
      case 93:
        return Be(e, L.BRACKET_R, o, o + 1);
      case 123:
        return Be(e, L.BRACE_L, o, o + 1);
      case 124:
        return Be(e, L.PIPE, o, o + 1);
      case 125:
        return Be(e, L.BRACE_R, o, o + 1);
      // StringValue
      case 34:
        return t.charCodeAt(o + 1) === 34 && t.charCodeAt(o + 2) === 34 ? np(e, o) : Xf(e, o);
    }
    if (Hn(r) || r === 45)
      return Yf(e, o, r);
    if (al(r))
      return ip(e, o);
    throw qe(
      e.source,
      o,
      r === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Rn(r) || Gi(t, o) ? `Unexpected character: ${on(e, o)}.` : `Invalid character: ${on(e, o)}.`
    );
  }
  return Be(e, L.EOF, i, i);
}
function Wf(e, n) {
  const t = e.source.body, i = t.length;
  let o = n + 1;
  for (; o < i; ) {
    const r = t.charCodeAt(o);
    if (r === 10 || r === 13)
      break;
    if (Rn(r))
      ++o;
    else if (Gi(t, o))
      o += 2;
    else
      break;
  }
  return Be(
    e,
    L.COMMENT,
    n,
    o,
    t.slice(n + 1, o)
  );
}
function Yf(e, n, t) {
  const i = e.source.body;
  let o = n, r = t, s = !1;
  if (r === 45 && (r = i.charCodeAt(++o)), r === 48) {
    if (r = i.charCodeAt(++o), Hn(r))
      throw qe(
        e.source,
        o,
        `Invalid number, unexpected digit after 0: ${on(
          e,
          o
        )}.`
      );
  } else
    o = mo(e, o, r), r = i.charCodeAt(o);
  if (r === 46 && (s = !0, r = i.charCodeAt(++o), o = mo(e, o, r), r = i.charCodeAt(o)), (r === 69 || r === 101) && (s = !0, r = i.charCodeAt(++o), (r === 43 || r === 45) && (r = i.charCodeAt(++o)), o = mo(e, o, r), r = i.charCodeAt(o)), r === 46 || al(r))
    throw qe(
      e.source,
      o,
      `Invalid number, expected digit but got: ${on(
        e,
        o
      )}.`
    );
  return Be(
    e,
    s ? L.FLOAT : L.INT,
    n,
    o,
    i.slice(n, o)
  );
}
function mo(e, n, t) {
  if (!Hn(t))
    throw qe(
      e.source,
      n,
      `Invalid number, expected digit but got: ${on(
        e,
        n
      )}.`
    );
  const i = e.source.body;
  let o = n + 1;
  for (; Hn(i.charCodeAt(o)); )
    ++o;
  return o;
}
function Xf(e, n) {
  const t = e.source.body, i = t.length;
  let o = n + 1, r = o, s = "";
  for (; o < i; ) {
    const a = t.charCodeAt(o);
    if (a === 34)
      return s += t.slice(r, o), Be(e, L.STRING, n, o + 1, s);
    if (a === 92) {
      s += t.slice(r, o);
      const l = t.charCodeAt(o + 1) === 117 ? t.charCodeAt(o + 2) === 123 ? Zf(e, o) : ep(e, o) : tp(e, o);
      s += l.value, o += l.size, r = o;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (Rn(a))
      ++o;
    else if (Gi(t, o))
      o += 2;
    else
      throw qe(
        e.source,
        o,
        `Invalid character within String: ${on(
          e,
          o
        )}.`
      );
  }
  throw qe(e.source, o, "Unterminated string.");
}
function Zf(e, n) {
  const t = e.source.body;
  let i = 0, o = 3;
  for (; o < 12; ) {
    const r = t.charCodeAt(n + o++);
    if (r === 125) {
      if (o < 5 || !Rn(i))
        break;
      return {
        value: String.fromCodePoint(i),
        size: o
      };
    }
    if (i = i << 4 | _n(r), i < 0)
      break;
  }
  throw qe(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${t.slice(
      n,
      n + o
    )}".`
  );
}
function ep(e, n) {
  const t = e.source.body, i = ys(t, n + 2);
  if (Rn(i))
    return {
      value: String.fromCodePoint(i),
      size: 6
    };
  if (ll(i) && t.charCodeAt(n + 6) === 92 && t.charCodeAt(n + 7) === 117) {
    const o = ys(t, n + 8);
    if (ul(o))
      return {
        value: String.fromCodePoint(i, o),
        size: 12
      };
  }
  throw qe(
    e.source,
    n,
    `Invalid Unicode escape sequence: "${t.slice(n, n + 6)}".`
  );
}
function ys(e, n) {
  return _n(e.charCodeAt(n)) << 12 | _n(e.charCodeAt(n + 1)) << 8 | _n(e.charCodeAt(n + 2)) << 4 | _n(e.charCodeAt(n + 3));
}
function _n(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function tp(e, n) {
  const t = e.source.body;
  switch (t.charCodeAt(n + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw qe(
    e.source,
    n,
    `Invalid character escape sequence: "${t.slice(
      n,
      n + 2
    )}".`
  );
}
function np(e, n) {
  const t = e.source.body, i = t.length;
  let o = e.lineStart, r = n + 3, s = r, a = "";
  const l = [];
  for (; r < i; ) {
    const d = t.charCodeAt(r);
    if (d === 34 && t.charCodeAt(r + 1) === 34 && t.charCodeAt(r + 2) === 34) {
      a += t.slice(s, r), l.push(a);
      const f = Be(
        e,
        L.BLOCK_STRING,
        n,
        r + 3,
        // Return a string of the lines joined with U+000A.
        Hf(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = o, f;
    }
    if (d === 92 && t.charCodeAt(r + 1) === 34 && t.charCodeAt(r + 2) === 34 && t.charCodeAt(r + 3) === 34) {
      a += t.slice(s, r), s = r + 1, r += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      a += t.slice(s, r), l.push(a), d === 13 && t.charCodeAt(r + 1) === 10 ? r += 2 : ++r, a = "", s = r, o = r;
      continue;
    }
    if (Rn(d))
      ++r;
    else if (Gi(t, r))
      r += 2;
    else
      throw qe(
        e.source,
        r,
        `Invalid character within String: ${on(
          e,
          r
        )}.`
      );
  }
  throw qe(e.source, r, "Unterminated string.");
}
function ip(e, n) {
  const t = e.source.body, i = t.length;
  let o = n + 1;
  for (; o < i; ) {
    const r = t.charCodeAt(o);
    if (jf(r))
      ++o;
    else
      break;
  }
  return Be(
    e,
    L.NAME,
    n,
    o,
    t.slice(n, o)
  );
}
const op = 10, dl = 2;
function mr(e) {
  return Qi(e, []);
}
function Qi(e, n) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return rp(e, n);
    default:
      return String(e);
  }
}
function rp(e, n) {
  if (e === null)
    return "null";
  if (n.includes(e))
    return "[Circular]";
  const t = [...n, e];
  if (sp(e)) {
    const i = e.toJSON();
    if (i !== e)
      return typeof i == "string" ? i : Qi(i, t);
  } else if (Array.isArray(e))
    return lp(e, t);
  return ap(e, t);
}
function sp(e) {
  return typeof e.toJSON == "function";
}
function ap(e, n) {
  const t = Object.entries(e);
  return t.length === 0 ? "{}" : n.length > dl ? "[" + up(e) + "]" : "{ " + t.map(
    ([o, r]) => o + ": " + Qi(r, n)
  ).join(", ") + " }";
}
function lp(e, n) {
  if (e.length === 0)
    return "[]";
  if (n.length > dl)
    return "[Array]";
  const t = Math.min(op, e.length), i = e.length - t, o = [];
  for (let r = 0; r < t; ++r)
    o.push(Qi(e[r], n));
  return i === 1 ? o.push("... 1 more item") : i > 1 && o.push(`... ${i} more items`), "[" + o.join(", ") + "]";
}
function up(e) {
  const n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (n === "Object" && typeof e.constructor == "function") {
    const t = e.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return n;
}
const dp = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", cp = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  dp ? function(n, t) {
    return n instanceof t;
  } : function(n, t) {
    if (n instanceof t)
      return !0;
    if (typeof n == "object" && n !== null) {
      var i;
      const o = t.prototype[Symbol.toStringTag], r = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in n ? n[Symbol.toStringTag] : (i = n.constructor) === null || i === void 0 ? void 0 : i.name
      );
      if (o === r) {
        const s = mr(n);
        throw new Error(`Cannot use ${o} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class cl {
  constructor(n, t = "GraphQL request", i = {
    line: 1,
    column: 1
  }) {
    typeof n == "string" || wi(!1, `Body must be a string. Received: ${mr(n)}.`), this.body = n, this.name = t, this.locationOffset = i, this.locationOffset.line > 0 || wi(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || wi(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function fp(e) {
  return cp(e, cl);
}
function pp(e, n) {
  const t = new hp(e, n), i = t.parseDocument();
  return Object.defineProperty(i, "tokenCount", {
    enumerable: !1,
    value: t.tokenCount
  }), i;
}
class hp {
  constructor(n, t = {}) {
    const { lexer: i, ...o } = t;
    if (i)
      this._lexer = i;
    else {
      const r = fp(n) ? n : new cl(n);
      this._lexer = new $f(r);
    }
    this._options = o, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const n = this.expectToken(L.NAME);
    return this.node(n, {
      kind: oe.NAME,
      value: n.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: oe.DOCUMENT,
      definitions: this.many(
        L.SOF,
        this.parseDefinition,
        L.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(L.BRACE_L))
      return this.parseOperationDefinition();
    const n = this.peekDescription(), t = n ? this._lexer.lookahead() : this._lexer.token;
    if (n && t.kind === L.BRACE_L)
      throw qe(
        this._lexer.source,
        this._lexer.token.start,
        "Unexpected description, descriptions are not supported on shorthand queries."
      );
    if (t.kind === L.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
      }
      if (n)
        throw qe(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, only GraphQL definitions support descriptions."
        );
      if (t.value === "extend")
        return this.parseTypeSystemExtension();
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const n = this._lexer.token;
    if (this.peek(L.BRACE_L))
      return this.node(n, {
        kind: oe.OPERATION_DEFINITION,
        operation: cn.QUERY,
        description: void 0,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseDescription(), i = this.parseOperationType();
    let o;
    return this.peek(L.NAME) && (o = this.parseName()), this.node(n, {
      kind: oe.OPERATION_DEFINITION,
      operation: i,
      description: t,
      name: o,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const n = this.expectToken(L.NAME);
    switch (n.value) {
      case "query":
        return cn.QUERY;
      case "mutation":
        return cn.MUTATION;
      case "subscription":
        return cn.SUBSCRIPTION;
    }
    throw this.unexpected(n);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      L.PAREN_L,
      this.parseVariableDefinition,
      L.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: oe.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(L.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(L.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const n = this._lexer.token;
    return this.expectToken(L.DOLLAR), this.node(n, {
      kind: oe.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: oe.SELECTION_SET,
      selections: this.many(
        L.BRACE_L,
        this.parseSelection,
        L.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(L.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const n = this._lexer.token, t = this.parseName();
    let i, o;
    return this.expectOptionalToken(L.COLON) ? (i = t, o = this.parseName()) : o = t, this.node(n, {
      kind: oe.FIELD,
      alias: i,
      name: o,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(L.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(n) {
    const t = n ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(L.PAREN_L, t, L.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(n = !1) {
    const t = this._lexer.token, i = this.parseName();
    return this.expectToken(L.COLON), this.node(t, {
      kind: oe.ARGUMENT,
      name: i,
      value: this.parseValueLiteral(n)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const n = this._lexer.token;
    this.expectToken(L.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(L.NAME) ? this.node(n, {
      kind: oe.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(n, {
      kind: oe.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(n, {
      kind: oe.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(n, {
      kind: oe.FRAGMENT_DEFINITION,
      description: t,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(n) {
    const t = this._lexer.token;
    switch (t.kind) {
      case L.BRACKET_L:
        return this.parseList(n);
      case L.BRACE_L:
        return this.parseObject(n);
      case L.INT:
        return this.advanceLexer(), this.node(t, {
          kind: oe.INT,
          value: t.value
        });
      case L.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: oe.FLOAT,
          value: t.value
        });
      case L.STRING:
      case L.BLOCK_STRING:
        return this.parseStringLiteral();
      case L.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: oe.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: oe.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: oe.NULL
            });
          default:
            return this.node(t, {
              kind: oe.ENUM,
              value: t.value
            });
        }
      case L.DOLLAR:
        if (n)
          if (this.expectToken(L.DOLLAR), this._lexer.token.kind === L.NAME) {
            const i = this._lexer.token.value;
            throw qe(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${i}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const n = this._lexer.token;
    return this.advanceLexer(), this.node(n, {
      kind: oe.STRING,
      value: n.value,
      block: n.kind === L.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(n) {
    const t = () => this.parseValueLiteral(n);
    return this.node(this._lexer.token, {
      kind: oe.LIST,
      values: this.any(L.BRACKET_L, t, L.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(n) {
    const t = () => this.parseObjectField(n);
    return this.node(this._lexer.token, {
      kind: oe.OBJECT,
      fields: this.any(L.BRACE_L, t, L.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(n) {
    const t = this._lexer.token, i = this.parseName();
    return this.expectToken(L.COLON), this.node(t, {
      kind: oe.OBJECT_FIELD,
      name: i,
      value: this.parseValueLiteral(n)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(n) {
    const t = [];
    for (; this.peek(L.AT); )
      t.push(this.parseDirective(n));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(n) {
    const t = this._lexer.token;
    return this.expectToken(L.AT), this.node(t, {
      kind: oe.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(n)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const n = this._lexer.token;
    let t;
    if (this.expectOptionalToken(L.BRACKET_L)) {
      const i = this.parseTypeReference();
      this.expectToken(L.BRACKET_R), t = this.node(n, {
        kind: oe.LIST_TYPE,
        type: i
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(L.BANG) ? this.node(n, {
      kind: oe.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: oe.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(L.STRING) || this.peek(L.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const i = this.parseConstDirectives(), o = this.many(
      L.BRACE_L,
      this.parseOperationTypeDefinition,
      L.BRACE_R
    );
    return this.node(n, {
      kind: oe.SCHEMA_DEFINITION,
      description: t,
      directives: i,
      operationTypes: o
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const n = this._lexer.token, t = this.parseOperationType();
    this.expectToken(L.COLON);
    const i = this.parseNamedType();
    return this.node(n, {
      kind: oe.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: i
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const i = this.parseName(), o = this.parseConstDirectives();
    return this.node(n, {
      kind: oe.SCALAR_TYPE_DEFINITION,
      description: t,
      name: i,
      directives: o
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const i = this.parseName(), o = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(n, {
      kind: oe.OBJECT_TYPE_DEFINITION,
      description: t,
      name: i,
      interfaces: o,
      directives: r,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(L.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      L.BRACE_L,
      this.parseFieldDefinition,
      L.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const n = this._lexer.token, t = this.parseDescription(), i = this.parseName(), o = this.parseArgumentDefs();
    this.expectToken(L.COLON);
    const r = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(n, {
      kind: oe.FIELD_DEFINITION,
      description: t,
      name: i,
      arguments: o,
      type: r,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      L.PAREN_L,
      this.parseInputValueDef,
      L.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const n = this._lexer.token, t = this.parseDescription(), i = this.parseName();
    this.expectToken(L.COLON);
    const o = this.parseTypeReference();
    let r;
    this.expectOptionalToken(L.EQUALS) && (r = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(n, {
      kind: oe.INPUT_VALUE_DEFINITION,
      description: t,
      name: i,
      type: o,
      defaultValue: r,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const i = this.parseName(), o = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(n, {
      kind: oe.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: i,
      interfaces: o,
      directives: r,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const i = this.parseName(), o = this.parseConstDirectives(), r = this.parseUnionMemberTypes();
    return this.node(n, {
      kind: oe.UNION_TYPE_DEFINITION,
      description: t,
      name: i,
      directives: o,
      types: r
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(L.EQUALS) ? this.delimitedMany(L.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const i = this.parseName(), o = this.parseConstDirectives(), r = this.parseEnumValuesDefinition();
    return this.node(n, {
      kind: oe.ENUM_TYPE_DEFINITION,
      description: t,
      name: i,
      directives: o,
      values: r
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      L.BRACE_L,
      this.parseEnumValueDefinition,
      L.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const n = this._lexer.token, t = this.parseDescription(), i = this.parseEnumValueName(), o = this.parseConstDirectives();
    return this.node(n, {
      kind: oe.ENUM_VALUE_DEFINITION,
      description: t,
      name: i,
      directives: o
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw qe(
        this._lexer.source,
        this._lexer.token.start,
        `${ci(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const i = this.parseName(), o = this.parseConstDirectives(), r = this.parseInputFieldsDefinition();
    return this.node(n, {
      kind: oe.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: i,
      directives: o,
      fields: r
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      L.BRACE_L,
      this.parseInputValueDef,
      L.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const n = this._lexer.lookahead();
    if (n.kind === L.NAME)
      switch (n.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(n);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), i = this.optionalMany(
      L.BRACE_L,
      this.parseOperationTypeDefinition,
      L.BRACE_R
    );
    if (t.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: i
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), i = this.parseConstDirectives();
    if (i.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: i
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (i.length === 0 && o.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: i,
      directives: o,
      fields: r
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (i.length === 0 && o.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: i,
      directives: o,
      fields: r
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    if (i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.UNION_TYPE_EXTENSION,
      name: t,
      directives: i,
      types: o
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    if (i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.ENUM_TYPE_EXTENSION,
      name: t,
      directives: i,
      values: o
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const n = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    if (i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(n, {
      kind: oe.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const n = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(L.AT);
    const i = this.parseName(), o = this.parseArgumentDefs(), r = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const s = this.parseDirectiveLocations();
    return this.node(n, {
      kind: oe.DIRECTIVE_DEFINITION,
      description: t,
      name: i,
      arguments: o,
      repeatable: r,
      locations: s
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(L.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const n = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Po, t.value))
      return t;
    throw this.unexpected(n);
  }
  // Schema Coordinates
  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */
  parseSchemaCoordinate() {
    const n = this._lexer.token, t = this.expectOptionalToken(L.AT), i = this.parseName();
    let o;
    !t && this.expectOptionalToken(L.DOT) && (o = this.parseName());
    let r;
    return (t || o) && this.expectOptionalToken(L.PAREN_L) && (r = this.parseName(), this.expectToken(L.COLON), this.expectToken(L.PAREN_R)), t ? r ? this.node(n, {
      kind: oe.DIRECTIVE_ARGUMENT_COORDINATE,
      name: i,
      argumentName: r
    }) : this.node(n, {
      kind: oe.DIRECTIVE_COORDINATE,
      name: i
    }) : o ? r ? this.node(n, {
      kind: oe.ARGUMENT_COORDINATE,
      name: i,
      fieldName: o,
      argumentName: r
    }) : this.node(n, {
      kind: oe.MEMBER_COORDINATE,
      name: i,
      memberName: o
    }) : this.node(n, {
      kind: oe.TYPE_COORDINATE,
      name: i
    });
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(n, t) {
    return this._options.noLocation !== !0 && (t.loc = new qf(
      n,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(n) {
    return this._lexer.token.kind === n;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(n) {
    const t = this._lexer.token;
    if (t.kind === n)
      return this.advanceLexer(), t;
    throw qe(
      this._lexer.source,
      t.start,
      `Expected ${fl(n)}, found ${ci(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(n) {
    return this._lexer.token.kind === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(n) {
    const t = this._lexer.token;
    if (t.kind === L.NAME && t.value === n)
      this.advanceLexer();
    else
      throw qe(
        this._lexer.source,
        t.start,
        `Expected "${n}", found ${ci(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(n) {
    const t = this._lexer.token;
    return t.kind === L.NAME && t.value === n ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(n) {
    const t = n ?? this._lexer.token;
    return qe(
      this._lexer.source,
      t.start,
      `Unexpected ${ci(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(n, t, i) {
    this.expectToken(n);
    const o = [];
    for (; !this.expectOptionalToken(i); )
      o.push(t.call(this));
    return o;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(n, t, i) {
    if (this.expectOptionalToken(n)) {
      const o = [];
      do
        o.push(t.call(this));
      while (!this.expectOptionalToken(i));
      return o;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(n, t, i) {
    this.expectToken(n);
    const o = [];
    do
      o.push(t.call(this));
    while (!this.expectOptionalToken(i));
    return o;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(n, t) {
    this.expectOptionalToken(n);
    const i = [];
    do
      i.push(t.call(this));
    while (this.expectOptionalToken(n));
    return i;
  }
  advanceLexer() {
    const { maxTokens: n } = this._options, t = this._lexer.advance();
    if (t.kind !== L.EOF && (++this._tokenCounter, n !== void 0 && this._tokenCounter > n))
      throw qe(
        this._lexer.source,
        t.start,
        `Document contains more that ${n} tokens. Parsing aborted.`
      );
  }
}
function ci(e) {
  const n = e.value;
  return fl(e.kind) + (n != null ? ` "${n}"` : "");
}
function fl(e) {
  return Jf(e) ? `"${e}"` : e;
}
function mp(e) {
  return `"${e.replace(Ap, gp)}"`;
}
const Ap = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function gp(e) {
  return yp[e.charCodeAt(0)];
}
const yp = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Kp = Object.freeze({});
function bp(e, n, t = rl) {
  const i = /* @__PURE__ */ new Map();
  for (const v of Object.values(oe))
    i.set(v, vp(n, v));
  let o, r = Array.isArray(e), s = [e], a = -1, l = [], d = e, f, g;
  const A = [], R = [];
  do {
    a++;
    const v = a === s.length, I = v && l.length !== 0;
    if (v) {
      if (f = R.length === 0 ? void 0 : A[A.length - 1], d = g, g = R.pop(), I)
        if (r) {
          d = d.slice();
          let D = 0;
          for (const [V, q] of l) {
            const x = V - D;
            q === null ? (d.splice(x, 1), D++) : d[x] = q;
          }
        } else {
          d = { ...d };
          for (const [D, V] of l)
            d[D] = V;
        }
      a = o.index, s = o.keys, l = o.edits, r = o.inArray, o = o.prev;
    } else if (g) {
      if (f = r ? a : s[a], d = g[f], d == null)
        continue;
      A.push(f);
    }
    let M;
    if (!Array.isArray(d)) {
      var F, y;
      gs(d) || wi(!1, `Invalid AST Node: ${mr(d)}.`);
      const D = v ? (F = i.get(d.kind)) === null || F === void 0 ? void 0 : F.leave : (y = i.get(d.kind)) === null || y === void 0 ? void 0 : y.enter;
      if (M = D?.call(n, d, f, g, A, R), M === Kp)
        break;
      if (M === !1) {
        if (!v) {
          A.pop();
          continue;
        }
      } else if (M !== void 0 && (l.push([f, M]), !v))
        if (gs(M))
          d = M;
        else {
          A.pop();
          continue;
        }
    }
    if (M === void 0 && I && l.push([f, d]), v)
      A.pop();
    else {
      var T;
      o = {
        inArray: r,
        index: a,
        keys: s,
        edits: l,
        prev: o
      }, r = Array.isArray(d), s = r ? d : (T = t[d.kind]) !== null && T !== void 0 ? T : [], a = -1, l = [], g && R.push(g), g = d;
    }
  } while (o !== void 0);
  return l.length !== 0 ? l[l.length - 1][1] : e;
}
function vp(e, n) {
  const t = e[n];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function wp(e) {
  return bp(e, Rp);
}
const Cp = 80, Rp = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Y(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const n = Ao(e.variableDefinitions) ? ce(`(
`, Y(e.variableDefinitions, `
`), `
)`) : ce("(", Y(e.variableDefinitions, ", "), ")"), t = ce("", e.description, `
`) + Y(
        [
          e.operation,
          Y([e.name, n]),
          Y(e.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: n, defaultValue: t, directives: i, description: o }) => ce("", o, `
`) + e + ": " + n + ce(" = ", t) + ce(" ", Y(i, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => Ft(e)
  },
  Field: {
    leave({ alias: e, name: n, arguments: t, directives: i, selectionSet: o }) {
      const r = ce("", e, ": ") + n;
      let s = r + ce("(", Y(t, ", "), ")");
      return s.length > Cp && (s = r + ce(`(
`, Ci(Y(t, `
`)), `
)`)), Y([s, Y(i, " "), o], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: n }) => "..." + e + ce(" ", Y(n, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: n, selectionSet: t }) => Y(
      [
        "...",
        ce("on ", e),
        Y(n, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({
      name: e,
      typeCondition: n,
      variableDefinitions: t,
      directives: i,
      selectionSet: o,
      description: r
    }) => ce("", r, `
`) + // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    `fragment ${e}${ce("(", Y(t, ", "), ")")} on ${n} ${ce("", Y(i, " "), " ")}` + o
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: n }) => n ? Qf(e) : mp(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Y(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Y(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: n }) => e + ": " + n
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: n }) => "@" + e + ce("(", Y(n, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: n, operationTypes: t }) => ce("", e, `
`) + Y(["schema", Y(n, " "), Ft(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: n }) => e + ": " + n
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: n, directives: t }) => ce("", e, `
`) + Y(["scalar", n, Y(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: t, directives: i, fields: o }) => ce("", e, `
`) + Y(
      [
        "type",
        n,
        ce("implements ", Y(t, " & ")),
        Y(i, " "),
        Ft(o)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: n, arguments: t, type: i, directives: o }) => ce("", e, `
`) + n + (Ao(t) ? ce(`(
`, Ci(Y(t, `
`)), `
)`) : ce("(", Y(t, ", "), ")")) + ": " + i + ce(" ", Y(o, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: n, type: t, defaultValue: i, directives: o }) => ce("", e, `
`) + Y(
      [n + ": " + t, ce("= ", i), Y(o, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: n, interfaces: t, directives: i, fields: o }) => ce("", e, `
`) + Y(
      [
        "interface",
        n,
        ce("implements ", Y(t, " & ")),
        Y(i, " "),
        Ft(o)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, types: i }) => ce("", e, `
`) + Y(
      ["union", n, Y(t, " "), ce("= ", Y(i, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, values: i }) => ce("", e, `
`) + Y(["enum", n, Y(t, " "), Ft(i)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: n, directives: t }) => ce("", e, `
`) + Y([n, Y(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: n, directives: t, fields: i }) => ce("", e, `
`) + Y(["input", n, Y(t, " "), Ft(i)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: n, arguments: t, repeatable: i, locations: o }) => ce("", e, `
`) + "directive @" + n + (Ao(t) ? ce(`(
`, Ci(Y(t, `
`)), `
)`) : ce("(", Y(t, ", "), ")")) + (i ? " repeatable" : "") + " on " + Y(o, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: n }) => Y(
      ["extend schema", Y(e, " "), Ft(n)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: n }) => Y(["extend scalar", e, Y(n, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: t, fields: i }) => Y(
      [
        "extend type",
        e,
        ce("implements ", Y(n, " & ")),
        Y(t, " "),
        Ft(i)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: n, directives: t, fields: i }) => Y(
      [
        "extend interface",
        e,
        ce("implements ", Y(n, " & ")),
        Y(t, " "),
        Ft(i)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: n, types: t }) => Y(
      [
        "extend union",
        e,
        Y(n, " "),
        ce("= ", Y(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: n, values: t }) => Y(["extend enum", e, Y(n, " "), Ft(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: n, fields: t }) => Y(["extend input", e, Y(n, " "), Ft(t)], " ")
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name: e }) => e
  },
  MemberCoordinate: {
    leave: ({ name: e, memberName: n }) => Y([e, ce(".", n)])
  },
  ArgumentCoordinate: {
    leave: ({ name: e, fieldName: n, argumentName: t }) => Y([e, ce(".", n), ce("(", t, ":)")])
  },
  DirectiveCoordinate: {
    leave: ({ name: e }) => Y(["@", e])
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name: e, argumentName: n }) => Y(["@", e, ce("(", n, ":)")])
  }
};
function Y(e, n = "") {
  var t;
  return (t = e?.filter((i) => i).join(n)) !== null && t !== void 0 ? t : "";
}
function Ft(e) {
  return ce(`{
`, Ci(Y(e, `
`)), `
}`);
}
function ce(e, n, t = "") {
  return n != null && n !== "" ? e + n + t : "";
}
function Ci(e) {
  return ce("  ", e.replace(/\n/g, `
  `));
}
function Ao(e) {
  var n;
  return (n = e?.some((t) => t.includes(`
`))) !== null && n !== void 0 ? n : !1;
}
const Ks = (e) => {
  let n;
  const t = e.definitions.filter((i) => i.kind === "OperationDefinition");
  return t.length === 1 && (n = t[0]?.name?.value), n;
}, go = (e) => {
  if (typeof e == "string") {
    let t;
    try {
      const i = pp(e);
      t = Ks(i);
    } catch {
    }
    return { query: e, operationName: t };
  }
  const n = Ks(e);
  return { query: wp(e), operationName: n };
};
class Mn extends Error {
  constructor(n, t) {
    const i = `${Mn.extractMessage(n)}: ${JSON.stringify({
      response: n,
      request: t
    })}`;
    super(i), Object.setPrototypeOf(this, Mn.prototype), this.response = n, this.request = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Mn);
  }
  static extractMessage(n) {
    return n.errors?.[0]?.message ?? `GraphQL Error (Code: ${n.status})`;
  }
}
var fi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pi = { exports: {} }, bs;
function Fp() {
  return bs || (bs = 1, (function(e, n) {
    var t = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof fi < "u" && fi, i = (function() {
      function r() {
        this.fetch = !1, this.DOMException = t.DOMException;
      }
      return r.prototype = t, new r();
    })();
    (function(r) {
      (function(s) {
        var a = typeof r < "u" && r || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof fi < "u" && fi || {}, l = {
          searchParams: "URLSearchParams" in a,
          iterable: "Symbol" in a && "iterator" in Symbol,
          blob: "FileReader" in a && "Blob" in a && (function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          })(),
          formData: "FormData" in a,
          arrayBuffer: "ArrayBuffer" in a
        };
        function d(S) {
          return S && DataView.prototype.isPrototypeOf(S);
        }
        if (l.arrayBuffer)
          var f = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], g = ArrayBuffer.isView || function(S) {
            return S && f.indexOf(Object.prototype.toString.call(S)) > -1;
          };
        function A(S) {
          if (typeof S != "string" && (S = String(S)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(S) || S === "")
            throw new TypeError('Invalid character in header field name: "' + S + '"');
          return S.toLowerCase();
        }
        function R(S) {
          return typeof S != "string" && (S = String(S)), S;
        }
        function F(S) {
          var B = {
            next: function() {
              var ee = S.shift();
              return { done: ee === void 0, value: ee };
            }
          };
          return l.iterable && (B[Symbol.iterator] = function() {
            return B;
          }), B;
        }
        function y(S) {
          this.map = {}, S instanceof y ? S.forEach(function(B, ee) {
            this.append(ee, B);
          }, this) : Array.isArray(S) ? S.forEach(function(B) {
            if (B.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + B.length);
            this.append(B[0], B[1]);
          }, this) : S && Object.getOwnPropertyNames(S).forEach(function(B) {
            this.append(B, S[B]);
          }, this);
        }
        y.prototype.append = function(S, B) {
          S = A(S), B = R(B);
          var ee = this.map[S];
          this.map[S] = ee ? ee + ", " + B : B;
        }, y.prototype.delete = function(S) {
          delete this.map[A(S)];
        }, y.prototype.get = function(S) {
          return S = A(S), this.has(S) ? this.map[S] : null;
        }, y.prototype.has = function(S) {
          return this.map.hasOwnProperty(A(S));
        }, y.prototype.set = function(S, B) {
          this.map[A(S)] = R(B);
        }, y.prototype.forEach = function(S, B) {
          for (var ee in this.map)
            this.map.hasOwnProperty(ee) && S.call(B, this.map[ee], ee, this);
        }, y.prototype.keys = function() {
          var S = [];
          return this.forEach(function(B, ee) {
            S.push(ee);
          }), F(S);
        }, y.prototype.values = function() {
          var S = [];
          return this.forEach(function(B) {
            S.push(B);
          }), F(S);
        }, y.prototype.entries = function() {
          var S = [];
          return this.forEach(function(B, ee) {
            S.push([ee, B]);
          }), F(S);
        }, l.iterable && (y.prototype[Symbol.iterator] = y.prototype.entries);
        function T(S) {
          if (!S._noBody) {
            if (S.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            S.bodyUsed = !0;
          }
        }
        function v(S) {
          return new Promise(function(B, ee) {
            S.onload = function() {
              B(S.result);
            }, S.onerror = function() {
              ee(S.error);
            };
          });
        }
        function I(S) {
          var B = new FileReader(), ee = v(B);
          return B.readAsArrayBuffer(S), ee;
        }
        function M(S) {
          var B = new FileReader(), ee = v(B), pe = /charset=([A-Za-z0-9_-]+)/.exec(S.type), ye = pe ? pe[1] : "utf-8";
          return B.readAsText(S, ye), ee;
        }
        function D(S) {
          for (var B = new Uint8Array(S), ee = new Array(B.length), pe = 0; pe < B.length; pe++)
            ee[pe] = String.fromCharCode(B[pe]);
          return ee.join("");
        }
        function V(S) {
          if (S.slice)
            return S.slice(0);
          var B = new Uint8Array(S.byteLength);
          return B.set(new Uint8Array(S)), B.buffer;
        }
        function q() {
          return this.bodyUsed = !1, this._initBody = function(S) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = S, S ? typeof S == "string" ? this._bodyText = S : l.blob && Blob.prototype.isPrototypeOf(S) ? this._bodyBlob = S : l.formData && FormData.prototype.isPrototypeOf(S) ? this._bodyFormData = S : l.searchParams && URLSearchParams.prototype.isPrototypeOf(S) ? this._bodyText = S.toString() : l.arrayBuffer && l.blob && d(S) ? (this._bodyArrayBuffer = V(S.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(S) || g(S)) ? this._bodyArrayBuffer = V(S) : this._bodyText = S = Object.prototype.toString.call(S) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof S == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(S) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, l.blob && (this.blob = function() {
            var S = T(this);
            if (S)
              return S;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var S = T(this);
              return S || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (l.blob)
                return this.blob().then(I);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var S = T(this);
            if (S)
              return S;
            if (this._bodyBlob)
              return M(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(D(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, l.formData && (this.formData = function() {
            return this.text().then(X);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var x = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function $(S) {
          var B = S.toUpperCase();
          return x.indexOf(B) > -1 ? B : S;
        }
        function z(S, B) {
          if (!(this instanceof z))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          B = B || {};
          var ee = B.body;
          if (S instanceof z) {
            if (S.bodyUsed)
              throw new TypeError("Already read");
            this.url = S.url, this.credentials = S.credentials, B.headers || (this.headers = new y(S.headers)), this.method = S.method, this.mode = S.mode, this.signal = S.signal, !ee && S._bodyInit != null && (ee = S._bodyInit, S.bodyUsed = !0);
          } else
            this.url = String(S);
          if (this.credentials = B.credentials || this.credentials || "same-origin", (B.headers || !this.headers) && (this.headers = new y(B.headers)), this.method = $(B.method || this.method || "GET"), this.mode = B.mode || this.mode || null, this.signal = B.signal || this.signal || (function() {
            if ("AbortController" in a) {
              var de = new AbortController();
              return de.signal;
            }
          })(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && ee)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(ee), (this.method === "GET" || this.method === "HEAD") && (B.cache === "no-store" || B.cache === "no-cache")) {
            var pe = /([?&])_=[^&]*/;
            if (pe.test(this.url))
              this.url = this.url.replace(pe, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var ye = /\?/;
              this.url += (ye.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        z.prototype.clone = function() {
          return new z(this, { body: this._bodyInit });
        };
        function X(S) {
          var B = new FormData();
          return S.trim().split("&").forEach(function(ee) {
            if (ee) {
              var pe = ee.split("="), ye = pe.shift().replace(/\+/g, " "), de = pe.join("=").replace(/\+/g, " ");
              B.append(decodeURIComponent(ye), decodeURIComponent(de));
            }
          }), B;
        }
        function he(S) {
          var B = new y(), ee = S.replace(/\r?\n[\t ]+/g, " ");
          return ee.split("\r").map(function(pe) {
            return pe.indexOf(`
`) === 0 ? pe.substr(1, pe.length) : pe;
          }).forEach(function(pe) {
            var ye = pe.split(":"), de = ye.shift().trim();
            if (de) {
              var De = ye.join(":").trim();
              try {
                B.append(de, De);
              } catch (Re) {
                console.warn("Response " + Re.message);
              }
            }
          }), B;
        }
        q.call(z.prototype);
        function Ae(S, B) {
          if (!(this instanceof Ae))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (B || (B = {}), this.type = "default", this.status = B.status === void 0 ? 200 : B.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = B.statusText === void 0 ? "" : "" + B.statusText, this.headers = new y(B.headers), this.url = B.url || "", this._initBody(S);
        }
        q.call(Ae.prototype), Ae.prototype.clone = function() {
          return new Ae(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new y(this.headers),
            url: this.url
          });
        }, Ae.error = function() {
          var S = new Ae(null, { status: 200, statusText: "" });
          return S.ok = !1, S.status = 0, S.type = "error", S;
        };
        var H = [301, 302, 303, 307, 308];
        Ae.redirect = function(S, B) {
          if (H.indexOf(B) === -1)
            throw new RangeError("Invalid status code");
          return new Ae(null, { status: B, headers: { location: S } });
        }, s.DOMException = a.DOMException;
        try {
          new s.DOMException();
        } catch {
          s.DOMException = function(B, ee) {
            this.message = B, this.name = ee;
            var pe = Error(B);
            this.stack = pe.stack;
          }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
        }
        function we(S, B) {
          return new Promise(function(ee, pe) {
            var ye = new z(S, B);
            if (ye.signal && ye.signal.aborted)
              return pe(new s.DOMException("Aborted", "AbortError"));
            var de = new XMLHttpRequest();
            function De() {
              de.abort();
            }
            de.onload = function() {
              var be = {
                statusText: de.statusText,
                headers: he(de.getAllResponseHeaders() || "")
              };
              ye.url.indexOf("file://") === 0 && (de.status < 200 || de.status > 599) ? be.status = 200 : be.status = de.status, be.url = "responseURL" in de ? de.responseURL : be.headers.get("X-Request-URL");
              var Ce = "response" in de ? de.response : de.responseText;
              setTimeout(function() {
                ee(new Ae(Ce, be));
              }, 0);
            }, de.onerror = function() {
              setTimeout(function() {
                pe(new TypeError("Network request failed"));
              }, 0);
            }, de.ontimeout = function() {
              setTimeout(function() {
                pe(new TypeError("Network request timed out"));
              }, 0);
            }, de.onabort = function() {
              setTimeout(function() {
                pe(new s.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function Re(be) {
              try {
                return be === "" && a.location.href ? a.location.href : be;
              } catch {
                return be;
              }
            }
            if (de.open(ye.method, Re(ye.url), !0), ye.credentials === "include" ? de.withCredentials = !0 : ye.credentials === "omit" && (de.withCredentials = !1), "responseType" in de && (l.blob ? de.responseType = "blob" : l.arrayBuffer && (de.responseType = "arraybuffer")), B && typeof B.headers == "object" && !(B.headers instanceof y || a.Headers && B.headers instanceof a.Headers)) {
              var Le = [];
              Object.getOwnPropertyNames(B.headers).forEach(function(be) {
                Le.push(A(be)), de.setRequestHeader(be, R(B.headers[be]));
              }), ye.headers.forEach(function(be, Ce) {
                Le.indexOf(Ce) === -1 && de.setRequestHeader(Ce, be);
              });
            } else
              ye.headers.forEach(function(be, Ce) {
                de.setRequestHeader(Ce, be);
              });
            ye.signal && (ye.signal.addEventListener("abort", De), de.onreadystatechange = function() {
              de.readyState === 4 && ye.signal.removeEventListener("abort", De);
            }), de.send(typeof ye._bodyInit > "u" ? null : ye._bodyInit);
          });
        }
        return we.polyfill = !0, a.fetch || (a.fetch = we, a.Headers = y, a.Request = z, a.Response = Ae), s.Headers = y, s.Request = z, s.Response = Ae, s.fetch = we, Object.defineProperty(s, "__esModule", { value: !0 }), s;
      })({});
    })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
    var o = t.fetch ? t : i;
    n = o.fetch, n.default = o.fetch, n.fetch = o.fetch, n.Headers = o.Headers, n.Request = o.Request, n.Response = o.Response, e.exports = n;
  })(pi, pi.exports)), pi.exports;
}
var Lo = Fp();
const Ri = /* @__PURE__ */ pl(Lo), kp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ri
}, Symbol.toStringTag, { value: "Module" })), un = (e) => {
  let n = {};
  return e && (typeof Headers < "u" && e instanceof Headers || kp && Lo.Headers && e instanceof Lo.Headers ? n = If(e) : Array.isArray(e) ? e.forEach(([t, i]) => {
    t && i !== void 0 && (n[t] = i);
  }) : n = e), n;
}, vs = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), Up = (e) => {
  if (!Array.isArray(e.query)) {
    const i = e, o = [`query=${encodeURIComponent(vs(i.query))}`];
    return e.variables && o.push(`variables=${encodeURIComponent(i.jsonSerializer.stringify(i.variables))}`), i.operationName && o.push(`operationName=${encodeURIComponent(i.operationName)}`), o.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const n = e, t = e.query.reduce((i, o, r) => (i.push({
    query: vs(o),
    variables: n.variables ? n.jsonSerializer.stringify(n.variables[r]) : void 0
  }), i), []);
  return `query=${encodeURIComponent(n.jsonSerializer.stringify(t))}`;
}, Ep = (e) => async (n) => {
  const { url: t, query: i, variables: o, operationName: r, fetch: s, fetchOptions: a, middleware: l } = n, d = { ...n.headers };
  let f = "", g;
  e === "POST" ? (g = Tp(i, o, r, a.jsonSerializer), typeof g == "string" && (d["Content-Type"] = "application/json")) : f = Up({
    query: i,
    variables: o,
    operationName: r,
    jsonSerializer: a.jsonSerializer ?? pr
  });
  const A = {
    method: e,
    headers: d,
    body: g,
    ...a
  };
  let R = t, F = A;
  if (l) {
    const y = await Promise.resolve(l({ ...A, url: t, operationName: r, variables: o })), { url: T, ...v } = y;
    R = T, F = v;
  }
  return f && (R = `${R}?${f}`), await s(R, F);
};
class Sp {
  constructor(n, t = {}) {
    this.url = n, this.requestConfig = t, this.rawRequest = async (...i) => {
      const [o, r, s] = i, a = Of(o, r, s), { headers: l, fetch: d = Ri, method: f = "POST", requestMiddleware: g, responseMiddleware: A, ...R } = this.requestConfig, { url: F } = this;
      a.signal !== void 0 && (R.signal = a.signal);
      const { operationName: y } = go(a.query);
      return yo({
        url: F,
        query: a.query,
        variables: a.variables,
        headers: {
          ...un(bo(l)),
          ...un(a.requestHeaders)
        },
        operationName: y,
        fetch: d,
        method: f,
        fetchOptions: R,
        middleware: g
      }).then((T) => (A && A(T), T)).catch((T) => {
        throw A && A(T), T;
      });
    };
  }
  async request(n, ...t) {
    const [i, o] = t, r = Df(n, i, o), { headers: s, fetch: a = Ri, method: l = "POST", requestMiddleware: d, responseMiddleware: f, ...g } = this.requestConfig, { url: A } = this;
    r.signal !== void 0 && (g.signal = r.signal);
    const { query: R, operationName: F } = go(r.document);
    return yo({
      url: A,
      query: R,
      variables: r.variables,
      headers: {
        ...un(bo(s)),
        ...un(r.requestHeaders)
      },
      operationName: F,
      fetch: a,
      method: l,
      fetchOptions: g,
      middleware: d
    }).then((y) => (f && f(y), y.data)).catch((y) => {
      throw f && f(y), y;
    });
  }
  // prettier-ignore
  batchRequests(n, t) {
    const i = _f(n, t), { headers: o, ...r } = this.requestConfig;
    i.signal !== void 0 && (r.signal = i.signal);
    const s = i.documents.map(({ document: l }) => go(l).query), a = i.documents.map(({ variables: l }) => l);
    return yo({
      url: this.url,
      query: s,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: a,
      headers: {
        ...un(bo(o)),
        ...un(i.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? Ri,
      method: this.requestConfig.method || "POST",
      fetchOptions: r,
      middleware: this.requestConfig.requestMiddleware
    }).then((l) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(l), l.data)).catch((l) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(l), l;
    });
  }
  setHeaders(n) {
    return this.requestConfig.headers = n, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(n, t) {
    const { headers: i } = this.requestConfig;
    return i ? i[n] = t : this.requestConfig.headers = { [n]: t }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(n) {
    return this.url = n, this;
  }
}
const yo = async (e) => {
  const { query: n, variables: t, fetchOptions: i } = e, o = Ep(Tf(e.method ?? "post")), r = Array.isArray(e.query), s = await o(e), a = await Ip(s, i.jsonSerializer ?? pr), l = Array.isArray(a) ? !a.some(({ data: f }) => !f) : !!a.data, d = Array.isArray(a) || !a.errors || Array.isArray(a.errors) && !a.errors.length || i.errorPolicy === "all" || i.errorPolicy === "ignore";
  if (s.ok && d && l) {
    const { errors: f, ...g } = (Array.isArray(a), a), A = i.errorPolicy === "ignore" ? g : a;
    return {
      ...r ? { data: A } : A,
      headers: s.headers,
      status: s.status
    };
  } else {
    const f = typeof a == "string" ? {
      error: a
    } : a;
    throw new Mn(
      // @ts-expect-error TODO
      { ...f, status: s.status, headers: s.headers },
      { query: n, variables: t }
    );
  }
};
async function Ko(e, n, ...t) {
  const i = Pf(e, n, ...t);
  return new Sp(i.url).request({
    ...i
  });
}
const Tp = (e, n, t, i) => {
  const o = i ?? pr;
  if (!Array.isArray(e))
    return o.stringify({ query: e, variables: n, operationName: t });
  if (typeof n < "u" && !Array.isArray(n))
    throw new Error("Cannot create request body with given variable type, array expected");
  const r = e.reduce((s, a, l) => (s.push({ query: a, variables: n ? n[l] : void 0 }), s), []);
  return o.stringify(r);
}, Ip = async (e, n) => {
  let t;
  return e.headers.forEach((i, o) => {
    o.toLowerCase() === "content-type" && (t = i);
  }), t && (t.toLowerCase().startsWith("application/json") || t.toLowerCase().startsWith("application/graphql+json") || t.toLowerCase().startsWith("application/graphql-response+json")) ? n.parse(await e.text()) : e.text();
}, bo = (e) => typeof e == "function" ? e() : e;
class J1 {
  tableId = "";
  filters = {};
  column = "";
  _schemaTablesInformation = {};
  selection = ["id", "name"];
  graphqlUrl = "";
  branch = "root";
  limits = {};
  orderings = {};
  findInAllColumns = "";
  page = {};
  aggregateQuery = !1;
  type = "";
  orCount = 0;
  searchFieldsByProperty = {};
  searchValue = "";
  /**
   * @param {string} graphqlUrl the endpoint to query
   */
  constructor(n) {
    this.graphqlUrl = n;
  }
  table(n) {
    return this.tableId = n, this;
  }
  /**
   * @param {string | string[]} columns
   * When you supply an object the Key is the table or REF property and the value is a string or string array
   */
  select(n) {
    let t = [];
    return Array.isArray(n) ? n ? t = this._createPathFromObject("", n) : t = this.selection : t = [n], t.forEach((i) => i.toLowerCase()), this.selection = t, this;
  }
  /**
   * Builds a query for use in EMX2 GraphQL api
   * @param {string} tableId
   * @param {string[]} columns
   * @param {object[]} filters
   * @returns GraphQL query string
   */
  async execute() {
    if (!this.tableId)
      throw Error(
        `You need to provide ${this.tableId ? "columns" : "a table id"}`
      );
    if (this.selection.length === 0) {
      const n = await this.getColumnsForTable(this.tableId);
      this.selection = n;
    }
    return await Ko(
      this.graphqlUrl,
      this.aggregateQuery ? this.getAggregateQuery() : this.getQuery()
    );
  }
  /** Executes the query as aggregate */
  aggregate() {
    return this.aggregateQuery = !0, this;
  }
  getQuery() {
    return this._createQuery(this.tableId, this.selection);
  }
  getAggregateQuery() {
    const n = Object.assign([], this.selection);
    return n.push("count"), this._createQuery(`${this.tableId}_agg`, n);
  }
  /**
   * Gets the table information for the current schema
   */
  async getSchemaTablesInformation() {
    if (Object.keys(this._schemaTablesInformation).length)
      return this._schemaTablesInformation;
    const n = await Ko(
      this.graphqlUrl,
      `
        {
            _schema {
              tables {
                name,
                columns {
                name,
                columnType
                }
              }
            }
          }
        `
    );
    return this._schemaTablesInformation = n._schema.tables, this._schemaTablesInformation;
  }
  async saveSetting(n, t) {
    const i = typeof t == "string" ? t : JSON.stringify(t);
    return (await Ko(
      this.graphqlUrl,
      `
      mutation{
        change(
            settings: {
              key: "${n}",
              value: "${encodeURI(i)}"
            }
        ){
            message
        }
    }
      `
    )).change.message;
  }
  /** returns the columns with adjusted names so it can directly be used to query. */
  async getColumnsForTable(n) {
    return await this.getSchemaTablesInformation(), this._schemaTablesInformation.find((t) => t.id === n).columns.filter(
      (t) => !t.columnType.includes("REF") && !t.columnType.includes("ONTOLOGY")
    );
  }
  /** returns the correct column names and their types. */
  async getColumnsMetadataForTable(n) {
    return await this.getSchemaTablesInformation(), this._schemaTablesInformation.find((t) => t.id === n).columns.map((t) => ({
      id: t.id,
      columnType: t.columnType
    }));
  }
  /**
   * If you want to create a nested query, for example { collections: { name: { like: 'lifelines' } } }
   * then column = 'collections', subcolumn = 'name'
   * @param {string} columnId
   * @returns
   */
  where(n) {
    return this.type = "_and", this.branch = "root", this.column = this._toCamelCase(n), this;
  }
  orWhere(n) {
    return this.orCount = this.orCount + 1, this.type = "_or", this.branch = "root", this.column = this._toCamelCase(n), this;
  }
  /**
   * Works as where, but then for nested properties
   * @param {string} columnId
   * @returns
   */
  filter(n) {
    this.type = "_and";
    const t = n.indexOf(".");
    return this.branch = this._toCamelCase(n.substring(0, t)), this.column = this._toCamelCase(n.substring(t + 1)), this;
  }
  /**
   * Works as orWhere, but then for nested properties
   * @param {string} columnId
   * @returns
   */
  orFilter(n) {
    this.type = "_or";
    const t = n.indexOf(".");
    return this.branch = this._toCamelCase(n.substring(0, t)), this.column = this._toCamelCase(n.substring(t + 1)), this;
  }
  /** Resets all filters, useful for when you want to add filters dynamically */
  resetAllFilters() {
    return this.filters = {}, this.findInAllColumns = "", this.page = {}, this.searchFieldsByProperty = {}, this.searchValue = "", this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {int} amount the amount you want to return
   * @returns
   */
  limit(n, t) {
    let i = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : n;
    return this.limits[i] = t, this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {int} amount the page you want to have starting at 0
   * @returns
   */
  offset(n, t) {
    let i = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : n;
    return this.page[i] = t, this;
  }
  /**
   * @param {string} itemId the name of the table or the nested column
   * @param {string} columnId the name of the column to apply the order to
   * @param {string} direction "asc" or "dsc"
   */
  orderBy(n, t, i) {
    let o = n.toLowerCase() === this.tableId.toLowerCase() ? "root" : this._toCamelCase(n);
    return this.orderings[o] = { column: t, direction: i }, this;
  }
  /**
   * Additional function, which does the same as search but might be more semantic
   * @param {any} value searches this value across all columns, can only be applied to the top level table
   */
  find(n) {
    return this.findInAllColumns = n, this;
  }
  /**
   * @param {any} value searches this value across all columns, can only be applied to the top level table
   */
  search(n) {
    return this.findInAllColumns = n, this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  equals(n) {
    return this._createFilter("equals", n), this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  in(n) {
    return this._createFilter("in", n), this;
  }
  /** Text, String, Url, Int, Bool, DateTime Filter */
  notEquals(n) {
    return this._createFilter("not_equals", n), this;
  }
  /** Text, String, Url, Filter */
  orLike(n) {
    return this._createFilter("orLike", n);
  }
  /** Text, String, Url, Filter */
  like(n) {
    return this._createFilter("like", n);
  }
  /** Text, String, Url, Filter */
  notLike(n) {
    return this._createFilter("not_like", n), this;
  }
  /** Text, String, Url, Filter */
  triagramSearch(n) {
    return this._createFilter("triagram_search", n), this;
  }
  /** Text, String, Url, Filter */
  textSearch(n) {
    return this._createFilter("text_search", n), this;
  }
  /** Int, DateTime Filter */
  between(n) {
    return this._createFilter("between", n), this;
  }
  /** Int, DateTime Filter */
  notBetween(n) {
    return this._createFilter("not_between", n), this;
  }
  _toPascalCase(n) {
    return n[0].toUpperCase() + n.substring(1);
  }
  _toCamelCase(n) {
    return n[0].toLowerCase() + n.substring(1);
  }
  _createQuery(n, t) {
    const i = this._generateModifiers("root");
    let o = `{
${n}${i} {
`, r = this._createBranches(t);
    return o = this._generateOutput(r, 1, this.filters, o), o += `  }
}`, o;
  }
  // the best query would be for example"
  // Biobanks(orderby: { name: ASC }, filter: {collections: {_and: [{materials: {name: {like: "BUFFY_COAT"}}}, {materials: {name: {like: "CELL_LINES"}}}]}})
  // but this requires another rewrite ;)
  _createFilterString(n, t) {
    let i = "";
    const o = n && n._and ? n._and.length : 0, r = n && n._or ? n._or.length : 0;
    if (o + r > 1) {
      let s = "";
      n._and.length && n._and.forEach((a) => {
        s.length && (s += ", "), s += `{ _and: [ ${a} ] }`;
      }), n._or.length && (s.length && (s += ", "), n._or.forEach((a) => {
        s.length && !s.endsWith(", ") && (s += ", "), s += `{ _or: [ ${a} ] }`;
      })), i += `_and: [ ${s} ]`;
    } else if (o === 1) {
      const s = n._and;
      i += `_and: [ ${s} ]`;
    } else if (r === 1) {
      const s = n._or;
      i += `_or: [ ${s} ]`;
    }
    if (this.searchValue && Object.keys(this.searchFieldsByProperty).includes(t) && this.searchFieldsByProperty[t].length) {
      let s = "";
      this.searchFieldsByProperty[t].forEach((a) => {
        s.length && (s += ", "), s += this.buildExpandedLike(a, this.searchValue);
      }), i = i.length ? `_and: [ { _or: [ ${s} ] } , { ${i} } ]` : `_or: [ ${s} ]`;
    }
    return i;
  }
  buildExpandedLike(n, t) {
    const i = n.split(".");
    return i.reduce((r, s) => r + `{ ${s}: `, "") + `{ like: "${t}" } }` + " }".repeat(i.length - 1);
  }
  /** Create a nested object to represent the branches and their properties */
  _createBranches(n) {
    let t = {};
    for (let i of n) {
      let o = i.split("."), r = t;
      for (let a = 0; a < o.length - 1; a++) {
        let l = this._toCamelCase(o[a].trim());
        r[l] || (r[l] = {}), r = r[l];
      }
      let s = this._toCamelCase(o[o.length - 1].trim());
      s.indexOf(".") >= 0 ? r[s] = {} : (r.properties || (r.properties = {}), r.properties[s] = !0);
    }
    return t;
  }
  /** Generate the bit inside parentheses */
  _generateModifiers(n) {
    const t = [];
    t.push(
      this.findInAllColumns.length && n === "root" ? `search: "${this.findInAllColumns}"` : ""
    ), t.push(
      this.limits[n] ? `limit: ${this.limits[n]}` : ""
    ), t.push(
      this.page[n] ? `offset: ${this.page[n]}` : ""
    ), t.push(
      this.orderings[n] ? `orderby: { ${this.orderings[n].column}: ${this.orderings[n].direction.toUpperCase()} }` : ""
    );
    const i = this._createFilterString(
      this.filters[n],
      n
    );
    i.length && t.push(`filter: { ${i} }`);
    const o = t.filter((r) => r.length > 0);
    return o.length ? `(${o.join(", ")})` : "";
  }
  _createFilterFromPath(n, t, i) {
    const o = Array.isArray(i) ? i : [i], r = this._getGqlOperator(t), s = n.split(".").reverse();
    if (this.type === "_or" && r === "equals") {
      let a = `{ ${r}: [${o.map(
        (l) => typeof l == "boolean" ? `${l}` : `"${l}"`
      )}] }`;
      for (const l of s)
        a = `{ ${l}: ${a} }`;
      this.filters[this.branch][this.type].push(a);
    } else
      for (const a of o) {
        let l = typeof a == "boolean" ? `${a}` : `"${a}"`, d = `{ ${r}: ${l} }`;
        for (const f of s)
          d = `{ ${f}: ${d} }`;
        this.filters[this.branch][this.type].push(d);
      }
  }
  _getGqlOperator(n) {
    switch (n) {
      case "in":
        return "equals";
      case "orLike":
        return "like";
      default:
        return n;
    }
  }
  /** Private function to create the correct filter syntax. */
  _createFilter(n, t) {
    return this.filters[this.branch] || (this.filters[this.branch] = {
      _and: [],
      _or: []
    }), this._createFilterFromPath(this.column, n, t), this.column = "", this;
  }
  /** Recursively generate the output string for the branches and their properties */
  _generateOutput(n, t, i, o) {
    let r = "    ".repeat(t);
    if (n.properties) {
      let s = n.properties;
      for (let a in s)
        s[a] === !0 && (o += `${r}${a},
`);
      o = `${o.substring(0, o.length - 2)}
`;
    }
    for (let s in n) {
      let a = n[s];
      if (s !== "properties") {
        o = `${o.substring(0, o.length - 1)},
`;
        const l = this._generateModifiers(s);
        o += `${r}${s}${l || ""} {
`, o = this._generateOutput(
          a,
          t + 1,
          i,
          o
        ), o += r + `}
`;
      }
    }
    return o;
  }
  _createPathFromObject(n, t, i = []) {
    for (const o of t)
      if (typeof o == "object") {
        const r = Object.keys(o)[0], s = n ? `${n}.${r}` : r;
        this._createPathFromObject(
          s,
          o[r],
          i
        );
      } else
        !n || n.length === 0 ? i.push(o) : i.push(`${n}.${o}`);
    return i;
  }
}
const P = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [i, o] of n)
    t[i] = o;
  return t;
}, Dp = {
  name: "ButtonAction",
  props: {
    href: { type: String, required: !1 },
    icon: { type: String, required: !1 },
    target: { type: String, required: !1 },
    disabled: { type: Boolean, required: !1 }
  },
  methods: {
    onClick() {
      window && window.open && this.href ? window.open(this.href, this.target ? this.target : "_self") : this.$emit("click");
    }
  },
  emits: ["click"]
}, Op = ["disabled"];
function _p(e, n, t, i, o, r) {
  return u(), c("button", {
    type: "button",
    class: "btn btn-primary",
    disabled: t.disabled,
    onClick: n[0] || (n[0] = ve((...s) => r.onClick && r.onClick(...s), ["prevent"]))
  }, [
    j(e.$slots, "default"),
    t.icon ? (u(), c("i", {
      key: 0,
      class: G(["fa fa-fw fa-" + t.icon, "mr-2 ml-0"])
    }, null, 2)) : b("", !0)
  ], 8, Op);
}
const it = /* @__PURE__ */ P(Dp, [["render", _p]]), Pp = {
  name: "ButtonAlt",
  extends: it,
  props: {
    light: { type: Boolean, default: !1 },
    icon: {
      type: String,
      required: !1,
      default: () => null
    }
  }
};
function Mp(e, n, t, i, o, r) {
  return u(), c("button", {
    type: "button",
    class: G(["btn border-0", t.light ? "btn-outline-light" : "btn-outline-primary"]),
    onClick: n[0] || (n[0] = ve((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    j(e.$slots, "default"),
    t.icon ? (u(), c("i", {
      key: 0,
      class: G("fa fa-fw fa-" + t.icon)
    }, null, 2)) : b("", !0)
  ], 2);
}
const mt = /* @__PURE__ */ P(Pp, [["render", Mp]]), Lp = {}, Np = {
  class: "alert alert-danger",
  role: "alert"
};
function Bp(e, n) {
  return u(), c("div", Np, [
    j(e.$slots, "default")
  ]);
}
const At = /* @__PURE__ */ P(Lp, [["render", Bp]]), xp = {}, qp = {
  class: "alert alert-success",
  role: "alert"
};
function Vp(e, n) {
  return u(), c("div", qp, [
    j(e.$slots, "default")
  ]);
}
const Fn = /* @__PURE__ */ P(xp, [["render", Vp]]), jp = {}, Hp = {
  class: "spinner-border",
  role: "status"
};
function Gp(e, n) {
  return u(), c("div", Hp, [...n[0] || (n[0] = [
    p("span", { class: "sr-only" }, "Loading...", -1)
  ])]);
}
const Ut = /* @__PURE__ */ P(jp, [["render", Gp]]), Qp = {
  name: "LayoutModal",
  props: {
    /** When true the modal will be shown */
    show: {
      type: Boolean,
      default: !0
    },
    /** Shown as the title of the model */
    title: { type: String, default: "" },
    isCloseButtonShown: { type: Boolean, default: !0 }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    escapeKeyHandler(e) {
      e.key === "Escape" && this.close();
    }
  },
  beforeMount() {
    document && document.addEventListener && document.addEventListener("keydown", this.escapeKeyHandler);
  },
  beforeDestroy() {
    document && document.removeEventListener && document.removeEventListener("keydown", this.escapeKeyHandler);
  },
  emits: ["close"]
}, $p = {
  key: 0,
  class: "modal fade show",
  role: "dialog",
  style: { display: "block", overflow: "scroll" },
  tabindex: "-1",
  "aria-modal": "true"
}, Jp = {
  key: 0,
  class: "modal-dialog modal-xl",
  role: "document"
}, zp = { class: "modal-content" }, Wp = { class: "modal-header" }, Yp = { class: "modal-title" }, Xp = { class: "modal-body bg-light" }, Zp = { class: "modal-footer" };
function eh(e, n, t, i, o, r) {
  return u(), c("div", null, [
    t.show ? (u(), c("div", $p, [
      t.show ? (u(), c("div", Jp, [
        p("div", zp, [
          p("div", Wp, [
            p("h5", Yp, E(t.title), 1),
            t.isCloseButtonShown ? (u(), c("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: n[0] || (n[0] = ve((...s) => r.close && r.close(...s), ["prevent"]))
            }, [...n[1] || (n[1] = [
              p("span", { "aria-hidden": "true" }, "×", -1)
            ])])) : b("", !0)
          ]),
          p("div", Xp, [
            j(e.$slots, "body", {}, void 0, !0)
          ]),
          p("div", Zp, [
            j(e.$slots, "footer", {}, void 0, !0)
          ])
        ])
      ])) : b("", !0)
    ])) : b("", !0)
  ]);
}
const Et = /* @__PURE__ */ P(Qp, [["render", eh], ["__scopeId", "data-v-84d87320"]]), ke = {
  name: "BaseInput",
  props: {
    /**
     * Unique identifier https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
     * Has no direct EMX2 implementation but can be constructed by concatenating the table name with the field name
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * Name of the element. For example used by the server to identify the fields in form submits.
     * relates to EMX2 columnId
     */
    name: {
      type: String,
      required: !1
    },
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    },
    /**
     * Caption for an item in a user interface.
     * relates to EMX2 label
     */
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    /**
     * EMX2 description
     */
    description: {
      type: String,
      required: !1
    },
    required: {
      type: [Boolean, String],
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      required: !1,
      default: () => null
    }
  },
  computed: {
    placeholderValue() {
      return this.placeholder;
    }
  },
  emits: ["update:modelValue"]
}, th = {
  name: "FormGroup",
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !1
    },
    required: {
      type: [String, Boolean],
      required: !1,
      default: () => !1
    },
    errorMessage: {
      type: String,
      required: !1
    }
  },
  methods: {
    isRequired: ti,
    hasDescription(e) {
      return e != null && e.length;
    }
  }
}, nh = { class: "form-group" }, ih = ["for"], oh = {
  key: 1,
  class: "float-right"
}, rh = {
  key: 2,
  class: "text-danger form-text"
}, sh = ["id"];
function ah(e, n, t, i, o, r) {
  return u(), c("div", nh, [
    t.label !== null && t.label !== void 0 ? (u(), c("label", {
      key: 0,
      for: t.id
    }, [
      p("b", null, E(t.label), 1)
    ], 8, ih)) : b("", !0),
    r.isRequired(t.required) ? (u(), c("span", oh, " (required) ")) : b("", !0),
    j(e.$slots, "default"),
    t.errorMessage ? (u(), c("small", rh, E(t.errorMessage), 1)) : b("", !0),
    r.hasDescription(t.description) ? (u(), c("small", {
      key: 3,
      id: t.id + "-help-text",
      class: "form-text text-muted"
    }, E(t.description), 9, sh)) : b("", !0)
  ]);
}
const Te = /* @__PURE__ */ P(th, [["render", ah]]), lh = {
  name: "InputPassword",
  components: { FormGroup: Te },
  extends: ke
}, uh = ["id", "name", "value", "aria-describedby", "placeholder"];
function dh(e, n, t, i, o, r) {
  const s = K("FormGroup");
  return u(), k(s, {
    id: e.id,
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      p("input", {
        id: e.id,
        name: e.name,
        value: e.modelValue,
        onInput: n[0] || (n[0] = (a) => e.$emit("update:modelValue", a.target.value)),
        type: "password",
        class: G(["form-control", { "is-invalid": e.errorMessage }]),
        "aria-describedby": e.id,
        placeholder: e.label
      }, null, 42, uh)
    ]),
    _: 1
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Ar = /* @__PURE__ */ P(lh, [["render", dh]]);
var at = "top", vt = "bottom", wt = "right", lt = "left", gr = "auto", ii = [at, vt, wt, lt], gn = "start", Gn = "end", ch = "clippingParents", hl = "viewport", Dn = "popper", fh = "reference", ws = /* @__PURE__ */ ii.reduce(function(e, n) {
  return e.concat([n + "-" + gn, n + "-" + Gn]);
}, []), ml = /* @__PURE__ */ [].concat(ii, [gr]).reduce(function(e, n) {
  return e.concat([n, n + "-" + gn, n + "-" + Gn]);
}, []), ph = "beforeRead", hh = "read", mh = "afterRead", Ah = "beforeMain", gh = "main", yh = "afterMain", Kh = "beforeWrite", bh = "write", vh = "afterWrite", wh = [ph, hh, mh, Ah, gh, yh, Kh, bh, vh];
function Dt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function ht(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var n = e.ownerDocument;
    return n && n.defaultView || window;
  }
  return e;
}
function rn(e) {
  var n = ht(e).Element;
  return e instanceof n || e instanceof Element;
}
function bt(e) {
  var n = ht(e).HTMLElement;
  return e instanceof n || e instanceof HTMLElement;
}
function yr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = ht(e).ShadowRoot;
  return e instanceof n || e instanceof ShadowRoot;
}
function Ch(e) {
  var n = e.state;
  Object.keys(n.elements).forEach(function(t) {
    var i = n.styles[t] || {}, o = n.attributes[t] || {}, r = n.elements[t];
    !bt(r) || !Dt(r) || (Object.assign(r.style, i), Object.keys(o).forEach(function(s) {
      var a = o[s];
      a === !1 ? r.removeAttribute(s) : r.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function Rh(e) {
  var n = e.state, t = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, t.popper), n.styles = t, n.elements.arrow && Object.assign(n.elements.arrow.style, t.arrow), function() {
    Object.keys(n.elements).forEach(function(i) {
      var o = n.elements[i], r = n.attributes[i] || {}, s = Object.keys(n.styles.hasOwnProperty(i) ? n.styles[i] : t[i]), a = s.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !bt(o) || !Dt(o) || (Object.assign(o.style, a), Object.keys(r).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const Fh = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Ch,
  effect: Rh,
  requires: ["computeStyles"]
};
function It(e) {
  return e.split("-")[0];
}
var Yt = Math.max, Pi = Math.min, yn = Math.round;
function No() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function Al() {
  return !/^((?!chrome|android).)*safari/i.test(No());
}
function Kn(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  var i = e.getBoundingClientRect(), o = 1, r = 1;
  n && bt(e) && (o = e.offsetWidth > 0 && yn(i.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && yn(i.height) / e.offsetHeight || 1);
  var s = rn(e) ? ht(e) : window, a = s.visualViewport, l = !Al() && t, d = (i.left + (l && a ? a.offsetLeft : 0)) / o, f = (i.top + (l && a ? a.offsetTop : 0)) / r, g = i.width / o, A = i.height / r;
  return {
    width: g,
    height: A,
    top: f,
    right: d + g,
    bottom: f + A,
    left: d,
    x: d,
    y: f
  };
}
function Kr(e) {
  var n = Kn(e), t = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(n.width - t) <= 1 && (t = n.width), Math.abs(n.height - i) <= 1 && (i = n.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: i
  };
}
function gl(e, n) {
  var t = n.getRootNode && n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && yr(t)) {
    var i = n;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function Mt(e) {
  return ht(e).getComputedStyle(e);
}
function kh(e) {
  return ["table", "td", "th"].indexOf(Dt(e)) >= 0;
}
function Vt(e) {
  return ((rn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function $i(e) {
  return Dt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (yr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Vt(e)
  );
}
function Cs(e) {
  return !bt(e) || // https://github.com/popperjs/popper-core/issues/837
  Mt(e).position === "fixed" ? null : e.offsetParent;
}
function Uh(e) {
  var n = /firefox/i.test(No()), t = /Trident/i.test(No());
  if (t && bt(e)) {
    var i = Mt(e);
    if (i.position === "fixed")
      return null;
  }
  var o = $i(e);
  for (yr(o) && (o = o.host); bt(o) && ["html", "body"].indexOf(Dt(o)) < 0; ) {
    var r = Mt(o);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || n && r.willChange === "filter" || n && r.filter && r.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function oi(e) {
  for (var n = ht(e), t = Cs(e); t && kh(t) && Mt(t).position === "static"; )
    t = Cs(t);
  return t && (Dt(t) === "html" || Dt(t) === "body" && Mt(t).position === "static") ? n : t || Uh(e) || n;
}
function br(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ln(e, n, t) {
  return Yt(e, Pi(n, t));
}
function Eh(e, n, t) {
  var i = Ln(e, n, t);
  return i > t ? t : i;
}
function yl() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Kl(e) {
  return Object.assign({}, yl(), e);
}
function bl(e, n) {
  return n.reduce(function(t, i) {
    return t[i] = e, t;
  }, {});
}
var Sh = function(n, t) {
  return n = typeof n == "function" ? n(Object.assign({}, t.rects, {
    placement: t.placement
  })) : n, Kl(typeof n != "number" ? n : bl(n, ii));
};
function Th(e) {
  var n, t = e.state, i = e.name, o = e.options, r = t.elements.arrow, s = t.modifiersData.popperOffsets, a = It(t.placement), l = br(a), d = [lt, wt].indexOf(a) >= 0, f = d ? "height" : "width";
  if (!(!r || !s)) {
    var g = Sh(o.padding, t), A = Kr(r), R = l === "y" ? at : lt, F = l === "y" ? vt : wt, y = t.rects.reference[f] + t.rects.reference[l] - s[l] - t.rects.popper[f], T = s[l] - t.rects.reference[l], v = oi(r), I = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, M = y / 2 - T / 2, D = g[R], V = I - A[f] - g[F], q = I / 2 - A[f] / 2 + M, x = Ln(D, q, V), $ = l;
    t.modifiersData[i] = (n = {}, n[$] = x, n.centerOffset = x - q, n);
  }
}
function Ih(e) {
  var n = e.state, t = e.options, i = t.element, o = i === void 0 ? "[data-popper-arrow]" : i;
  o != null && (typeof o == "string" && (o = n.elements.popper.querySelector(o), !o) || gl(n.elements.popper, o) && (n.elements.arrow = o));
}
const Dh = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Th,
  effect: Ih,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function bn(e) {
  return e.split("-")[1];
}
var Oh = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function _h(e, n) {
  var t = e.x, i = e.y, o = n.devicePixelRatio || 1;
  return {
    x: yn(t * o) / o || 0,
    y: yn(i * o) / o || 0
  };
}
function Rs(e) {
  var n, t = e.popper, i = e.popperRect, o = e.placement, r = e.variation, s = e.offsets, a = e.position, l = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, g = e.isFixed, A = s.x, R = A === void 0 ? 0 : A, F = s.y, y = F === void 0 ? 0 : F, T = typeof f == "function" ? f({
    x: R,
    y
  }) : {
    x: R,
    y
  };
  R = T.x, y = T.y;
  var v = s.hasOwnProperty("x"), I = s.hasOwnProperty("y"), M = lt, D = at, V = window;
  if (d) {
    var q = oi(t), x = "clientHeight", $ = "clientWidth";
    if (q === ht(t) && (q = Vt(t), Mt(q).position !== "static" && a === "absolute" && (x = "scrollHeight", $ = "scrollWidth")), q = q, o === at || (o === lt || o === wt) && r === Gn) {
      D = vt;
      var z = g && q === V && V.visualViewport ? V.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        q[x]
      );
      y -= z - i.height, y *= l ? 1 : -1;
    }
    if (o === lt || (o === at || o === vt) && r === Gn) {
      M = wt;
      var X = g && q === V && V.visualViewport ? V.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        q[$]
      );
      R -= X - i.width, R *= l ? 1 : -1;
    }
  }
  var he = Object.assign({
    position: a
  }, d && Oh), Ae = f === !0 ? _h({
    x: R,
    y
  }, ht(t)) : {
    x: R,
    y
  };
  if (R = Ae.x, y = Ae.y, l) {
    var H;
    return Object.assign({}, he, (H = {}, H[D] = I ? "0" : "", H[M] = v ? "0" : "", H.transform = (V.devicePixelRatio || 1) <= 1 ? "translate(" + R + "px, " + y + "px)" : "translate3d(" + R + "px, " + y + "px, 0)", H));
  }
  return Object.assign({}, he, (n = {}, n[D] = I ? y + "px" : "", n[M] = v ? R + "px" : "", n.transform = "", n));
}
function Ph(e) {
  var n = e.state, t = e.options, i = t.gpuAcceleration, o = i === void 0 ? !0 : i, r = t.adaptive, s = r === void 0 ? !0 : r, a = t.roundOffsets, l = a === void 0 ? !0 : a, d = {
    placement: It(n.placement),
    variation: bn(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: o,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, Rs(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, Rs(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const Mh = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ph,
  data: {}
};
var hi = {
  passive: !0
};
function Lh(e) {
  var n = e.state, t = e.instance, i = e.options, o = i.scroll, r = o === void 0 ? !0 : o, s = i.resize, a = s === void 0 ? !0 : s, l = ht(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return r && d.forEach(function(f) {
    f.addEventListener("scroll", t.update, hi);
  }), a && l.addEventListener("resize", t.update, hi), function() {
    r && d.forEach(function(f) {
      f.removeEventListener("scroll", t.update, hi);
    }), a && l.removeEventListener("resize", t.update, hi);
  };
}
const Nh = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Lh,
  data: {}
};
var Bh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Fi(e) {
  return e.replace(/left|right|bottom|top/g, function(n) {
    return Bh[n];
  });
}
var xh = {
  start: "end",
  end: "start"
};
function Fs(e) {
  return e.replace(/start|end/g, function(n) {
    return xh[n];
  });
}
function vr(e) {
  var n = ht(e), t = n.pageXOffset, i = n.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: i
  };
}
function wr(e) {
  return Kn(Vt(e)).left + vr(e).scrollLeft;
}
function qh(e, n) {
  var t = ht(e), i = Vt(e), o = t.visualViewport, r = i.clientWidth, s = i.clientHeight, a = 0, l = 0;
  if (o) {
    r = o.width, s = o.height;
    var d = Al();
    (d || !d && n === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: a + wr(e),
    y: l
  };
}
function Vh(e) {
  var n, t = Vt(e), i = vr(e), o = (n = e.ownerDocument) == null ? void 0 : n.body, r = Yt(t.scrollWidth, t.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = Yt(t.scrollHeight, t.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -i.scrollLeft + wr(e), l = -i.scrollTop;
  return Mt(o || t).direction === "rtl" && (a += Yt(t.clientWidth, o ? o.clientWidth : 0) - r), {
    width: r,
    height: s,
    x: a,
    y: l
  };
}
function Cr(e) {
  var n = Mt(e), t = n.overflow, i = n.overflowX, o = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + o + i);
}
function vl(e) {
  return ["html", "body", "#document"].indexOf(Dt(e)) >= 0 ? e.ownerDocument.body : bt(e) && Cr(e) ? e : vl($i(e));
}
function Nn(e, n) {
  var t;
  n === void 0 && (n = []);
  var i = vl(e), o = i === ((t = e.ownerDocument) == null ? void 0 : t.body), r = ht(i), s = o ? [r].concat(r.visualViewport || [], Cr(i) ? i : []) : i, a = n.concat(s);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Nn($i(s)))
  );
}
function Bo(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function jh(e, n) {
  var t = Kn(e, !1, n === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function ks(e, n, t) {
  return n === hl ? Bo(qh(e, t)) : rn(n) ? jh(n, t) : Bo(Vh(Vt(e)));
}
function Hh(e) {
  var n = Nn($i(e)), t = ["absolute", "fixed"].indexOf(Mt(e).position) >= 0, i = t && bt(e) ? oi(e) : e;
  return rn(i) ? n.filter(function(o) {
    return rn(o) && gl(o, i) && Dt(o) !== "body";
  }) : [];
}
function Gh(e, n, t, i) {
  var o = n === "clippingParents" ? Hh(e) : [].concat(n), r = [].concat(o, [t]), s = r[0], a = r.reduce(function(l, d) {
    var f = ks(e, d, i);
    return l.top = Yt(f.top, l.top), l.right = Pi(f.right, l.right), l.bottom = Pi(f.bottom, l.bottom), l.left = Yt(f.left, l.left), l;
  }, ks(e, s, i));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function wl(e) {
  var n = e.reference, t = e.element, i = e.placement, o = i ? It(i) : null, r = i ? bn(i) : null, s = n.x + n.width / 2 - t.width / 2, a = n.y + n.height / 2 - t.height / 2, l;
  switch (o) {
    case at:
      l = {
        x: s,
        y: n.y - t.height
      };
      break;
    case vt:
      l = {
        x: s,
        y: n.y + n.height
      };
      break;
    case wt:
      l = {
        x: n.x + n.width,
        y: a
      };
      break;
    case lt:
      l = {
        x: n.x - t.width,
        y: a
      };
      break;
    default:
      l = {
        x: n.x,
        y: n.y
      };
  }
  var d = o ? br(o) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (r) {
      case gn:
        l[d] = l[d] - (n[f] / 2 - t[f] / 2);
        break;
      case Gn:
        l[d] = l[d] + (n[f] / 2 - t[f] / 2);
        break;
    }
  }
  return l;
}
function Qn(e, n) {
  n === void 0 && (n = {});
  var t = n, i = t.placement, o = i === void 0 ? e.placement : i, r = t.strategy, s = r === void 0 ? e.strategy : r, a = t.boundary, l = a === void 0 ? ch : a, d = t.rootBoundary, f = d === void 0 ? hl : d, g = t.elementContext, A = g === void 0 ? Dn : g, R = t.altBoundary, F = R === void 0 ? !1 : R, y = t.padding, T = y === void 0 ? 0 : y, v = Kl(typeof T != "number" ? T : bl(T, ii)), I = A === Dn ? fh : Dn, M = e.rects.popper, D = e.elements[F ? I : A], V = Gh(rn(D) ? D : D.contextElement || Vt(e.elements.popper), l, f, s), q = Kn(e.elements.reference), x = wl({
    reference: q,
    element: M,
    placement: o
  }), $ = Bo(Object.assign({}, M, x)), z = A === Dn ? $ : q, X = {
    top: V.top - z.top + v.top,
    bottom: z.bottom - V.bottom + v.bottom,
    left: V.left - z.left + v.left,
    right: z.right - V.right + v.right
  }, he = e.modifiersData.offset;
  if (A === Dn && he) {
    var Ae = he[o];
    Object.keys(X).forEach(function(H) {
      var we = [wt, vt].indexOf(H) >= 0 ? 1 : -1, S = [at, vt].indexOf(H) >= 0 ? "y" : "x";
      X[H] += Ae[S] * we;
    });
  }
  return X;
}
function Qh(e, n) {
  n === void 0 && (n = {});
  var t = n, i = t.placement, o = t.boundary, r = t.rootBoundary, s = t.padding, a = t.flipVariations, l = t.allowedAutoPlacements, d = l === void 0 ? ml : l, f = bn(i), g = f ? a ? ws : ws.filter(function(F) {
    return bn(F) === f;
  }) : ii, A = g.filter(function(F) {
    return d.indexOf(F) >= 0;
  });
  A.length === 0 && (A = g);
  var R = A.reduce(function(F, y) {
    return F[y] = Qn(e, {
      placement: y,
      boundary: o,
      rootBoundary: r,
      padding: s
    })[It(y)], F;
  }, {});
  return Object.keys(R).sort(function(F, y) {
    return R[F] - R[y];
  });
}
function $h(e) {
  if (It(e) === gr)
    return [];
  var n = Fi(e);
  return [Fs(e), n, Fs(n)];
}
function Jh(e) {
  var n = e.state, t = e.options, i = e.name;
  if (!n.modifiersData[i]._skip) {
    for (var o = t.mainAxis, r = o === void 0 ? !0 : o, s = t.altAxis, a = s === void 0 ? !0 : s, l = t.fallbackPlacements, d = t.padding, f = t.boundary, g = t.rootBoundary, A = t.altBoundary, R = t.flipVariations, F = R === void 0 ? !0 : R, y = t.allowedAutoPlacements, T = n.options.placement, v = It(T), I = v === T, M = l || (I || !F ? [Fi(T)] : $h(T)), D = [T].concat(M).reduce(function(be, Ce) {
      return be.concat(It(Ce) === gr ? Qh(n, {
        placement: Ce,
        boundary: f,
        rootBoundary: g,
        padding: d,
        flipVariations: F,
        allowedAutoPlacements: y
      }) : Ce);
    }, []), V = n.rects.reference, q = n.rects.popper, x = /* @__PURE__ */ new Map(), $ = !0, z = D[0], X = 0; X < D.length; X++) {
      var he = D[X], Ae = It(he), H = bn(he) === gn, we = [at, vt].indexOf(Ae) >= 0, S = we ? "width" : "height", B = Qn(n, {
        placement: he,
        boundary: f,
        rootBoundary: g,
        altBoundary: A,
        padding: d
      }), ee = we ? H ? wt : lt : H ? vt : at;
      V[S] > q[S] && (ee = Fi(ee));
      var pe = Fi(ee), ye = [];
      if (r && ye.push(B[Ae] <= 0), a && ye.push(B[ee] <= 0, B[pe] <= 0), ye.every(function(be) {
        return be;
      })) {
        z = he, $ = !1;
        break;
      }
      x.set(he, ye);
    }
    if ($)
      for (var de = F ? 3 : 1, De = function(Ce) {
        var Ye = D.find(function(ge) {
          var ne = x.get(ge);
          if (ne)
            return ne.slice(0, Ce).every(function(ae) {
              return ae;
            });
        });
        if (Ye)
          return z = Ye, "break";
      }, Re = de; Re > 0; Re--) {
        var Le = De(Re);
        if (Le === "break") break;
      }
    n.placement !== z && (n.modifiersData[i]._skip = !0, n.placement = z, n.reset = !0);
  }
}
const zh = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Jh,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Us(e, n, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - n.height - t.y,
    right: e.right - n.width + t.x,
    bottom: e.bottom - n.height + t.y,
    left: e.left - n.width - t.x
  };
}
function Es(e) {
  return [at, wt, vt, lt].some(function(n) {
    return e[n] >= 0;
  });
}
function Wh(e) {
  var n = e.state, t = e.name, i = n.rects.reference, o = n.rects.popper, r = n.modifiersData.preventOverflow, s = Qn(n, {
    elementContext: "reference"
  }), a = Qn(n, {
    altBoundary: !0
  }), l = Us(s, i), d = Us(a, o, r), f = Es(l), g = Es(d);
  n.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: g
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": g
  });
}
const Yh = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Wh
};
function Xh(e, n, t) {
  var i = It(e), o = [lt, at].indexOf(i) >= 0 ? -1 : 1, r = typeof t == "function" ? t(Object.assign({}, n, {
    placement: e
  })) : t, s = r[0], a = r[1];
  return s = s || 0, a = (a || 0) * o, [lt, wt].indexOf(i) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function Zh(e) {
  var n = e.state, t = e.options, i = e.name, o = t.offset, r = o === void 0 ? [0, 0] : o, s = ml.reduce(function(f, g) {
    return f[g] = Xh(g, n.rects, r), f;
  }, {}), a = s[n.placement], l = a.x, d = a.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += l, n.modifiersData.popperOffsets.y += d), n.modifiersData[i] = s;
}
const em = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Zh
};
function tm(e) {
  var n = e.state, t = e.name;
  n.modifiersData[t] = wl({
    reference: n.rects.reference,
    element: n.rects.popper,
    placement: n.placement
  });
}
const nm = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: tm,
  data: {}
};
function im(e) {
  return e === "x" ? "y" : "x";
}
function om(e) {
  var n = e.state, t = e.options, i = e.name, o = t.mainAxis, r = o === void 0 ? !0 : o, s = t.altAxis, a = s === void 0 ? !1 : s, l = t.boundary, d = t.rootBoundary, f = t.altBoundary, g = t.padding, A = t.tether, R = A === void 0 ? !0 : A, F = t.tetherOffset, y = F === void 0 ? 0 : F, T = Qn(n, {
    boundary: l,
    rootBoundary: d,
    padding: g,
    altBoundary: f
  }), v = It(n.placement), I = bn(n.placement), M = !I, D = br(v), V = im(D), q = n.modifiersData.popperOffsets, x = n.rects.reference, $ = n.rects.popper, z = typeof y == "function" ? y(Object.assign({}, n.rects, {
    placement: n.placement
  })) : y, X = typeof z == "number" ? {
    mainAxis: z,
    altAxis: z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, z), he = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, Ae = {
    x: 0,
    y: 0
  };
  if (q) {
    if (r) {
      var H, we = D === "y" ? at : lt, S = D === "y" ? vt : wt, B = D === "y" ? "height" : "width", ee = q[D], pe = ee + T[we], ye = ee - T[S], de = R ? -$[B] / 2 : 0, De = I === gn ? x[B] : $[B], Re = I === gn ? -$[B] : -x[B], Le = n.elements.arrow, be = R && Le ? Kr(Le) : {
        width: 0,
        height: 0
      }, Ce = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : yl(), Ye = Ce[we], ge = Ce[S], ne = Ln(0, x[B], be[B]), ae = M ? x[B] / 2 - de - ne - Ye - X.mainAxis : De - ne - Ye - X.mainAxis, Ie = M ? -x[B] / 2 + de + ne + ge + X.mainAxis : Re + ne + ge + X.mainAxis, Ve = n.elements.arrow && oi(n.elements.arrow), Ne = Ve ? D === "y" ? Ve.clientTop || 0 : Ve.clientLeft || 0 : 0, Pe = (H = he?.[D]) != null ? H : 0, Xe = ee + ae - Pe - Ne, jt = ee + Ie - Pe, Nt = Ln(R ? Pi(pe, Xe) : pe, ee, R ? Yt(ye, jt) : ye);
      q[D] = Nt, Ae[D] = Nt - ee;
    }
    if (a) {
      var Ze, le = D === "x" ? at : lt, Oe = D === "x" ? vt : wt, je = q[V], ot = V === "y" ? "height" : "width", Bt = je + T[le], xt = je - T[Oe], gt = [at, lt].indexOf(v) !== -1, Ht = (Ze = he?.[V]) != null ? Ze : 0, ai = gt ? Bt : je - x[ot] - $[ot] - Ht + X.altAxis, kn = gt ? je + x[ot] + $[ot] - Ht - X.altAxis : xt, li = R && gt ? Eh(ai, je, kn) : Ln(R ? ai : Bt, je, R ? kn : xt);
      q[V] = li, Ae[V] = li - je;
    }
    n.modifiersData[i] = Ae;
  }
}
const rm = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: om,
  requiresIfExists: ["offset"]
};
function sm(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function am(e) {
  return e === ht(e) || !bt(e) ? vr(e) : sm(e);
}
function lm(e) {
  var n = e.getBoundingClientRect(), t = yn(n.width) / e.offsetWidth || 1, i = yn(n.height) / e.offsetHeight || 1;
  return t !== 1 || i !== 1;
}
function um(e, n, t) {
  t === void 0 && (t = !1);
  var i = bt(n), o = bt(n) && lm(n), r = Vt(n), s = Kn(e, o, t), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !t) && ((Dt(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Cr(r)) && (a = am(n)), bt(n) ? (l = Kn(n, !0), l.x += n.clientLeft, l.y += n.clientTop) : r && (l.x = wr(r))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function dm(e) {
  var n = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(r) {
    n.set(r.name, r);
  });
  function o(r) {
    t.add(r.name);
    var s = [].concat(r.requires || [], r.requiresIfExists || []);
    s.forEach(function(a) {
      if (!t.has(a)) {
        var l = n.get(a);
        l && o(l);
      }
    }), i.push(r);
  }
  return e.forEach(function(r) {
    t.has(r.name) || o(r);
  }), i;
}
function cm(e) {
  var n = dm(e);
  return wh.reduce(function(t, i) {
    return t.concat(n.filter(function(o) {
      return o.phase === i;
    }));
  }, []);
}
function fm(e) {
  var n;
  return function() {
    return n || (n = new Promise(function(t) {
      Promise.resolve().then(function() {
        n = void 0, t(e());
      });
    })), n;
  };
}
function pm(e) {
  var n = e.reduce(function(t, i) {
    var o = t[i.name];
    return t[i.name] = o ? Object.assign({}, o, i, {
      options: Object.assign({}, o.options, i.options),
      data: Object.assign({}, o.data, i.data)
    }) : i, t;
  }, {});
  return Object.keys(n).map(function(t) {
    return n[t];
  });
}
var Ss = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ts() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return !n.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function hm(e) {
  e === void 0 && (e = {});
  var n = e, t = n.defaultModifiers, i = t === void 0 ? [] : t, o = n.defaultOptions, r = o === void 0 ? Ss : o;
  return function(a, l, d) {
    d === void 0 && (d = r);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ss, r),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, g = [], A = !1, R = {
      state: f,
      setOptions: function(v) {
        var I = typeof v == "function" ? v(f.options) : v;
        y(), f.options = Object.assign({}, r, f.options, I), f.scrollParents = {
          reference: rn(a) ? Nn(a) : a.contextElement ? Nn(a.contextElement) : [],
          popper: Nn(l)
        };
        var M = cm(pm([].concat(i, f.options.modifiers)));
        return f.orderedModifiers = M.filter(function(D) {
          return D.enabled;
        }), F(), R.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!A) {
          var v = f.elements, I = v.reference, M = v.popper;
          if (Ts(I, M)) {
            f.rects = {
              reference: um(I, oi(M), f.options.strategy === "fixed"),
              popper: Kr(M)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(X) {
              return f.modifiersData[X.name] = Object.assign({}, X.data);
            });
            for (var D = 0; D < f.orderedModifiers.length; D++) {
              if (f.reset === !0) {
                f.reset = !1, D = -1;
                continue;
              }
              var V = f.orderedModifiers[D], q = V.fn, x = V.options, $ = x === void 0 ? {} : x, z = V.name;
              typeof q == "function" && (f = q({
                state: f,
                options: $,
                name: z,
                instance: R
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: fm(function() {
        return new Promise(function(T) {
          R.forceUpdate(), T(f);
        });
      }),
      destroy: function() {
        y(), A = !0;
      }
    };
    if (!Ts(a, l))
      return R;
    R.setOptions(d).then(function(T) {
      !A && d.onFirstUpdate && d.onFirstUpdate(T);
    });
    function F() {
      f.orderedModifiers.forEach(function(T) {
        var v = T.name, I = T.options, M = I === void 0 ? {} : I, D = T.effect;
        if (typeof D == "function") {
          var V = D({
            state: f,
            name: v,
            instance: R,
            options: M
          }), q = function() {
          };
          g.push(V || q);
        }
      });
    }
    function y() {
      g.forEach(function(T) {
        return T();
      }), g = [];
    }
    return R;
  };
}
var mm = [Nh, nm, Mh, Fh, em, zh, rm, Dh, Yh], Cl = /* @__PURE__ */ hm({
  defaultModifiers: mm
});
const Am = {
  props: {
    /** the value of the tooltip. If left empty no tooltip is rendered */
    value: String,
    /** placement of the tooltip conform popperjs. Also determines where the tooltip will stick in case screen is too small.
     * See https://popper.js.org/docs/v1/#popperplacements--codeenumcode
     */
    placement: { type: String, default: "auto-end" }
  },
  data() {
    return {
      popperInstance: null,
      display: !1
    };
  },
  methods: {
    async showTooltip() {
      this.display = !0, await this.$nextTick();
      const e = this.$refs.tooltipContainer, n = this.$refs.toolTip;
      e && n && (this.popperInstance = Cl(e, n, {
        strategy: "fixed",
        placement: this.placement
      }));
    },
    async destroyTooltip() {
      this.popperInstance?.destroy(), this.display = !1;
    }
  }
}, gm = {
  key: 0,
  ref: "toolTip"
}, ym = { class: "mg-tooltip m-1" };
function Km(e, n, t, i, o, r) {
  return u(), c("span", {
    class: "mg-tooltip-container",
    onMouseenter: n[0] || (n[0] = (...s) => r.showTooltip && r.showTooltip(...s)),
    onMouseleave: n[1] || (n[1] = (...s) => r.destroyTooltip && r.destroyTooltip(...s)),
    ref: "tooltipContainer"
  }, [
    j(e.$slots, "default"),
    t.value && o.display ? (u(), c("div", gm, [
      p("div", ym, E(t.value), 1)
    ], 512)) : b("", !0)
  ], 544);
}
const vn = /* @__PURE__ */ P(Am, [["render", Km]]), bm = {
  extends: it,
  components: {
    Tooltip: vn
  },
  props: {
    label: String,
    icon: String,
    tooltip: String
  }
}, vm = {
  key: 0,
  class: "mr-2"
};
function wm(e, n, t, i, o, r) {
  const s = K("Tooltip");
  return u(), c("button", {
    class: "btn p-0 m-0 btn-outline-primary border-0",
    onClick: n[0] || (n[0] = ve((...a) => e.onClick && e.onClick(...a), ["prevent"]))
  }, [
    O(s, {
      value: t.tooltip,
      class: "mt-n1 mb-n1 p-1"
    }, {
      default: w(() => [
        t.label ? (u(), c("span", vm, E(t.label), 1)) : b("", !0),
        p("i", {
          class: G("fas fa-fw fa-" + t.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]);
}
const Rt = /* @__PURE__ */ P(bm, [["render", wm]]), Cm = {
  extends: Rt
}, Rm = {
  key: 0,
  class: "mr-2"
};
function Fm(e, n, t, i, o, r) {
  const s = K("Tooltip");
  return u(), c("button", {
    class: "btn p-0 m-0 btn-outline-danger border-0",
    onClick: n[0] || (n[0] = (...a) => e.onClick && e.onClick(...a))
  }, [
    O(s, {
      value: e.tooltip,
      class: "p-1 mt-n1 mb-n1"
    }, {
      default: w(() => [
        e.label ? (u(), c("span", Rm, E(e.label), 1)) : b("", !0),
        p("i", {
          class: G("fas fa-fw fa-" + e.icon)
        }, null, 2)
      ]),
      _: 1
    }, 8, ["value"])
  ]);
}
const Rr = /* @__PURE__ */ P(Cm, [["render", Fm]]), km = {}, Um = { class: "input-group" }, Em = {
  key: 0,
  class: "input-group-prepend"
}, Sm = {
  key: 1,
  class: "input-group-append"
};
function Tm(e, n) {
  return u(), c("div", Um, [
    e.$slots.prepend ? (u(), c("div", Em, [
      j(e.$slots, "prepend")
    ])) : b("", !0),
    j(e.$slots, "default"),
    e.$slots.append ? (u(), c("div", Sm, [
      j(e.$slots, "append")
    ])) : b("", !0)
  ]);
}
const Qe = /* @__PURE__ */ P(km, [["render", Tm]]), Im = {
  name: "InputString",
  components: { FormGroup: Te, InputGroup: Qe },
  extends: ke,
  props: {
    stringLength: {
      type: Number,
      default: 255
    }
  },
  computed: {
    stringError() {
      return this.modelValue && this.modelValue.length && this.modelValue.length > this.stringLength ? `Please limit to ${this.stringLength} characters.` : this.errorMessage;
    }
  }
}, Dm = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function Om(e, n, t, i, o, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: w(() => [
      O(s, null, {
        prepend: w(() => [
          j(e.$slots, "prepend", {}, void 0, !0)
        ]),
        append: w(() => [
          j(e.$slots, "append", {}, void 0, !0)
        ]),
        default: w(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (l) => e.$emit("update:modelValue", l.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholderValue,
            readonly: e.readonly
          }, null, 42, Dm)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const kt = /* @__PURE__ */ P(Im, [["render", Om], ["__scopeId", "data-v-eb9c2ec3"]]), _m = "{_session { email, token, settings{key,value}}}", Pm = `mutation change($users:[UsersInput]){
        change(users:$users){
            message
          }
        }`, Mm = `mutation createToken($email:String,$tokenName:String){
        createToken(email:$email,tokenName:$tokenName){
            message,token
          }
        }`, Lm = Se({
  components: {
    ButtonAction: it,
    InputString: kt,
    IconDanger: Rr,
    MessageSuccess: Fn,
    MessageError: At,
    Tooltip: vn
  },
  data() {
    return {
      session: null,
      tokenName: "",
      lastTokenValue: "",
      errorMessage: "",
      successMessage: ""
    };
  },
  computed: {
    accessTokens() {
      const e = this.session?.settings?.find(
        (n) => n.key === "access-tokens" && !!n.value
      );
      return e ? e.value.split(",").filter((n) => n !== "") : [];
    },
    duplicateNameMessage() {
      return this.accessTokens.includes(this.tokenName) ? "Duplicate token name" : "";
    }
  },
  methods: {
    async fetchSession() {
      const e = await Ge("/api/graphql", _m);
      this.session = e._session;
    },
    clean() {
      this.errorMessage = "", this.successMessage = "", this.lastTokenValue = "";
    },
    async deleteToken(e) {
      this.clean();
      let n = this.accessTokens;
      n.splice(e, 1);
      const t = {
        users: {
          email: this.session?.email,
          settings: {
            key: "access-tokens",
            value: n.join(",")
          }
        }
      };
      Ge("/api/graphql", Pm, t).then(() => {
        this.successMessage = "Token removed", this.lastTokenValue = "", this.fetchSession();
      }).catch((i) => {
        this.errorMessage = i.message;
      });
    },
    async createToken() {
      this.clean();
      const e = {
        email: this.session?.email,
        tokenName: this.tokenName
      };
      Ge("/api/graphql", Mm, e).then((n) => {
        this.successMessage = n.createToken.message, this.lastTokenValue = n.createToken.token, this.tokenName = "", this.fetchSession();
      }).catch((n) => {
        this.errorMessage = n.message;
      });
    },
    copyToClipboard(e) {
      navigator.clipboard.writeText(e);
    }
  },
  mounted() {
    this.fetchSession();
  }
}), Nm = { key: 0 }, Bm = {
  key: 0,
  style: { cursor: "pointer" }
}, xm = { class: "form-inline" };
function qm(e, n, t, i, o, r) {
  const s = K("IconDanger"), a = K("Tooltip"), l = K("MessageSuccess"), d = K("MessageError"), f = K("ButtonAction"), g = K("InputString");
  return u(), c("div", null, [
    e.accessTokens.length ? (u(), c("div", Nm, [
      n[3] || (n[3] = p("label", null, [
        p("b", null, "Access tokens")
      ], -1)),
      p("ul", null, [
        (u(!0), c(ie, null, se(e.accessTokens, (A, R) => (u(), c("li", { key: A }, [
          N(E(A) + " ", 1),
          O(s, {
            onClick: (F) => e.deleteToken(R),
            icon: "times"
          }, null, 8, ["onClick"])
        ]))), 128))
      ])
    ])) : b("", !0),
    e.successMessage ? (u(), k(l, { key: 1 }, {
      default: w(() => [
        N(E(e.successMessage) + ". ", 1),
        e.lastTokenValue ? (u(), c("div", Bm, [
          p("label", null, [
            p("b", null, [
              n[5] || (n[5] = N(" New token. Please copy for use: ", -1)),
              O(a, {
                value: "Click to copy to clipboard",
                placement: "top",
                onClick: n[0] || (n[0] = ve((A) => e.copyToClipboard(e.lastTokenValue), ["prevent"]))
              }, {
                default: w(() => [...n[4] || (n[4] = [
                  p("i", {
                    id: "copy-icon",
                    class: "fa fa-clipboard"
                  }, null, -1)
                ])]),
                _: 1
              })
            ])
          ]),
          p("pre", {
            onClick: n[1] || (n[1] = ve((A) => e.copyToClipboard(e.lastTokenValue), ["prevent"]))
          }, "          " + E(e.lastTokenValue) + `
        `, 1)
        ])) : b("", !0)
      ]),
      _: 1
    })) : b("", !0),
    e.errorMessage ? (u(), k(d, { key: 2 }, {
      default: w(() => [
        N(E(e.errorMessage), 1)
      ]),
      _: 1
    })) : b("", !0),
    n[7] || (n[7] = p("label", null, [
      p("b", null, "Create a token")
    ], -1)),
    p("form", xm, [
      e.tokenName ? (u(), k(f, {
        key: e.tokenName,
        disabled: !!e.duplicateNameMessage,
        onClick: e.createToken
      }, {
        default: w(() => [...n[6] || (n[6] = [
          N(" Create token ", -1)
        ])]),
        _: 1
      }, 8, ["disabled", "onClick"])) : b("", !0),
      O(g, {
        id: "token-name",
        placeholder: "new token name",
        modelValue: e.tokenName,
        "onUpdate:modelValue": n[2] || (n[2] = (A) => e.tokenName = A),
        errorMessage: e.duplicateNameMessage
      }, null, 8, ["modelValue", "errorMessage"])
    ])
  ]);
}
const Vm = /* @__PURE__ */ P(Lm, [["render", qm]]), jm = Se({
  components: {
    LayoutModal: Et,
    ButtonAlt: mt,
    ButtonAction: it,
    InputPassword: Ar,
    MessageError: At,
    MessageSuccess: Fn,
    Spinner: Ut,
    TokenManager: Vm
  },
  props: {
    user: String
  },
  data() {
    return {
      password: null,
      password2: null,
      loading: !1,
      graphqlError: null,
      success: null,
      error: null
    };
  },
  methods: {
    async updatePassword() {
      if (this.password !== this.password2)
        this.error = "Error: Passwords entered must be the same";
      else {
        this.error = null, this.loading = !0;
        const e = await Ge(
          "graphql",
          `mutation{changePassword(password: "${this.password}"){status,message}}`
        ).catch((n) => {
          this.graphqlError = JSON.stringify(n);
        });
        e.changePassword.status === "SUCCESS" ? this.success = "Success. Password changed" : this.error = "Password change failed: " + e.changePassword.message, this.loading = !1;
      }
    },
    close() {
      this.error = null, this.$emit("cancel");
    }
  },
  emits: ["cancel"]
});
function Hm(e, n, t, i, o, r) {
  const s = K("Spinner"), a = K("MessageSuccess"), l = K("MessageError"), d = K("InputPassword"), f = K("ButtonAction"), g = K("TokenManager"), A = K("LayoutForm"), R = K("ButtonAlt"), F = K("LayoutModal");
  return e.loading ? (u(), k(s, { key: 0 })) : (u(), k(F, {
    key: 1,
    title: "Change account",
    show: !0,
    onClose: e.close
  }, {
    body: w(() => [
      O(A, null, {
        default: w(() => [
          n[3] || (n[3] = p("h2", null, "Change password", -1)),
          e.success ? (u(), k(a, { key: 0 }, {
            default: w(() => [
              N(E(e.success), 1)
            ]),
            _: 1
          })) : b("", !0),
          e.graphqlError ? (u(), k(l, { key: 1 }, {
            default: w(() => [
              N(E(e.graphqlError), 1)
            ]),
            _: 1
          })) : b("", !0),
          O(d, {
            id: "account-password",
            modelValue: e.password,
            "onUpdate:modelValue": n[0] || (n[0] = (y) => e.password = y),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the password",
            onEnterPressed: e.updatePassword
          }, null, 8, ["modelValue", "onEnterPressed"]),
          O(d, {
            id: "account-password2",
            modelValue: e.password2,
            "onUpdate:modelValue": n[1] || (n[1] = (y) => e.password2 = y),
            label: "Password Repeat",
            placeholder: "Enter password",
            description: "Please enter the password again",
            onEnterPressed: e.updatePassword
          }, null, 8, ["modelValue", "onEnterPressed"]),
          O(f, { onClick: e.updatePassword }, {
            default: w(() => [...n[2] || (n[2] = [
              N("Update password", -1)
            ])]),
            _: 1
          }, 8, ["onClick"]),
          n[4] || (n[4] = p("h2", { class: "mt-4" }, "Manage tokens", -1)),
          O(g)
        ]),
        _: 1
      })
    ]),
    footer: w(() => [
      O(R, { onClick: e.close }, {
        default: w(() => [...n[5] || (n[5] = [
          N("Close", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const Gm = /* @__PURE__ */ P(jm, [["render", Hm]]), Qm = {
  name: "ButtonOutline",
  extends: it,
  props: {
    light: { type: Boolean, default: !1 }
  }
}, $m = ["disabled"];
function Jm(e, n, t, i, o, r) {
  return u(), c("button", {
    type: "button",
    class: G(t.light ? "btn btn-outline-light" : "btn btn-outline-primary"),
    disabled: e.disabled,
    onClick: n[0] || (n[0] = ve((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    e.icon ? (u(), c("i", {
      key: 0,
      class: G(["fa-" + e.icon, "fa fa-fw mr-2 ml-0"])
    }, null, 2)) : b("", !0),
    j(e.$slots, "default")
  ], 10, $m);
}
const Ji = /* @__PURE__ */ P(Qm, [["render", Jm]]), zm = {
  name: "ButtonAction",
  props: {
    href: String,
    icon: String,
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Wm = ["disabled"];
function Ym(e, n, t, i, o, r) {
  return u(), c("button", {
    type: "submit",
    class: "btn btn-primary",
    disabled: t.disabled
  }, [
    j(e.$slots, "default"),
    t.icon ? (u(), c("i", {
      key: 0,
      class: G(["fa fa-fw fa-" + t.icon, "mr-2 ml-0"])
    }, null, 2)) : b("", !0)
  ], 8, Wm);
}
const Xm = /* @__PURE__ */ P(zm, [["render", Ym]]), Zm = {};
function eA(e, n) {
  return u(), c("form", {
    onSubmit: n[0] || (n[0] = ve((t) => e.$emit("submit"), ["prevent"]))
  }, [
    j(e.$slots, "default")
  ], 32);
}
const tA = /* @__PURE__ */ P(Zm, [["render", eA]]), nA = {
  extends: ke,
  components: {
    FormGroup: Te
  },
  props: {
    options: Array,
    hideClearButton: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      result: this.modelValue ? [...this.modelValue] : []
    };
  }
}, iA = ["id", "value", "aria-describedby"], oA = ["for"];
function rA(e, n, t, i, o, r) {
  const s = K("FormGroup");
  return u(), k(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    class: "checkbox-form-group",
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      (u(!0), c(ie, null, se(t.options, (a, l) => (u(), c("div", {
        key: l,
        class: "form-check form-check-inline"
      }, [
        tt(p("input", {
          id: `${e.id}-${l}`,
          "onUpdate:modelValue": n[0] || (n[0] = (d) => o.result = d),
          class: "form-check-input",
          type: "checkbox",
          value: a,
          onChange: n[1] || (n[1] = (d) => e.$emit(
            "update:modelValue",
            o.result.filter((f) => f !== null)
          )),
          "aria-describedby": `${e.id}-help`
        }, null, 40, iA), [
          [ea, o.result]
        ]),
        p("label", {
          class: "form-check-label",
          for: `${e.id}-${l}`
        }, E(a), 9, oA)
      ]))), 128)),
      t.hideClearButton ? b("", !0) : (u(), c("button", {
        key: 0,
        class: "checkbox-clear-value btn-link btn m-0 p-0",
        onClick: n[2] || (n[2] = ve((a) => {
          o.result = [], e.$emit("update:modelValue", o.result);
        }, ["prevent"]))
      }, " clear "))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const sA = /* @__PURE__ */ P(nA, [["render", rA]]), { POLICY_TEXT_KEY: aA } = Hc, lA = Se({
  name: "MolgenisSignin",
  components: {
    ButtonAlt: mt,
    InputPassword: Ar,
    InputString: kt,
    MessageError: At,
    MessageSuccess: Fn,
    FormMolgenis: tA,
    LayoutModal: Et,
    ButtonSubmit: Xm,
    InputCheckbox: sA
  },
  data: function() {
    return {
      email: "",
      password: "",
      error: "",
      success: null,
      loading: !1,
      userAgrees: [],
      privacyPolicyLabel: "Agree with privacy policy",
      privacyPolicy: "",
      isPrivacyPolicyEnabled: !1,
      privacyError: "Please agree with the privacy policy"
    };
  },
  methods: {
    async signin() {
      !this.email || !this.password ? this.error = "Email and password should be filled in" : this.isPrivacyPolicyEnabled && this.userAgrees[0] !== this.privacyPolicyLabel ? this.error = this.privacyError : (this.error = "", this.loading = !0, Ge(
        "/api/graphql",
        `mutation{signin(email: "${this.email}", password: "${this.password}"){status,message}}`
      ).then(
        (e) => {
          e.signin.status === "SUCCESS" ? (this.success = "Signed in with " + this.email, this.$emit("signin", this.email)) : this.error = e.signin.message;
        }
      ).catch(
        (e) => this.error = "internal server graphqlError" + e
      ), this.loading = !1);
    },
    onSignInFailed(e) {
      this.error = e, this.$emit("signInFailed", this.email);
    },
    onCancel() {
      this.error = "", this.$emit("cancel");
    },
    async fetchPrivacyPolicy() {
      const e = await Ge(
        "graphql",
        "{_settings{key, value}}"
      ), n = e._settings.find(
        (i) => i.key === aA
      );
      this.privacyPolicy = n?.value;
      const t = e._settings.find((i) => i.key === "isPrivacyPolicyEnabled");
      this.isPrivacyPolicyEnabled = t?.value === "true";
    }
  },
  watch: {
    async show(e) {
      e === !0 && await this.$nextTick(), this.$refs.email.$el.children[1].focus();
    }
  },
  emits: ["cancel", "signInFailed", "signin"],
  mounted() {
    this.fetchPrivacyPolicy();
  }
}), uA = { key: 0 };
function dA(e, n, t, i, o, r) {
  const s = K("MessageSuccess"), a = K("ButtonAlt"), l = K("MessageError"), d = K("InputString"), f = K("InputPassword"), g = K("InputCheckbox"), A = K("FormMolgenis"), R = K("ButtonSubmit"), F = K("LayoutModal");
  return e.success ? (u(), c("div", uA, [
    O(s, null, {
      default: w(() => [
        N(E(e.success), 1)
      ]),
      _: 1
    }),
    O(a, { onClick: e.onCancel }, {
      default: w(() => [...n[3] || (n[3] = [
        N("Close", -1)
      ])]),
      _: 1
    }, 8, ["onClick"])
  ])) : (u(), k(F, {
    key: 1,
    title: "Sign in",
    show: !0,
    onClose: e.onCancel
  }, {
    body: w(() => [
      O(A, {
        id: "signin-form",
        onSubmit: e.signin
      }, {
        default: w(() => [
          e.error ? (u(), k(l, { key: 0 }, {
            default: w(() => [
              N(E(e.error), 1)
            ]),
            _: 1
          })) : b("", !0),
          O(d, {
            id: "signInFormEmail",
            ref: "email",
            name: "email",
            modelValue: e.email,
            "onUpdate:modelValue": n[0] || (n[0] = (y) => e.email = y),
            label: "Username",
            placeholder: "Enter username",
            description: "Please enter username",
            autofocus: ""
          }, null, 8, ["modelValue"]),
          O(f, {
            id: "signInFormPassword",
            name: "password",
            modelValue: e.password,
            "onUpdate:modelValue": n[1] || (n[1] = (y) => e.password = y),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the provided password",
            onEnterPressed: e.signin
          }, null, 8, ["modelValue", "onEnterPressed"]),
          e.isPrivacyPolicyEnabled ? (u(), c("div", {
            key: 1,
            class: G(["alert", e.error === e.privacyError ? "alert-danger" : "alert-info"]),
            role: "alert"
          }, [
            n[4] || (n[4] = p("b", null, "Privacy policy", -1)),
            p("p", null, E(e.privacyPolicy), 1),
            O(g, {
              class: "mb-0",
              id: "privacy-agreement",
              name: "privacy-agreement",
              required: !0,
              options: [e.privacyPolicyLabel],
              hideClearButton: !0,
              modelValue: e.userAgrees,
              "onUpdate:modelValue": n[2] || (n[2] = (y) => e.userAgrees = y)
            }, null, 8, ["options", "modelValue"])
          ], 2)) : b("", !0)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    footer: w(() => [
      O(a, { onClick: e.onCancel }, {
        default: w(() => [...n[5] || (n[5] = [
          N("Cancel", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]),
      O(R, { form: "signin-form" }, {
        default: w(() => [...n[6] || (n[6] = [
          N(" Sign in ", -1)
        ])]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const cA = /* @__PURE__ */ P(lA, [["render", dA]]), fA = {};
function pA(e, n, t, i, o, r) {
  return u(), c("form", null, [
    j(e.$slots, "default")
  ]);
}
const hA = /* @__PURE__ */ P(fA, [["render", pA]]), mA = Se({
  components: {
    ButtonAction: it,
    ButtonAlt: mt,
    InputPassword: Ar,
    InputString: kt,
    MessageError: At,
    MessageSuccess: Fn,
    LayoutForm: hA,
    Spinner: Ut,
    LayoutModal: Et
  },
  data: function() {
    return {
      email: null,
      password: null,
      passwordRepeat: null,
      loading: !1,
      error: null,
      success: null
    };
  },
  methods: {
    signup() {
      this.email === null || this.password === null || this.passwordRepeat === null ? this.error = "Error: valid email address and password should be filled in" : this.password !== this.passwordRepeat ? this.error = "Error: Passwords entered must be the same" : (this.error = null, this.loading = !0, Ge(
        "/api/graphql",
        `mutation{signup(email: "${this.email}", password: "${this.password}"){status,message}}`
      ).then((e) => {
        e.signup.status === "SUCCESS" ? this.success = "Success. Signed up with email: " + this.email : this.error = "Signup failed: " + e.signup.message;
      }).catch((e) => {
        this.error = "Sign up failed: " + e.response.message;
      }), this.loading = !1);
    },
    close() {
      this.error = null, this.$emit("close");
    }
  },
  emits: ["close"]
});
function AA(e, n, t, i, o, r) {
  const s = K("Spinner"), a = K("MessageSuccess"), l = K("ButtonAlt"), d = K("LayoutModal"), f = K("MessageError"), g = K("InputString"), A = K("InputPassword"), R = K("LayoutForm"), F = K("ButtonAction");
  return e.loading ? (u(), k(s, { key: 0 })) : e.success ? (u(), k(d, {
    key: 1,
    title: "Sign up",
    show: !0
  }, {
    body: w(() => [
      O(a, null, {
        default: w(() => [
          N(E(e.success), 1)
        ]),
        _: 1
      })
    ]),
    footer: w(() => [
      O(l, { onClick: e.close }, {
        default: w(() => [...n[3] || (n[3] = [
          N("Close", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  })) : (u(), k(d, {
    key: 2,
    title: "Sign up",
    show: !0,
    onClose: e.close
  }, {
    body: w(() => [
      O(R, null, {
        default: w(() => [
          e.error ? (u(), k(f, { key: 0 }, {
            default: w(() => [
              N(E(e.error), 1)
            ]),
            _: 1
          })) : b("", !0),
          O(g, {
            id: "signup-email",
            modelValue: e.email,
            "onUpdate:modelValue": n[0] || (n[0] = (y) => e.email = y),
            label: "Email address",
            placeholder: "Enter valid email address",
            description: "Please enter your email address"
          }, null, 8, ["modelValue"]),
          O(A, {
            id: "signup-password",
            modelValue: e.password,
            "onUpdate:modelValue": n[1] || (n[1] = (y) => e.password = y),
            label: "Password",
            placeholder: "Enter password",
            description: "Please enter the password",
            onEnterPressed: e.signup
          }, null, 8, ["modelValue", "onEnterPressed"]),
          O(A, {
            id: "signup-password-repeat",
            modelValue: e.passwordRepeat,
            "onUpdate:modelValue": n[2] || (n[2] = (y) => e.passwordRepeat = y),
            label: "Password Repeat",
            placeholder: "Enter password",
            description: "Please enter the password again",
            onEnterPressed: e.signup
          }, null, 8, ["modelValue", "onEnterPressed"])
        ]),
        _: 1
      })
    ]),
    footer: w(() => [
      O(l, { onClick: e.close }, {
        default: w(() => [...n[4] || (n[4] = [
          N("Cancel", -1)
        ])]),
        _: 1
      }, 8, ["onClick"]),
      O(F, { onClick: e.signup }, {
        default: w(() => [...n[5] || (n[5] = [
          N("Sign up", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]));
}
const gA = /* @__PURE__ */ P(mA, [["render", AA]]);
var Is = {
  expireTimes: "1d",
  path: "; path=/",
  domain: "",
  secure: !1,
  sameSite: "; SameSite=Lax"
}, yA = (
  /** @class */
  (function() {
    function e() {
      this.current_default_config = Is;
    }
    return e.prototype.config = function(n) {
      for (var t in this.current_default_config)
        this.current_default_config[t] = n[t] ? n[t] : Is[t];
    }, e.prototype.get = function(n) {
      var t = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(n).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
      if (t && t.substring(0, 1) === "{" && t.substring(t.length - 1, t.length) === "}")
        try {
          t = JSON.parse(t);
        } catch {
          return t;
        }
      return t;
    }, e.prototype.set = function(n, t, i, o, r, s, a) {
      if (n) {
        if (/^(?:expires|max-age|path|domain|secure|SameSite)$/i.test(n))
          throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + n);
      } else throw new Error("Cookie name is not found in the first argument.");
      t && t.constructor === Object && (t = JSON.stringify(t));
      var l = "";
      if (i == null && (i = this.current_default_config.expireTimes ? this.current_default_config.expireTimes : ""), i && i != 0)
        switch (i.constructor) {
          case Number:
            i === 1 / 0 || i === -1 ? l = "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : l = "; max-age=" + i;
            break;
          case String:
            if (/^(?:\d+(y|m|d|h|min|s))$/i.test(i)) {
              var d = i.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
              switch (i.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()) {
                // Frequency sorting
                case "m":
                  l = "; max-age=" + +d * 2592e3;
                  break;
                // 60 * 60 * 24 * 30
                case "d":
                  l = "; max-age=" + +d * 86400;
                  break;
                // 60 * 60 * 24
                case "h":
                  l = "; max-age=" + +d * 3600;
                  break;
                // 60 * 60
                case "min":
                  l = "; max-age=" + +d * 60;
                  break;
                // 60
                case "s":
                  l = "; max-age=" + d;
                  break;
                case "y":
                  l = "; max-age=" + +d * 31104e3;
                  break;
              }
            } else
              l = "; expires=" + i;
            break;
          case Date:
            l = "; expires=" + i.toUTCString();
            break;
        }
      return document.cookie = encodeURIComponent(n) + "=" + encodeURIComponent(t) + l + (r ? "; domain=" + r : this.current_default_config.domain ? this.current_default_config.domain : "") + (o ? "; path=" + o : this.current_default_config.path ? this.current_default_config.path : "; path=/") + (s == null ? this.current_default_config.secure ? "; Secure" : "" : s ? "; Secure" : "") + (a == null ? this.current_default_config.sameSite ? "; SameSute=" + this.current_default_config.sameSite : "" : a ? "; SameSite=" + a : ""), this;
    }, e.prototype.remove = function(n, t, i) {
      return !n || !this.isKey(n) ? !1 : (document.cookie = encodeURIComponent(n) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (i ? "; domain=" + i : this.current_default_config.domain ? this.current_default_config.domain : "") + (t ? "; path=" + t : this.current_default_config.path ? this.current_default_config.path : "; path=/") + "; SameSite=Lax", !0);
    }, e.prototype.isKey = function(n) {
      return new RegExp("(?:^|;\\s*)" + encodeURIComponent(n).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    }, e.prototype.keys = function() {
      if (!document.cookie)
        return [];
      for (var n = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/), t = 0; t < n.length; t++)
        n[t] = decodeURIComponent(n[t]);
      return n;
    }, e;
  })()
), vo = null;
function Rl() {
  vo == null && (vo = new yA());
  var e = Au(vo);
  return { cookies: e };
}
const { cookies: KA } = Rl(), bA = {
  name: "LocaleSwitch",
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    locales: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      cookies: null
    };
  },
  methods: {
    emit(e) {
      e.target.value !== void 0 ? (KA.set("MOLGENIS.locale", e.target.value), this.$emit("update:modelValue", e.target.value)) : this.$emit("update:modelValue", "en");
    }
  },
  emits: ["update:modelValue"]
}, vA = { class: "d-inline-flex from-group" }, wA = ["modelValue"], CA = ["selected"];
function RA(e, n, t, i, o, r) {
  return u(), c("div", vA, [
    p("select", {
      class: "form-control bg-primary text-white border-0 mr-2 pl-0 pr-0",
      modelValue: t.modelValue,
      onInput: n[0] || (n[0] = (...s) => r.emit && r.emit(...s))
    }, [
      (u(!0), c(ie, null, se(t.locales, (s) => (u(), c("option", {
        key: s,
        selected: s === t.modelValue
      }, E(s), 9, CA))), 128))
    ], 40, wA)
  ]);
}
const FA = /* @__PURE__ */ P(bA, [["render", RA]]), { cookies: kA } = Rl(), Ds = `{
  _session { email, admin, roles, tablePermissions{name,id,canView,canInsert,canUpdate,canDelete,isRowLevel}, schemas, token, settings{key,value} },
  _settings (keys: ["menu", "page.", "cssURL", "logoURL", "isOidcEnabled","locales", "additionalCss", "additionalFooterHtml", "additionalJs"]){ key, value },
  _manifest { ImplementationVersion,SpecificationVersion,DatabaseVersion }
}`, Os = { locale: "en", settings: {} }, UA = Se({
  components: {
    ButtonOutline: Ji,
    MolgenisSignin: cA,
    SignupForm: gA,
    MolgenisAccount: Gm,
    Spinner: Ut,
    ButtonAlt: mt,
    LocaleSwitch: FA
  },
  props: {
    graphql: {
      default: "graphql",
      type: String
    }
  },
  data: function() {
    return {
      showSigninForm: !1,
      showSignupForm: !1,
      showChangePasswordForm: !1,
      error: null,
      loading: !1,
      session: Os,
      version: null
    };
  },
  watch: {
    email() {
      this.showSigninForm = !1, this.showSignupForm = !1;
    }
  },
  created() {
    this.reload();
  },
  computed: {
    isOidcEnabled() {
      return this.session?.settings?.isOidcEnabled === "true";
    },
    oidcLoginUrl() {
      return "/_login" + (window?.location?.href ? `?redirect=${encodeURIComponent(window.location.href)}` : "");
    },
    locales() {
      if (this.session?.settings?.locales) {
        if (Array.isArray(this.session.settings.locales))
          return this.session.settings.locales;
        this.error = 'locales should be array similar to ["en"] but instead was ' + JSON.stringify(this.session.settings.locales);
      }
      return ["en"];
    }
  },
  methods: {
    loadSettings(e) {
      e._settings.forEach((n) => {
        const t = n.value?.startsWith("[") || n.value?.startsWith("{") ? this.parseJson(n.value) : n.value;
        this.session.settings === void 0 && (this.session.settings = {}), this.session.settings[n.key] = t;
      });
    },
    async reload() {
      this.loading = !0;
      const e = await Promise.allSettled([
        Ge("/apps/central/graphql", Ds),
        Ge(this.graphql, Ds)
      ]), n = e[0].status === "fulfilled" ? e[0].value : this.handleError(e[0].reason), t = e[1].status === "fulfilled" ? e[1].value : this.handleError(e[1].reason);
      if (t && t._session ? this.session = t._session : this.session = Os, n && n._settings && (this.loadSettings(n), this.session.manifest = n._manifest), t && t._settings && (this.loadSettings(t), this.session.settings && t._settings.find((i) => i.key === "menu") === void 0 && n?._settings.find((i) => i.key === "menu") !== void 0 && delete this.session.settings.menu, this.session.manifest = t._manifest), this.session.locale === void 0) {
        const i = kA.get("MOLGENIS.locale");
        i && (this.session.locale = i);
      }
      this.loading = !1, this.$emit("update:modelValue", this.session);
    },
    handleError(e) {
      this.error = "internal server error " + e, e?.response?.data?.errors[0]?.message ? this.$emit("error", e.response.data.errors[0].message) : this.$emit("error", this.error);
    },
    parseJson(e) {
      try {
        return JSON.parse(e);
      } catch (n) {
        return this.error = "Parsing of settings failed: " + n + ". value: " + e, null;
      }
    },
    changed() {
      this.reload(), this.showSigninForm = !1, this.$emit("update:modelValue", this.session);
    },
    closeSigninForm() {
      this.showSigninForm = !1, this.error = null;
    },
    closeSignupForm() {
      this.showSignupForm = !1, this.error = null;
    },
    async signout() {
      this.loading = !0, this.showSigninForm = !1, (await Ge("graphql", "mutation{signout{status}}").catch(
        (n) => this.error = "internal server error" + n
      )).signout.status === "SUCCESS" ? this.session = {} : this.error = "sign out failed", this.loading = !1, this.$emit("update:modelValue", this.session), this.reload();
    }
  },
  emits: ["update:modelValue", "error"]
}), EA = { key: 1 }, SA = { key: 0 }, TA = { key: 1 };
function IA(e, n, t, i, o, r) {
  const s = K("Spinner"), a = K("ButtonAlt"), l = K("MolgenisAccount"), d = K("ButtonOutline"), f = K("SignupForm"), g = K("MolgenisSignin"), A = K("LocaleSwitch");
  return e.loading ? (u(), k(s, { key: 0 })) : (u(), c("div", EA, [
    p("div", null, [
      e.session.email && e.session.email != "anonymous" ? (u(), c("span", SA, [
        O(a, {
          onClick: n[0] || (n[0] = (R) => e.showChangePasswordForm = !0),
          class: "text-light"
        }, {
          default: w(() => [
            N(" Hi " + E(e.session.email), 1)
          ]),
          _: 1
        }),
        n[6] || (n[6] = N("  ", -1)),
        e.showChangePasswordForm ? (u(), k(l, {
          key: 0,
          error: e.error,
          onCancel: n[1] || (n[1] = (R) => e.showChangePasswordForm = !1)
        }, null, 8, ["error"])) : b("", !0),
        O(d, {
          onClick: e.signout,
          light: !0
        }, {
          default: w(() => [...n[5] || (n[5] = [
            N("Sign out", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ])) : (u(), c("span", TA, [
        tt(O(a, {
          onClick: n[2] || (n[2] = (R) => e.showSignupForm = !0),
          light: !0
        }, {
          default: w(() => [...n[7] || (n[7] = [
            N(" Sign up ", -1)
          ])]),
          _: 1
        }, 512), [
          [Bi, !e.isOidcEnabled]
        ]),
        e.showSignupForm ? (u(), k(f, {
          key: 0,
          error: e.error,
          onClose: e.closeSignupForm
        }, null, 8, ["error", "onClose"])) : b("", !0),
        e.isOidcEnabled ? (u(), k(d, {
          key: 1,
          href: e.oidcLoginUrl,
          light: !0
        }, {
          default: w(() => [...n[8] || (n[8] = [
            N(" Sign in", -1)
          ])]),
          _: 1
        }, 8, ["href"])) : (u(), k(d, {
          key: 2,
          onClick: n[3] || (n[3] = (R) => e.showSigninForm = !0),
          light: !0
        }, {
          default: w(() => [...n[9] || (n[9] = [
            N(" Sign in", -1)
          ])]),
          _: 1
        })),
        e.showSigninForm ? (u(), k(g, {
          key: 3,
          onSignin: e.changed,
          onCancel: e.closeSigninForm
        }, null, 8, ["onSignin", "onCancel"])) : b("", !0)
      ])),
      e.locales.length > 1 ? (u(), k(A, {
        key: 2,
        class: "ml-2",
        modelValue: e.session.locale,
        "onUpdate:modelValue": n[4] || (n[4] = (R) => e.session.locale = R),
        locales: e.locales
      }, null, 8, ["modelValue", "locales"])) : b("", !0)
    ]),
    (u(), k(Pt("style"), null, {
      default: w(() => [
        N(E(e.session?.settings?.additionalCss), 1)
      ]),
      _: 1
    }))
  ]));
}
const DA = /* @__PURE__ */ P(UA, [["render", IA]]), OA = {
  name: "PersonDetails",
  computed: {
    imgSrc() {
      return `
        data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQ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        `;
    }
  }
}, _A = { class: "card" }, PA = { class: "row no-gutters" }, MA = { class: "col-8 small" }, LA = { class: "col-4" }, NA = ["src"];
function BA(e, n, t, i, o, r) {
  return u(), c("div", _A, [
    p("div", PA, [
      p("div", MA, [
        j(e.$slots, "details", {}, () => [
          n[0] || (n[0] = p("strong", null, "Anonymous", -1))
        ], !0)
      ]),
      p("div", LA, [
        j(e.$slots, "image", {}, () => [
          p("img", {
            src: r.imgSrc,
            alt: "person-place-holder-image",
            class: "img-thumbnail"
          }, null, 8, NA)
        ], !0)
      ])
    ])
  ]);
}
const xA = /* @__PURE__ */ P(OA, [["render", BA], ["__scopeId", "data-v-283371f3"]]), qA = {
  name: "ContactDisplay",
  components: { PersonDetails: xA },
  props: {
    contact: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    contributionType: {
      type: Array,
      required: !1,
      default: () => []
    },
    contributionDescription: {
      type: String,
      required: !1
    }
  },
  computed: {
    contributions() {
      return [...this.contributionType].sort((e, n) => e.order - n.order).map((e) => e.name).join(",");
    },
    imgSrc() {
      return this.contact.photo && this.contact.photo.url ? this.contact.photo.url : null;
    }
  }
}, VA = { key: 0 }, jA = { key: 1 }, HA = { key: 2 }, GA = { key: 3 }, QA = { key: 4 }, $A = { key: 0 }, JA = { key: 1 }, zA = {
  key: 2,
  class: "mt-3"
}, WA = {
  key: 3,
  class: "mt-3"
}, YA = ["src", "alt"];
function XA(e, n, t, i, o, r) {
  const s = K("person-details");
  return u(), k(s, null, gu({
    details: w(() => [
      p("strong", null, [
        t.contact.title && t.contact.title.name ? (u(), c("span", VA, E(t.contact.title.name), 1)) : b("", !0),
        t.contact.initials ? (u(), c("span", jA, E(t.contact.initials), 1)) : b("", !0),
        t.contact.firstName && t.contact.initials ? (u(), c("span", HA, " (" + E(t.contact.firstName) + ") ", 1)) : t.contact.firstName ? (u(), c("span", GA, E(t.contact.firstName), 1)) : b("", !0),
        t.contact.surname ? (u(), c("span", QA, E(t.contact.surname), 1)) : b("", !0)
      ]),
      r.contributions.length ? (u(), c("div", $A, E(r.contributions), 1)) : b("", !0),
      t.contact.email ? (u(), c("div", JA, E(t.contact.email), 1)) : b("", !0),
      t.contributionDescription ? (u(), c("div", zA, [
        p("p", null, E(t.contributionDescription), 1)
      ])) : b("", !0),
      t.contact.department ? (u(), c("div", WA, [
        p("p", null, E(t.contact.department), 1)
      ])) : b("", !0)
    ]),
    _: 2
  }, [
    r.imgSrc ? {
      name: "image",
      fn: w(() => [
        p("img", {
          src: r.imgSrc,
          alt: t.contact.surname + "-image",
          class: "img-thumbnail"
        }, null, 8, YA)
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const z1 = /* @__PURE__ */ P(qA, [["render", XA], ["__scopeId", "data-v-5583439c"]]), ZA = {
  name: "GridBlock",
  props: {
    heading: {
      type: String,
      required: !1
    }
  }
}, eg = { class: "card block" }, tg = { key: 0 };
function ng(e, n, t, i, o, r) {
  return u(), c("div", eg, [
    t.heading ? (u(), c("h3", tg, E(t.heading), 1)) : b("", !0),
    j(e.$slots, "default", {}, void 0, !0)
  ]);
}
const ig = /* @__PURE__ */ P(ZA, [["render", ng], ["__scopeId", "data-v-7318de25"]]), og = {
  name: "ImageCard",
  props: {
    title: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !1
    },
    linkUrl: {
      type: String,
      required: !1
    },
    linkText: {
      type: String,
      required: !1,
      default: () => "LEARN MORE"
    }
  }
}, rg = { class: "card image-card" }, sg = { class: "card-body" }, ag = {
  key: 0,
  class: "card-title"
}, lg = {
  key: 1,
  class: "card-text"
}, ug = {
  key: 2,
  class: "card-text"
}, dg = { class: "text-muted" }, cg = ["href"];
function fg(e, n, t, i, o, r) {
  return u(), c("div", rg, [
    j(e.$slots, "image"),
    p("div", sg, [
      j(e.$slots, "body", {}, () => [
        t.title ? (u(), c("h5", ag, E(t.title), 1)) : b("", !0),
        t.description ? (u(), c("p", lg, E(t.description), 1)) : b("", !0),
        t.linkUrl ? (u(), c("p", ug, [
          p("small", dg, [
            p("a", {
              href: t.linkUrl,
              class: "stretched-link"
            }, E(t.linkText), 9, cg)
          ])
        ])) : b("", !0)
      ])
    ])
  ]);
}
const W1 = /* @__PURE__ */ P(og, [["render", fg]]), pg = {
  name: "ImageDisplay",
  props: {
    url: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      required: !1,
      default: () => "image"
    },
    id: {
      type: String,
      required: !1
    },
    size: {
      type: Number,
      required: !1
    },
    extension: {
      type: String,
      required: !1
    },
    isClickable: {
      type: Boolean,
      default: () => !1
    }
  }
}, hg = ["src", "alt"];
function mg(e, n, t, i, o, r) {
  return u(), c("img", {
    src: t.url,
    alt: t.alt,
    class: G(["img-thumbnail", { clickable: t.isClickable }]),
    onClick: n[0] || (n[0] = (s) => e.$emit("clicked", t.id))
  }, null, 10, hg);
}
const Y1 = /* @__PURE__ */ P(pg, [["render", mg], ["__scopeId", "data-v-b58d7d8b"]]), Ag = {
  props: {
    text: String,
    length: {
      type: Number,
      default: () => 20
    }
  },
  data() {
    return {
      expand: !1
    };
  }
}, gg = { key: 0 }, yg = { key: 1 }, Kg = { key: 2 }, bg = { key: 3 };
function vg(e, n, t, i, o, r) {
  return u(), c("div", null, [
    t.text === "undefined" ? (u(), c("span", gg)) : t.text.length <= t.length ? (u(), c("span", yg, E(t.text), 1)) : o.expand ? (u(), c("span", Kg, [
      N(E(t.text) + " ", 1),
      p("a", {
        onClick: n[0] || (n[0] = ve((s) => o.expand = !1, ["stop", "prevent"])),
        href: "#"
      }, "...show less ")
    ])) : (u(), c("span", bg, [
      N(E(t.text.slice(0, t.length)) + " ", 1),
      p("a", {
        onClick: n[1] || (n[1] = ve((s) => o.expand = !0, ["stop", "prevent"])),
        href: "#",
        title: "Expand text"
      }, " ...show more ")
    ]))
  ]);
}
const Fl = /* @__PURE__ */ P(Ag, [["render", vg]]), wg = {
  name: "KeyValueBlock",
  components: { GridBlock: ig, ReadMore: Fl },
  props: {
    heading: {
      type: String,
      required: !1
    },
    /**
     * List of items
     * Item has:
     * key: String (required)
     * label: String (required)
     * value: String, Number, Boolean, Object
     */
    items: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  computed: {
    computedHeading() {
      return this.heading ? this.heading : this.items.length === 1 ? this.items[0].label : null;
    }
  }
}, Cg = { key: 1 }, Rg = {
  key: 0,
  class: "list-unstyled"
}, Fg = { key: 1 };
function kg(e, n, t, i, o, r) {
  const s = K("read-more"), a = K("grid-block");
  return u(), k(a, { heading: r.computedHeading }, {
    default: w(() => [
      t.items.length === 1 && t.items[0].value ? (u(), k(s, {
        key: 0,
        text: t.items[0].value,
        length: 750
      }, null, 8, ["text"])) : t.items.length > 1 ? (u(), c("div", Cg, [
        (u(!0), c(ie, null, se(t.items, (l, d) => (u(), c("div", { key: d }, [
          p("strong", null, E(l.label), 1),
          Array.isArray(l.value) ? (u(), c("ul", Rg, [
            (u(!0), c(ie, null, se(l.value, (f, g) => (u(), c("li", { key: g }, E(f), 1))), 128))
          ])) : (u(), c("p", Fg, E(l.value), 1))
        ]))), 128))
      ])) : b("", !0)
    ]),
    _: 1
  }, 8, ["heading"]);
}
const X1 = /* @__PURE__ */ P(wg, [["render", kg]]), Ug = {
  name: "LinksList",
  props: {
    /**
     * List of link items
     * Link item has:
     * label: String
     * href: String (required)
     * text: String
     */
    items: {
      type: Array,
      required: !0
    },
    isHorizontal: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  }
}, Eg = {
  key: 0,
  class: "font-weight-bold pr-1"
}, Sg = ["href"], Tg = ["href"];
function Ig(e, n, t, i, o, r) {
  return u(), c("ul", {
    class: G(["list-group", { "list-group-horizontal": t.isHorizontal }])
  }, [
    (u(!0), c(ie, null, se(t.items, (s, a) => (u(), c("li", {
      class: "list-group-item",
      key: a
    }, [
      s.label ? (u(), c("span", Eg, E(s.label), 1)) : b("", !0),
      s.text ? (u(), c("a", {
        key: 1,
        href: s.href
      }, E(s.text), 9, Sg)) : (u(), c("a", {
        key: 2,
        href: s.href
      }, E(s.href), 9, Tg))
    ]))), 128))
  ], 2);
}
const Z1 = /* @__PURE__ */ P(Ug, [["render", Ig], ["__scopeId", "data-v-191b287c"]]), Dg = {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      required: !0
    },
    subTitle: {
      type: String,
      required: !1
    },
    subTitleLink: {
      type: [String, Object],
      required: !1
    },
    logoUrl: {
      type: String,
      required: !1
    }
  },
  computed: {
    nTitleColumns() {
      return this.logoUrl ? 9 : 12;
    },
    isVueRouterLink() {
      return this.subTitleLink && typeof this.subTitleLink == "object" || typeof this.subTitleLink == "string" && !(this.subTitleLink.startsWith("http://") || this.subTitleLink.startsWith("https://"));
    }
  }
}, Og = { class: "row" }, _g = {
  key: 0,
  class: "col-3 d-flex flex-row-reverse"
}, Pg = ["src"], Mg = { key: 0 }, Lg = { class: "text-muted" }, Ng = ["href"];
function Bg(e, n, t, i, o, r) {
  const s = K("router-link");
  return u(), c("div", null, [
    p("div", Og, [
      p("div", {
        class: G("col-" + r.nTitleColumns)
      }, [
        p("h1", null, E(t.title), 1)
      ], 2),
      t.logoUrl ? (u(), c("div", _g, [
        p("img", {
          class: "justify-content-center align-self-center",
          src: t.logoUrl,
          alt: "page logo"
        }, null, 8, Pg)
      ])) : b("", !0)
    ]),
    t.subTitle ? (u(), c("h3", Mg, [
      p("small", Lg, [
        t.subTitleLink && r.isVueRouterLink ? (u(), k(s, Zo(Jn({ key: 0 }, t.subTitleLink)), {
          default: w(() => [
            N(E(t.subTitle), 1)
          ]),
          _: 1
        }, 16)) : t.subTitleLink && !r.isVueRouterLink ? (u(), c("a", {
          key: 1,
          href: t.subTitleLink
        }, E(t.subTitle), 9, Ng)) : (u(), c(ie, { key: 2 }, [
          N(E(t.subTitle), 1)
        ], 64))
      ])
    ])) : b("", !0)
  ]);
}
const ek = /* @__PURE__ */ P(Dg, [["render", Bg], ["__scopeId", "data-v-1dd47602"]]), xg = {
  name: "TableDisplay",
  props: {
    /**
     * List of column objects, each object has a label and name
     */
    columns: {
      type: Array,
      default: () => []
    },
    /**
     * List of row objects, each row is a key value object, where the keys refer to the column.name property
     */
    rows: {
      type: Array,
      default: () => []
    },
    isClickable: {
      type: Boolean,
      default: () => !1
    }
  }
}, qg = ["onClick"];
function Vg(e, n, t, i, o, r) {
  return u(), c("table", {
    class: G(["table", { "table-hover": t.isClickable }])
  }, [
    p("thead", null, [
      p("tr", null, [
        (u(!0), c(ie, null, se(t.columns, (s, a) => (u(), c("th", {
          key: a,
          scope: "col"
        }, E(s.label), 1))), 128))
      ])
    ]),
    p("tbody", null, [
      (u(!0), c(ie, null, se(t.rows, (s, a) => (u(), c("tr", {
        key: a,
        onClick: (l) => e.$emit("row-click", s)
      }, [
        (u(!0), c(ie, null, se(t.columns, (l, d) => (u(), c("td", { key: d }, E(s[l.name]), 1))), 128))
      ], 8, qg))), 128))
    ])
  ], 2);
}
const tk = /* @__PURE__ */ P(xg, [["render", Vg]]), jg = {
  components: {
    IconAction: Rt
  },
  data() {
    return {
      expandedState: this.expanded
    };
  },
  props: {
    title: String,
    conditions: Array,
    expanded: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    count() {
      return Array.isArray(this.conditions) ? this.conditions.length : null;
    }
  }
}, Hg = { class: "mb-2 pt-2 border-top bg-white" }, Gg = { class: "mb-0 font-weight-bold p-2" }, Qg = {
  key: 0,
  class: "badge badge-secondary"
}, $g = {
  key: 0,
  class: "p-2"
};
function Jg(e, n, t, i, o, r) {
  const s = K("IconAction");
  return u(), c("div", Hg, [
    p("div", {
      class: "filter-header d-flex flex-row justify-content-between",
      onClick: n[0] || (n[0] = (a) => o.expandedState = !o.expandedState)
    }, [
      p("h6", Gg, [
        N(E(t.title) + " ", 1),
        r.count > 0 ? (u(), c("span", Qg, E(r.count), 1)) : b("", !0)
      ]),
      O(s, {
        class: "ml-auto",
        icon: o.expandedState ? "angle-up" : "angle-down"
      }, null, 8, ["icon"])
    ]),
    j(e.$slots, "header", {}, void 0, !0),
    o.expandedState ? (u(), c("div", $g, [
      j(e.$slots, "default", {}, void 0, !0)
    ])) : b("", !0)
  ]);
}
const zg = /* @__PURE__ */ P(jg, [["render", Jg], ["__scopeId", "data-v-6316fb7d"]]), Wg = {
  name: "InputRadio",
  extends: ke,
  components: { FormGroup: Te },
  props: {
    options: {
      type: Array,
      required: !0
    },
    isClearable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    direction: {
      type: String,
      required: !1,
      default: "horizontal"
    }
  },
  data() {
    return {
      radioValue: this.modelValue,
      isMouseOver: !1
    };
  },
  watch: {
    radioValue() {
      this.$emit("update:modelValue", this.radioValue);
    },
    modelValue(e) {
      this.radioValue = e;
    }
  },
  computed: {
    isClearShown() {
      return this.isClearable !== void 0 && this.isClearable === !1 ? !1 : this.isMouseOver && this.radioValue !== null && this.radioValue !== void 0;
    }
  }
}, Yg = ["id", "aria-describedby", "value"], Xg = ["for"], Zg = { class: "input-group-append" };
function ey(e, n, t, i, o, r) {
  const s = K("FormGroup");
  return u(), k(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    class: "radio-form-group",
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      p("div", {
        onMouseenter: n[2] || (n[2] = (a) => o.isMouseOver = !0),
        onMouseleave: n[3] || (n[3] = (a) => o.isMouseOver = !1),
        class: G(["input-group", t.direction === "vertical" ? "flex-column" : "flex-row"])
      }, [
        (u(!0), c(ie, null, se(t.options, (a, l) => (u(), c("div", {
          key: l,
          class: "form-check form-check-inline"
        }, [
          tt(p("input", {
            class: G(["form-check-input", { "is-invalid": e.errorMessage }]),
            type: "radio",
            id: e.id + l,
            "aria-describedby": e.id + "Help",
            value: a,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => o.radioValue = d)
          }, null, 10, Yg), [
            [yu, o.radioValue]
          ]),
          p("label", {
            class: "form-check-label",
            for: e.id + l
          }, E(a), 9, Xg)
        ]))), 128)),
        p("div", Zg, [
          tt(p("button", {
            class: "btn btn-link radio-clear-value",
            onClick: n[1] || (n[1] = (a) => o.radioValue = null)
          }, " clear ", 512), [
            [Bi, r.isClearShown]
          ])
        ])
      ], 34)
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Fr = /* @__PURE__ */ P(Wg, [["render", ey], ["__scopeId", "data-v-ac59342c"]]), ty = {
  name: "InputBoolean",
  components: { InputRadio: Fr },
  extends: ke,
  props: {
    inplace: { type: Boolean, default: !1 },
    isClearable: { type: Boolean, default: !0 }
  },
  methods: {
    insertValue(e) {
      return e === !0 ? "Yes" : e === !1 ? "No" : null;
    },
    returnValue(e) {
      return e === "Yes" ? !0 : e === "No" ? !1 : null;
    }
  }
}, ny = { key: 0 }, iy = ["id", "checked", "aria-describedby"], oy = ["for"];
function ry(e, n, t, i, o, r) {
  const s = K("InputRadio");
  return t.inplace ? (u(), c("div", ny, [
    p("input", {
      id: e.id,
      checked: e.modelValue,
      type: "checkbox",
      "aria-describedby": e.id + "Help",
      onChange: n[0] || (n[0] = (a) => e.$emit("update:modelValue", a.target.checked))
    }, null, 40, iy),
    p("label", {
      class: "ml-1",
      for: e.id
    }, E(e.label), 9, oy)
  ])) : (u(), k(s, Jn({ key: 1 }, e.$props, {
    id: e.id,
    modelValue: r.insertValue(e.modelValue),
    options: ["Yes", "No"],
    isClearable: t.isClearable,
    "onUpdate:modelValue": n[1] || (n[1] = (a) => e.$emit("update:modelValue", r.returnValue(a)))
  }), null, 16, ["id", "modelValue", "isClearable"]));
}
const zi = /* @__PURE__ */ P(ty, [["render", ry]]), sy = {
  name: "BooleanFilter",
  components: { InputBoolean: zi },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Boolean,
      required: !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function ay(e, n, t, i, o, r) {
  const s = K("InputBoolean");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    onClearCondition: n[0] || (n[0] = (a) => e.$emit("clearCondition"))
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const xo = /* @__PURE__ */ P(sy, [["render", ay]]);
var wo = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], pn = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(e) {
    return typeof console < "u" && console.warn(e);
  },
  getWeek: function(e) {
    var n = new Date(e.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var t = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - t.getTime()) / 864e5 - 3 + (t.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, $n = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(e) {
    var n = e % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, rt = function(e, n) {
  return n === void 0 && (n = 2), ("000" + e).slice(n * -1);
}, yt = function(e) {
  return e === !0 ? 1 : 0;
};
function _s(e, n) {
  var t;
  return function() {
    var i = this, o = arguments;
    clearTimeout(t), t = setTimeout(function() {
      return e.apply(i, o);
    }, n);
  };
}
var Co = function(e) {
  return e instanceof Array ? e : [e];
};
function et(e, n, t) {
  if (t === !0)
    return e.classList.add(n);
  e.classList.remove(n);
}
function Fe(e, n, t) {
  var i = window.document.createElement(e);
  return n = n || "", t = t || "", i.className = n, t !== void 0 && (i.textContent = t), i;
}
function mi(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
}
function kl(e, n) {
  if (n(e))
    return e;
  if (e.parentNode)
    return kl(e.parentNode, n);
}
function Ai(e, n) {
  var t = Fe("div", "numInputWrapper"), i = Fe("input", "numInput " + e), o = Fe("span", "arrowUp"), r = Fe("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? i.type = "number" : (i.type = "text", i.pattern = "\\d*"), n !== void 0)
    for (var s in n)
      i.setAttribute(s, n[s]);
  return t.appendChild(i), t.appendChild(o), t.appendChild(r), t;
}
function dt(e) {
  try {
    if (typeof e.composedPath == "function") {
      var n = e.composedPath();
      return n[0];
    }
    return e.target;
  } catch {
    return e.target;
  }
}
var Ro = function() {
}, Mi = function(e, n, t) {
  return t.months[n ? "shorthand" : "longhand"][e];
}, ly = {
  D: Ro,
  F: function(e, n, t) {
    e.setMonth(t.months.longhand.indexOf(n));
  },
  G: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  H: function(e, n) {
    e.setHours(parseFloat(n));
  },
  J: function(e, n) {
    e.setDate(parseFloat(n));
  },
  K: function(e, n, t) {
    e.setHours(e.getHours() % 12 + 12 * yt(new RegExp(t.amPM[1], "i").test(n)));
  },
  M: function(e, n, t) {
    e.setMonth(t.months.shorthand.indexOf(n));
  },
  S: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  U: function(e, n) {
    return new Date(parseFloat(n) * 1e3);
  },
  W: function(e, n, t) {
    var i = parseInt(n), o = new Date(e.getFullYear(), 0, 2 + (i - 1) * 7, 0, 0, 0, 0);
    return o.setDate(o.getDate() - o.getDay() + t.firstDayOfWeek), o;
  },
  Y: function(e, n) {
    e.setFullYear(parseFloat(n));
  },
  Z: function(e, n) {
    return new Date(n);
  },
  d: function(e, n) {
    e.setDate(parseFloat(n));
  },
  h: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  i: function(e, n) {
    e.setMinutes(parseFloat(n));
  },
  j: function(e, n) {
    e.setDate(parseFloat(n));
  },
  l: Ro,
  m: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  n: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  s: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  u: function(e, n) {
    return new Date(parseFloat(n));
  },
  w: Ro,
  y: function(e, n) {
    e.setFullYear(2e3 + parseFloat(n));
  }
}, Qt = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, Bn = {
  Z: function(e) {
    return e.toISOString();
  },
  D: function(e, n, t) {
    return n.weekdays.shorthand[Bn.w(e, n, t)];
  },
  F: function(e, n, t) {
    return Mi(Bn.n(e, n, t) - 1, !1, n);
  },
  G: function(e, n, t) {
    return rt(Bn.h(e, n, t));
  },
  H: function(e) {
    return rt(e.getHours());
  },
  J: function(e, n) {
    return n.ordinal !== void 0 ? e.getDate() + n.ordinal(e.getDate()) : e.getDate();
  },
  K: function(e, n) {
    return n.amPM[yt(e.getHours() > 11)];
  },
  M: function(e, n) {
    return Mi(e.getMonth(), !0, n);
  },
  S: function(e) {
    return rt(e.getSeconds());
  },
  U: function(e) {
    return e.getTime() / 1e3;
  },
  W: function(e, n, t) {
    return t.getWeek(e);
  },
  Y: function(e) {
    return rt(e.getFullYear(), 4);
  },
  d: function(e) {
    return rt(e.getDate());
  },
  h: function(e) {
    return e.getHours() % 12 ? e.getHours() % 12 : 12;
  },
  i: function(e) {
    return rt(e.getMinutes());
  },
  j: function(e) {
    return e.getDate();
  },
  l: function(e, n) {
    return n.weekdays.longhand[e.getDay()];
  },
  m: function(e) {
    return rt(e.getMonth() + 1);
  },
  n: function(e) {
    return e.getMonth() + 1;
  },
  s: function(e) {
    return e.getSeconds();
  },
  u: function(e) {
    return e.getTime();
  },
  w: function(e) {
    return e.getDay();
  },
  y: function(e) {
    return String(e.getFullYear()).substring(2);
  }
}, Ul = function(e) {
  var n = e.config, t = n === void 0 ? pn : n, i = e.l10n, o = i === void 0 ? $n : i, r = e.isMobile, s = r === void 0 ? !1 : r;
  return function(a, l, d) {
    var f = d || o;
    return t.formatDate !== void 0 && !s ? t.formatDate(a, l, f) : l.split("").map(function(g, A, R) {
      return Bn[g] && R[A - 1] !== "\\" ? Bn[g](a, f, t) : g !== "\\" ? g : "";
    }).join("");
  };
}, qo = function(e) {
  var n = e.config, t = n === void 0 ? pn : n, i = e.l10n, o = i === void 0 ? $n : i;
  return function(r, s, a, l) {
    if (!(r !== 0 && !r)) {
      var d = l || o, f, g = r;
      if (r instanceof Date)
        f = new Date(r.getTime());
      else if (typeof r != "string" && r.toFixed !== void 0)
        f = new Date(r);
      else if (typeof r == "string") {
        var A = s || (t || pn).dateFormat, R = String(r).trim();
        if (R === "today")
          f = /* @__PURE__ */ new Date(), a = !0;
        else if (t && t.parseDate)
          f = t.parseDate(r, A);
        else if (/Z$/.test(R) || /GMT$/.test(R))
          f = new Date(r);
        else {
          for (var F = void 0, y = [], T = 0, v = 0, I = ""; T < A.length; T++) {
            var M = A[T], D = M === "\\", V = A[T - 1] === "\\" || D;
            if (Qt[M] && !V) {
              I += Qt[M];
              var q = new RegExp(I).exec(r);
              q && (F = !0) && y[M !== "Y" ? "push" : "unshift"]({
                fn: ly[M],
                val: q[++v]
              });
            } else D || (I += ".");
          }
          f = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), y.forEach(function(x) {
            var $ = x.fn, z = x.val;
            return f = $(f, z, d) || f;
          }), f = F ? f : void 0;
        }
      }
      if (!(f instanceof Date && !isNaN(f.getTime()))) {
        t.errorHandler(new Error("Invalid date provided: " + g));
        return;
      }
      return a === !0 && f.setHours(0, 0, 0, 0), f;
    }
  };
};
function ct(e, n, t) {
  return t === void 0 && (t = !0), t !== !1 ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : e.getTime() - n.getTime();
}
var uy = function(e, n, t) {
  return e > Math.min(n, t) && e < Math.max(n, t);
}, Fo = function(e, n, t) {
  return e * 3600 + n * 60 + t;
}, dy = function(e) {
  var n = Math.floor(e / 3600), t = (e - n * 3600) / 60;
  return [n, t, e - n * 3600 - t * 60];
}, cy = {
  DAY: 864e5
};
function ko(e) {
  var n = e.defaultHour, t = e.defaultMinute, i = e.defaultSeconds;
  if (e.minDate !== void 0) {
    var o = e.minDate.getHours(), r = e.minDate.getMinutes(), s = e.minDate.getSeconds();
    n < o && (n = o), n === o && t < r && (t = r), n === o && t === r && i < s && (i = e.minDate.getSeconds());
  }
  if (e.maxDate !== void 0) {
    var a = e.maxDate.getHours(), l = e.maxDate.getMinutes();
    n = Math.min(n, a), n === a && (t = Math.min(l, t)), n === a && t === l && (i = e.maxDate.getSeconds());
  }
  return { hours: n, minutes: t, seconds: i };
}
typeof Object.assign != "function" && (Object.assign = function(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  if (!e)
    throw TypeError("Cannot convert undefined or null to object");
  for (var i = function(a) {
    a && Object.keys(a).forEach(function(l) {
      return e[l] = a[l];
    });
  }, o = 0, r = n; o < r.length; o++) {
    var s = r[o];
    i(s);
  }
  return e;
});
var Je = function() {
  return Je = Object.assign || function(e) {
    for (var n, t = 1, i = arguments.length; t < i; t++) {
      n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Je.apply(this, arguments);
}, Ps = function() {
  for (var e = 0, n = 0, t = arguments.length; n < t; n++) e += arguments[n].length;
  for (var i = Array(e), o = 0, n = 0; n < t; n++)
    for (var r = arguments[n], s = 0, a = r.length; s < a; s++, o++)
      i[o] = r[s];
  return i;
}, fy = 300;
function py(e, n) {
  var t = {
    config: Je(Je({}, pn), Me.defaultConfig),
    l10n: $n
  };
  t.parseDate = qo({ config: t.config, l10n: t.l10n }), t._handlers = [], t.pluginElements = [], t.loadedPlugins = [], t._bind = y, t._setHoursFromDate = A, t._positionCalendar = Oe, t.changeMonth = De, t.changeYear = ge, t.clear = Re, t.close = Le, t.onMouseOver = Ne, t._createElement = Fe, t.createDay = q, t.destroy = be, t.isEnabled = ne, t.jumpToDate = I, t.updateValue = Ot, t.open = Xe, t.redraw = Bt, t.set = ai, t.setDate = li, t.toggle = iu;
  function i() {
    t.utils = {
      getDaysInMonth: function(h, m) {
        return h === void 0 && (h = t.currentMonth), m === void 0 && (m = t.currentYear), h === 1 && (m % 4 === 0 && m % 100 !== 0 || m % 400 === 0) ? 29 : t.l10n.daysInMonth[h];
      }
    };
  }
  function o() {
    t.element = t.input = e, t.isOpen = !1, Nt(), le(), tu(), eu(), i(), t.isMobile || V(), v(), (t.selectedDates.length || t.config.noCalendar) && (t.config.enableTime && A(t.config.noCalendar ? t.latestSelectedDateObj : void 0), Ot(!1)), a();
    var h = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !t.isMobile && h && Oe(), _e("onReady");
  }
  function r() {
    var h;
    return ((h = t.calendarContainer) === null || h === void 0 ? void 0 : h.getRootNode()).activeElement || document.activeElement;
  }
  function s(h) {
    return h.bind(t);
  }
  function a() {
    var h = t.config;
    h.weekNumbers === !1 && h.showMonths === 1 || h.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (t.calendarContainer !== void 0 && (t.calendarContainer.style.visibility = "hidden", t.calendarContainer.style.display = "block"), t.daysContainer !== void 0) {
        var m = (t.days.offsetWidth + 1) * h.showMonths;
        t.daysContainer.style.width = m + "px", t.calendarContainer.style.width = m + (t.weekWrapper !== void 0 ? t.weekWrapper.offsetWidth : 0) + "px", t.calendarContainer.style.removeProperty("visibility"), t.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function l(h) {
    if (t.selectedDates.length === 0) {
      var m = t.config.minDate === void 0 || ct(/* @__PURE__ */ new Date(), t.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(t.config.minDate.getTime()), U = ko(t.config);
      m.setHours(U.hours, U.minutes, U.seconds, m.getMilliseconds()), t.selectedDates = [m], t.latestSelectedDateObj = m;
    }
    h !== void 0 && h.type !== "blur" && su(h);
    var _ = t._input.value;
    g(), Ot(), t._input.value !== _ && t._debouncedChange();
  }
  function d(h, m) {
    return h % 12 + 12 * yt(m === t.l10n.amPM[1]);
  }
  function f(h) {
    switch (h % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return h % 12;
    }
  }
  function g() {
    if (!(t.hourElement === void 0 || t.minuteElement === void 0)) {
      var h = (parseInt(t.hourElement.value.slice(-2), 10) || 0) % 24, m = (parseInt(t.minuteElement.value, 10) || 0) % 60, U = t.secondElement !== void 0 ? (parseInt(t.secondElement.value, 10) || 0) % 60 : 0;
      t.amPM !== void 0 && (h = d(h, t.amPM.textContent));
      var _ = t.config.minTime !== void 0 || t.config.minDate && t.minDateHasTime && t.latestSelectedDateObj && ct(t.latestSelectedDateObj, t.config.minDate, !0) === 0, Q = t.config.maxTime !== void 0 || t.config.maxDate && t.maxDateHasTime && t.latestSelectedDateObj && ct(t.latestSelectedDateObj, t.config.maxDate, !0) === 0;
      if (t.config.maxTime !== void 0 && t.config.minTime !== void 0 && t.config.minTime > t.config.maxTime) {
        var W = Fo(t.config.minTime.getHours(), t.config.minTime.getMinutes(), t.config.minTime.getSeconds()), me = Fo(t.config.maxTime.getHours(), t.config.maxTime.getMinutes(), t.config.maxTime.getSeconds()), te = Fo(h, m, U);
        if (te > me && te < W) {
          var Ke = dy(W);
          h = Ke[0], m = Ke[1], U = Ke[2];
        }
      } else {
        if (Q) {
          var Z = t.config.maxTime !== void 0 ? t.config.maxTime : t.config.maxDate;
          h = Math.min(h, Z.getHours()), h === Z.getHours() && (m = Math.min(m, Z.getMinutes())), m === Z.getMinutes() && (U = Math.min(U, Z.getSeconds()));
        }
        if (_) {
          var ue = t.config.minTime !== void 0 ? t.config.minTime : t.config.minDate;
          h = Math.max(h, ue.getHours()), h === ue.getHours() && m < ue.getMinutes() && (m = ue.getMinutes()), m === ue.getMinutes() && (U = Math.max(U, ue.getSeconds()));
        }
      }
      R(h, m, U);
    }
  }
  function A(h) {
    var m = h || t.latestSelectedDateObj;
    m && m instanceof Date && R(m.getHours(), m.getMinutes(), m.getSeconds());
  }
  function R(h, m, U) {
    t.latestSelectedDateObj !== void 0 && t.latestSelectedDateObj.setHours(h % 24, m, U || 0, 0), !(!t.hourElement || !t.minuteElement || t.isMobile) && (t.hourElement.value = rt(t.config.time_24hr ? h : (12 + h) % 12 + 12 * yt(h % 12 === 0)), t.minuteElement.value = rt(m), t.amPM !== void 0 && (t.amPM.textContent = t.l10n.amPM[yt(h >= 12)]), t.secondElement !== void 0 && (t.secondElement.value = rt(U)));
  }
  function F(h) {
    var m = dt(h), U = parseInt(m.value) + (h.delta || 0);
    (U / 1e3 > 1 || h.key === "Enter" && !/[^\d]/.test(U.toString())) && ge(U);
  }
  function y(h, m, U, _) {
    if (m instanceof Array)
      return m.forEach(function(Q) {
        return y(h, Q, U, _);
      });
    if (h instanceof Array)
      return h.forEach(function(Q) {
        return y(Q, m, U, _);
      });
    h.addEventListener(m, U, _), t._handlers.push({
      remove: function() {
        return h.removeEventListener(m, U, _);
      }
    });
  }
  function T() {
    _e("onChange");
  }
  function v() {
    if (t.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(U) {
      Array.prototype.forEach.call(t.element.querySelectorAll("[data-" + U + "]"), function(_) {
        return y(_, "click", t[U]);
      });
    }), t.isMobile) {
      nu();
      return;
    }
    var h = _s(Pe, 50);
    if (t._debouncedChange = _s(T, fy), t.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && y(t.daysContainer, "mouseover", function(U) {
      t.config.mode === "range" && Ne(dt(U));
    }), y(t._input, "keydown", Ve), t.calendarContainer !== void 0 && y(t.calendarContainer, "keydown", Ve), !t.config.inline && !t.config.static && y(window, "resize", h), window.ontouchstart !== void 0 ? y(window.document, "touchstart", Ye) : y(window.document, "mousedown", Ye), y(window.document, "focus", Ye, { capture: !0 }), t.config.clickOpens === !0 && (y(t._input, "focus", t.open), y(t._input, "click", t.open)), t.daysContainer !== void 0 && (y(t.monthNav, "click", ru), y(t.monthNav, ["keyup", "increment"], F), y(t.daysContainer, "click", gt)), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0) {
      var m = function(U) {
        return dt(U).select();
      };
      y(t.timeContainer, ["increment"], l), y(t.timeContainer, "blur", l, { capture: !0 }), y(t.timeContainer, "click", M), y([t.hourElement, t.minuteElement], ["focus", "click"], m), t.secondElement !== void 0 && y(t.secondElement, "focus", function() {
        return t.secondElement && t.secondElement.select();
      }), t.amPM !== void 0 && y(t.amPM, "click", function(U) {
        l(U);
      });
    }
    t.config.allowInput && y(t._input, "blur", Ie);
  }
  function I(h, m) {
    var U = h !== void 0 ? t.parseDate(h) : t.latestSelectedDateObj || (t.config.minDate && t.config.minDate > t.now ? t.config.minDate : t.config.maxDate && t.config.maxDate < t.now ? t.config.maxDate : t.now), _ = t.currentYear, Q = t.currentMonth;
    try {
      U !== void 0 && (t.currentYear = U.getFullYear(), t.currentMonth = U.getMonth());
    } catch (W) {
      W.message = "Invalid date supplied: " + U, t.config.errorHandler(W);
    }
    m && t.currentYear !== _ && (_e("onYearChange"), H()), m && (t.currentYear !== _ || t.currentMonth !== Q) && _e("onMonthChange"), t.redraw();
  }
  function M(h) {
    var m = dt(h);
    ~m.className.indexOf("arrow") && D(h, m.classList.contains("arrowUp") ? 1 : -1);
  }
  function D(h, m, U) {
    var _ = h && dt(h), Q = U || _ && _.parentNode && _.parentNode.firstChild, W = Zi("increment");
    W.delta = m, Q && Q.dispatchEvent(W);
  }
  function V() {
    var h = window.document.createDocumentFragment();
    if (t.calendarContainer = Fe("div", "flatpickr-calendar"), t.calendarContainer.tabIndex = -1, !t.config.noCalendar) {
      if (h.appendChild(B()), t.innerContainer = Fe("div", "flatpickr-innerContainer"), t.config.weekNumbers) {
        var m = de(), U = m.weekWrapper, _ = m.weekNumbers;
        t.innerContainer.appendChild(U), t.weekNumbers = _, t.weekWrapper = U;
      }
      t.rContainer = Fe("div", "flatpickr-rContainer"), t.rContainer.appendChild(pe()), t.daysContainer || (t.daysContainer = Fe("div", "flatpickr-days"), t.daysContainer.tabIndex = -1), Ae(), t.rContainer.appendChild(t.daysContainer), t.innerContainer.appendChild(t.rContainer), h.appendChild(t.innerContainer);
    }
    t.config.enableTime && h.appendChild(ee()), et(t.calendarContainer, "rangeMode", t.config.mode === "range"), et(t.calendarContainer, "animate", t.config.animate === !0), et(t.calendarContainer, "multiMonth", t.config.showMonths > 1), t.calendarContainer.appendChild(h);
    var Q = t.config.appendTo !== void 0 && t.config.appendTo.nodeType !== void 0;
    if ((t.config.inline || t.config.static) && (t.calendarContainer.classList.add(t.config.inline ? "inline" : "static"), t.config.inline && (!Q && t.element.parentNode ? t.element.parentNode.insertBefore(t.calendarContainer, t._input.nextSibling) : t.config.appendTo !== void 0 && t.config.appendTo.appendChild(t.calendarContainer)), t.config.static)) {
      var W = Fe("div", "flatpickr-wrapper");
      t.element.parentNode && t.element.parentNode.insertBefore(W, t.element), W.appendChild(t.element), t.altInput && W.appendChild(t.altInput), W.appendChild(t.calendarContainer);
    }
    !t.config.static && !t.config.inline && (t.config.appendTo !== void 0 ? t.config.appendTo : window.document.body).appendChild(t.calendarContainer);
  }
  function q(h, m, U, _) {
    var Q = ne(m, !0), W = Fe("span", h, m.getDate().toString());
    return W.dateObj = m, W.$i = _, W.setAttribute("aria-label", t.formatDate(m, t.config.ariaDateFormat)), h.indexOf("hidden") === -1 && ct(m, t.now) === 0 && (t.todayDateElem = W, W.classList.add("today"), W.setAttribute("aria-current", "date")), Q ? (W.tabIndex = -1, eo(m) && (W.classList.add("selected"), t.selectedDateElem = W, t.config.mode === "range" && (et(W, "startRange", t.selectedDates[0] && ct(m, t.selectedDates[0], !0) === 0), et(W, "endRange", t.selectedDates[1] && ct(m, t.selectedDates[1], !0) === 0), h === "nextMonthDay" && W.classList.add("inRange")))) : W.classList.add("flatpickr-disabled"), t.config.mode === "range" && ou(m) && !eo(m) && W.classList.add("inRange"), t.weekNumbers && t.config.showMonths === 1 && h !== "prevMonthDay" && _ % 7 === 6 && t.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + t.config.getWeek(m) + "</span>"), _e("onDayCreate", W), W;
  }
  function x(h) {
    h.focus(), t.config.mode === "range" && Ne(h);
  }
  function $(h) {
    for (var m = h > 0 ? 0 : t.config.showMonths - 1, U = h > 0 ? t.config.showMonths : -1, _ = m; _ != U; _ += h)
      for (var Q = t.daysContainer.children[_], W = h > 0 ? 0 : Q.children.length - 1, me = h > 0 ? Q.children.length : -1, te = W; te != me; te += h) {
        var Ke = Q.children[te];
        if (Ke.className.indexOf("hidden") === -1 && ne(Ke.dateObj))
          return Ke;
      }
  }
  function z(h, m) {
    for (var U = h.className.indexOf("Month") === -1 ? h.dateObj.getMonth() : t.currentMonth, _ = m > 0 ? t.config.showMonths : -1, Q = m > 0 ? 1 : -1, W = U - t.currentMonth; W != _; W += Q)
      for (var me = t.daysContainer.children[W], te = U - t.currentMonth === W ? h.$i + m : m < 0 ? me.children.length - 1 : 0, Ke = me.children.length, Z = te; Z >= 0 && Z < Ke && Z != (m > 0 ? Ke : -1); Z += Q) {
        var ue = me.children[Z];
        if (ue.className.indexOf("hidden") === -1 && ne(ue.dateObj) && Math.abs(h.$i - Z) >= Math.abs(m))
          return x(ue);
      }
    t.changeMonth(Q), X($(Q), 0);
  }
  function X(h, m) {
    var U = r(), _ = ae(U || document.body), Q = h !== void 0 ? h : _ ? U : t.selectedDateElem !== void 0 && ae(t.selectedDateElem) ? t.selectedDateElem : t.todayDateElem !== void 0 && ae(t.todayDateElem) ? t.todayDateElem : $(m > 0 ? 1 : -1);
    Q === void 0 ? t._input.focus() : _ ? z(Q, m) : x(Q);
  }
  function he(h, m) {
    for (var U = (new Date(h, m, 1).getDay() - t.l10n.firstDayOfWeek + 7) % 7, _ = t.utils.getDaysInMonth((m - 1 + 12) % 12, h), Q = t.utils.getDaysInMonth(m, h), W = window.document.createDocumentFragment(), me = t.config.showMonths > 1, te = me ? "prevMonthDay hidden" : "prevMonthDay", Ke = me ? "nextMonthDay hidden" : "nextMonthDay", Z = _ + 1 - U, ue = 0; Z <= _; Z++, ue++)
      W.appendChild(q("flatpickr-day " + te, new Date(h, m - 1, Z), Z, ue));
    for (Z = 1; Z <= Q; Z++, ue++)
      W.appendChild(q("flatpickr-day", new Date(h, m, Z), Z, ue));
    for (var Ee = Q + 1; Ee <= 42 - U && (t.config.showMonths === 1 || ue % 7 !== 0); Ee++, ue++)
      W.appendChild(q("flatpickr-day " + Ke, new Date(h, m + 1, Ee % Q), Ee, ue));
    var Tt = Fe("div", "dayContainer");
    return Tt.appendChild(W), Tt;
  }
  function Ae() {
    if (t.daysContainer !== void 0) {
      mi(t.daysContainer), t.weekNumbers && mi(t.weekNumbers);
      for (var h = document.createDocumentFragment(), m = 0; m < t.config.showMonths; m++) {
        var U = new Date(t.currentYear, t.currentMonth, 1);
        U.setMonth(t.currentMonth + m), h.appendChild(he(U.getFullYear(), U.getMonth()));
      }
      t.daysContainer.appendChild(h), t.days = t.daysContainer.firstChild, t.config.mode === "range" && t.selectedDates.length === 1 && Ne();
    }
  }
  function H() {
    if (!(t.config.showMonths > 1 || t.config.monthSelectorType !== "dropdown")) {
      var h = function(_) {
        return t.config.minDate !== void 0 && t.currentYear === t.config.minDate.getFullYear() && _ < t.config.minDate.getMonth() ? !1 : !(t.config.maxDate !== void 0 && t.currentYear === t.config.maxDate.getFullYear() && _ > t.config.maxDate.getMonth());
      };
      t.monthsDropdownContainer.tabIndex = -1, t.monthsDropdownContainer.innerHTML = "";
      for (var m = 0; m < 12; m++)
        if (h(m)) {
          var U = Fe("option", "flatpickr-monthDropdown-month");
          U.value = new Date(t.currentYear, m).getMonth().toString(), U.textContent = Mi(m, t.config.shorthandCurrentMonth, t.l10n), U.tabIndex = -1, t.currentMonth === m && (U.selected = !0), t.monthsDropdownContainer.appendChild(U);
        }
    }
  }
  function we() {
    var h = Fe("div", "flatpickr-month"), m = window.document.createDocumentFragment(), U;
    t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? U = Fe("span", "cur-month") : (t.monthsDropdownContainer = Fe("select", "flatpickr-monthDropdown-months"), t.monthsDropdownContainer.setAttribute("aria-label", t.l10n.monthAriaLabel), y(t.monthsDropdownContainer, "change", function(me) {
      var te = dt(me), Ke = parseInt(te.value, 10);
      t.changeMonth(Ke - t.currentMonth), _e("onMonthChange");
    }), H(), U = t.monthsDropdownContainer);
    var _ = Ai("cur-year", { tabindex: "-1" }), Q = _.getElementsByTagName("input")[0];
    Q.setAttribute("aria-label", t.l10n.yearAriaLabel), t.config.minDate && Q.setAttribute("min", t.config.minDate.getFullYear().toString()), t.config.maxDate && (Q.setAttribute("max", t.config.maxDate.getFullYear().toString()), Q.disabled = !!t.config.minDate && t.config.minDate.getFullYear() === t.config.maxDate.getFullYear());
    var W = Fe("div", "flatpickr-current-month");
    return W.appendChild(U), W.appendChild(_), m.appendChild(W), h.appendChild(m), {
      container: h,
      yearElement: Q,
      monthElement: U
    };
  }
  function S() {
    mi(t.monthNav), t.monthNav.appendChild(t.prevMonthNav), t.config.showMonths && (t.yearElements = [], t.monthElements = []);
    for (var h = t.config.showMonths; h--; ) {
      var m = we();
      t.yearElements.push(m.yearElement), t.monthElements.push(m.monthElement), t.monthNav.appendChild(m.container);
    }
    t.monthNav.appendChild(t.nextMonthNav);
  }
  function B() {
    return t.monthNav = Fe("div", "flatpickr-months"), t.yearElements = [], t.monthElements = [], t.prevMonthNav = Fe("span", "flatpickr-prev-month"), t.prevMonthNav.innerHTML = t.config.prevArrow, t.nextMonthNav = Fe("span", "flatpickr-next-month"), t.nextMonthNav.innerHTML = t.config.nextArrow, S(), Object.defineProperty(t, "_hidePrevMonthArrow", {
      get: function() {
        return t.__hidePrevMonthArrow;
      },
      set: function(h) {
        t.__hidePrevMonthArrow !== h && (et(t.prevMonthNav, "flatpickr-disabled", h), t.__hidePrevMonthArrow = h);
      }
    }), Object.defineProperty(t, "_hideNextMonthArrow", {
      get: function() {
        return t.__hideNextMonthArrow;
      },
      set: function(h) {
        t.__hideNextMonthArrow !== h && (et(t.nextMonthNav, "flatpickr-disabled", h), t.__hideNextMonthArrow = h);
      }
    }), t.currentYearElement = t.yearElements[0], ui(), t.monthNav;
  }
  function ee() {
    t.calendarContainer.classList.add("hasTime"), t.config.noCalendar && t.calendarContainer.classList.add("noCalendar");
    var h = ko(t.config);
    t.timeContainer = Fe("div", "flatpickr-time"), t.timeContainer.tabIndex = -1;
    var m = Fe("span", "flatpickr-time-separator", ":"), U = Ai("flatpickr-hour", {
      "aria-label": t.l10n.hourAriaLabel
    });
    t.hourElement = U.getElementsByTagName("input")[0];
    var _ = Ai("flatpickr-minute", {
      "aria-label": t.l10n.minuteAriaLabel
    });
    if (t.minuteElement = _.getElementsByTagName("input")[0], t.hourElement.tabIndex = t.minuteElement.tabIndex = -1, t.hourElement.value = rt(t.latestSelectedDateObj ? t.latestSelectedDateObj.getHours() : t.config.time_24hr ? h.hours : f(h.hours)), t.minuteElement.value = rt(t.latestSelectedDateObj ? t.latestSelectedDateObj.getMinutes() : h.minutes), t.hourElement.setAttribute("step", t.config.hourIncrement.toString()), t.minuteElement.setAttribute("step", t.config.minuteIncrement.toString()), t.hourElement.setAttribute("min", t.config.time_24hr ? "0" : "1"), t.hourElement.setAttribute("max", t.config.time_24hr ? "23" : "12"), t.hourElement.setAttribute("maxlength", "2"), t.minuteElement.setAttribute("min", "0"), t.minuteElement.setAttribute("max", "59"), t.minuteElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(U), t.timeContainer.appendChild(m), t.timeContainer.appendChild(_), t.config.time_24hr && t.timeContainer.classList.add("time24hr"), t.config.enableSeconds) {
      t.timeContainer.classList.add("hasSeconds");
      var Q = Ai("flatpickr-second");
      t.secondElement = Q.getElementsByTagName("input")[0], t.secondElement.value = rt(t.latestSelectedDateObj ? t.latestSelectedDateObj.getSeconds() : h.seconds), t.secondElement.setAttribute("step", t.minuteElement.getAttribute("step")), t.secondElement.setAttribute("min", "0"), t.secondElement.setAttribute("max", "59"), t.secondElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(Fe("span", "flatpickr-time-separator", ":")), t.timeContainer.appendChild(Q);
    }
    return t.config.time_24hr || (t.amPM = Fe("span", "flatpickr-am-pm", t.l10n.amPM[yt((t.latestSelectedDateObj ? t.hourElement.value : t.config.defaultHour) > 11)]), t.amPM.title = t.l10n.toggleTitle, t.amPM.tabIndex = -1, t.timeContainer.appendChild(t.amPM)), t.timeContainer;
  }
  function pe() {
    t.weekdayContainer ? mi(t.weekdayContainer) : t.weekdayContainer = Fe("div", "flatpickr-weekdays");
    for (var h = t.config.showMonths; h--; ) {
      var m = Fe("div", "flatpickr-weekdaycontainer");
      t.weekdayContainer.appendChild(m);
    }
    return ye(), t.weekdayContainer;
  }
  function ye() {
    if (t.weekdayContainer) {
      var h = t.l10n.firstDayOfWeek, m = Ps(t.l10n.weekdays.shorthand);
      h > 0 && h < m.length && (m = Ps(m.splice(h, m.length), m.splice(0, h)));
      for (var U = t.config.showMonths; U--; )
        t.weekdayContainer.children[U].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + m.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function de() {
    t.calendarContainer.classList.add("hasWeeks");
    var h = Fe("div", "flatpickr-weekwrapper");
    h.appendChild(Fe("span", "flatpickr-weekday", t.l10n.weekAbbreviation));
    var m = Fe("div", "flatpickr-weeks");
    return h.appendChild(m), {
      weekWrapper: h,
      weekNumbers: m
    };
  }
  function De(h, m) {
    m === void 0 && (m = !0);
    var U = m ? h : h - t.currentMonth;
    U < 0 && t._hidePrevMonthArrow === !0 || U > 0 && t._hideNextMonthArrow === !0 || (t.currentMonth += U, (t.currentMonth < 0 || t.currentMonth > 11) && (t.currentYear += t.currentMonth > 11 ? 1 : -1, t.currentMonth = (t.currentMonth + 12) % 12, _e("onYearChange"), H()), Ae(), _e("onMonthChange"), ui());
  }
  function Re(h, m) {
    if (h === void 0 && (h = !0), m === void 0 && (m = !0), t.input.value = "", t.altInput !== void 0 && (t.altInput.value = ""), t.mobileInput !== void 0 && (t.mobileInput.value = ""), t.selectedDates = [], t.latestSelectedDateObj = void 0, m === !0 && (t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth()), t.config.enableTime === !0) {
      var U = ko(t.config), _ = U.hours, Q = U.minutes, W = U.seconds;
      R(_, Q, W);
    }
    t.redraw(), h && _e("onChange");
  }
  function Le() {
    t.isOpen = !1, t.isMobile || (t.calendarContainer !== void 0 && t.calendarContainer.classList.remove("open"), t._input !== void 0 && t._input.classList.remove("active")), _e("onClose");
  }
  function be() {
    t.config !== void 0 && _e("onDestroy");
    for (var h = t._handlers.length; h--; )
      t._handlers[h].remove();
    if (t._handlers = [], t.mobileInput)
      t.mobileInput.parentNode && t.mobileInput.parentNode.removeChild(t.mobileInput), t.mobileInput = void 0;
    else if (t.calendarContainer && t.calendarContainer.parentNode)
      if (t.config.static && t.calendarContainer.parentNode) {
        var m = t.calendarContainer.parentNode;
        if (m.lastChild && m.removeChild(m.lastChild), m.parentNode) {
          for (; m.firstChild; )
            m.parentNode.insertBefore(m.firstChild, m);
          m.parentNode.removeChild(m);
        }
      } else
        t.calendarContainer.parentNode.removeChild(t.calendarContainer);
    t.altInput && (t.input.type = "text", t.altInput.parentNode && t.altInput.parentNode.removeChild(t.altInput), delete t.altInput), t.input && (t.input.type = t.input._type, t.input.classList.remove("flatpickr-input"), t.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(U) {
      try {
        delete t[U];
      } catch {
      }
    });
  }
  function Ce(h) {
    return t.calendarContainer.contains(h);
  }
  function Ye(h) {
    if (t.isOpen && !t.config.inline) {
      var m = dt(h), U = Ce(m), _ = m === t.input || m === t.altInput || t.element.contains(m) || h.path && h.path.indexOf && (~h.path.indexOf(t.input) || ~h.path.indexOf(t.altInput)), Q = !_ && !U && !Ce(h.relatedTarget), W = !t.config.ignoredFocusElements.some(function(me) {
        return me.contains(m);
      });
      Q && W && (t.config.allowInput && t.setDate(t._input.value, !1, t.config.altInput ? t.config.altFormat : t.config.dateFormat), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0 && t.input.value !== "" && t.input.value !== void 0 && l(), t.close(), t.config && t.config.mode === "range" && t.selectedDates.length === 1 && t.clear(!1));
    }
  }
  function ge(h) {
    if (!(!h || t.config.minDate && h < t.config.minDate.getFullYear() || t.config.maxDate && h > t.config.maxDate.getFullYear())) {
      var m = h, U = t.currentYear !== m;
      t.currentYear = m || t.currentYear, t.config.maxDate && t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth = Math.min(t.config.maxDate.getMonth(), t.currentMonth) : t.config.minDate && t.currentYear === t.config.minDate.getFullYear() && (t.currentMonth = Math.max(t.config.minDate.getMonth(), t.currentMonth)), U && (t.redraw(), _e("onYearChange"), H());
    }
  }
  function ne(h, m) {
    var U;
    m === void 0 && (m = !0);
    var _ = t.parseDate(h, void 0, m);
    if (t.config.minDate && _ && ct(_, t.config.minDate, m !== void 0 ? m : !t.minDateHasTime) < 0 || t.config.maxDate && _ && ct(_, t.config.maxDate, m !== void 0 ? m : !t.maxDateHasTime) > 0)
      return !1;
    if (!t.config.enable && t.config.disable.length === 0)
      return !0;
    if (_ === void 0)
      return !1;
    for (var Q = !!t.config.enable, W = (U = t.config.enable) !== null && U !== void 0 ? U : t.config.disable, me = 0, te = void 0; me < W.length; me++) {
      if (te = W[me], typeof te == "function" && te(_))
        return Q;
      if (te instanceof Date && _ !== void 0 && te.getTime() === _.getTime())
        return Q;
      if (typeof te == "string") {
        var Ke = t.parseDate(te, void 0, !0);
        return Ke && Ke.getTime() === _.getTime() ? Q : !Q;
      } else if (typeof te == "object" && _ !== void 0 && te.from && te.to && _.getTime() >= te.from.getTime() && _.getTime() <= te.to.getTime())
        return Q;
    }
    return !Q;
  }
  function ae(h) {
    return t.daysContainer !== void 0 ? h.className.indexOf("hidden") === -1 && h.className.indexOf("flatpickr-disabled") === -1 && t.daysContainer.contains(h) : !1;
  }
  function Ie(h) {
    var m = h.target === t._input, U = t._input.value.trimEnd() !== to();
    m && U && !(h.relatedTarget && Ce(h.relatedTarget)) && t.setDate(t._input.value, !0, h.target === t.altInput ? t.config.altFormat : t.config.dateFormat);
  }
  function Ve(h) {
    var m = dt(h), U = t.config.wrap ? e.contains(m) : m === t._input, _ = t.config.allowInput, Q = t.isOpen && (!_ || !U), W = t.config.inline && U && !_;
    if (h.keyCode === 13 && U) {
      if (_)
        return t.setDate(t._input.value, !0, m === t.altInput ? t.config.altFormat : t.config.dateFormat), t.close(), m.blur();
      t.open();
    } else if (Ce(m) || Q || W) {
      var me = !!t.timeContainer && t.timeContainer.contains(m);
      switch (h.keyCode) {
        case 13:
          me ? (h.preventDefault(), l(), xt()) : gt(h);
          break;
        case 27:
          h.preventDefault(), xt();
          break;
        case 8:
        case 46:
          U && !t.config.allowInput && (h.preventDefault(), t.clear());
          break;
        case 37:
        case 39:
          if (!me && !U) {
            h.preventDefault();
            var te = r();
            if (t.daysContainer !== void 0 && (_ === !1 || te && ae(te))) {
              var Ke = h.keyCode === 39 ? 1 : -1;
              h.ctrlKey ? (h.stopPropagation(), De(Ke), X($(1), 0)) : X(void 0, Ke);
            }
          } else t.hourElement && t.hourElement.focus();
          break;
        case 38:
        case 40:
          h.preventDefault();
          var Z = h.keyCode === 40 ? 1 : -1;
          t.daysContainer && m.$i !== void 0 || m === t.input || m === t.altInput ? h.ctrlKey ? (h.stopPropagation(), ge(t.currentYear - Z), X($(1), 0)) : me || X(void 0, Z * 7) : m === t.currentYearElement ? ge(t.currentYear - Z) : t.config.enableTime && (!me && t.hourElement && t.hourElement.focus(), l(h), t._debouncedChange());
          break;
        case 9:
          if (me) {
            var ue = [
              t.hourElement,
              t.minuteElement,
              t.secondElement,
              t.amPM
            ].concat(t.pluginElements).filter(function(ut) {
              return ut;
            }), Ee = ue.indexOf(m);
            if (Ee !== -1) {
              var Tt = ue[Ee + (h.shiftKey ? -1 : 1)];
              h.preventDefault(), (Tt || t._input).focus();
            }
          } else !t.config.noCalendar && t.daysContainer && t.daysContainer.contains(m) && h.shiftKey && (h.preventDefault(), t._input.focus());
          break;
      }
    }
    if (t.amPM !== void 0 && m === t.amPM)
      switch (h.key) {
        case t.l10n.amPM[0].charAt(0):
        case t.l10n.amPM[0].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[0], g(), Ot();
          break;
        case t.l10n.amPM[1].charAt(0):
        case t.l10n.amPM[1].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[1], g(), Ot();
          break;
      }
    (U || Ce(m)) && _e("onKeyDown", h);
  }
  function Ne(h, m) {
    if (m === void 0 && (m = "flatpickr-day"), !(t.selectedDates.length !== 1 || h && (!h.classList.contains(m) || h.classList.contains("flatpickr-disabled")))) {
      for (var U = h ? h.dateObj.getTime() : t.days.firstElementChild.dateObj.getTime(), _ = t.parseDate(t.selectedDates[0], void 0, !0).getTime(), Q = Math.min(U, t.selectedDates[0].getTime()), W = Math.max(U, t.selectedDates[0].getTime()), me = !1, te = 0, Ke = 0, Z = Q; Z < W; Z += cy.DAY)
        ne(new Date(Z), !0) || (me = me || Z > Q && Z < W, Z < _ && (!te || Z > te) ? te = Z : Z > _ && (!Ke || Z < Ke) && (Ke = Z));
      var ue = Array.from(t.rContainer.querySelectorAll("*:nth-child(-n+" + t.config.showMonths + ") > ." + m));
      ue.forEach(function(Ee) {
        var Tt = Ee.dateObj, ut = Tt.getTime(), Un = te > 0 && ut < te || Ke > 0 && ut > Ke;
        if (Un) {
          Ee.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(an) {
            Ee.classList.remove(an);
          });
          return;
        } else if (me && !Un)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(an) {
          Ee.classList.remove(an);
        }), h !== void 0 && (h.classList.add(U <= t.selectedDates[0].getTime() ? "startRange" : "endRange"), _ < U && ut === _ ? Ee.classList.add("startRange") : _ > U && ut === _ && Ee.classList.add("endRange"), ut >= te && (Ke === 0 || ut <= Ke) && uy(ut, _, U) && Ee.classList.add("inRange"));
      });
    }
  }
  function Pe() {
    t.isOpen && !t.config.static && !t.config.inline && Oe();
  }
  function Xe(h, m) {
    if (m === void 0 && (m = t._positionElement), t.isMobile === !0) {
      if (h) {
        h.preventDefault();
        var U = dt(h);
        U && U.blur();
      }
      t.mobileInput !== void 0 && (t.mobileInput.focus(), t.mobileInput.click()), _e("onOpen");
      return;
    } else if (t._input.disabled || t.config.inline)
      return;
    var _ = t.isOpen;
    t.isOpen = !0, _ || (t.calendarContainer.classList.add("open"), t._input.classList.add("active"), _e("onOpen"), Oe(m)), t.config.enableTime === !0 && t.config.noCalendar === !0 && t.config.allowInput === !1 && (h === void 0 || !t.timeContainer.contains(h.relatedTarget)) && setTimeout(function() {
      return t.hourElement.select();
    }, 50);
  }
  function jt(h) {
    return function(m) {
      var U = t.config["_" + h + "Date"] = t.parseDate(m, t.config.dateFormat), _ = t.config["_" + (h === "min" ? "max" : "min") + "Date"];
      U !== void 0 && (t[h === "min" ? "minDateHasTime" : "maxDateHasTime"] = U.getHours() > 0 || U.getMinutes() > 0 || U.getSeconds() > 0), t.selectedDates && (t.selectedDates = t.selectedDates.filter(function(Q) {
        return ne(Q);
      }), !t.selectedDates.length && h === "min" && A(U), Ot()), t.daysContainer && (Bt(), U !== void 0 ? t.currentYearElement[h] = U.getFullYear().toString() : t.currentYearElement.removeAttribute(h), t.currentYearElement.disabled = !!_ && U !== void 0 && _.getFullYear() === U.getFullYear());
    };
  }
  function Nt() {
    var h = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], m = Je(Je({}, JSON.parse(JSON.stringify(e.dataset || {}))), n), U = {};
    t.config.parseDate = m.parseDate, t.config.formatDate = m.formatDate, Object.defineProperty(t.config, "enable", {
      get: function() {
        return t.config._enable;
      },
      set: function(ue) {
        t.config._enable = qr(ue);
      }
    }), Object.defineProperty(t.config, "disable", {
      get: function() {
        return t.config._disable;
      },
      set: function(ue) {
        t.config._disable = qr(ue);
      }
    });
    var _ = m.mode === "time";
    if (!m.dateFormat && (m.enableTime || _)) {
      var Q = Me.defaultConfig.dateFormat || pn.dateFormat;
      U.dateFormat = m.noCalendar || _ ? "H:i" + (m.enableSeconds ? ":S" : "") : Q + " H:i" + (m.enableSeconds ? ":S" : "");
    }
    if (m.altInput && (m.enableTime || _) && !m.altFormat) {
      var W = Me.defaultConfig.altFormat || pn.altFormat;
      U.altFormat = m.noCalendar || _ ? "h:i" + (m.enableSeconds ? ":S K" : " K") : W + (" h:i" + (m.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(t.config, "minDate", {
      get: function() {
        return t.config._minDate;
      },
      set: jt("min")
    }), Object.defineProperty(t.config, "maxDate", {
      get: function() {
        return t.config._maxDate;
      },
      set: jt("max")
    });
    var me = function(ue) {
      return function(Ee) {
        t.config[ue === "min" ? "_minTime" : "_maxTime"] = t.parseDate(Ee, "H:i:S");
      };
    };
    Object.defineProperty(t.config, "minTime", {
      get: function() {
        return t.config._minTime;
      },
      set: me("min")
    }), Object.defineProperty(t.config, "maxTime", {
      get: function() {
        return t.config._maxTime;
      },
      set: me("max")
    }), m.mode === "time" && (t.config.noCalendar = !0, t.config.enableTime = !0), Object.assign(t.config, U, m);
    for (var te = 0; te < h.length; te++)
      t.config[h[te]] = t.config[h[te]] === !0 || t.config[h[te]] === "true";
    wo.filter(function(ue) {
      return t.config[ue] !== void 0;
    }).forEach(function(ue) {
      t.config[ue] = Co(t.config[ue] || []).map(s);
    }), t.isMobile = !t.config.disableMobile && !t.config.inline && t.config.mode === "single" && !t.config.disable.length && !t.config.enable && !t.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var te = 0; te < t.config.plugins.length; te++) {
      var Ke = t.config.plugins[te](t) || {};
      for (var Z in Ke)
        wo.indexOf(Z) > -1 ? t.config[Z] = Co(Ke[Z]).map(s).concat(t.config[Z]) : typeof m[Z] > "u" && (t.config[Z] = Ke[Z]);
    }
    m.altInputClass || (t.config.altInputClass = Ze().className + " " + t.config.altInputClass), _e("onParseConfig");
  }
  function Ze() {
    return t.config.wrap ? e.querySelector("[data-input]") : e;
  }
  function le() {
    typeof t.config.locale != "object" && typeof Me.l10ns[t.config.locale] > "u" && t.config.errorHandler(new Error("flatpickr: invalid locale " + t.config.locale)), t.l10n = Je(Je({}, Me.l10ns.default), typeof t.config.locale == "object" ? t.config.locale : t.config.locale !== "default" ? Me.l10ns[t.config.locale] : void 0), Qt.D = "(" + t.l10n.weekdays.shorthand.join("|") + ")", Qt.l = "(" + t.l10n.weekdays.longhand.join("|") + ")", Qt.M = "(" + t.l10n.months.shorthand.join("|") + ")", Qt.F = "(" + t.l10n.months.longhand.join("|") + ")", Qt.K = "(" + t.l10n.amPM[0] + "|" + t.l10n.amPM[1] + "|" + t.l10n.amPM[0].toLowerCase() + "|" + t.l10n.amPM[1].toLowerCase() + ")";
    var h = Je(Je({}, n), JSON.parse(JSON.stringify(e.dataset || {})));
    h.time_24hr === void 0 && Me.defaultConfig.time_24hr === void 0 && (t.config.time_24hr = t.l10n.time_24hr), t.formatDate = Ul(t), t.parseDate = qo({ config: t.config, l10n: t.l10n });
  }
  function Oe(h) {
    if (typeof t.config.position == "function")
      return void t.config.position(t, h);
    if (t.calendarContainer !== void 0) {
      _e("onPreCalendarPosition");
      var m = h || t._positionElement, U = Array.prototype.reduce.call(t.calendarContainer.children, (function(hu, mu) {
        return hu + mu.offsetHeight;
      }), 0), _ = t.calendarContainer.offsetWidth, Q = t.config.position.split(" "), W = Q[0], me = Q.length > 1 ? Q[1] : null, te = m.getBoundingClientRect(), Ke = window.innerHeight - te.bottom, Z = W === "above" || W !== "below" && Ke < U && te.top > U, ue = window.pageYOffset + te.top + (Z ? -U - 2 : m.offsetHeight + 2);
      if (et(t.calendarContainer, "arrowTop", !Z), et(t.calendarContainer, "arrowBottom", Z), !t.config.inline) {
        var Ee = window.pageXOffset + te.left, Tt = !1, ut = !1;
        me === "center" ? (Ee -= (_ - te.width) / 2, Tt = !0) : me === "right" && (Ee -= _ - te.width, ut = !0), et(t.calendarContainer, "arrowLeft", !Tt && !ut), et(t.calendarContainer, "arrowCenter", Tt), et(t.calendarContainer, "arrowRight", ut);
        var Un = window.document.body.offsetWidth - (window.pageXOffset + te.right), an = Ee + _ > window.document.body.offsetWidth, au = Un + _ > window.document.body.offsetWidth;
        if (et(t.calendarContainer, "rightMost", an), !t.config.static)
          if (t.calendarContainer.style.top = ue + "px", !an)
            t.calendarContainer.style.left = Ee + "px", t.calendarContainer.style.right = "auto";
          else if (!au)
            t.calendarContainer.style.left = "auto", t.calendarContainer.style.right = Un + "px";
          else {
            var no = je();
            if (no === void 0)
              return;
            var lu = window.document.body.offsetWidth, uu = Math.max(0, lu / 2 - _ / 2), du = ".flatpickr-calendar.centerMost:before", cu = ".flatpickr-calendar.centerMost:after", fu = no.cssRules.length, pu = "{left:" + te.left + "px;right:auto;}";
            et(t.calendarContainer, "rightMost", !1), et(t.calendarContainer, "centerMost", !0), no.insertRule(du + "," + cu + pu, fu), t.calendarContainer.style.left = uu + "px", t.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function je() {
    for (var h = null, m = 0; m < document.styleSheets.length; m++) {
      var U = document.styleSheets[m];
      if (U.cssRules) {
        try {
          U.cssRules;
        } catch {
          continue;
        }
        h = U;
        break;
      }
    }
    return h ?? ot();
  }
  function ot() {
    var h = document.createElement("style");
    return document.head.appendChild(h), h.sheet;
  }
  function Bt() {
    t.config.noCalendar || t.isMobile || (H(), ui(), Ae());
  }
  function xt() {
    t._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(t.close, 0) : t.close();
  }
  function gt(h) {
    h.preventDefault(), h.stopPropagation();
    var m = function(ue) {
      return ue.classList && ue.classList.contains("flatpickr-day") && !ue.classList.contains("flatpickr-disabled") && !ue.classList.contains("notAllowed");
    }, U = kl(dt(h), m);
    if (U !== void 0) {
      var _ = U, Q = t.latestSelectedDateObj = new Date(_.dateObj.getTime()), W = (Q.getMonth() < t.currentMonth || Q.getMonth() > t.currentMonth + t.config.showMonths - 1) && t.config.mode !== "range";
      if (t.selectedDateElem = _, t.config.mode === "single")
        t.selectedDates = [Q];
      else if (t.config.mode === "multiple") {
        var me = eo(Q);
        me ? t.selectedDates.splice(parseInt(me), 1) : t.selectedDates.push(Q);
      } else t.config.mode === "range" && (t.selectedDates.length === 2 && t.clear(!1, !1), t.latestSelectedDateObj = Q, t.selectedDates.push(Q), ct(Q, t.selectedDates[0], !0) !== 0 && t.selectedDates.sort(function(ue, Ee) {
        return ue.getTime() - Ee.getTime();
      }));
      if (g(), W) {
        var te = t.currentYear !== Q.getFullYear();
        t.currentYear = Q.getFullYear(), t.currentMonth = Q.getMonth(), te && (_e("onYearChange"), H()), _e("onMonthChange");
      }
      if (ui(), Ae(), Ot(), !W && t.config.mode !== "range" && t.config.showMonths === 1 ? x(_) : t.selectedDateElem !== void 0 && t.hourElement === void 0 && t.selectedDateElem && t.selectedDateElem.focus(), t.hourElement !== void 0 && t.hourElement !== void 0 && t.hourElement.focus(), t.config.closeOnSelect) {
        var Ke = t.config.mode === "single" && !t.config.enableTime, Z = t.config.mode === "range" && t.selectedDates.length === 2 && !t.config.enableTime;
        (Ke || Z) && xt();
      }
      T();
    }
  }
  var Ht = {
    locale: [le, ye],
    showMonths: [S, a, pe],
    minDate: [I],
    maxDate: [I],
    positionElement: [Vr],
    clickOpens: [
      function() {
        t.config.clickOpens === !0 ? (y(t._input, "focus", t.open), y(t._input, "click", t.open)) : (t._input.removeEventListener("focus", t.open), t._input.removeEventListener("click", t.open));
      }
    ]
  };
  function ai(h, m) {
    if (h !== null && typeof h == "object") {
      Object.assign(t.config, h);
      for (var U in h)
        Ht[U] !== void 0 && Ht[U].forEach(function(_) {
          return _();
        });
    } else
      t.config[h] = m, Ht[h] !== void 0 ? Ht[h].forEach(function(_) {
        return _();
      }) : wo.indexOf(h) > -1 && (t.config[h] = Co(m));
    t.redraw(), Ot(!0);
  }
  function kn(h, m) {
    var U = [];
    if (h instanceof Array)
      U = h.map(function(_) {
        return t.parseDate(_, m);
      });
    else if (h instanceof Date || typeof h == "number")
      U = [t.parseDate(h, m)];
    else if (typeof h == "string")
      switch (t.config.mode) {
        case "single":
        case "time":
          U = [t.parseDate(h, m)];
          break;
        case "multiple":
          U = h.split(t.config.conjunction).map(function(_) {
            return t.parseDate(_, m);
          });
          break;
        case "range":
          U = h.split(t.l10n.rangeSeparator).map(function(_) {
            return t.parseDate(_, m);
          });
          break;
      }
    else
      t.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(h)));
    t.selectedDates = t.config.allowInvalidPreload ? U : U.filter(function(_) {
      return _ instanceof Date && ne(_, !1);
    }), t.config.mode === "range" && t.selectedDates.sort(function(_, Q) {
      return _.getTime() - Q.getTime();
    });
  }
  function li(h, m, U) {
    if (m === void 0 && (m = !1), U === void 0 && (U = t.config.dateFormat), h !== 0 && !h || h instanceof Array && h.length === 0)
      return t.clear(m);
    kn(h, U), t.latestSelectedDateObj = t.selectedDates[t.selectedDates.length - 1], t.redraw(), I(void 0, m), A(), t.selectedDates.length === 0 && t.clear(!1), Ot(m), m && _e("onChange");
  }
  function qr(h) {
    return h.slice().map(function(m) {
      return typeof m == "string" || typeof m == "number" || m instanceof Date ? t.parseDate(m, void 0, !0) : m && typeof m == "object" && m.from && m.to ? {
        from: t.parseDate(m.from, void 0),
        to: t.parseDate(m.to, void 0)
      } : m;
    }).filter(function(m) {
      return m;
    });
  }
  function eu() {
    t.selectedDates = [], t.now = t.parseDate(t.config.now) || /* @__PURE__ */ new Date();
    var h = t.config.defaultDate || ((t.input.nodeName === "INPUT" || t.input.nodeName === "TEXTAREA") && t.input.placeholder && t.input.value === t.input.placeholder ? null : t.input.value);
    h && kn(h, t.config.dateFormat), t._initialDate = t.selectedDates.length > 0 ? t.selectedDates[0] : t.config.minDate && t.config.minDate.getTime() > t.now.getTime() ? t.config.minDate : t.config.maxDate && t.config.maxDate.getTime() < t.now.getTime() ? t.config.maxDate : t.now, t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth(), t.selectedDates.length > 0 && (t.latestSelectedDateObj = t.selectedDates[0]), t.config.minTime !== void 0 && (t.config.minTime = t.parseDate(t.config.minTime, "H:i")), t.config.maxTime !== void 0 && (t.config.maxTime = t.parseDate(t.config.maxTime, "H:i")), t.minDateHasTime = !!t.config.minDate && (t.config.minDate.getHours() > 0 || t.config.minDate.getMinutes() > 0 || t.config.minDate.getSeconds() > 0), t.maxDateHasTime = !!t.config.maxDate && (t.config.maxDate.getHours() > 0 || t.config.maxDate.getMinutes() > 0 || t.config.maxDate.getSeconds() > 0);
  }
  function tu() {
    if (t.input = Ze(), !t.input) {
      t.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    t.input._type = t.input.type, t.input.type = "text", t.input.classList.add("flatpickr-input"), t._input = t.input, t.config.altInput && (t.altInput = Fe(t.input.nodeName, t.config.altInputClass), t._input = t.altInput, t.altInput.placeholder = t.input.placeholder, t.altInput.disabled = t.input.disabled, t.altInput.required = t.input.required, t.altInput.tabIndex = t.input.tabIndex, t.altInput.type = "text", t.input.setAttribute("type", "hidden"), !t.config.static && t.input.parentNode && t.input.parentNode.insertBefore(t.altInput, t.input.nextSibling)), t.config.allowInput || t._input.setAttribute("readonly", "readonly"), Vr();
  }
  function Vr() {
    t._positionElement = t.config.positionElement || t._input;
  }
  function nu() {
    var h = t.config.enableTime ? t.config.noCalendar ? "time" : "datetime-local" : "date";
    t.mobileInput = Fe("input", t.input.className + " flatpickr-mobile"), t.mobileInput.tabIndex = 1, t.mobileInput.type = h, t.mobileInput.disabled = t.input.disabled, t.mobileInput.required = t.input.required, t.mobileInput.placeholder = t.input.placeholder, t.mobileFormatStr = h === "datetime-local" ? "Y-m-d\\TH:i:S" : h === "date" ? "Y-m-d" : "H:i:S", t.selectedDates.length > 0 && (t.mobileInput.defaultValue = t.mobileInput.value = t.formatDate(t.selectedDates[0], t.mobileFormatStr)), t.config.minDate && (t.mobileInput.min = t.formatDate(t.config.minDate, "Y-m-d")), t.config.maxDate && (t.mobileInput.max = t.formatDate(t.config.maxDate, "Y-m-d")), t.input.getAttribute("step") && (t.mobileInput.step = String(t.input.getAttribute("step"))), t.input.type = "hidden", t.altInput !== void 0 && (t.altInput.type = "hidden");
    try {
      t.input.parentNode && t.input.parentNode.insertBefore(t.mobileInput, t.input.nextSibling);
    } catch {
    }
    y(t.mobileInput, "change", function(m) {
      t.setDate(dt(m).value, !1, t.mobileFormatStr), _e("onChange"), _e("onClose");
    });
  }
  function iu(h) {
    if (t.isOpen === !0)
      return t.close();
    t.open(h);
  }
  function _e(h, m) {
    if (t.config !== void 0) {
      var U = t.config[h];
      if (U !== void 0 && U.length > 0)
        for (var _ = 0; U[_] && _ < U.length; _++)
          U[_](t.selectedDates, t.input.value, t, m);
      h === "onChange" && (t.input.dispatchEvent(Zi("change")), t.input.dispatchEvent(Zi("input")));
    }
  }
  function Zi(h) {
    var m = document.createEvent("Event");
    return m.initEvent(h, !0, !0), m;
  }
  function eo(h) {
    for (var m = 0; m < t.selectedDates.length; m++) {
      var U = t.selectedDates[m];
      if (U instanceof Date && ct(U, h) === 0)
        return "" + m;
    }
    return !1;
  }
  function ou(h) {
    return t.config.mode !== "range" || t.selectedDates.length < 2 ? !1 : ct(h, t.selectedDates[0]) >= 0 && ct(h, t.selectedDates[1]) <= 0;
  }
  function ui() {
    t.config.noCalendar || t.isMobile || !t.monthNav || (t.yearElements.forEach(function(h, m) {
      var U = new Date(t.currentYear, t.currentMonth, 1);
      U.setMonth(t.currentMonth + m), t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? t.monthElements[m].textContent = Mi(U.getMonth(), t.config.shorthandCurrentMonth, t.l10n) + " " : t.monthsDropdownContainer.value = U.getMonth().toString(), h.value = U.getFullYear().toString();
    }), t._hidePrevMonthArrow = t.config.minDate !== void 0 && (t.currentYear === t.config.minDate.getFullYear() ? t.currentMonth <= t.config.minDate.getMonth() : t.currentYear < t.config.minDate.getFullYear()), t._hideNextMonthArrow = t.config.maxDate !== void 0 && (t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth + 1 > t.config.maxDate.getMonth() : t.currentYear > t.config.maxDate.getFullYear()));
  }
  function to(h) {
    var m = h || (t.config.altInput ? t.config.altFormat : t.config.dateFormat);
    return t.selectedDates.map(function(U) {
      return t.formatDate(U, m);
    }).filter(function(U, _, Q) {
      return t.config.mode !== "range" || t.config.enableTime || Q.indexOf(U) === _;
    }).join(t.config.mode !== "range" ? t.config.conjunction : t.l10n.rangeSeparator);
  }
  function Ot(h) {
    h === void 0 && (h = !0), t.mobileInput !== void 0 && t.mobileFormatStr && (t.mobileInput.value = t.latestSelectedDateObj !== void 0 ? t.formatDate(t.latestSelectedDateObj, t.mobileFormatStr) : ""), t.input.value = to(t.config.dateFormat), t.altInput !== void 0 && (t.altInput.value = to(t.config.altFormat)), h !== !1 && _e("onValueUpdate");
  }
  function ru(h) {
    var m = dt(h), U = t.prevMonthNav.contains(m), _ = t.nextMonthNav.contains(m);
    U || _ ? De(U ? -1 : 1) : t.yearElements.indexOf(m) >= 0 ? m.select() : m.classList.contains("arrowUp") ? t.changeYear(t.currentYear + 1) : m.classList.contains("arrowDown") && t.changeYear(t.currentYear - 1);
  }
  function su(h) {
    h.preventDefault();
    var m = h.type === "keydown", U = dt(h), _ = U;
    t.amPM !== void 0 && U === t.amPM && (t.amPM.textContent = t.l10n.amPM[yt(t.amPM.textContent === t.l10n.amPM[0])]);
    var Q = parseFloat(_.getAttribute("min")), W = parseFloat(_.getAttribute("max")), me = parseFloat(_.getAttribute("step")), te = parseInt(_.value, 10), Ke = h.delta || (m ? h.which === 38 ? 1 : -1 : 0), Z = te + me * Ke;
    if (typeof _.value < "u" && _.value.length === 2) {
      var ue = _ === t.hourElement, Ee = _ === t.minuteElement;
      Z < Q ? (Z = W + Z + yt(!ue) + (yt(ue) && yt(!t.amPM)), Ee && D(void 0, -1, t.hourElement)) : Z > W && (Z = _ === t.hourElement ? Z - W - yt(!t.amPM) : Q, Ee && D(void 0, 1, t.hourElement)), t.amPM && ue && (me === 1 ? Z + te === 23 : Math.abs(Z - te) > me) && (t.amPM.textContent = t.l10n.amPM[yt(t.amPM.textContent === t.l10n.amPM[0])]), _.value = rt(Z);
    }
  }
  return o(), t;
}
function hn(e, n) {
  for (var t = Array.prototype.slice.call(e).filter(function(s) {
    return s instanceof HTMLElement;
  }), i = [], o = 0; o < t.length; o++) {
    var r = t[o];
    try {
      if (r.getAttribute("data-fp-omit") !== null)
        continue;
      r._flatpickr !== void 0 && (r._flatpickr.destroy(), r._flatpickr = void 0), r._flatpickr = py(r, n || {}), i.push(r._flatpickr);
    } catch (s) {
      console.error(s);
    }
  }
  return i.length === 1 ? i[0] : i;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(e) {
  return hn(this, e);
}, HTMLElement.prototype.flatpickr = function(e) {
  return hn([this], e);
});
var Me = function(e, n) {
  return typeof e == "string" ? hn(window.document.querySelectorAll(e), n) : e instanceof Node ? hn([e], n) : hn(e, n);
};
Me.defaultConfig = {};
Me.l10ns = {
  en: Je({}, $n),
  default: Je({}, $n)
};
Me.localize = function(e) {
  Me.l10ns.default = Je(Je({}, Me.l10ns.default), e);
};
Me.setDefaults = function(e) {
  Me.defaultConfig = Je(Je({}, Me.defaultConfig), e);
};
Me.parseDate = qo({});
Me.formatDate = Ul({});
Me.compareDates = ct;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(e) {
  return hn(this, e);
});
Date.prototype.fp_incr = function(e) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof e == "string" ? parseInt(e, 10) : e));
};
typeof window < "u" && (window.flatpickr = Me);
const El = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], hy = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function Ms(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Ls(e) {
  return e instanceof Array ? e : [e];
}
function Uo(e) {
  return e && e.length ? e : null;
}
const Ns = [...El, ...hy], my = ["locale", "showMonths"], Ay = Se({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return ta("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...Ns.map(Ms)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => El
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = Me(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let e = Object.assign({}, this.config);
      this.events.forEach((t) => {
        let i = Me.defaultConfig[t] || [], o = (...r) => {
          this.$emit(Ms(t), ...r);
        };
        e[t] = Ls(e[t] || []).concat(i, o);
      });
      const n = this.onClose.bind(this);
      return e.onClose = Ls(e.onClose || []).concat(n), e.defaultDate = this.modelValue || e.defaultDate, e;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(e) {
      const n = e.target;
      Ti().then(() => {
        this.$emit("update:modelValue", Uo(n.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(e) {
      this.$emit("blur", Uo(e.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(e, n) {
      this.$emit("update:modelValue", n);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(e) {
      e ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(e) {
        if (!this.fp)
          return;
        let n = Object.assign({}, e);
        Ns.forEach((t) => {
          delete n[t];
        }), this.fp.set(n), my.forEach((t) => {
          typeof n[t] < "u" && this.fp.set(t, n[t]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(e) {
      var n;
      !this.$el || e === Uo(this.$el.value) || (n = this.fp) === null || n === void 0 || n.setDate(e, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
}), gy = {
  extends: ke,
  components: {
    FlatPickr: Ay
  },
  props: {
    readonly: { type: Boolean, default: !1 },
    config: {
      type: Object,
      required: !0
    }
  }
}, yy = ["id", "required"];
function Ky(e, n, t, i, o, r) {
  const s = K("FlatPickr");
  return t.readonly ? tt((u(), c("input", {
    key: 0,
    id: e.id,
    readonly: "",
    "onUpdate:modelValue": n[0] || (n[0] = (a) => e.modelValue = a),
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    required: e.required
  }, null, 10, yy)), [
    [er, e.modelValue]
  ]) : (u(), k(s, {
    key: 1,
    id: e.id,
    modelValue: e.modelValue,
    style: { background: "white" },
    class: "form-control active",
    config: t.config,
    placeholder: e.placeholder,
    disabled: t.readonly,
    onInput: n[1] || (n[1] = (a) => e.$emit("update:modelValue", a.target.value))
  }, null, 8, ["id", "modelValue", "config", "placeholder", "disabled"]));
}
const Sl = /* @__PURE__ */ P(gy, [["render", Ky]]), by = {
  components: { BaseInputDate: Sl, FormGroup: Te, InputGroup: Qe },
  extends: ke,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    },
    readonly: { type: Boolean, default: !1 }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e, this.$emit("update:modelValue", t);
    }
  },
  computed: {
    config() {
      return {
        wrap: !1,
        dateFormat: "Y-m-d",
        allowInput: !1,
        clickOpens: !this.readonly
      };
    }
  }
};
function vy(e, n, t, i, o, r) {
  const s = K("BaseInputDate"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id,
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, { class: "d-flex" }, {
        prepend: w(() => [
          j(e.$slots, "prepend")
        ]),
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            readonly: t.readonly,
            config: r.config,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: "m-0"
          }, null, 8, ["id", "modelValue", "readonly", "config"]),
          O(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            readonly: t.readonly,
            config: r.config,
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: "m-0"
          }, null, 8, ["id", "modelValue", "readonly", "config"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Tl = /* @__PURE__ */ P(by, [["render", vy]]), wy = {
  name: "DateFilter",
  components: { InputRangeDate: Tl },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function Cy(e, n, t, i, o, r) {
  const s = K("InputRangeDate");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: w(() => [
      t.condition ? (u(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : b("", !0),
      t.showAddButton && t.condition ? (u(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Vo = /* @__PURE__ */ P(wy, [["render", Cy]]), Ry = {
  extends: ke,
  components: {
    BaseInputDate: Sl,
    FormGroup: Te,
    InputGroup: Qe
  },
  props: {
    readonly: { type: Boolean, default: !1 }
  },
  computed: {
    config() {
      return {
        wrap: !1,
        dateFormat: "Y-m-d",
        allowInput: !1,
        clickOpens: !this.readonly
      };
    }
  }
};
function Fy(e, n, t, i, o, r) {
  const s = K("BaseInputDate"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, null, {
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: t.readonly,
            class: G({ "is-invalid": e.errorMessage }),
            required: e.required,
            config: r.config,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "class", "required", "config"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Wi = /* @__PURE__ */ P(Ry, [["render", Fy]]), Yi = {
  name: "InputDateTime",
  extends: Wi,
  computed: {
    config() {
      return {
        wrap: !0,
        dateFormat: "Y-m-dTH:i:S",
        allowInput: !1,
        enableTime: !0,
        clickOpens: !this.readonly
      };
    }
  }
}, ky = {
  components: { InputDateTime: Yi, FormGroup: Te },
  extends: Tl
}, Uy = { class: "d-flex" };
function Ey(e, n, t, i, o, r) {
  const s = K("InputDateTime"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      p("div", Uy, [
        O(s, {
          id: e.id + "-from",
          modelValue: e.modelValue[0],
          readonly: e.readonly,
          "onUpdate:modelValue": n[0] || (n[0] = (l) => e.emitValue(l, 0)),
          placeholder: "from",
          class: "m-0"
        }, null, 8, ["id", "modelValue", "readonly"]),
        O(s, {
          id: e.id + "-to",
          modelValue: e.modelValue[1],
          readonly: e.readonly,
          "onUpdate:modelValue": n[1] || (n[1] = (l) => e.emitValue(l, 1)),
          placeholder: "to",
          class: "m-0"
        }, null, 8, ["id", "modelValue", "readonly"])
      ])
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Sy = /* @__PURE__ */ P(ky, [["render", Ey]]), Ty = {
  name: "DateTimeFilter",
  components: { InputRangeDateTime: Sy },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  }
};
function Iy(e, n, t, i, o, r) {
  const s = K("InputRangeDateTime");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: w(() => [
      t.condition ? (u(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : b("", !0),
      t.showAddButton && t.condition ? (u(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const jo = /* @__PURE__ */ P(Ty, [["render", Iy]]), { CODE_MINUS: Dy, CODE_PERIOD: Oy } = Lt, _y = {
  extends: ke,
  methods: {
    handleInputChanged(e) {
      const n = e.target?.value;
      n ? this.emitIfValid(n) : this.$emit("update:modelValue", null);
    },
    emitIfValid(e) {
      if (e === null) {
        this.$emit("update:modelValue", null);
        return;
      }
      const n = e.replace(",", ""), t = parseFloat(n);
      isNaN(t) ? this.$emit("update:modelValue", e) : this.$emit("update:modelValue", t);
    },
    handleKeyValidity(e) {
      const n = e.which ?? e.keyCode;
      if (n === Dy) {
        const t = cr(e.target?.value);
        this.emitIfValid(t);
      }
      n === Oy && e.target?.value.indexOf(".") > -1 && e.preventDefault(), dr(e) || e.preventDefault();
    },
    isRequired: ti
  }
}, Py = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function My(e, n, t, i, o, r) {
  return u(), c("input", {
    id: e.id,
    type: "text",
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (...s) => r.handleKeyValidity && r.handleKeyValidity(...s)),
    onInput: n[1] || (n[1] = (...s) => r.handleInputChanged && r.handleInputChanged(...s))
  }, null, 42, Py);
}
const Il = /* @__PURE__ */ P(_y, [["render", My]]), Ly = {
  components: { FormGroup: Te, BaseInputDecimal: Il, InputGroup: Qe },
  extends: ke,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e, this.$emit("update:modelValue", t);
    }
  }
};
function Ny(e, n, t, i, o, r) {
  const s = K("BaseInputDecimal"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id + "-from",
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, { class: "d-flex" }, {
        prepend: w(() => [
          j(e.$slots, "prepend")
        ]),
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          O(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const By = /* @__PURE__ */ P(Ly, [["render", Ny]]), xy = {
  name: "DecimalFilter",
  components: { InputRangeDecimal: By },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function qy(e, n, t, i, o, r) {
  const s = K("InputRangeDecimal");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: w(() => [
      t.condition ? (u(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : b("", !0),
      t.showAddButton && t.condition ? (u(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Ho = /* @__PURE__ */ P(xy, [["render", qy]]), { CODE_MINUS: Vy } = Lt, jy = {
  extends: ke,
  methods: {
    emitIfValid(e) {
      const n = e.target.value;
      isNaN(n) || !n ? this.$emit("update:modelValue", null) : this.$emit("update:modelValue", parseInt(n));
    },
    handleKeyValidity(e) {
      if ((e.which ? e.which : e.keyCode) === Vy) {
        const t = cr(e.target.value);
        typeof t == "string" ? this.$emit("update:modelValue", parseInt(t)) : this.$emit("update:modelValue", t);
      }
      (!dr(e) || e.key === ".") && e.preventDefault();
    },
    isRequired: ti
  }
}, Hy = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function Gy(e, n, t, i, o, r) {
  return u(), c("input", {
    id: e.id,
    type: "number",
    step: "1",
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (...s) => r.handleKeyValidity && r.handleKeyValidity(...s)),
    onInput: n[1] || (n[1] = (...s) => r.emitIfValid && r.emitIfValid(...s))
  }, null, 42, Hy);
}
const kr = /* @__PURE__ */ P(jy, [["render", Gy]]), Qy = {
  components: { BaseIntInput: kr, FormGroup: Te, InputGroup: Qe },
  extends: ke,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e === "" ? null : parseInt(e), this.$emit("update:modelValue", t);
    }
  }
};
function $y(e, n, t, i, o, r) {
  const s = K("BaseIntInput"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id + "-from",
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, { class: "d-flex" }, {
        prepend: w(() => [
          j(e.$slots, "prepend")
        ]),
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          O(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const Jy = /* @__PURE__ */ P(Qy, [["render", $y]]), zy = {
  name: "IntegerFilter",
  components: { InputRangeInt: Jy },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function Wy(e, n, t, i, o, r) {
  const s = K("InputRangeInt");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: w(() => [
      t.condition ? (u(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : b("", !0),
      t.showAddButton && t.condition ? (u(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Go = /* @__PURE__ */ P(zy, [["render", Wy]]), { CODE_MINUS: Yy } = Lt, Xy = {
  extends: ke,
  methods: {
    emitIfValid(e) {
      const n = e.target.value;
      n?.length ? this.$emit("update:modelValue", n) : this.$emit("update:modelValue", null);
    },
    handleKeyValidity(e) {
      (e.which ?? e.keyCode) === Yy && this.$emit("update:modelValue", cr(e.target.value)), dr(e) || e.preventDefault();
    },
    isRequired: ti
  },
  emits: ["update:modelValue"]
}, Zy = ["id", "value", "aria-describedby", "placeholder", "readonly", "required"];
function eK(e, n, t, i, o, r) {
  return u(), c("input", {
    id: e.id,
    value: e.modelValue,
    class: G(["form-control", { "is-invalid": e.errorMessage }]),
    "aria-describedby": e.id + "Help",
    placeholder: e.placeholder,
    readonly: e.readonly,
    required: r.isRequired(e.required),
    onKeypress: n[0] || (n[0] = (s) => r.handleKeyValidity(s)),
    onInput: n[1] || (n[1] = (s) => r.emitIfValid(s))
  }, null, 42, Zy);
}
const Dl = /* @__PURE__ */ P(Xy, [["render", eK]]), tK = {
  components: { BaseInputLong: Dl, FormGroup: Te, InputGroup: Qe },
  extends: ke,
  props: {
    modelValue: {
      type: Array,
      default: () => [null, null]
    }
  },
  methods: {
    emitValue(e, n) {
      let t = [...this.modelValue];
      t[n] = e === "" ? null : e, this.$emit("update:modelValue", t);
    }
  }
};
function nK(e, n, t, i, o, r) {
  const s = K("BaseInputLong"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id + "-from",
    label: e.label,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, { class: "d-flex" }, {
        prepend: w(() => [
          j(e.$slots, "prepend")
        ]),
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id + "-from",
            modelValue: t.modelValue[0],
            "onUpdate:modelValue": n[0] || (n[0] = (d) => r.emitValue(d, 0)),
            placeholder: "from",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"]),
          O(s, {
            id: e.id + "-to",
            modelValue: t.modelValue[1],
            "onUpdate:modelValue": n[1] || (n[1] = (d) => r.emitValue(d, 1)),
            placeholder: "to",
            class: G({ "is-invalid": e.errorMessage })
          }, null, 8, ["id", "modelValue", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "description", "errorMessage"]);
}
const iK = /* @__PURE__ */ P(tK, [["render", nK]]), oK = {
  name: "LongFilter",
  components: { InputRangeLong: iK },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Array,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function rK(e, n, t, i, o, r) {
  const s = K("InputRangeLong");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: w(() => [
      t.condition ? (u(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : b("", !0),
      t.showAddButton && t.condition ? (u(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const Bs = /* @__PURE__ */ P(oK, [["render", rK]]), sK = {
  name: "InputOntologySubtree",
  props: {
    terms: {
      type: Array,
      required: !0,
      default: () => []
    },
    isMultiSelect: { type: Boolean, default: !1 }
  },
  methods: {
    countVisibleChildren(e) {
      return e.children ? e.children.filter((n) => n.visible).length : 0;
    },
    getExpandState(e) {
      return this.countVisibleChildren(e) == 0 ? "fas fa-angle-right invisible" : e.expanded ? "fas fa-angle-down" : "fas fa-angle-right";
    },
    //expensive?
    getAllChildNames(e) {
      let n = [];
      return e.children && e.children.forEach((t) => {
        n.push(t.name), n = n.concat(this.getAllChildNames(t));
      }), n;
    },
    getSelectState(e) {
      return e.selected === "complete" ? this.isMultiSelect ? "fas fa-check-square" : "fas fa-check-circle" : e.selected === "partial" ? this.isMultiSelect ? "far fa-check-square" : "far fa-circle" : this.isMultiSelect ? "far fa-square" : "far fa-circle";
    },
    toggleExpandOrSelect(e) {
      e.children ? this.toggleExpand(e) : this.toggleSelect(e);
    },
    toggleSelect(e) {
      e.selected === "complete" ? this.$emit("deselect", e.name) : this.$emit("select", e.name);
    },
    toggleExpand(e) {
      this.$emit("toggleExpand", e.name);
    }
  }
}, aK = { style: { "list-style-type": "none" } }, lK = ["onClick"], uK = ["onClick"], dK = ["onClick"], cK = { key: 0 }, fK = { key: 0 }, pK = {
  key: 1,
  class: "text-muted"
}, hK = { key: 2 };
function mK(e, n, t, i, o, r) {
  const s = K("InputOntologySubtree", !0);
  return u(), c("ul", aK, [
    (u(!0), c(ie, null, se(t.terms.filter((a) => a.visible).sort((a, l) => a.order - l.order), (a) => (u(), c("li", {
      key: a.name + a.selected + a.expanded
    }, [
      p("span", {
        onClick: ve((l) => r.toggleExpand(a), ["stop"])
      }, [
        p("i", {
          class: G(["fa-fw pl-2 pt-1 ml-3", r.getExpandState(a)]),
          role: "button"
        }, null, 2)
      ], 8, lK),
      p("span", {
        onClick: ve((l) => r.toggleSelect(a), ["stop"])
      }, [
        a.selectable ? (u(), c("i", {
          key: 0,
          class: G(["fa-fw text-primary pl-2 pt-1", r.getSelectState(a)]),
          role: "button"
        }, null, 2)) : b("", !0)
      ], 8, uK),
      p("span", {
        onClick: ve((l) => r.toggleExpandOrSelect(a), ["stop"]),
        class: "flex-grow-1 pl-2",
        role: "button"
      }, [
        N(E(a.label ? a.label : a.name) + " ", 1),
        a.code ? (u(), c("span", cK, [
          n[3] || (n[3] = N(" (", -1)),
          a.codesystem ? (u(), c("span", fK, E(a.codesystem) + ": ", 1)) : b("", !0),
          N(" " + E(a.code) + ") ", 1)
        ])) : b("", !0),
        a.definition ? (u(), c("small", pK, [
          p("i", null, " - " + E(a.definition), 1)
        ])) : b("", !0),
        a.children && r.countVisibleChildren(a) > 0 ? (u(), c("span", hK, " (" + E(r.countVisibleChildren(a)) + ") ", 1)) : b("", !0)
      ], 8, dK),
      a.expanded ? (u(), k(s, {
        key: 0,
        terms: a.children,
        isMultiSelect: t.isMultiSelect,
        onSelect: n[0] || (n[0] = (l) => e.$emit("select", l)),
        onDeselect: n[1] || (n[1] = (l) => e.$emit("deselect", l)),
        onToggleExpand: n[2] || (n[2] = (l) => e.$emit("toggleExpand", l))
      }, null, 8, ["terms", "isMultiSelect"])) : b("", !0)
    ]))), 128))
  ]);
}
const AK = /* @__PURE__ */ P(sK, [["render", mK]]);
var ki = { exports: {} }, gK = ki.exports, xs;
function yK() {
  return xs || (xs = 1, (function(e, n) {
    (function(t, i) {
      e.exports = i();
    })(gK, function() {
      var t = "__v-click-outside", i = typeof window < "u", o = typeof navigator < "u", r = i && ("ontouchstart" in window || o && navigator.msMaxTouchPoints > 0) ? ["touchstart"] : ["click"], s = function(f) {
        var g = f.event, A = f.handler;
        (0, f.middleware)(g) && A(g);
      }, a = function(f, g) {
        var A = (function(I) {
          var M = typeof I == "function";
          if (!M && typeof I != "object") throw new Error("v-click-outside: Binding value must be a function or an object");
          return { handler: M ? I : I.handler, middleware: I.middleware || function(D) {
            return D;
          }, events: I.events || r, isActive: I.isActive !== !1, detectIframe: I.detectIframe !== !1, capture: !!I.capture };
        })(g.value), R = A.handler, F = A.middleware, y = A.detectIframe, T = A.capture;
        if (A.isActive) {
          if (f[t] = A.events.map(function(I) {
            return { event: I, srcTarget: document.documentElement, handler: function(M) {
              return (function(D) {
                var V = D.el, q = D.event, x = D.handler, $ = D.middleware, z = q.path || q.composedPath && q.composedPath();
                (z ? z.indexOf(V) < 0 : !V.contains(q.target)) && s({ event: q, handler: x, middleware: $ });
              })({ el: f, event: M, handler: R, middleware: F });
            }, capture: T };
          }), y) {
            var v = { event: "blur", srcTarget: window, handler: function(I) {
              return (function(M) {
                var D = M.el, V = M.event, q = M.handler, x = M.middleware;
                setTimeout(function() {
                  var $ = document.activeElement;
                  $ && $.tagName === "IFRAME" && !D.contains($) && s({ event: V, handler: q, middleware: x });
                }, 0);
              })({ el: f, event: I, handler: R, middleware: F });
            }, capture: T };
            f[t] = [].concat(f[t], [v]);
          }
          f[t].forEach(function(I) {
            var M = I.event, D = I.srcTarget, V = I.handler;
            return setTimeout(function() {
              f[t] && D.addEventListener(M, V, T);
            }, 0);
          });
        }
      }, l = function(f) {
        (f[t] || []).forEach(function(g) {
          return g.srcTarget.removeEventListener(g.event, g.handler, g.capture);
        }), delete f[t];
      }, d = i ? { beforeMount: a, updated: function(f, g) {
        var A = g.value, R = g.oldValue;
        JSON.stringify(A) !== JSON.stringify(R) && (l(f), a(f, { value: A }));
      }, unmounted: l } : {};
      return { install: function(f) {
        f.directive("click-outside", d);
      }, directive: d };
    });
  })(ki)), ki.exports;
}
var KK = yK();
const Xi = /* @__PURE__ */ pl(KK), bK = {
  extends: ke,
  components: {
    FormGroup: Te,
    InputOntologySubtree: AK,
    MessageError: At,
    Spinner: Ut
  },
  directives: {
    clickOutside: Xi.directive
  },
  props: {
    /** if you don't want to use autoload using table you can provide options via 'items'. Should be format [{name:a, parent:b},{name:b}]
     */
    options: {
      type: Array,
      default: null
    },
    /** show as pulldown. When false, shows always expanded*/
    showExpanded: {
      type: Boolean,
      default: !1
    },
    isMultiSelect: {
      type: Boolean,
      default: !1
    },
    tableId: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      error: null,
      warning: null,
      // used for drop down focus state
      focus: !1,
      //huge object with all the terms, flattened
      //includes also its children
      terms: {},
      search: null,
      //we use key to force updates
      key: 1,
      //use to block to many search results
      searchResultCount: 0,
      data: [],
      loading: !0
    };
  },
  computed: {
    rootTerms() {
      return this.terms ? Object.values(this.terms).filter(
        (n) => !n.parent && n.visible
      ) : [];
    },
    selectionWithoutChildren() {
      let e = [];
      return this.key && this.rootTerms.forEach((n) => {
        e.push(...Ol(n));
      }), e;
    }
  },
  methods: {
    toggleExpand(e) {
      this.terms[e].expanded = !this.terms[e].expanded, this.key++;
    },
    loseFocusWhenClickedOutside() {
      this.focus && !this.showExpanded && (this.focus = !1);
    },
    toggleFocus() {
      this.showExpanded || (this.focus = !this.focus, this.focus && this.$refs.search.focus());
    },
    getParents(e) {
      let n = [], t = e.parent;
      for (; t; )
        n.push(this.terms[t.name]), this.terms[t.name].parent && //check for parent that are indirect parent of themselves
        !n.includes(this.terms[t.name].parent.name) ? t = this.terms[t.name].parent : t = null;
      return n;
    },
    getChildren(e) {
      return this.data.filter(
        (n) => n.parent?.name === e
      );
    },
    getAllChildren(e) {
      let n = [];
      return e.children && (n = e.children, e.children.forEach(
        (t) => n = n.concat(this.getAllChildren(t))
      )), n;
    },
    select(e) {
      this.isMultiSelect || Object.keys(this.terms).forEach(
        (t) => this.terms[t].selected = "unselected"
      );
      let n = this.terms[e];
      n.selected = "complete", this.isMultiSelect && (this.getAllChildren(n).forEach(
        (t) => t.selected = "complete"
      ), this.getParents(n).forEach((t) => {
        t.children.every(
          (i) => i.selected === "complete"
        ) ? t.selected = "complete" : t.selected = "partial";
      })), this.emitValue(), this.$refs.search.focus(), this.isMultiSelect || (this.focus = !1), this.key++, this.search = null;
    },
    deselect(e) {
      if (this.isMultiSelect) {
        let n = this.terms[e];
        n.selected = "unselected", this.getAllChildren(this.terms[e]).forEach(
          (t) => t.selected = "unselected"
        ), this.getParents(n).forEach((t) => {
          t.children.some(
            (i) => i.selected === "complete"
          ) ? t.selected = "partial" : t.selected = "unselected";
        });
      } else
        Object.keys(this.terms).forEach(
          (n) => this.terms[n].selected = "unselected"
        );
      this.emitValue(), this.$refs.search.focus(), this.key++;
    },
    clearSelection() {
      this.terms && Object.values(this.terms).forEach(
        (e) => e.selected = "unselected"
      ), this.emitValue(), this.$refs.search.focus(), this.key++;
    },
    emitValue() {
      let e = Object.values(this.terms).filter((n) => n.selected === "complete").map((n) => ({ name: n.name }));
      this.isMultiSelect ? this.$emit("update:modelValue", e) : this.$emit("update:modelValue", e[0] || null);
    },
    applySelection(e) {
      if (Object.keys(this.terms).forEach(
        (n) => this.terms[n].selected = "unselected"
      ), e && this.isMultiSelect)
        e.forEach((n) => {
          let t = this.terms[n.name];
          t && (this.getAllChildren(t).length == 0 && (t.selected = "complete"), this.isMultiSelect && (this.getAllChildren(t).forEach(
            (i) => i.selected = "complete"
          ), this.getParents(t).forEach((i) => {
            i.children.every(
              (o) => o.selected === "complete"
            ) ? i.selected = "complete" : i.selected = "partial";
          })));
        });
      else if (e) {
        let n = this.terms[e.name];
        n && (n.selected = "complete", this.getParents(n).forEach((t) => {
          t.selected = "partial";
        }));
      }
      this.key++;
    }
  },
  watch: {
    search() {
      if (this.searchResultCount = 0, this.search) {
        Object.values(this.terms).forEach((n) => {
          n.visible = !1, n.selectable = !1;
        });
        let e = this.search.trim().split(/[\s,:]+/).filter((n) => n.trim().length > 0).map((n) => n.toLowerCase());
        Object.values(this.terms).forEach((n) => {
          if (e.every(
            (t) => n.name.toLowerCase().includes(t) || n.label?.toLowerCase().includes(t) || n.definition?.toLowerCase().includes(t) || n.code?.toLowerCase().includes(t) || n.codesystem?.toLowerCase().includes(t)
          )) {
            if (n.visible = !0, n.selectable = !0, this.searchResultCount++, n.parent) {
              let t = this.terms[n.parent.name];
              for (; t && !t.visible; )
                t.visible = !0, t.parent && (t = this.terms[t.parent.name]);
            }
            this.getAllChildren(n).forEach((t) => {
              t.visible = !0, t.selectable = !0;
            });
          }
        });
      } else
        Object.values(this.terms).forEach((e) => {
          e.visible = !0, e.selectable = !0, this.searchResultCount++;
        });
      Object.values(this.terms).filter((e) => e.visible).length < 50 && Object.values(this.terms).filter((e) => e.visible && e.children).forEach((e) => e.expanded = !0), this.key++;
    },
    modelValue: {
      deep: !0,
      handler() {
        this.applySelection(this.modelValue), this.key++;
      }
    },
    data() {
      if (!this.data || !this.data.length)
        this.loading = !1, this.warning = `Ontology '${this.tableId}' in schema '${this.schemaId}' is empty`;
      else {
        this.warning = null, this.searchResultCount = 0;
        let e = {};
        this.data.forEach((n) => {
          e[n.name] ? (e[n.name].definition = n.definition, e[n.name].label = n.label, e[n.name].code = n.code, e[n.name].codesystem = n.codesystem, e[n.name].order = n.order) : e[n.name] = {
            name: n.name,
            visible: !0,
            selectable: !0,
            selected: "unselected",
            definition: n.definition,
            code: n.code,
            codesystem: n.codesystem,
            label: n.label,
            order: n.order
          }, n.parent && (e[n.name].parent = n.parent, e[n.parent.name] || (e[n.parent.name] = {
            name: n.parent.name,
            visible: !0,
            selectable: !0,
            selected: "unselected"
          }), e[n.parent.name].children || (e[n.parent.name].children = []), e[n.parent.name].children.push(e[n.name])), this.searchResultCount++;
        }), this.terms = e, this.applySelection(this.modelValue);
      }
    }
  },
  async mounted() {
    if (this.tableId) {
      const e = nt.newClient(this.schemaId);
      this.data = await e.fetchOntologyOptions(this.tableId);
    }
  },
  created() {
    this.options ? (this.data = this.options, this.loading = !1) : this.limit = 1e5;
  }
};
function Ol(e) {
  let n = [];
  return e.selected === "complete" ? n.push(e) : e.children && e.children.forEach(
    (t) => n.push(...Ol(t))
  ), n;
}
const vK = ["onClick"], wK = {
  key: 0,
  class: "input-group-prepend"
}, CK = ["placeholder"], RK = { class: "d-inline-block float-right" }, FK = {
  key: 0,
  class: "p-2 fa fa-times",
  style: { "vertical-align": "middle" }
}, kK = {
  key: 0,
  class: "p-2 fa fa-caret-down",
  style: { "vertical-align": "middle" }
}, UK = {
  key: 0,
  class: "pl-4"
}, EK = { key: 3 };
function SK(e, n, t, i, o, r) {
  const s = K("MessageError"), a = K("MessageWarning"), l = K("InputOntologySubtree"), d = K("Spinner"), f = K("FormGroup"), g = zn("click-outside");
  return u(), k(f, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      o.error ? (u(), k(s, { key: 0 }, {
        default: w(() => [
          N(E(o.error), 1)
        ]),
        _: 1
      })) : b("", !0),
      o.warning ? (u(), k(a, { key: 1 }, {
        default: w(() => [
          N(E(o.warning), 1)
        ]),
        _: 1
      })) : (u(), c("div", {
        key: 2,
        class: G(["p-0 m-0", { dropdown: !t.showExpanded, "border rounded": !t.showExpanded }])
      }, [
        p("div", {
          class: "border-0 text-left form-control",
          style: { height: "auto", cursor: "pointer" },
          onClick: n[5] || (n[5] = (...A) => r.toggleFocus && r.toggleFocus(...A))
        }, [
          (u(!0), c(ie, null, se(r.selectionWithoutChildren.sort(
            (A, R) => A.order - R.order
          ), (A) => (u(), c("span", {
            class: "btn btn-sm btn-primary text-white mr-1",
            key: A,
            onClick: ve((R) => r.deselect(A.name), ["stop"])
          }, [
            N(E(A.label ? A.label : A.name) + " ", 1),
            n[6] || (n[6] = p("span", { class: "fa fa-times" }, null, -1))
          ], 8, vK))), 128)),
          t.showExpanded && r.selectionWithoutChildren.length > 0 ? (u(), c("i", {
            key: 0,
            class: "p-2 fa fa-times",
            style: { "vertical-align": "middle" },
            onClick: n[0] || (n[0] = ve((...A) => r.clearSelection && r.clearSelection(...A), ["stop"]))
          })) : b("", !0),
          p("span", {
            class: G({ "input-group": t.showExpanded })
          }, [
            t.showExpanded ? (u(), c("div", wK, [...n[7] || (n[7] = [
              p("button", {
                class: "btn border-right-0 border btn-outline-primary",
                type: "button"
              }, [
                p("i", { class: "fa fa-search" })
              ], -1)
            ])])) : b("", !0),
            tt(p("input", {
              type: "text",
              ref: "search",
              placeholder: o.focus || t.showExpanded ? "Type to search" : "",
              class: G({
                "form-control": t.showExpanded,
                "border-0": !t.showExpanded
              }),
              "onUpdate:modelValue": n[1] || (n[1] = (A) => o.search = A),
              onClick: n[2] || (n[2] = ve(() => {
              }, ["stop"])),
              onFocus: n[3] || (n[3] = (A) => o.focus = !0)
            }, null, 42, CK), [
              [er, o.search]
            ])
          ], 2),
          p("span", RK, [
            p("span", {
              onClick: n[4] || (n[4] = ve((...A) => r.clearSelection && r.clearSelection(...A), ["prevent", "stop"])),
              style: { cursor: "pointer" }
            }, [
              !t.showExpanded && r.selectionWithoutChildren.length > 0 ? (u(), c("i", FK)) : b("", !0)
            ]),
            t.showExpanded ? b("", !0) : (u(), c("i", kK))
          ])
        ]),
        o.focus || t.showExpanded ? tt((u(), c("div", {
          key: 0,
          class: G(["w-100 show p-0 overflow-auto", { "dropdown-menu": !t.showExpanded }])
        }, [
          o.search && Object.keys(o.terms).length > 50 && o.searchResultCount >= 0 ? (u(), c("span", UK, " found " + E(o.searchResultCount) + " terms. ", 1)) : b("", !0),
          r.rootTerms.length > 0 ? (u(), k(l, {
            key: o.key,
            terms: r.rootTerms,
            isMultiSelect: t.isMultiSelect,
            onSelect: r.select,
            onDeselect: r.deselect,
            onToggleExpand: r.toggleExpand,
            style: { "max-height": "100vh" },
            class: "pt-2 pl-0"
          }, null, 8, ["terms", "isMultiSelect", "onSelect", "onDeselect", "onToggleExpand"])) : o.loading ? (u(), k(d, { key: 2 })) : (u(), c("div", EK, "No results found"))
        ], 2)), [
          [g, r.loseFocusWhenClickedOutside]
        ]) : b("", !0)
      ], 2))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Li = /* @__PURE__ */ P(bK, [["render", SK]]), TK = {
  name: "InputOntologyFilter",
  components: { InputOntology: Li },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Object,
      required: !1
    },
    schemaId: {
      required: !1,
      type: String
    },
    tableId: {
      type: String,
      required: !0
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  }
};
function IK(e, n, t, i, o, r) {
  const s = K("InputOntology");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    tableId: t.tableId,
    schemaId: t.schemaId,
    isMultiSelect: !0,
    showExpanded: !0
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "tableId", "schemaId"]);
}
const Qo = /* @__PURE__ */ P(TK, [["render", IK]]), _l = /* @__PURE__ */ Se({
  __name: "RadioFilter",
  props: {
    id: {},
    condition: {},
    tableId: {},
    schemaId: {},
    refLabel: {},
    orderBy: {},
    filter: {}
  },
  emits: ["updateCondition", "clearCondition"],
  setup(e, { emit: n }) {
    const t = n, i = nt.newClient(e.schemaId), o = fe(), r = fe({}), s = xe(
      () => nn(e.condition || {}, e.refLabel)
    );
    l();
    function a(d) {
      d ? t("updateCondition", r.value[d]) : t("clearCondition", d);
    }
    async function l() {
      const d = {
        orderby: e.orderBy,
        filter: e.filter
      }, A = ((await i.fetchTableData(e.tableId, d))[e.tableId] || []).map(
        async (F) => ni(F, e.tableId, e.schemaId)
      ), R = await Promise.all(A);
      r.value = R.reduce((F, y) => {
        const T = nn(y, e.refLabel);
        return F[T] = y, F;
      }, {}), o.value = Object.keys(r.value).sort();
    }
    return (d, f) => o.value?.length ? (u(), k(Fr, {
      key: 0,
      id: e.id,
      modelValue: s.value,
      tableId: e.tableId,
      schemaId: e.schemaId,
      refLabel: e.refLabel,
      options: o.value,
      "onUpdate:modelValue": a,
      direction: "vertical"
    }, null, 8, ["id", "modelValue", "tableId", "schemaId", "refLabel", "options"])) : b("", !0);
  }
}), DK = {
  props: {
    label: String
  }
}, OK = { class: "btn btn-sm btn-outline-primary mr-2 mb-2" };
function _K(e, n, t, i, o, r) {
  return u(), c("button", OK, [
    N(E(t.label) + "  ", 1),
    n[0] || (n[0] = p("i", { class: "fa fa-times" }, null, -1))
  ]);
}
const Pl = /* @__PURE__ */ P(DK, [["render", _K]]), qs = {
  add: "plus",
  edit: "pencil-alt",
  delete: "trash",
  clone: "copy"
}, PK = {
  components: {
    IconAction: Rt,
    IconDanger: Rr
  },
  props: {
    type: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(qs).includes(e);
      }
    }
  },
  computed: {
    icon() {
      return qs[this.type];
    }
  },
  emits: ["add", "edit", "delete", "clone"]
};
function MK(e, n, t, i, o, r) {
  return u(), c("span", null, [
    (u(), k(Pt(t.type === "delete" ? "IconDanger" : "IconAction"), {
      icon: r.icon,
      onClick: n[0] || (n[0] = (s) => e.$emit(t.type))
    }, null, 8, ["icon"]))
  ]);
}
const sn = /* @__PURE__ */ P(PK, [["render", MK]]), Ml = /* @__PURE__ */ Se({
  __name: "RowButtonAdd",
  props: {
    id: {},
    tableId: {},
    schemaId: {},
    label: { default: "" },
    defaultValue: {},
    visibleColumns: {}
  },
  emits: ["close", "update:newRow"],
  setup(e, { emit: n }) {
    const t = na({
      loader: () => Promise.resolve().then(() => Ql)
    });
    let i = fe(!1);
    const o = n;
    function r() {
      i.value = !1, o("close");
    }
    return (s, a) => (u(), c("span", null, [
      e.label !== "" ? (u(), k(Ji, {
        key: 0,
        onClick: a[0] || (a[0] = (l) => Ii(i) ? i.value = !0 : i = !0)
      }, {
        default: w(() => [
          N(E(e.label), 1)
        ]),
        _: 1
      })) : (u(), k(sn, {
        key: 1,
        type: "add",
        onAdd: a[1] || (a[1] = (l) => Ii(i) ? i.value = !0 : i = !0)
      })),
      re(i) ? (u(), k(re(t), {
        key: 2,
        id: e.id + "add-modal",
        tableId: e.tableId,
        isModalShown: re(i),
        schemaId: e.schemaId,
        defaultValue: e.defaultValue,
        visibleColumns: e.visibleColumns,
        applyDefaultValues: !0,
        onClose: r,
        "onUpdate:newRow": a[2] || (a[2] = (l) => s.$emit("update:newRow", l))
      }, null, 8, ["id", "tableId", "isModalShown", "schemaId", "defaultValue", "visibleColumns"])) : b("", !0)
    ]));
  }
}), Ll = /* @__PURE__ */ Se({
  __name: "StringDisplay",
  props: {
    data: { type: [String, Object, Number, Boolean] }
  },
  setup(e) {
    return (n, t) => (u(), c("div", null, E(e.data), 1));
  }
}), LK = {
  name: "FileDisplay",
  props: {
    data: {
      type: [Object],
      required: !0
    },
    metadata: {
      type: Object,
      required: !0
    }
  },
  computed: {
    fileSize() {
      const e = ["", "k", "M", "G", "T", "P", "E"], n = Math.log10(this.data.size) / 3 | 0;
      if (n == 0)
        return this.data.size;
      var t = e[n], i = Math.pow(10, n * 3), o = this.data.size / i;
      return o.toFixed(1) + t;
    }
  }
}, NK = ["href"];
function BK(e, n, t, i, o, r) {
  return t.data.id ? (u(), c("a", {
    key: 0,
    href: t.data.url,
    target: "_blank"
  }, E(t.data?.filename ? t.data.filename : t.metadata.name + "." + t.data.extension) + " (" + E(r.fileSize) + ") ", 9, NK)) : b("", !0);
}
const Nl = /* @__PURE__ */ P(LK, [["render", BK]]), xK = /* @__PURE__ */ Se({
  __name: "TextDisplay",
  props: {
    data: {}
  },
  setup(e) {
    return (n, t) => (u(), k(Fl, { text: e.data }, null, 8, ["text"]));
  }
}), qK = {
  name: "ObjectDisplay",
  props: {
    data: {
      type: [Object],
      required: !0
    },
    metadata: {
      type: [Object]
    }
  },
  computed: {
    hasTemplate() {
      return !!this.metadata.refLabel || !!this.metadata.refLabelDefault;
    },
    asTemplate() {
      const e = Object.keys(this.data), n = Object.values(this.data), t = this.metadata.refLabel ? this.metadata.refLabel : this.metadata.refLabelDefault;
      try {
        return new Function(...e, "return `" + t + "`;")(...n);
      } catch (i) {
        const o = JSON.stringify(e), r = JSON.stringify(n);
        return `${i.message} we got keys: ${o} vals: ${r} and template: ${t}`;
      }
    },
    asDotSeparatedString() {
      let e = "";
      return Object.keys(this.data).forEach((n) => {
        this.data[n] === null || (typeof this.data[n] == "object" ? e += An(this.data[n]) : e += "." + this.data[n]);
      }), e.replace(/^\./, "");
    }
  }
}, VK = { key: 0 }, jK = { key: 1 };
function HK(e, n, t, i, o, r) {
  return r.hasTemplate ? (u(), c("span", VK, E(r.asTemplate), 1)) : (u(), c("span", jK, E(r.asDotSeparatedString), 1));
}
const Ur = /* @__PURE__ */ P(qK, [["render", HK]]), GK = {
  name: "EmailDisplay",
  props: {
    data: {
      type: String,
      required: !0
    }
  }
}, QK = ["href"];
function $K(e, n, t, i, o, r) {
  return u(), c("a", {
    href: `mailto:${t.data}`
  }, E(t.data), 9, QK);
}
const Er = /* @__PURE__ */ P(GK, [["render", $K]]), JK = {
  name: "HyperlinkDisplay",
  props: {
    data: {
      type: String,
      required: !0
    }
  }
}, zK = ["href"];
function WK(e, n, t, i, o, r) {
  return u(), c("a", {
    target: "_blank",
    href: t.data
  }, E(t.data), 9, zK);
}
const Sr = /* @__PURE__ */ P(JK, [["render", WK]]), YK = {
  REF_ARRAY: "ObjectDisplay",
  MULTISELECT: "ObjectDisplay",
  CHECKBOX: "ObjectDisplay",
  ONTOLOGY_ARRAY: "ObjectDisplay",
  REFBACK: "ObjectDisplay",
  EMAIL_ARRAY: "EmailDisplay",
  HYPERLINK_ARRAY: "HyperlinkDisplay"
}, XK = {
  name: "ListDisplay",
  components: { ObjectDisplay: Ur, StringDisplay: Ll, EmailDisplay: Er, HyperlinkDisplay: Sr },
  data() {
    return {
      isFolded: !0
    };
  },
  props: {
    data: {
      type: [Array],
      required: !0
    },
    metadata: {
      type: Object,
      required: !0
    },
    foldCuttOff: {
      type: Number,
      required: !1,
      default: () => 3
    }
  },
  computed: {
    cellTypeComponentName() {
      return YK[this.metadata.columnType] || "StringDisplay";
    },
    visibleListItems() {
      return this.isFolded ? this.data.slice(0, this.foldCuttOff) : this.data;
    }
  },
  methods: {
    onFoldClicked(e) {
      this.isFolded = !this.isFolded, e.target.blur(), e.target.parentElement.blur();
    }
  }
}, ZK = {
  key: 0,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-down",
  class: "svg-inline--fa fa-chevron-down fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, eb = {
  key: 1,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-up",
  class: "svg-inline--fa fa-chevron-up fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};
function tb(e, n, t, i, o, r) {
  return u(), c("div", null, [
    tt(p("button", {
      onClick: n[0] || (n[0] = ve((...s) => r.onFoldClicked && r.onFoldClicked(...s), ["stop", "prevent"])),
      class: "btn btn-sm float-right fold-btn"
    }, [
      p("template", null, [
        o.isFolded ? (u(), c("svg", ZK, [...n[1] || (n[1] = [
          p("path", {
            fill: "currentColor",
            d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
          }, null, -1)
        ])])) : (u(), c("svg", eb, [...n[2] || (n[2] = [
          p("path", {
            fill: "currentColor",
            d: "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
          }, null, -1)
        ])]))
      ])
    ], 512), [
      [Bi, t.data.length > t.foldCuttOff]
    ]),
    (u(!0), c(ie, null, se(r.visibleListItems, (s, a) => (u(), c("div", { key: a }, [
      (u(), k(Pt(r.cellTypeComponentName), {
        data: s,
        metadata: t.metadata
      }, null, 8, ["data", "metadata"]))
    ]))), 128))
  ]);
}
const nb = /* @__PURE__ */ P(XK, [["render", tb], ["__scopeId", "data-v-44c19699"]]), ib = {
  FILE: "FileDisplay",
  TEXT: "TextDisplay",
  JSON: "TextDisplay",
  REFBACK: "ListDisplay",
  MULTISELECT: "ListDisplay",
  CHECKBOX: "ListDisplay",
  REF: "ObjectDisplay",
  SELECT: "ObjectDisplay",
  RADIO: "ObjectDisplay",
  ONTOLOGY: "ObjectDisplay",
  EMAIL: "EmailDisplay",
  HYPERLINK: "HyperlinkDisplay"
}, ob = Se({
  name: "DataDisplayCell",
  components: {
    StringDisplay: Ll,
    FileDisplay: Nl,
    TextDisplay: xK,
    ListDisplay: nb,
    ObjectDisplay: Ur,
    EmailDisplay: Er,
    HyperlinkDisplay: Sr
  },
  props: {
    data: {
      type: [String, Object, Array, Number, Boolean],
      required: !1
    },
    metadata: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cellTypeComponentName() {
      return this.isArrayType ? "ListDisplay" : ib[this.metadata.columnType] || "StringDisplay";
    },
    isArrayType() {
      return this.metadata.columnType.includes("ARRAY") || this.metadata.columnType === "MULTISELECT" || this.metadata.columnType === "CHECKBOX";
    },
    isEmpty() {
      return this.data === void 0 || this.data === null || Array.isArray(this.data) && this.data.length === 0;
    }
  }
});
function rb(e, n, t, i, o, r) {
  return e.isEmpty ? b("", !0) : (u(), k(Pt(e.cellTypeComponentName), {
    key: 0,
    data: e.data,
    metadata: e.metadata
  }, null, 8, ["data", "metadata"]));
}
const Bl = /* @__PURE__ */ P(ob, [["render", rb]]), sb = {
  name: "TableRow",
  components: { DataDisplayCell: Bl },
  props: {
    row: {
      type: Object,
      required: !0
    },
    columns: { type: Array, required: !0 },
    tableId: { type: String, required: !0 },
    client: { type: Object, required: !0 },
    showSelect: { type: Boolean, required: !1 },
    selection: { type: Array, required: !1 }
  },
  data() {
    return {
      rowKey: null
    };
  },
  computed: {
    isSelected() {
      return !!this.selection?.find((e) => e && this.rowKey && fn(e, this.rowKey));
    }
  },
  methods: {
    isRefType: _i,
    async convertRowToPrimaryKey(e) {
      return await this.client.convertRowToPrimaryKey(e, this.tableId);
    },
    onColumnClick(e) {
      this.$emit("column-click", e);
    },
    onCellClick(e) {
      const n = this.row[e.id];
      n && this.$emit("cellClick", {
        cellValue: We(n),
        column: We(e)
      });
    },
    onRowClick() {
      if (this.showSelect) {
        const e = this.isSelected ? "deselect" : "select";
        this.$emit(e, To(this.rowKey));
      } else
        this.$emit("rowClick", To(this.rowKey));
    },
    hasRowheader() {
      return this.showSelect || !!this.$slots.rowheader;
    }
  },
  mounted() {
    this.client.convertRowToPrimaryKey(this.row, this.tableId).then((e) => {
      this.rowKey = e;
    }).catch((e) => {
      console.log(e);
    });
  }
}, ab = { key: 0 }, lb = { style: { display: "flex" } }, ub = {
  key: 0,
  class: "form-check form-check-inline mr-1"
}, db = ["checked"], cb = {
  key: 0,
  class: "fas fa-user-edit"
}, fb = ["onClick"];
function pb(e, n, t, i, o, r) {
  const s = K("DataDisplayCell");
  return u(), c("tr", {
    class: G(
      (r.isSelected ? "table-primary" : "table-hover") + (t.row.mg_draft ? "alert alert-warning" : "")
    )
  }, [
    r.hasRowheader ? (u(), c("td", ab, [
      p("div", lb, [
        t.showSelect ? (u(), c("div", ub, [
          p("input", {
            type: "checkbox",
            class: "form-check-input position-static",
            checked: r.isSelected,
            onClick: n[0] || (n[0] = (...a) => r.onRowClick && r.onRowClick(...a))
          }, null, 8, db)
        ])) : b("", !0),
        j(e.$slots, "rowheader", {
          row: t.row,
          rowKey: o.rowKey
        }, void 0, !0)
      ]),
      t.row.mg_draft ? (u(), c("i", cb, "draft")) : b("", !0)
    ])) : b("", !0),
    (u(!0), c(ie, null, se(t.columns, (a) => (u(), c("td", {
      key: a.id + r.isSelected,
      style: xi([{ cursor: "pointer" }, a.showColumn ? "" : "display: none"]),
      onClick: (l) => {
        r.onRowClick(), r.onCellClick(a);
      },
      class: G({ refType: r.isRefType(a.columnType) })
    }, [
      O(s, {
        data: t.row[a.id],
        metadata: a
      }, null, 8, ["data", "metadata"])
    ], 14, fb))), 128))
  ], 2);
}
const hb = /* @__PURE__ */ P(sb, [["render", pb], ["__scopeId", "data-v-e0c9e76a"]]), mb = {
  components: { TableRow: hb },
  props: {
    selection: { type: Array, required: !1 },
    /** column metadata, two-way binded to allow for reorder
     * TODO: handle this through events since props are meant to be 1-way
     */
    columns: { type: Array, default: () => [] },
    tableMetadata: { type: Object, required: !1 },
    /** if tableMetadata is not supplied table id should be set */
    tableId: { type: String, required: !1 },
    data: { type: Array, default: () => [] },
    showSelect: { type: Boolean, default: !1 },
    schemaId: { type: String, required: !1 }
  },
  data() {
    return {
      client: nt.newClient(this.schemaId)
    };
  },
  computed: {
    dataColumns() {
      return this.columns.filter(
        (n) => n.columnType !== "HEADING" && n.columnType !== "SECTION"
      ).map((n) => (n.showColumn == null && (n.showColumn = !0), n));
    }
  },
  methods: {
    hasColheader() {
      return this.showSelect || !!this.$slots.colheader;
    },
    onColumnClick(e) {
      this.$emit("column-click", e);
    },
    onRowSelect(e) {
      this.$emit("select", e), this.$emit("update:selection", [...To(this.selection), e]);
    },
    onRowDeselect(e) {
      const n = JSON.stringify(
        e,
        Object.keys(e).sort()
      ), t = this.selection.map(
        (i) => JSON.stringify(i, Object.keys(i).sort())
      ).findIndex((i) => i === n);
      this.$emit("deselect", e), this.$emit("update:selection", this.selection.toSpliced(t, 1));
    }
  }
}, Ab = { style: { "overflow-x": "scroll" } }, gb = { class: "table table-sm bg-white table-bordered table-hover" }, yb = {
  key: 0,
  slot: "header",
  scope: "col",
  style: { width: "1px" }
}, Kb = { style: { "text-align": "left", "font-weight": "normal" } }, bb = ["onClick"], vb = { key: 0 }, wb = ["colspan"];
function Cb(e, n, t, i, o, r) {
  const s = K("TableRow");
  return u(), c("div", Ab, [
    p("table", gb, [
      p("thead", null, [
        r.hasColheader ? (u(), c("th", yb, [
          n[2] || (n[2] = p("h6", { class: "mb-0 mt-2 d-inline" }, "#", -1)),
          p("span", Kb, [
            j(e.$slots, "rowcolheader", {}, void 0, !0)
          ])
        ])) : b("", !0),
        (u(!0), c(ie, null, se(r.dataColumns, (a) => (u(), c("th", {
          key: a.id + a.showColumn,
          scope: "col",
          class: "column-drag-header",
          style: xi(a.showColumn ? "" : "display: none")
        }, [
          p("h6", {
            class: "mb-0 align-text-bottom text-nowrap",
            onClick: (l) => r.onColumnClick(a)
          }, [
            N(E(a.name) + " ", 1),
            j(e.$slots, "colheader", { col: a }, void 0, !0)
          ], 8, bb)
        ], 4))), 128))
      ]),
      p("tbody", null, [
        t.data && !t.data.length ? (u(), c("tr", vb, [
          p("td", {
            colspan: r.dataColumns.length + 1,
            class: "alert-warning"
          }, " No results found ", 8, wb)
        ])) : (u(!0), c(ie, { key: 1 }, se(t.data, (a) => (u(), k(s, {
          row: a,
          columns: r.dataColumns,
          tableId: t.tableId || t.tableMetadata.id,
          client: o.client,
          showSelect: t.showSelect,
          selection: t.selection,
          onCellClick: n[0] || (n[0] = (l) => e.$emit("cellClick", l)),
          onRowClick: n[1] || (n[1] = (l) => e.$emit("rowClick", l)),
          onSelect: r.onRowSelect,
          onDeselect: r.onRowDeselect
        }, {
          rowheader: w((l) => [
            j(e.$slots, "rowheader", {
              row: l.row,
              rowKey: l.rowKey
            }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["row", "columns", "tableId", "client", "showSelect", "selection", "onSelect", "onDeselect"]))), 256))
      ])
    ])
  ]);
}
const Tr = /* @__PURE__ */ P(mb, [["render", Cb], ["__scopeId", "data-v-3a1e9256"]]), Rb = ["id", "aria-describedby", "placeholder"], Ir = /* @__PURE__ */ Se({
  __name: "InputSearch",
  props: {
    modelValue: {},
    isClearBtnShown: { type: Boolean, default: !1 },
    isEmitOnType: { type: Boolean, default: !1 },
    id: {},
    label: {},
    description: {},
    errorMessage: {},
    placeholder: { default: "Search" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: n, emit: t }) {
    const i = e;
    n({ clearInput: l });
    const o = fe(i.modelValue || ""), r = t;
    function s(d) {
      (d.key === "Enter" || i.isEmitOnType) && a();
    }
    function a() {
      r("update:modelValue", o.value);
    }
    function l() {
      o.value = "", a();
    }
    return (d, f) => (u(), k(Te, {
      id: e.id,
      label: e.label,
      description: e.description,
      errorMessage: e.errorMessage
    }, {
      default: w(() => [
        O(Qe, null, {
          append: w(() => [
            e.isClearBtnShown ? (u(), c("button", {
              key: 0,
              onClick: l,
              class: "btn btn-outline-primary",
              type: "button"
            }, [...f[1] || (f[1] = [
              p("i", { class: "fas fa-fw fa-times" }, null, -1)
            ])])) : b("", !0),
            p("button", {
              onClick: a,
              class: "btn btn-outline-primary",
              type: "button"
            }, [...f[2] || (f[2] = [
              p("i", { class: "fas fa-fw fa-search" }, null, -1)
            ])])
          ]),
          default: w(() => [
            tt(p("input", {
              id: e.id,
              ref: e.id,
              "onUpdate:modelValue": f[0] || (f[0] = (g) => o.value = g),
              type: "text",
              class: "form-control",
              "aria-describedby": e.id,
              placeholder: e.placeholder,
              onKeyup: s
            }, null, 40, Rb), [
              [er, o.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "label", "description", "errorMessage"]));
  }
}), Fb = Se({
  props: {
    /** current page */
    modelValue: { type: Number, default: 1 },
    /** total records, i.e. sql count */
    count: { type: Number, required: !0 },
    /** number of records per page, i.e. sql limit */
    limit: { type: Number, default: 10 }
  },
  methods: {
    emitValue(e, n) {
      n || this.$emit("update:modelValue", e);
    },
    rowRange(e, n, t) {
      if (t === 0)
        return "-";
      {
        const i = (e - 1) * n + 1, o = Math.min(t, e * n);
        return `${i} - ${o} of ${t}`;
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.count / this.limit);
    },
    isFirstPage() {
      return this.modelValue === 1;
    },
    isLastPage() {
      return this.modelValue === this.totalPages || this.count === 0;
    }
  },
  watch: {
    value() {
      this.modelValue < 1 && this.$emit("update:modelValue", 1);
    },
    count() {
      this.modelValue > this.totalPages && this.$emit("update:modelValue", 1);
    }
  },
  created() {
    this.modelValue < 1 && this.$emit("update:modelValue", 1);
  }
}), kb = { "aria-label": "Pagination" }, Ub = { class: "pagination justify-content-center mb-0" }, Eb = { class: "page-item disabled" }, Sb = {
  class: "page-link text-nowrap",
  href: "#"
};
function Tb(e, n, t, i, o, r) {
  return u(), c("nav", kb, [
    p("ul", Ub, [
      p("li", {
        class: G(["page-item", { disabled: e.isFirstPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[0] || (n[0] = ve((s) => e.emitValue(1, e.isFirstPage), ["prevent"]))
        }, [...n[4] || (n[4] = [
          p("span", { "aria-hidden": "true" }, "«", -1),
          p("span", { class: "sr-only" }, "First", -1)
        ])])
      ], 2),
      p("li", {
        class: G(["page-item", { disabled: e.isFirstPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[1] || (n[1] = ve((s) => e.emitValue(Math.max(e.modelValue - 1, 1), e.isFirstPage), ["prevent"]))
        }, [...n[5] || (n[5] = [
          p("span", { "aria-hidden": "true" }, "‹", -1),
          p("span", { class: "sr-only" }, "Previous", -1)
        ])])
      ], 2),
      p("li", Eb, [
        p("a", Sb, E(e.rowRange(e.modelValue, e.limit, e.count)), 1)
      ]),
      p("li", {
        class: G(["page-item", { disabled: e.isLastPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[2] || (n[2] = ve((s) => e.emitValue(Math.min(e.modelValue + 1, e.totalPages), e.isLastPage), ["prevent"]))
        }, [...n[6] || (n[6] = [
          p("span", { "aria-hidden": "true" }, "›", -1),
          p("span", { class: "sr-only" }, "Next", -1)
        ])])
      ], 2),
      p("li", {
        class: G(["page-item", { disabled: e.isLastPage }])
      }, [
        p("a", {
          class: "page-link",
          href: "#",
          onClick: n[3] || (n[3] = ve((s) => e.emitValue(e.totalPages, e.isLastPage), ["prevent"]))
        }, [...n[7] || (n[7] = [
          p("span", { "aria-hidden": "true" }, "»", -1),
          p("span", { class: "sr-only" }, "Last", -1)
        ])])
      ], 2)
    ])
  ]);
}
const xl = /* @__PURE__ */ P(Fb, [["render", Tb]]), Ib = {
  name: "RowButtonEdit",
  components: {
    RowButton: sn,
    EditModal: na(() => Promise.resolve().then(() => Ql))
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    },
    pkey: {
      type: Object
    },
    visibleColumns: {
      type: Array,
      required: !1,
      default: () => null
    }
  },
  data() {
    return {
      isModalShown: !1
    };
  },
  methods: {
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function Db(e, n, t, i, o, r) {
  const s = K("RowButton"), a = K("EditModal");
  return u(), c("span", null, [
    O(s, {
      type: "edit",
      onEdit: n[0] || (n[0] = (l) => o.isModalShown = !0)
    }),
    o.isModalShown ? (u(), k(a, {
      key: 0,
      id: t.id + "edit-modal",
      tableId: t.tableId,
      pkey: t.pkey,
      isModalShown: o.isModalShown,
      schemaId: t.schemaId,
      visibleColumns: t.visibleColumns,
      onClose: r.handleClose
    }, null, 8, ["id", "tableId", "pkey", "isModalShown", "schemaId", "visibleColumns", "onClose"])) : b("", !0)
  ]);
}
const Ob = /* @__PURE__ */ P(Ib, [["render", Db]]), _b = {
  extends: it
};
function Pb(e, n, t, i, o, r) {
  return u(), c("button", {
    type: "button",
    class: "btn btn-danger",
    onClick: n[0] || (n[0] = ve((...s) => e.onClick && e.onClick(...s), ["prevent"]))
  }, [
    j(e.$slots, "default")
  ]);
}
const Mb = /* @__PURE__ */ P(_b, [["render", Pb]]), Lb = {
  name: "ConfirmModal",
  components: {
    LayoutModal: Et,
    ButtonAlt: mt,
    ButtonAction: it,
    ButtonDanger: Mb
  },
  props: {
    title: {
      type: String,
      required: !1
    },
    actionLabel: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !1
    },
    tableLabel: {
      type: String,
      required: !1
    },
    pkey: Object,
    additionalMsg: {
      type: String,
      required: !1
    },
    actionType: {
      type: String,
      required: !1,
      default: () => "primary"
      // or danger
    }
  },
  methods: {
    flattenObject: An
  },
  computed: {
    pkeyAsString() {
      return this.flattenObject(this.pkey);
    }
  }
}, Nb = { key: 1 }, Bb = { key: 0 }, xb = { key: 1 }, qb = {
  key: 0,
  class: "mt-2"
};
function Vb(e, n, t, i, o, r) {
  const s = K("ButtonAlt"), a = K("ButtonDanger"), l = K("ButtonAction"), d = K("LayoutModal");
  return u(), k(d, {
    title: t.title,
    onClose: n[3] || (n[3] = (f) => e.$emit("close"))
  }, {
    body: w(() => [
      e.$slots.default ? j(e.$slots, "default", { key: 0 }) : (u(), c("div", Nb, [
        N(E(t.actionLabel) + " ", 1),
        p("strong", null, [
          t.tableId ? (u(), c("span", Bb, E(t.tableLabel), 1)) : b("", !0),
          t.pkey ? (u(), c("span", xb, "(" + E(r.pkeyAsString) + ")", 1)) : b("", !0)
        ]),
        n[4] || (n[4] = p("br", null, null, -1)),
        n[5] || (n[5] = N("Are you sure ? ", -1)),
        n[6] || (n[6] = p("br", null, null, -1)),
        t.additionalMsg ? (u(), c("p", qb, E(t.additionalMsg), 1)) : b("", !0)
      ]))
    ]),
    footer: w(() => [
      O(s, {
        onClick: n[0] || (n[0] = (f) => e.$emit("close"))
      }, {
        default: w(() => [...n[7] || (n[7] = [
          N("Close", -1)
        ])]),
        _: 1
      }),
      t.actionType === "danger" ? (u(), k(a, {
        key: 0,
        onClick: n[1] || (n[1] = (f) => e.$emit("confirmed"))
      }, {
        default: w(() => [
          N(E(t.actionLabel), 1)
        ]),
        _: 1
      })) : (u(), k(l, {
        key: 1,
        onClick: n[2] || (n[2] = (f) => e.$emit("confirmed"))
      }, {
        default: w(() => [
          N(E(t.actionLabel), 1)
        ]),
        _: 1
      }))
    ]),
    _: 3
  }, 8, ["title"]);
}
const Dr = /* @__PURE__ */ P(Lb, [["render", Vb]]), jb = {
  name: "RowButtonDelete",
  components: { RowButton: sn, ConfirmModal: Dr },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    tableLabel: {
      type: String,
      required: !0
    },
    pkey: {
      type: Object
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isModalShown: !1,
      client: null,
      cascadeDeleteMsg: null
    };
  },
  watch: {
    isModalShown(e) {
      this.cascadeDeleteMsg = e ? this.fetchCascadeDeleteMsg() : null;
    }
  },
  methods: {
    async handleExecuteDelete() {
      this.client || (this.client = nt.newClient(this.schemaId)), await this.client.deleteRow(this.pkey, this.tableId).then(() => {
        this.$emit("success", {
          deletedKey: this.pkey,
          deleteFrom: this.tableId
        });
      }).catch((e) => {
        const n = e?.response?.data?.errors && Array.isArray(e?.response?.data?.errors) ? e.response.data.errors[0].message : "Failed to delete row data from table ";
        this.$emit("error", { errorMessage: n, error: e });
      }), this.handleClose();
    },
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    },
    async fetchCascadeDeleteMsg() {
      return this.client || (this.client = nt.newClient(this.schemaId)), await this.client.fetchCascadeDeleteMsg(this.tableId).then((e) => {
        this.$emit("cascadeDeleteMsg", e);
      }).catch((e) => {
        const n = e?.response?.data?.errors && Array.isArray(e?.response?.data?.errors) ? e.response.data.errors[0].message : "Failed to fetch cascade delete info from table ";
        this.$emit("error", { errorMessage: n, error: e });
      });
    }
  }
};
function Hb(e, n, t, i, o, r) {
  const s = K("RowButton"), a = K("ConfirmModal");
  return u(), c("span", null, [
    O(s, {
      type: "delete",
      onDelete: n[0] || (n[0] = (l) => o.isModalShown = !0)
    }),
    o.isModalShown ? (u(), k(a, {
      key: 0,
      title: "Delete from " + t.tableId,
      actionLabel: "Delete",
      actionType: "danger",
      tableId: t.tableId,
      tableLable: t.tableLabel,
      pkey: t.pkey,
      additionalMsg: e.additionalMsg,
      onClose: r.handleClose,
      onConfirmed: r.handleExecuteDelete
    }, null, 8, ["title", "tableId", "tableLable", "pkey", "additionalMsg", "onClose", "onConfirmed"])) : b("", !0)
  ]);
}
const Gb = /* @__PURE__ */ P(jb, [["render", Hb]]), Qb = {
  name: "TableSearch",
  components: {
    TableMolgenis: Tr,
    MessageError: At,
    InputSearch: Ir,
    Pagination: xl,
    Spinner: Ut,
    RowButtonAdd: Ml,
    RowButtonEdit: Ob,
    RowButtonDelete: Gb
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !0
    },
    selection: { type: Array, default: () => [] },
    /** enables checkbox to select rows */
    showSelect: {
      type: Boolean,
      default: !1
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    showColumns: {
      type: Array
    },
    canEdit: {
      type: Boolean,
      default: !1
    },
    canInsert: { default: !1 },
    canUpdate: { default: !1 },
    canDelete: { default: !1 },
    filter: {
      type: Object,
      required: !1
    }
  },
  data: function() {
    return {
      page: 1,
      limit: 20,
      count: 0,
      loading: !0,
      graphqlError: "",
      searchTerms: "",
      tableMetadata: {},
      data: void 0
    };
  },
  computed: {
    showHeaderIfNeeded() {
      return this.showHeader || this.count > this.limit;
    },
    columnsVisible() {
      return this.tableMetadata?.columns.filter(
        (e) => this.showColumns == null && !e.id.startsWith("mg_") || this.showColumns != null && this.showColumns.includes(e.id)
      );
    }
  },
  methods: {
    select(e) {
      this.$emit("select", e), this.$refs.inputSearch.clearInput();
    },
    selectNew(e) {
      this.$emit("update:newRow", e), this.$refs.inputSearch.clearInput();
    },
    deselect(e) {
      this.$emit("deselect", e), this.$refs.inputSearch.clearInput();
    },
    async loadData() {
      this.loading = !0;
      const e = {
        limit: this.limit,
        offset: this.limit * (this.page - 1),
        searchTerms: this.searchTerms,
        filter: this.filter
      }, n = nt.newClient(this.schemaId), t = await n.fetchTableData(this.tableId, e).catch(() => this.graphqlError = "Failed to load data");
      this.tableMetadata = await n.fetchTableMetaData(this.tableId), this.data = t[this.tableId], this.count = t[`${this.tableId}_agg`].count, this.loading = !1;
    }
  },
  watch: {
    page() {
      this.loadData();
    },
    searchTerms() {
      this.loadData();
    }
  },
  async mounted() {
    this.loadData();
  },
  emits: ["select", "update:newRow", "deselect"]
}, $b = {
  key: 1,
  style: { "text-align": "center" }
}, Jb = {
  key: 0,
  class: "form-inline justify-content-between mb-2 bg-white"
}, zb = { key: 2 };
function Wb(e, n, t, i, o, r) {
  const s = K("MessageError"), a = K("InputSearch"), l = K("Pagination"), d = K("Spinner"), f = K("RowButtonAdd"), g = K("RowButtonEdit"), A = K("RowButtonDelete"), R = K("TableMolgenis");
  return u(), c("div", null, [
    e.graphqlError ? (u(), k(s, { key: 0 }, {
      default: w(() => [
        N(E(e.graphqlError), 1)
      ]),
      _: 1
    })) : (u(), c("div", $b, [
      r.showHeaderIfNeeded ? (u(), c("form", Jb, [
        t.tableId ? (u(), k(a, {
          key: 0,
          id: "input-search",
          modelValue: e.searchTerms,
          "onUpdate:modelValue": n[0] || (n[0] = (F) => e.searchTerms = F),
          ref: "inputSearch"
        }, null, 8, ["modelValue"])) : b("", !0),
        O(l, {
          class: "ml-2",
          modelValue: e.page,
          "onUpdate:modelValue": n[1] || (n[1] = (F) => e.page = F),
          limit: e.limit,
          count: e.count
        }, null, 8, ["modelValue", "limit", "count"])
      ])) : b("", !0),
      e.loading ? (u(), k(d, { key: 1 })) : (u(), c("div", zb, [
        O(R, {
          schemaId: t.schemaId,
          selection: t.selection,
          tableMetadata: e.tableMetadata,
          columns: r.columnsVisible,
          data: e.data,
          showSelect: t.showSelect,
          onSelect: r.select,
          onDeselect: r.deselect
        }, {
          header: w(() => [
            j(e.$slots, "colheader", Zo(ia(e.$props))),
            p("label", null, E(e.count) + " records found", 1)
          ]),
          rowcolheader: w(() => [
            t.canInsert ?? t.canEdit ? (u(), k(f, {
              key: 0,
              id: "row-button-add-" + t.tableId,
              tableId: t.tableId,
              schemaId: t.schemaId,
              onClose: r.loadData,
              "onUpdate:newRow": r.selectNew,
              class: "d-inline p-0"
            }, null, 8, ["id", "tableId", "schemaId", "onClose", "onUpdate:newRow"])) : b("", !0)
          ]),
          colheader: w(() => [
            j(e.$slots, "colheader", Jn(e.$props, {
              canEdit: t.canEdit,
              reload: r.loadData,
              schemaId: t.schemaId
            }))
          ]),
          rowheader: w((F) => [
            j(e.$slots, "rowheader", {
              row: F.row,
              metadata: e.tableMetadata,
              rowKey: F.rowKey
            }),
            t.canUpdate ?? t.canEdit ? (u(), k(g, {
              key: 0,
              id: "row-button-edit-" + t.tableId,
              tableId: t.tableId,
              schemaId: t.schemaId,
              pkey: F.rowKey,
              onClose: r.loadData,
              class: "text-left"
            }, null, 8, ["id", "tableId", "schemaId", "pkey", "onClose"])) : b("", !0),
            t.canDelete ?? t.canEdit ? (u(), k(A, {
              key: 1,
              id: "row-button-del-" + t.tableId,
              tableId: t.tableId,
              tableLabel: e.tableMetadata.label,
              schemaId: t.schemaId,
              pkey: F.rowKey,
              onClose: r.loadData
            }, null, 8, ["id", "tableId", "tableLabel", "schemaId", "pkey", "onClose"])) : b("", !0)
          ]),
          _: 3
        }, 8, ["schemaId", "selection", "tableMetadata", "columns", "data", "showSelect", "onSelect", "onDeselect"])
      ]))
    ]))
  ]);
}
const ql = /* @__PURE__ */ P(Qb, [["render", Wb]]), Yb = {
  extends: ke,
  data: function() {
    return {
      client: null,
      showSelect: !1,
      data: [],
      selection: We(this.modelValue),
      count: 0,
      tableMetadata: null,
      tablePermission: void 0,
      loading: !1
    };
  },
  components: {
    FilterWell: Pl,
    TableSearch: ql,
    LayoutModal: Et,
    FormGroup: Te,
    ButtonOutline: Ji,
    Spinner: Ut,
    RowButtonAdd: Ml,
    Tooltip: vn
  },
  props: {
    schemaId: {
      type: String,
      required: !1,
      default: ""
    },
    filter: Object,
    orderby: Object,
    multipleColumns: Boolean,
    maxNum: { type: Number, default: 11 },
    tableId: {
      type: String,
      required: !0
    },
    refLabel: {
      type: String,
      required: !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  computed: {
    canInsert() {
      return this.tablePermission?.canInsert ?? this.canEdit;
    },
    title() {
      return "Select " + (this.tableMetadata?.label || this.tableId);
    },
    showMultipleColumns() {
      return this.multipleColumns && this.count > 12;
    }
  },
  methods: {
    applyJsTemplate: nn,
    deselect(e) {
      this.selection = this.selection.filter(
        (n) => !fn(n, e)
      ), this.emitSelection();
    },
    clearValue() {
      this.selection = [], this.emitSelection();
    },
    handleUpdateSelection(e) {
      this.selection = [...e], this.emitSelection();
    },
    select(e) {
      this.selection = [...this.selection, e], this.emitSelection();
    },
    async selectNew(e) {
      const n = await dn(
        e,
        this.tableId,
        this.schemaId
      );
      this.selection = [...this.selection, n], this.emitSelection(), this.loadOptions();
    },
    emitSelection() {
      this.selection.length ? this.$emit("update:modelValue", this.selection) : this.$emit("update:modelValue", []);
    },
    openSelect() {
      this.showSelect = !0;
    },
    toggle(e) {
      this.selection?.some(
        (n) => fn(n, e)
      ) ? this.selection = this.selection.filter(
        (n) => !fn(n, e)
      ) : this.selection = [...this.selection, e], this.emitSelection();
    },
    closeSelect() {
      this.loadOptions(), this.showSelect = !1;
    },
    async loadOptions() {
      if (!this.client) {
        console.error("Tried loading options before client is initialised");
        return;
      }
      this.loading = !0;
      const e = {
        limit: this.maxNum,
        filter: this.filter,
        orderby: this.orderby
      }, n = await this.client.fetchTableData(this.tableId, e), i = (n[this.tableId] || []).map(
        async (o) => dn(o, this.tableId, this.schemaId)
      );
      this.count = n[this.tableId + "_agg"].count, this.data = await Promise.all(i), this.loading = !1, this.$emit("optionsLoaded", this.data);
    },
    async loadPermission() {
      this.tablePermission = await fr(
        this.schemaId,
        this.tableId,
        this.tablePermissions
      );
    }
  },
  watch: {
    schemaId: "loadPermission",
    tableId: "loadPermission",
    async modelValue() {
      if (!this.modelValue)
        this.selection = [];
      else {
        const e = We(this.modelValue).map(
          async (n) => dn(n, this.tableId, this.schemaId)
        );
        this.selection = await Promise.all(e);
      }
    },
    filter() {
      this.loading || this.loadOptions();
    }
  },
  async created() {
    if (this.loadPermission(), this.loading = !0, this.client = nt.newClient(this.schemaId), this.tableMetadata = await this.client.fetchTableMetaData(this.tableId), await this.loadOptions(), this.loading = !0, !this.modelValue)
      this.selection = [];
    else {
      const e = We(this.modelValue).map(
        async (n) => dn(n, this.tableId, this.schemaId)
      );
      this.selection = await Promise.all(e);
    }
    this.loading = !1;
  },
  emits: ["optionsLoaded", "update:modelValue"]
}, Xb = ["id", "name", "value"], Zb = ["for", "onClick"], ev = { key: 2 }, tv = { class: "m-1" };
function nv(e, n, t, i, o, r) {
  const s = K("FilterWell"), a = K("ButtonAlt"), l = K("Spinner"), d = K("RowButtonAdd"), f = K("ButtonOutline"), g = K("TableSearch"), A = K("LayoutModal"), R = K("FormGroup");
  return u(), k(R, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      p("div", null, [
        p("div", null, [
          p("div", null, [
            (u(!0), c(ie, null, se(e.selection, (F) => (u(), k(s, {
              key: JSON.stringify(F),
              label: r.applyJsTemplate(F, t.refLabel),
              onClick: (y) => r.deselect(F)
            }, null, 8, ["label", "onClick"]))), 128))
          ]),
          Array.isArray(e.modelValue) && e.modelValue.length ? (u(), k(a, {
            key: 0,
            class: "pl-1",
            icon: "fa fa-clear",
            onClick: r.clearValue
          }, {
            default: w(() => [...n[3] || (n[3] = [
              N(" clear selection ", -1)
            ])]),
            _: 1
          }, 8, ["onClick"])) : b("", !0)
        ]),
        p("div", {
          class: G(
            r.showMultipleColumns ? "d-flex align-content-stretch flex-wrap" : ""
          )
        }, [
          e.loading ? (u(), k(l, { key: 0 })) : e.data.length ? (u(!0), c(ie, { key: 1 }, se(e.data, (F, y) => (u(), c("div", {
            class: G(["form-check custom-control custom-checkbox", r.showMultipleColumns ? "col-12 col-md-6 col-lg-4" : ""]),
            key: y
          }, [
            tt(p("input", {
              id: `${e.id}-${JSON.stringify(F)}`,
              name: e.id,
              type: "checkbox",
              value: F,
              "onUpdate:modelValue": n[0] || (n[0] = (T) => e.selection = T),
              onChange: n[1] || (n[1] = (...T) => r.emitSelection && r.emitSelection(...T)),
              class: G(["form-check-input", { "is-invalid": e.errorMessage }])
            }, null, 42, Xb), [
              [ea, e.selection]
            ]),
            p("label", {
              class: "form-check-label",
              for: `${e.id}-${JSON.stringify(F)}`,
              onClick: ve((T) => r.toggle(F), ["prevent"])
            }, E(r.applyJsTemplate(F, t.refLabel)), 9, Zb)
          ], 2))), 128)) : (u(), c("div", ev, "No entries found for " + E(e.label), 1))
        ], 2),
        p("div", tv, [
          r.canInsert ? (u(), k(d, {
            key: 0,
            id: "add-entry",
            label: `Add new ${e.label}`,
            tableId: t.tableId,
            schemaId: t.schemaId,
            "onUpdate:newRow": r.selectNew,
            class: "mr-1"
          }, null, 8, ["label", "tableId", "schemaId", "onUpdate:newRow"])) : b("", !0),
          O(f, {
            class: G(r.showMultipleColumns ? "col-12 col-md-6 col-lg-4" : ""),
            icon: "fa fa-search",
            onClick: r.openSelect
          }, {
            default: w(() => [
              N(E(e.count > t.maxNum ? `Show all ${e.count} options with details ` : "More details "), 1)
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ]),
        e.showSelect ? (u(), k(A, {
          key: 0,
          title: r.title,
          onClose: r.closeSelect
        }, {
          body: w(() => [
            O(g, {
              selection: e.selection,
              "onUpdate:selection": n[2] || (n[2] = (F) => e.selection = F),
              schemaId: t.schemaId,
              tableId: t.tableId,
              canEdit: t.canEdit,
              canInsert: r.canInsert,
              showSelect: !0,
              filter: t.filter,
              limit: 10,
              onSelect: r.select,
              onDeselect: r.deselect,
              "onUpdate:newRow": r.selectNew
            }, null, 8, ["selection", "schemaId", "tableId", "canEdit", "canInsert", "filter", "onSelect", "onDeselect", "onUpdate:newRow"])
          ]),
          footer: w(() => [
            O(a, { onClick: r.closeSelect }, {
              default: w(() => [...n[4] || (n[4] = [
                N("Close", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["title", "onClose"])) : b("", !0)
      ])
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Ui = /* @__PURE__ */ P(Yb, [["render", nv]]), iv = {
  name: "RefListFilter",
  components: { InputRefList: Ui },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: Object,
      required: !1
    },
    schemaId: {
      required: !1,
      type: String
    },
    tableId: {
      type: String,
      required: !0
    },
    refLabel: {
      type: String,
      required: !0
    }
  },
  methods: {
    onUpdateCondition(e) {
      e === null ? this.$emit("clearCondition", e) : this.$emit("updateCondition", e);
    }
  }
};
function ov(e, n, t, i, o, r) {
  const s = K("InputRefList");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition,
    tableId: t.tableId,
    schemaId: t.schemaId,
    refLabel: t.refLabel
  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "tableId", "schemaId", "refLabel"]);
}
const Gt = /* @__PURE__ */ P(iv, [["render", ov]]), rv = {
  name: "StringFilter",
  components: { InputString: kt },
  props: {
    id: {
      type: String,
      required: !0
    },
    condition: {
      type: String,
      required: !1
    },
    showAddButton: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    onUpdateCondition(e) {
      this.$emit("updateCondition", e);
    }
  },
  emits: ["updateCondition", "clearCondition", "addCondition"]
};
function sv(e, n, t, i, o, r) {
  const s = K("InputString");
  return u(), k(s, {
    id: t.id,
    modelValue: t.condition,
    "onUpdate:modelValue": r.onUpdateCondition
  }, {
    append: w(() => [
      t.condition ? (u(), c("button", {
        key: 0,
        onClick: n[0] || (n[0] = (a) => e.$emit("clearCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[2] || (n[2] = [
        p("i", { class: "fas fa-fw fa-times" }, null, -1)
      ])])) : b("", !0),
      t.showAddButton && t.condition ? (u(), c("button", {
        key: 1,
        onClick: n[1] || (n[1] = (a) => e.$emit("addCondition")),
        class: "btn btn-outline-primary",
        type: "button"
      }, [...n[3] || (n[3] = [
        p("i", { class: "fas fa-fw fa-plus" }, null, -1)
      ])])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "onUpdate:modelValue"]);
}
const ft = /* @__PURE__ */ P(rv, [["render", sv]]), Vs = {
  AUTO_ID: ft,
  STRING: ft,
  STRING_ARRAY: ft,
  EMAIL: ft,
  EMAIL_ARRAY: ft,
  HYPERLINK: ft,
  HYPERLINK_ARRAY: ft,
  TEXT: ft,
  TEXT_ARRAY: ft,
  JSON: ft,
  UUID: ft,
  UUID_ARRAY: ft,
  INT: Go,
  INT_ARRAY: Go,
  DECIMAL: Ho,
  DECIMAL_ARRAY: Ho,
  LONG: Bs,
  LONG_ARRAY: Bs,
  DATE: Vo,
  DATE_ARRAY: Vo,
  DATETIME: jo,
  DATETIME_ARRAY: jo,
  BOOL: xo,
  BOOl_ARRAY: xo,
  SELECT: Gt,
  MULTISELECT: Gt,
  CHECKBOX: Gt,
  REF: Gt,
  REFBACK: Gt,
  REF_ARRAY: Gt,
  ONTOLOGY: Qo,
  ONTOLOGY_ARRAY: Qo,
  RADIO: _l
}, av = {
  name: "FilterInput",
  components: {
    StringFilter: ft,
    IntegerFilter: Go,
    DecimalFilter: Ho,
    DateFilter: Vo,
    DateTimeFilter: jo,
    BooleanFilter: xo,
    RefListFilter: Gt,
    OntologyFilter: Qo,
    RadioFilter: _l
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    columnType: {
      type: String,
      required: !0,
      validator(e) {
        return Object.keys(Vs).includes(e);
      }
    },
    conditions: {
      type: Array,
      required: !0
    },
    tableId: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    refLabel: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      // used to add new empty field when adding conditions
      fieldCount: this.isMultiConditionFilter ? 1 : this.conditions.length || 1
    };
  },
  computed: {
    filterType() {
      return Vs[this.columnType];
    },
    isMultiConditionFilter() {
      return [
        "MULTI_SELECT",
        "REF",
        "REF_ARRAY",
        "REFBACK",
        "ONTOLOGY",
        "ONTOLOGY_ARRAY"
      ].includes(this.columnType);
    }
  },
  methods: {
    updateCondition(e, n) {
      if (this.isMultiConditionFilter)
        this.$emit("updateConditions", We(n));
      else if (!this.conditions.length)
        this.$emit("updateConditions", [n]);
      else {
        let t = We(this.conditions);
        t[e] = n, this.$emit("updateConditions", t);
      }
    },
    clearCondition(e) {
      let n = [...this.conditions];
      n.splice(e, 1), this.$emit("updateConditions", n), this.fieldCount > 1 && this.fieldCount--;
    }
  },
  watch: {
    conditions(e) {
      this.fieldCount = this.isMultiConditionFilter ? 1 : e.length || 1;
    }
  },
  emits: ["updateConditions"]
}, lv = { key: 0 };
function uv(e, n, t, i, o, r) {
  return u(), c("div", null, [
    r.isMultiConditionFilter ? (u(), c("div", lv, [
      (u(), k(Pt(r.filterType), {
        id: t.id,
        condition: t.conditions,
        onUpdateCondition: n[0] || (n[0] = (s) => r.updateCondition(e.index - 1, s)),
        tableId: t.tableId,
        schemaId: t.schemaId,
        refLabel: t.refLabel
      }, null, 40, ["id", "condition", "tableId", "schemaId", "refLabel"]))
    ])) : (u(!0), c(ie, { key: 1 }, se(o.fieldCount, (s) => (u(), c("div", { key: s }, [
      (u(), k(Pt(r.filterType), {
        id: t.id + s,
        condition: t.conditions[s - 1],
        onUpdateCondition: (a) => r.updateCondition(s - 1, a),
        onClearCondition: (a) => r.clearCondition(s - 1),
        onAddCondition: n[1] || (n[1] = (a) => o.fieldCount++),
        showAddButton: s === t.conditions.length,
        tableId: t.tableId,
        schemaId: t.schemaId,
        refLabel: t.refLabel
      }, null, 40, ["id", "condition", "onUpdateCondition", "onClearCondition", "showAddButton", "tableId", "schemaId", "refLabel"]))
    ]))), 128))
  ]);
}
const dv = /* @__PURE__ */ P(av, [["render", uv]]), cv = {
  name: "FilterSidebar",
  components: {
    FilterInput: dv,
    FilterContainer: zg
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  computed: {
    visibleFilters() {
      return this.filters.filter(
        (e) => e.showFilter && !["HEADING", "SECTION"].includes(e.columnType)
      );
    }
  },
  methods: {
    handleUpdateFilter(e, n) {
      let t = [...this.visibleFilters];
      t[e].conditions = n, this.$emit("updateFilters", t);
    }
  }
}, fv = { class: "sidebar-container" };
function pv(e, n, t, i, o, r) {
  const s = K("FilterInput"), a = K("FilterContainer");
  return u(), c("div", fv, [
    (u(!0), c(ie, null, se(r.visibleFilters, (l, d) => (u(), k(a, {
      key: l.id,
      title: l.label,
      conditions: l.conditions
    }, {
      default: w(() => [
        O(s, {
          id: "filter-" + l.id,
          conditions: r.visibleFilters[d].conditions,
          onUpdateConditions: (f) => r.handleUpdateFilter(d, f),
          columnType: l.columnType,
          tableId: l.refTableId,
          schemaId: l.refSchemaId ? l.refSchemaId : t.schemaId,
          refLabel: l.refLabel ? l.refLabel : l.refLabelDefault
        }, null, 8, ["id", "conditions", "onUpdateConditions", "columnType", "tableId", "schemaId", "refLabel"])
      ]),
      _: 2
    }, 1032, ["title", "conditions"]))), 128))
  ]);
}
const hv = /* @__PURE__ */ P(cv, [["render", pv], ["__scopeId", "data-v-8ea81881"]]), mv = {
  props: {
    /** two-way bindable array of column metadata. Will add 'conditions' property to hold filter values */
    filters: { type: Array, default: () => [] }
  },
  components: {
    FilterWell: Pl
  },
  computed: {
    countFilters() {
      let e = 0;
      return Array.isArray(this.filters) && this.filters.forEach((n) => {
        Array.isArray(n.conditions) && n.conditions.forEach((t) => {
          Array.isArray(t) ? (t[0] !== null || t[1] != null) && e++ : t != null && e++;
        });
      }), e;
    }
  },
  methods: {
    renderValue(e) {
      return typeof e == "object" && e !== null ? this.flattenObject(e) : e;
    },
    flattenObject(e) {
      let n = "";
      return Object.keys(e).forEach((t) => {
        e[t] === null || (typeof e[t] == "object" ? n += this.flattenObject(e[t]) : n += " " + e[t]);
      }), n;
    },
    remove(e, n) {
      let t = this.filters;
      t[e].conditions.splice(n, 1), this.$emit("updateFilters", t);
    },
    removeAll() {
      let e = this.filters;
      for (let n in e)
        Array.isArray(e[n].conditions) && e[n].conditions.splice(0);
      this.$emit("updateFilters", e);
    },
    getSelectLabel(e, n) {
      const t = n.map(
        (i) => nn({ value: i }, e.refLabel || e.refLabelDefault)
      ).join(", ");
      return e.label + " contains:" + t;
    },
    isSelectType(e) {
      return ["MULTISELECT", "SELECT", "CHECKBOX"].includes(e);
    }
  }
}, Av = { key: 0 }, gv = { class: "d-flex align-items-center" }, yv = { key: 0 }, Kv = { key: 1 };
function bv(e, n, t, i, o, r) {
  const s = K("FilterWell");
  return u(), c("span", null, [
    r.countFilters > 0 ? (u(), c("div", Av, [
      p("div", gv, [
        N(E(r.countFilters) + " filter " + E(r.countFilters > 1 ? "s" : "") + " ( ", 1),
        p("button", {
          type: "button",
          onClick: n[0] || (n[0] = (...a) => r.removeAll && r.removeAll(...a)),
          class: "btn btn-link pl-0 pr-0"
        }, " remove all filters "),
        n[1] || (n[1] = N(" ) : ", -1))
      ]),
      (u(!0), c(ie, null, se(t.filters, (a, l) => (u(), c("span", {
        key: a.id
      }, [
        (u(!0), c(ie, null, se(a.conditions, (d, f) => (u(), c("span", { key: f }, [
          Array.isArray(d) ? (u(), c("span", yv, [
            r.isSelectType(a.columnType) ? (u(), k(s, {
              key: 0,
              onClick: (g) => r.remove(l, f),
              label: r.getSelectLabel(a, d)
            }, null, 8, ["onClick", "label"])) : d[0] !== null && d[1] !== null ? (u(), k(s, {
              key: 1,
              onClick: (g) => r.remove(l, f),
              label: d[0] + " < " + a.label + " < " + d[1]
            }, null, 8, ["onClick", "label"])) : d[0] !== null ? (u(), k(s, {
              key: 2,
              onClick: (g) => r.remove(l, f),
              label: d[0] + " < " + a.id
            }, null, 8, ["onClick", "label"])) : d[1] !== null ? (u(), k(s, {
              key: 3,
              onClick: (g) => r.remove(l, f),
              label: a.label + " < " + d[1]
            }, null, 8, ["onClick", "label"])) : b("", !0)
          ])) : (u(), c("span", Kv, [
            O(s, {
              onClick: (g) => r.remove(l, f),
              label: a.label + " = " + r.renderValue(d)
            }, null, 8, ["onClick", "label"])
          ]))
        ]))), 128))
      ]))), 128))
    ])) : b("", !0)
  ]);
}
const vv = /* @__PURE__ */ P(mv, [["render", bv]]), wv = {
  extends: ke,
  components: {
    FormGroup: Te,
    BaseInputDecimal: Il,
    InputGroup: Qe
  }
};
function Cv(e, n, t, i, o, r) {
  const s = K("BaseInputDecimal"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, null, {
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id,
            modelValue: e.modelValue,
            class: G({ "is-invalid": e.errorMessage }),
            placeholder: e.placeholder,
            required: e.required,
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "class", "placeholder", "required"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Or = /* @__PURE__ */ P(wv, [["render", Cv]]), Rv = {
  name: "InputEmail",
  components: { FormGroup: Te, InputGroup: Qe },
  extends: ke,
  props: {
    stringLength: {
      type: Number,
      default: 255
    },
    additionalValidValidationStrings: {
      type: Array,
      default: []
    }
  },
  computed: {
    stringError() {
      return typeof this.modelValue == "string" ? this.modelValue.length > this.stringLength ? `Please limit to ${this.stringLength} characters.` : this.validateEmail(this.modelValue) ? this.errorMessage : "Please enter a valid email address" : this.errorMessage;
    }
  },
  methods: {
    validateEmail(e) {
      return this.additionalValidValidationStrings.includes(e) || e?.match(Lt.EMAIL_REGEX);
    }
  }
}, Fv = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function kv(e, n, t, i, o, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: w(() => [
      O(s, null, {
        append: w(() => [
          j(e.$slots, "append", {}, void 0, !0)
        ]),
        default: w(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (l) => e.$emit("update:modelValue", l.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, Fv)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Vl = /* @__PURE__ */ P(Rv, [["render", kv], ["__scopeId", "data-v-d474af2a"]]), Uv = {
  name: "InputHyperlink",
  components: { FormGroup: Te, InputGroup: Qe },
  extends: ke,
  computed: {
    stringError() {
      return typeof this.modelValue == "string" ? this.validateHyperlink(this.modelValue) ? this.errorMessage : "Please enter a valid hyperlink" : this.errorMessage;
    }
  },
  methods: {
    validateHyperlink(e) {
      return e?.match(Lt.HYPERLINK_REGEX);
    }
  }
}, Ev = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function Sv(e, n, t, i, o, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: w(() => [
      O(s, null, {
        append: w(() => [
          j(e.$slots, "append", {}, void 0, !0)
        ]),
        default: w(() => [
          p("input", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: e.modelValue,
            onInput: n[0] || (n[0] = (l) => (
              //@ts-ignore
              e.$emit("update:modelValue", l.target?.value)
            )),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, Ev)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const jl = /* @__PURE__ */ P(Uv, [["render", Sv], ["__scopeId", "data-v-09994973"]]), Tv = {
  extends: ke,
  components: {
    FormGroup: Te,
    BaseInputInt: kr,
    InputGroup: Qe
  }
};
function Iv(e, n, t, i, o, r) {
  const s = K("BaseInputInt"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, null, {
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: e.readonly,
            required: e.required,
            class: G({ "is-invalid": e.errorMessage }),
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const _r = /* @__PURE__ */ P(Tv, [["render", Iv]]), Dv = {
  extends: ke,
  components: {
    FormGroup: Te,
    BaseInputLong: Dl,
    InputGroup: Qe
  }
};
function Ov(e, n, t, i, o, r) {
  const s = K("BaseInputLong"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, null, {
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          O(s, {
            id: e.id,
            modelValue: e.modelValue,
            placeholder: e.placeholder,
            readonly: e.readonly,
            required: e.required,
            class: G({ "is-invalid": e.errorMessage }),
            "onUpdate:modelValue": n[0] || (n[0] = (d) => e.$emit("update:modelValue", d))
          }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Pr = /* @__PURE__ */ P(Dv, [["render", Ov]]), _v = {
  extends: ke,
  components: {
    FormGroup: Te,
    InputGroup: Qe
  },
  methods: {
    resizeTextarea(e) {
      e.target.style.height = "auto", e.target.style.height = e.target.scrollHeight + "px";
    }
  },
  mounted() {
    const e = this.$refs.textarea;
    Ti(() => {
      e.setAttribute(
        "style",
        "height:" + e.scrollHeight + "px;overflow-y:hidden;"
      );
    }), e.addEventListener("input", this.resizeTextarea);
  },
  beforeDestroy() {
    this.$refs.textarea.addEventListener("input", this.resizeTextarea);
  }
}, Pv = ["value", "aria-describedby", "placeholder", "readonly"];
function Mv(e, n, t, i, o, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(s, null, {
        append: w(() => [
          j(e.$slots, "append")
        ]),
        default: w(() => [
          p("textarea", {
            ref: "textarea",
            value: e.modelValue,
            class: G(["form-control", { "is-invalid": e.errorMessage }]),
            "aria-describedby": e.id + "Help",
            placeholder: e.placeholder,
            readonly: e.readonly,
            onInput: n[0] || (n[0] = (l) => e.$emit("update:modelValue", l.target.value))
          }, null, 42, Pv)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const ri = /* @__PURE__ */ P(_v, [["render", Mv]]), Mr = /* @__PURE__ */ Se({
  __name: "InputNonNegativeInt",
  props: /* @__PURE__ */ bu({
    id: {},
    label: {},
    required: { type: Boolean },
    description: {},
    errorMessage: {},
    placeholder: {},
    readonly: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = e, t = Ku(e, "modelValue"), i = xe(() => typeof t.value == "number" && lr(t.value) ? Ga : n.errorMessage);
    return (o, r) => (u(), k(Te, {
      id: e.id,
      label: e.label,
      required: e.required,
      description: e.description,
      errorMessage: i.value
    }, {
      default: w(() => [
        O(Qe, null, {
          append: w(() => [
            j(o.$slots, "append")
          ]),
          default: w(() => [
            O(kr, {
              id: e.id,
              modelValue: t.value,
              placeholder: e.placeholder,
              readonly: e.readonly,
              required: e.required,
              class: G({ "is-invalid": i.value }),
              "onUpdate:modelValue": r[0] || (r[0] = (s) => o.$emit("update:modelValue", s))
            }, null, 8, ["id", "modelValue", "placeholder", "readonly", "required", "class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id", "label", "required", "description", "errorMessage"]));
  }
}), Lv = {
  name: "ArrayInput",
  extends: ke,
  components: { FormGroup: Te },
  data() {
    return { values: this.modelValue?.length ? this.modelValue : [null] };
  },
  props: {
    columnType: {
      type: String,
      required: !0
    }
  },
  computed: {
    inputType() {
      return {
        BOOL_ARRAY: zi,
        DATE_ARRAY: Wi,
        DATETIME_ARRAY: Yi,
        DECIMAL_ARRAY: Or,
        PERIOD_ARRAY: kt,
        EMAIL_ARRAY: Vl,
        HYPERLINK_ARRAY: jl,
        INT_ARRAY: _r,
        NON_NEGATIVE_INT_ARRAY: Mr,
        LONG_ARRAY: Pr,
        STRING_ARRAY: kt,
        TEXT_ARRAY: ri,
        UUID_ARRAY: kt
      }[this.columnType];
    }
  },
  methods: {
    addItem(e) {
      this.values.splice(e + 1, 0, null), this.$emit("update:modelValue", this.values);
    },
    clearInput(e) {
      this.values.length > 1 && this.values.splice(e, 1), this.$emit("update:modelValue", this.values);
    },
    handleUpdate(e, n) {
      this.values[n] = e, this.$emit("update:modelValue", this.values);
    }
  },
  emits: ["update:modelValue"]
}, Nv = ["onClick"], Bv = ["onClick"];
function xv(e, n, t, i, o, r) {
  const s = K("FormGroup");
  return u(), k(s, {
    id: e.id + "-0",
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      (u(!0), c(ie, null, se(o.values, (a, l) => (u(), c("div", { key: l }, [
        (u(), k(Pt(r.inputType), {
          id: e.id + "-" + l,
          modelValue: o.values[l],
          showAddButton: l === o.values.length,
          "onUpdate:modelValue": (d) => r.handleUpdate(d, l)
        }, {
          append: w(() => [
            o.values.length > 1 ? (u(), c("button", {
              key: 0,
              onClick: (d) => r.clearInput(l),
              class: "btn btn-outline-primary",
              type: "button"
            }, [...n[0] || (n[0] = [
              p("i", { class: "fas fa-fw fa-times" }, null, -1)
            ])], 8, Nv)) : b("", !0),
            p("button", {
              onClick: (d) => r.addItem(l),
              class: "btn btn-outline-primary",
              type: "button"
            }, [...n[1] || (n[1] = [
              p("i", { class: "fas fa-fw fa-plus" }, null, -1)
            ])], 8, Bv)
          ]),
          _: 2
        }, 1032, ["id", "modelValue", "showAddButton", "onUpdate:modelValue"]))
      ]))), 128))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const pt = /* @__PURE__ */ P(Lv, [["render", xv]]), qv = {
  directives: {
    clickOutside: Xi.directive
  },
  props: {
    label: { type: String, required: !0 },
    icon: { type: String, default: "" },
    isMenuItem: { type: Boolean, required: !1 },
    placement: { type: String, default: "bottom-start" },
    closeOnClick: { type: Boolean, default: !1 }
  },
  data() {
    return {
      display: !1,
      popperInstance: null
    };
  },
  methods: {
    handleOnClick() {
      this.closeOnClick && (this.display = !this.display);
    },
    async toggle() {
      if (this.display = !this.display, this.display) {
        await this.$nextTick();
        const e = this.$refs.showInputButton, n = this.$refs.dropdown;
        this.popperInstance = Cl(e, n, {
          placement: this.placement,
          modifiers: { offset: { offset: "0,2px" } }
        });
      } else
        this.popperInstance.destroy();
    }
  }
}, Vv = { key: 0 };
function jv(e, n, t, i, o, r) {
  const s = zn("click-outside");
  return u(), c("span", null, [
    p("button", {
      type: "button",
      ref: "showInputButton",
      class: G(["btn btn-outline-primary", { "dropdown-toggle": !t.icon, "nav-link": t.isMenuItem }]),
      onClick: n[0] || (n[0] = (...a) => r.toggle && r.toggle(...a))
    }, [
      t.label ? (u(), c("span", Vv, E(t.label), 1)) : b("", !0),
      t.icon ? (u(), c("span", {
        key: 1,
        class: G("fa fa-" + t.icon + " fa-lg ml-2")
      }, null, 2)) : b("", !0)
    ], 2),
    o.display ? tt((u(), c("span", {
      key: 0,
      class: "mg-dropdown-drop bg-white border rounded",
      ref: "dropdown",
      onClick: n[1] || (n[1] = (...a) => r.handleOnClick && r.handleOnClick(...a))
    }, [
      j(e.$slots, "default", { close: r.toggle }, void 0, !0)
    ])), [
      [s, r.toggle]
    ]) : b("", !0)
  ]);
}
const Lr = /* @__PURE__ */ P(qv, [["render", jv], ["__scopeId", "data-v-5663ccf8"]]), Hv = {
  components: { IconAction: Rt },
  name: "InlineInput",
  props: {
    modelValue: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    }
  },
  data() {
    return {
      isEditing: !1,
      isInputFieldVisible: !1
    };
  },
  methods: {
    onfocusout() {
      this.isInputFieldVisible && (this.isEditing = !1, this.isInputFieldVisible = !1);
    },
    async openAndFocusInput() {
      this.isEditing = !0, this.isEditing = !0, await this.$nextTick(), this.isInputFieldVisible = !0, this.$refs.inlineInput.querySelector("input")?.focus();
    }
  }
}, Gv = { key: 0 };
function Qv(e, n, t, i, o, r) {
  const s = K("IconAction");
  return u(), c("span", {
    onFocusout: n[2] || (n[2] = (...a) => r.onfocusout && r.onfocusout(...a)),
    ref: "inlineInput"
  }, [
    o.isEditing ? (u(), c("span", Gv, [
      j(e.$slots, "default", {}, void 0, !0)
    ])) : (u(), c("span", {
      key: 1,
      onClick: n[0] || (n[0] = (a) => r.openAndFocusInput()),
      class: "editable"
    }, [
      j(e.$slots, "display", {}, () => [
        N(E(t.modelValue), 1)
      ], !0)
    ])),
    o.isEditing ? b("", !0) : (u(), k(s, {
      key: 2,
      icon: "pencil-alt",
      onClick: n[1] || (n[1] = (a) => r.openAndFocusInput())
    }))
  ], 544);
}
const $v = /* @__PURE__ */ P(Hv, [["render", Qv], ["__scopeId", "data-v-de78a1fe"]]), Jv = {
  extends: ke,
  components: { FormGroup: Te },
  data() {
    return {
      filename: this.modelValue instanceof File ? this.modelValue?.name : ""
    };
  },
  props: {
    modelValue: {
      default: null
    }
  },
  methods: {
    handleFileUpload(e) {
      const n = e.target;
      n?.files && (this.filename = n.files[0]?.name, this.$emit("update:modelValue", n.files[0]));
    },
    clearInput() {
      this.filename = null, this.$emit("update:modelValue", null);
    }
  }
}, zv = { class: "input-group" }, Wv = ["id"], Yv = ["placeholder"], Xv = { class: "input-group-append" }, Zv = { class: "input-group-append" }, ew = { key: 0 }, tw = ["href"];
function nw(e, n, t, i, o, r) {
  const s = K("FormGroup");
  return u(), k(s, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      p("div", zv, [
        p("input", {
          id: e.id,
          ref: "file",
          type: "file",
          style: { display: "none" },
          onChange: n[0] || (n[0] = (...a) => r.handleFileUpload && r.handleFileUpload(...a))
        }, null, 40, Wv),
        p("input", {
          class: G(["form-control active", { "is-invalid": e.errorMessage }]),
          placeholder: o.filename,
          onClick: n[1] || (n[1] = (a) => e.$refs.file.click()),
          onKeydown: n[2] || (n[2] = ve(() => {
          }, ["prevent"]))
        }, null, 42, Yv),
        p("div", Xv, [
          p("button", {
            class: "btn bg-transparent text-primary",
            type: "button",
            title: "Toggle",
            "data-toggle": "",
            onClick: n[3] || (n[3] = (...a) => r.clearInput && r.clearInput(...a)),
            style: { "margin-left": "-40px", "z-index": "100" }
          }, [...n[5] || (n[5] = [
            p("i", { class: "fa fa-times" }, [
              p("span", {
                "aria-hidden": "true",
                class: "sr-only"
              }, "Clear")
            ], -1)
          ])])
        ]),
        p("div", Zv, [
          p("button", {
            class: "btn btn-outline-primary",
            type: "button",
            title: "Toggle",
            "data-toggle": "",
            onClick: n[4] || (n[4] = (a) => e.$refs.file.click())
          }, " Browse ")
        ])
      ]),
      t.modelValue ? (u(), c("div", ew, [
        t.modelValue && t.modelValue.url ? (u(), c("a", {
          key: 0,
          href: t.modelValue.url
        }, " Previous value: " + E(t.modelValue?.filename ? t.modelValue.filename : t.modelValue.id + "." + t.modelValue.extension), 9, tw)) : b("", !0)
      ])) : b("", !0)
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Hl = /* @__PURE__ */ P(Jv, [["render", nw]]), iw = {
  components: { IconAction: Rt },
  props: {
    inplace: Boolean,
    label: String,
    columnType: String,
    description: String,
    editMeta: Boolean
  },
  data() {
    return { focusLabel: !1, focusDescription: !1 };
  },
  methods: {
    toggleFocusLabel() {
      this.focusLabel = !this.focusLabel;
    },
    toggleFocusDescription() {
      this.focusDescription = !this.focusDescription;
    },
    stripHtml(e) {
      return e && e.replace(
        /(<\/?(?:h1|h2|h3|h4|p|label|a)[^>]*>)|<[^>]+>/gi,
        "$1"
      );
    }
  },
  emits: ["update:description", "update:label"]
}, ow = {
  key: 0,
  class: "d-flex form-group bg-white rounded pt-4 pb-1 mb-1"
}, rw = { key: 0 }, sw = ["value"], aw = {
  key: 2,
  class: "d-flex form-group bg-white rounded pb-1 mb-1"
}, lw = ["value", "aria-describedby"];
function uw(e, n, t, i, o, r) {
  const s = K("IconAction");
  return u(), c("div", null, [
    o.focusLabel ? (u(), c("input", {
      key: 1,
      value: t.label,
      class: "form-control",
      onInput: n[0] || (n[0] = (a) => e.$emit("update:label", a.target.value)),
      onBlur: n[1] || (n[1] = (...a) => r.toggleFocusLabel && r.toggleFocusLabel(...a))
    }, null, 40, sw)) : (u(), c("span", ow, [
      t.label !== "_top" ? (u(), c("h1", rw, E(t.label), 1)) : b("", !0),
      t.inplace || t.editMeta ? (u(), k(s, {
        key: 1,
        class: "hoverIcon align-top",
        icon: "pencil-alt",
        onClick: r.toggleFocusLabel
      }, null, 8, ["onClick"])) : b("", !0)
    ])),
    o.focusDescription ? (u(), c("textarea", {
      key: 3,
      value: t.description,
      class: G({
        "form-control": !0
      }),
      "aria-describedby": e.id + "Help",
      onInput: n[2] || (n[2] = (a) => e.$emit("update:description", a.target.value)),
      onBlur: n[3] || (n[3] = (...a) => r.toggleFocusDescription && r.toggleFocusDescription(...a))
    }, null, 40, lw)) : (u(), c("div", aw, [
      p("p", null, E(t.description), 1),
      t.inplace || t.editMeta ? (u(), k(s, {
        key: 0,
        class: "hoverIcon align-top",
        icon: "pencil-alt",
        onClick: r.toggleFocusDescription
      }, null, 8, ["onClick"])) : b("", !0)
    ]))
  ]);
}
const $o = /* @__PURE__ */ P(iw, [["render", uw]]), dw = {}, cw = {
  class: "alert alert-warning",
  role: "alert"
};
function fw(e, n) {
  return u(), c("div", cw, [
    j(e.$slots, "default")
  ]);
}
const pw = /* @__PURE__ */ P(dw, [["render", fw]]), hw = {
  name: "InputRefBack",
  extends: ke,
  components: {
    FormGroup: Te,
    TableMolgenis: Tr,
    RowButton: sn,
    Spinner: Ut,
    MessageWarning: pw,
    ConfirmModal: Dr,
    MessageError: At
  },
  props: {
    /** name of the table from which is referred back to this field */
    tableId: {
      type: String,
      required: !0
    },
    /** id of the column in the other table */
    refBackId: {
      type: String,
      required: !0
    },
    /**
     * primary key of the current table that refback should point to
     * when empty ( in case of draft , add message is shown instead of the table)
     *  */
    pkey: {
      type: [Object, null],
      required: !0
    },
    expressionData: {
      type: Object,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    /**
     * if table (that has a column that is referred to by this table) can be edited
     *  */
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  data() {
    return {
      client: null,
      tablePermission: void 0,
      tableMetadata: null,
      data: null,
      isLoading: !1,
      isEditModalShown: !1,
      isDeleteModalShown: !1,
      editMode: "add",
      // add, edit, clone
      editRowPrimaryKey: null,
      graphqlError: null,
      defaultValue: null
    };
  },
  computed: {
    canInsert() {
      return this.tablePermission?.canInsert ?? this.canEdit;
    },
    canModify() {
      return this.tablePermission?.canUpdate ?? this.canEdit;
    },
    canRemove() {
      return this.tablePermission?.canDelete ?? this.canEdit;
    },
    graphqlFilter() {
      return {
        [this.refBackId]: {
          equals: this.pkey
        }
      };
    },
    visibleColumnIds() {
      return this.visibleColumns.map((e) => e.id);
    },
    visibleColumns() {
      return this.tableMetadata && this.tableMetadata.columns ? this.tableMetadata.columns.filter(
        (e) => e.id != this.refBackId && !e.id.startsWith("mg_")
      ) : [];
    },
    hasPrimaryKey() {
      return this.pkey ? !!Object.values(this.pkey).length : !1;
    }
  },
  methods: {
    async reload() {
      this.isLoading = !0;
      const e = await this.client.fetchTableDataValues(this.tableId, {
        filter: this.graphqlFilter
      });
      this.data = el(e, this.tableMetadata), this.isLoading = !1;
    },
    handleRowAction(e, n) {
      this.editMode = e, this.editRowPrimaryKey = n, this.isEditModalShown = !0;
    },
    handleModalClose() {
      this.isEditModalShown = !1, this.reload();
    },
    handleDeleteRowRequest(e) {
      this.editRowPrimaryKey = e, this.isDeleteModalShown = !0;
    },
    async handleExecuteDelete() {
      this.isDeleteModalShown = !1, await this.client.deleteRow(this.editRowPrimaryKey, this.tableId).catch(this.handleError).then(this.reload());
      let e = this.modelValue.filter(
        (n) => !fn(n, this.editRowPrimaryKey)
      );
      this.$emit("update:modelValue", e);
    },
    handleError(e) {
      Array.isArray(e?.response?.data?.errors) ? this.graphqlError = e.response.data.errors[0].message : this.graphqlError = e, this.loading = !1;
    },
    async loadPermission() {
      this.tablePermission = await fr(
        this.schemaId,
        this.tableId,
        this.tablePermissions
      );
    }
  },
  watch: {
    schemaId: "loadPermission",
    tableId: "loadPermission"
  },
  mounted: async function() {
    this.loadPermission(), this.client = nt.newClient(this.schemaId), this.isLoading = !0, this.tableMetadata = await this.client.fetchTableMetaData(this.tableId).catch((e) => this.graphqlError = e.message), this.defaultValue = new Object(), this.defaultValue[this.refBackId] = this.expressionData, await this.reload();
  }
};
function mw(e, n, t, i, o, r) {
  const s = K("Spinner"), a = K("RowButton"), l = K("TableMolgenis"), d = K("MessageWarning"), f = K("MessageError"), g = K("EditModal"), A = K("ConfirmModal"), R = K("FormGroup");
  return u(), k(R, Zo(ia(e.$props)), {
    default: w(() => [
      o.isLoading ? (u(), k(s, { key: 0 })) : r.hasPrimaryKey ? (u(), k(l, {
        key: 1,
        schemaId: t.schemaId,
        data: o.data,
        columns: r.visibleColumns,
        "table-metadata": o.tableMetadata,
        style: { "overflow-x": "scroll" }
      }, {
        rowcolheader: w(() => [
          j(e.$slots, "rowcolheader", Jn(e.$props, {
            canEdit: t.canEdit,
            reload: r.reload,
            schemaId: t.schemaId
          })),
          r.canInsert ? (u(), k(a, {
            key: 0,
            type: "add",
            onAdd: n[0] || (n[0] = (F) => r.handleRowAction("add")),
            class: "d-inline p-0"
          })) : b("", !0)
        ]),
        rowheader: w((F) => [
          j(e.$slots, "rowheader", {
            row: F.row,
            metadata: o.tableMetadata,
            rowKey: F.rowKey
          }),
          r.canModify ? (u(), k(a, {
            key: 0,
            type: "edit",
            table: t.tableId,
            schemaId: t.schemaId,
            "visible-columns": r.visibleColumnIds,
            pkey: F.rowKey,
            onClose: r.reload,
            onEdit: (y) => r.handleRowAction("edit", F.rowKey)
          }, null, 8, ["table", "schemaId", "visible-columns", "pkey", "onClose", "onEdit"])) : b("", !0),
          r.canInsert ? (u(), k(a, {
            key: 1,
            type: "clone",
            table: t.tableId,
            schemaId: t.schemaId,
            pkey: F.rowKey,
            "visible-columns": r.visibleColumnIds,
            onClose: r.reload,
            onClone: (y) => r.handleRowAction("clone", F.rowKey)
          }, null, 8, ["table", "schemaId", "pkey", "visible-columns", "onClose", "onClone"])) : b("", !0),
          r.canRemove ? (u(), k(a, {
            key: 2,
            type: "delete",
            onDelete: (y) => r.handleDeleteRowRequest(F.rowKey)
          }, null, 8, ["onDelete"])) : b("", !0)
        ]),
        _: 3
      }, 8, ["schemaId", "data", "columns", "table-metadata"])) : (u(), k(d, { key: 2 }, {
        default: w(() => [...n[2] || (n[2] = [
          N(" This can only be filled in after you have saved (or saved draft). ", -1)
        ])]),
        _: 1
      })),
      o.graphqlError ? (u(), k(f, { key: 3 }, {
        default: w(() => [
          N(E(o.graphqlError), 1)
        ]),
        _: 1
      })) : b("", !0),
      o.isEditModalShown ? (u(), k(g, {
        key: 4,
        isModalShown: !0,
        id: t.tableId + "-edit-modal",
        tableId: t.tableId,
        pkey: o.editRowPrimaryKey,
        visibleColumns: r.visibleColumnIds,
        clone: o.editMode === "clone",
        schemaId: t.schemaId,
        defaultValue: o.defaultValue,
        applyDefaultValues: !0,
        onClose: r.handleModalClose
      }, null, 8, ["id", "tableId", "pkey", "visibleColumns", "clone", "schemaId", "defaultValue", "onClose"])) : b("", !0),
      o.isDeleteModalShown ? (u(), k(A, {
        key: 5,
        title: "Delete from " + t.tableId,
        actionLabel: "Delete",
        actionType: "danger",
        tableId: t.tableId,
        tableLabel: o.tableMetadata.label,
        pkey: o.editRowPrimaryKey,
        onClose: n[1] || (n[1] = (F) => o.isDeleteModalShown = !1),
        onConfirmed: r.handleExecuteDelete
      }, null, 8, ["title", "tableId", "tableLabel", "pkey", "onConfirmed"])) : b("", !0)
    ]),
    _: 3
  }, 16);
}
const Gl = /* @__PURE__ */ P(hw, [["render", mw]]), Aw = {
  name: "InputRefSelect",
  extends: ke,
  data: function() {
    return {
      showSelect: !1,
      tablePermission: void 0
    };
  },
  components: {
    TableSearch: ql,
    LayoutModal: Et,
    FormGroup: Te,
    ButtonAction: it,
    ButtonAlt: mt,
    InputGroup: Qe
  },
  props: {
    tableId: String,
    schemaId: {
      type: String,
      required: !1
    },
    filter: Object,
    refLabel: {
      type: String,
      required: !0
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  computed: {
    title() {
      return "Select " + this.tableId;
    }
  },
  watch: {
    schemaId: "loadPermission",
    tableId: "loadPermission"
  },
  created() {
    this.loadPermission();
  },
  methods: {
    applyJsTemplate: nn,
    async loadPermission() {
      this.tablePermission = await fr(
        this.schemaId,
        this.tableId,
        this.tablePermissions
      );
    },
    async select(e) {
      this.showSelect = !1, this.$emit("update:modelValue", await e);
    }
  }
}, gw = ["value", "readonly"];
function yw(e, n, t, i, o, r) {
  const s = K("ButtonAction"), a = K("TableSearch"), l = K("ButtonAlt"), d = K("LayoutModal"), f = K("InputGroup"), g = K("FormGroup");
  return u(), k(g, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(f, null, {
        append: w(() => [
          e.modelValue && !this.readonly ? (u(), c("button", {
            key: 0,
            onClick: n[2] || (n[2] = (A) => e.$emit("update:modelValue", null)),
            class: "btn btn-outline-primary",
            type: "button"
          }, [...n[7] || (n[7] = [
            p("i", { class: "fas fa-fw fa-times" }, null, -1)
          ])])) : b("", !0)
        ]),
        default: w(() => [
          p("input", {
            class: G(["form-control", { "is-invalid": e.errorMessage }]),
            onClick: n[0] || (n[0] = (A) => e.showSelect = !this.readonly),
            onFocus: n[1] || (n[1] = (A) => e.showSelect = !this.readonly),
            value: r.applyJsTemplate(e.modelValue, t.refLabel),
            readonly: e.readonly
          }, null, 42, gw),
          e.showSelect ? (u(), k(d, {
            key: 0,
            title: r.title,
            onClose: n[6] || (n[6] = (A) => e.showSelect = !1)
          }, {
            body: w(() => [
              O(a, {
                tableId: t.tableId,
                filter: t.filter,
                schemaId: t.schemaId,
                canInsert: e.tablePermission?.canInsert,
                canUpdate: e.tablePermission?.canUpdate,
                canDelete: e.tablePermission?.canDelete,
                onSelect: n[3] || (n[3] = (A) => r.select(A)),
                onDeselect: n[4] || (n[4] = (A) => e.deselect(e.selectIdx))
              }, {
                rowheader: w((A) => [
                  O(s, {
                    onClick: (R) => r.select(A.row)
                  }, {
                    default: w(() => [...n[8] || (n[8] = [
                      N(" Select ", -1)
                    ])]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["tableId", "filter", "schemaId", "canInsert", "canUpdate", "canDelete"])
            ]),
            footer: w(() => [
              O(l, {
                onClick: n[5] || (n[5] = (A) => e.showSelect = !1)
              }, {
                default: w(() => [...n[9] || (n[9] = [
                  N("Close", -1)
                ])]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])) : b("", !0)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const Ei = /* @__PURE__ */ P(Aw, [["render", yw]]), Kw = {
  name: "InputJson",
  components: { FormGroup: Te, InputGroup: Qe },
  extends: ke,
  props: {
    modelValue: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    stringError() {
      if (typeof this.modelValue == "string") {
        try {
          if (!Xa(JSON.parse(this.modelValue)))
            return "Root element must be an object or array";
        } catch {
          return "Please enter valid JSON";
        }
        return this.errorMessage;
      } else
        return this.errorMessage;
    }
  }
}, bw = ["id", "name", "value", "aria-describedby", "placeholder", "readonly"];
function vw(e, n, t, i, o, r) {
  const s = K("InputGroup"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: r.stringError
  }, {
    default: w(() => [
      O(s, null, {
        default: w(() => [
          p("textarea", {
            id: e.id,
            ref: e.id,
            name: e.name,
            value: t.modelValue,
            onInput: n[0] || (n[0] = (l) => e.$emit("update:modelValue", l.target.value)),
            type: "text",
            class: G(["form-control", { "is-invalid": r.stringError }]),
            "aria-describedby": e.id,
            placeholder: e.placeholder,
            readonly: e.readonly
          }, null, 42, bw)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const ww = /* @__PURE__ */ P(Kw, [["render", vw], ["__scopeId", "data-v-8abd8c88"]]), Cw = {
  AUTO_ID: kt,
  HEADING: $o,
  SECTION: $o,
  EMAIL: Vl,
  HYPERLINK: jl,
  STRING: kt,
  TEXT: ri,
  JSON: ww,
  INT: _r,
  NON_NEGATIVE_INT: Mr,
  LONG: Pr,
  DECIMAL: Or,
  BOOL: zi,
  DATE: Wi,
  REF: Ei,
  //bootstrap will be deprecated so here we don't differentiate
  SELECT: Ei,
  RADIO: Ei,
  REFBACK: Gl,
  FILE: Hl,
  DATETIME: Yi,
  PERIOD: kt,
  ONTOLOGY: Li,
  EMAIL_ARRAY: pt,
  BOOL_ARRAY: pt,
  DATE_ARRAY: pt,
  DATETIME_ARRAY: pt,
  PERIOD_ARRAY: pt,
  DECIMAL_ARRAY: pt,
  HYPERLINK_ARRAY: pt,
  INT_ARRAY: pt,
  NON_NEGATIVE_INT_ARRAY: pt,
  LONG_ARRAY: pt,
  ONTOLOGY_ARRAY: Li,
  REF_ARRAY: Ui,
  //bootstrap will be deprecated so here we don't differentiate
  CHECKBOX: Ui,
  MULTISELECT: Ui,
  STRING_ARRAY: pt,
  TEXT_ARRAY: pt
}, Rw = {
  name: "FormInput",
  extends: ke,
  props: {
    columnType: {
      type: String,
      required: !0
    },
    inplace: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    description: {
      type: String,
      default: null
    },
    editMeta: {
      type: Boolean,
      required: !1
    },
    filter: {
      type: Object,
      required: !1
    },
    pkey: {
      type: Object,
      required: !1,
      default: () => null
    },
    expressionData: {
      type: Object,
      required: !1
    },
    refBackId: {
      type: String,
      required: !1
    },
    refBackType: {
      type: String,
      required: !1
    },
    refLabel: {
      type: String,
      required: !1
    },
    schemaId: {
      type: String,
      required: !1
    },
    tableId: {
      type: String,
      required: !1
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  components: {
    InlineInput: $v,
    ArrayInput: pt,
    InputString: kt,
    InputInt: _r,
    InputNonNegativeInt: Mr,
    InputLong: Pr,
    InputDecimal: Or,
    InputBoolean: zi,
    InputDate: Wi,
    InputDateTime: Yi,
    InputFile: Hl,
    InputText: ri,
    InputHeading: $o,
    InputOntology: Li,
    InputRefBack: Gl,
    InputRefSelect: Ei
  },
  computed: {
    typeToInput() {
      return Cw[this.columnType];
    }
  },
  methods: {
    handleUpdate(e) {
      this.$emit("update:modelValue", e);
    }
  }
}, Fw = { key: 1 };
function kw(e, n, t, i, o, r) {
  return u(), k(Pt(t.inplace ? "InlineInput" : "span"), {
    value: e.modelValue,
    id: e.id
  }, {
    default: w(() => [
      r.typeToInput ? (u(), k(Pt(r.typeToInput), Jn({
        key: 0,
        isMultiSelect: t.columnType === "ONTOLOGY_ARRAY"
      }, e.$props, { "onUpdate:modelValue": r.handleUpdate }), null, 16, ["isMultiSelect", "onUpdate:modelValue"])) : (u(), c("div", Fw, "UNSUPPORTED TYPE '" + E(t.columnType) + "'", 1))
    ]),
    _: 1
  }, 8, ["value", "id"]);
}
const Uw = /* @__PURE__ */ P(Rw, [["render", kw]]), { AUTO_ID: Ew } = Lt, Sw = {
  name: "RowEdit",
  data() {
    return {
      internalValues: We(
        this.defaultValue ? this.defaultValue : this.modelValue
      ),
      refFilter: {}
    };
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    // id: used as html id for components
    id: {
      type: String,
      required: !0
    },
    // tableId: name of the molgenis table loaded
    tableId: {
      type: String,
      required: !0
    },
    // defines the form structure
    tableMetaData: {
      type: Object,
      required: !0
    },
    // pkey:  when updating existing record, this is the primary key value
    pkey: { type: Object },
    // clone: when you want to clone instead of update
    clone: {
      type: Boolean,
      required: !1
    },
    // visibleColumns:  visible columns, useful if you only want to allow partial edit (column of object)
    // examples ['name','description']
    visibleColumns: {
      type: Array,
      required: !1
    },
    // defaultValue: when creating new record, this is initialization value
    defaultValue: {
      type: Object,
      required: !1
    },
    // object with the whole schema, needed to create refLink filter
    schemaMetaData: {
      type: Object,
      required: !0
    },
    canEdit: {
      type: Boolean,
      required: !1,
      default: () => !0
    },
    tablePermissions: {
      type: Array,
      required: !1,
      default: () => []
    },
    errorPerColumn: {
      type: Object,
      default: () => ({})
    },
    applyDefaultValues: {
      type: Boolean,
      default: () => !1
    }
  },
  emits: ["update:modelValue"],
  components: {
    FormInput: Uw
  },
  computed: {
    shownColumnsWithoutMeta() {
      return (this?.tableMetaData?.columns ? this.tableMetaData.columns.filter(
        (n) => !n.id?.startsWith("mg_") && n.id !== "_mg_top_of_form"
      ) : []).filter(this.showColumn);
    }
  },
  methods: {
    showColumn(e) {
      return e.refLinkId ? this.internalValues[e.refLinkId] : (this.visibleColumns ? this.visibleColumns.includes(e.id) : !0) && this.isVisible(e) && e.id !== "mg_tableclass";
    },
    isVisible(e) {
      try {
        return ur(
          e,
          this.internalValues,
          this.tableMetaData
        );
      } catch (n) {
        return console.log("isVisible expression error: ", n), this.errorPerColumn[e.id] = n, !0;
      }
    },
    applyComputed() {
      this.tableMetaData.columns.forEach((e) => {
        if (e.computed && e.columnType !== Ew)
          try {
            this.internalValues[e.id] = mn(
              e.computed,
              this.internalValues,
              this.tableMetaData
            );
          } catch (n) {
            console.log("Computed expression failed: ", n), this.errorPerColumn[e.id] = "Computed expression failed: " + n;
          }
      });
    },
    //update reflink filters and reset values if reflink changes
    async updateRefLinks(e) {
      const n = this.tableMetaData.columns.filter(
        (t) => this.internalValues[e.id] && t.refLinkId === e.id
      );
      for (const t of n) {
        const o = this.schemaMetaData.tables.find(
          (r) => r.id === t.refTableId
        ).columns.filter(
          (r) => r.key === 1 && r.refTableId === e.refTableId
        );
        for (const r of o)
          this.internalValues[t.id] = null, this.refFilter[t.id] = {
            [r.id]: {
              equals: await ni(
                this.internalValues[e.id],
                r.refTableId,
                r.refSchemaId || this.schemaMetaData.schemaId
              )
            }
          };
      }
    },
    handleModelValueUpdate(e, n) {
      this.internalValues[n.id] = e, this.updateRefLinks(n), this.onValuesUpdate();
    },
    onValuesUpdate() {
      this.applyComputed(), this.$emit("update:modelValue", this.internalValues);
    }
  },
  watch: {
    tableMetaData: {
      handler() {
        this.onValuesUpdate();
      },
      deep: !0
    }
  },
  created() {
    this.tableMetaData.columns.forEach((e) => {
      if (this.applyDefaultValues && e.defaultValue && !this.internalValues[e.id])
        if (e.defaultValue.startsWith("="))
          try {
            this.internalValues[e.id] = mn(
              "(" + e.defaultValue.substr(1) + ")",
              this.internalValues,
              this.tableMetaData
            );
          } catch (n) {
            this.errorPerColumn[e.id] = "Default value expression failed: " + n;
          }
        else e.columnType === "BOOL" ? this.internalValues[e.id] = Tw(
          e.defaultValue
        ) : this.internalValues[e.id] = e.defaultValue;
    }), this.onValuesUpdate();
  }
};
function Tw(e) {
  return e === "TRUE" || e === "true" || e === !0 ? !0 : e === "FALSE" || e === "false" || e === !1 ? !1 : void 0;
}
function Iw(e, n, t, i, o, r) {
  const s = K("FormInput");
  return u(), c("div", null, [
    (u(!0), c(ie, null, se(r.shownColumnsWithoutMeta, (a) => (u(), k(s, {
      key: JSON.stringify(a),
      id: `${t.id}-${a.id}`,
      modelValue: o.internalValues[a.id],
      expressionData: o.internalValues,
      columnType: a.columnType,
      description: a.description,
      errorMessage: t.errorPerColumn[a.id],
      label: a.formLabel ?? a.label,
      schemaId: a.refSchemaId || t.schemaMetaData.id,
      pkey: t.pkey,
      readonly: a.readonly || t.pkey && a.key === 1 && !t.clone || a.computed !== void 0 && a.computed.trim() !== "",
      refBackId: a.refBackId,
      refLabel: a.refLabel || a.refLabelDefault,
      required: a.required,
      tableId: a.refTableId,
      canEdit: t.canEdit,
      tablePermissions: t.tablePermissions,
      filter: o.refFilter[a.id],
      "onUpdate:modelValue": (l) => r.handleModelValueUpdate(l, a)
    }, null, 8, ["id", "modelValue", "expressionData", "columnType", "description", "errorMessage", "label", "schemaId", "pkey", "readonly", "refBackId", "refLabel", "required", "tableId", "canEdit", "tablePermissions", "filter", "onUpdate:modelValue"]))), 128))
  ]);
}
const Dw = /* @__PURE__ */ P(Sw, [["render", Iw]]), Ow = { class: "w-100" }, _w = {
  class: "d-flex",
  style: { gap: "0.5rem" }
}, Pw = /* @__PURE__ */ Se({
  __name: "RowEditFooter",
  props: {
    tableLabel: { default: "" },
    successMessage: {},
    errorMessage: {},
    saveDraftDisabledMessage: {},
    saveDisabledMessage: {}
  },
  setup(e) {
    const n = e, {
      tableLabel: t,
      successMessage: i,
      errorMessage: o,
      saveDraftDisabledMessage: r,
      saveDisabledMessage: s
    } = Wn(n);
    return (a, l) => (u(), c("div", Ow, [
      p("div", null, [
        re(i) ? (u(), k(Fn, { key: 0 }, {
          default: w(() => [
            N(E(re(i)), 1)
          ]),
          _: 1
        })) : b("", !0)
      ]),
      p("div", null, [
        re(o) ? (u(), k(At, { key: 0 }, {
          default: w(() => [
            N(E(re(o)), 1)
          ]),
          _: 1
        })) : b("", !0)
      ]),
      p("div", _w, [
        j(a.$slots, "default"),
        O(mt, {
          onClick: l[0] || (l[0] = (d) => a.$emit("cancel"))
        }, {
          default: w(() => [...l[3] || (l[3] = [
            N(" Close", -1)
          ])]),
          _: 1
        }),
        O(vn, {
          name: "disabled-draft-tooltip",
          value: re(r) ? re(r) : "",
          placement: "bottom"
        }, {
          default: w(() => [
            O(Ji, {
              onClick: l[1] || (l[1] = (d) => a.$emit("saveDraft")),
              disabled: !!re(r),
              class: "mr-2 pr-3"
            }, {
              default: w(() => [...l[4] || (l[4] = [
                N(" Save draft ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["value"]),
        O(vn, {
          name: "disabled-save-tooltip",
          value: re(s) ? re(s) : "",
          placement: "bottom"
        }, {
          default: w(() => [
            O(it, {
              onClick: l[2] || (l[2] = (d) => a.$emit("save")),
              disabled: !!re(s)
            }, {
              default: w(() => [
                N(" Save " + E(re(t)), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]));
  }
}), Mw = {
  key: 0,
  class: "container"
}, Lw = { class: "row" }, Nw = {
  key: 0,
  class: "col-2 border-left chapter-menu overflow-auto",
  style: { "max-height": "calc(100vh - 200px)" }
}, Bw = ["onClick"], xw = { class: "mr-auto" }, qw = { key: 0 }, Vw = /* @__PURE__ */ Se({
  __name: "EditModal",
  props: {
    id: {},
    tableId: {},
    isModalShown: { type: Boolean },
    schemaId: {},
    pkey: {},
    clone: { type: Boolean, default: !1 },
    visibleColumns: {},
    useChapters: { type: [Boolean, null], default: null },
    defaultValue: { default: null },
    applyDefaultValues: { type: Boolean },
    tablePermissions: { default: () => [] }
  },
  emits: ["update:newRow", "close"],
  setup(e, { emit: n }) {
    const t = e, {
      tablePermissions: i,
      applyDefaultValues: o,
      clone: r,
      defaultValue: s,
      id: a,
      pkey: l,
      schemaId: d,
      tableId: f,
      useChapters: g,
      visibleColumns: A
    } = t, { isModalShown: R } = Wn(t), { IS_CHAPTERS_ENABLED_FIELD_NAME: F } = Lt, y = fe({}), T = fe({}), v = fe(), I = fe(), M = fe(), D = fe(""), V = fe(!1), q = fe(1), x = fe(), $ = fe(""), z = n, X = xe(() => v.value?.label), he = xe(() => l && r ? "copy" : l ? "update" : "insert"), Ae = xe(
      () => `${he.value} into table: ${X.value} (${f})`
    ), H = xe(() => {
      const Ie = df(
        v.value?.columns || [],
        A
      ).filter(
        (Pe) => {
          if (v.value)
            try {
              return ur(Pe, y.value, v.value);
            } catch (Xe) {
              return T.value[Pe.id] = Xe, !0;
            }
        }
      ).filter(
        (Pe) => !Pe.id.startsWith("mg_")
      );
      return cf(Ie).filter(
        (Pe) => Pe.length > 1
      );
    }), we = xe(() => H.value.map((ne) => {
      const ae = ne.filter(
        (Ie) => !!T.value[Ie]
      );
      return {
        style: ff(ne, T.value),
        errorFields: ae
      };
    })), S = xe(() => v.value?.columns.some(
      (ae) => ae.key === 1 && ae.columnType !== "AUTO_ID" && !ee(y.value[ae.id])
    ) ? "Cannot save draft: primary key is required" : ""), B = xe(() => x.value && H.value.length > 1);
    oa(async () => {
      V.value = !1, M.value = nt.newClient(d), I.value = await M.value.fetchSchemaMetaData();
      const ne = await M.value.fetchSettings();
      if (g === null ? x.value = ne.find(
        (ae) => ae.key === F
      )?.value !== "false" : x.value = !!g, v.value = await M.value.fetchTableMetaData(f), l) {
        const ae = await be();
        r ? y.value = uf(v.value, ae) : y.value = ae;
      }
      y.value = { ...y.value, ...We(s) }, Ye(), V.value = !0;
    });
    function ee(ne) {
      return ne != null && ne !== "";
    }
    function pe(ne) {
      q.value = ne;
    }
    function ye() {
      De({ ...y.value, mg_draft: !1 });
    }
    function de() {
      De({ ...y.value, mg_draft: !0 });
    }
    async function De(ne) {
      D.value = "";
      let ae;
      const Ie = Re(
        ne,
        v.value
      );
      l && !r ? ae = await M.value?.updateDataRow(Ie, f, d).catch(Le) : ae = await M.value?.insertDataRow(Ie, f, d).catch(Le), ae && (z("update:newRow", ne), Ce());
    }
    function Re(ne, ae) {
      if (ae) {
        let Ie = { ...ne };
        return ae.columns.forEach((Ve) => {
          Ve.columnType === "REFBACK" && delete Ie[Ve.id];
        }), Ie;
      } else
        return ne;
    }
    function Le(ne) {
      ne.response?.status === 403 ? D.value = "Schema doesn't exist or permission denied. Do you need to Sign In?" : D.value = ne.response?.data?.errors[0]?.message || "An Error occurred during save";
    }
    async function be() {
      if (l) {
        const ne = await M.value?.fetchRowData(f, l);
        if (!ne)
          D.value = `Error, unable to fetch data for this row (${l})`;
        else
          return ne;
      } else
        D.value = "No row key provided";
    }
    function Ce() {
      D.value = "", z("close");
    }
    function Ye() {
      v.value && (T.value = Xc(v.value, y.value)), $.value = pf(T.value);
    }
    function ge(ne) {
      const ae = v.value?.columns.find(
        (Ie) => Ie.id === ne
      );
      return ae?.label || ae?.id || ne;
    }
    return (ne, ae) => (u(), k(Et, {
      title: Ae.value,
      show: re(R),
      onClose: Ce
    }, {
      body: w(() => [
        V.value && v.value ? (u(), c("div", Mw, [
          p("div", Lw, [
            p("div", {
              class: G(["overflow-auto mr-n3", { "col-10": B.value, "col-12": !B.value }]),
              style: { "max-height": "calc(100vh - 200px)" }
            }, [
              I.value ? (u(), k(Dw, {
                key: 0,
                id: re(a),
                modelValue: y.value,
                "onUpdate:modelValue": [
                  ae[0] || (ae[0] = (Ie) => y.value = Ie),
                  Ye
                ],
                pkey: re(l),
                tableId: re(f),
                tableMetaData: v.value,
                schemaMetaData: I.value,
                visibleColumns: x.value ? H.value[q.value - 1] : re(A),
                clone: re(r),
                errorPerColumn: T.value,
                applyDefaultValues: re(o),
                tablePermissions: re(i)
              }, null, 8, ["id", "modelValue", "pkey", "tableId", "tableMetaData", "schemaMetaData", "visibleColumns", "clone", "errorPerColumn", "applyDefaultValues", "tablePermissions"])) : b("", !0)
            ], 2),
            B.value ? (u(), c("div", Nw, [
              ae[3] || (ae[3] = p("div", { class: "mb-1" }, [
                p("b", null, "Chapters")
              ], -1)),
              (u(!0), c(ie, null, se(H.value, (Ie, Ve) => (u(), c("div", null, [
                O(vn, {
                  name: `chapter-${Ie[0]}-error-tooltip`,
                  value: we.value[Ve].errorFields.length ? `errors in:
${we.value[Ve].errorFields}` : "",
                  placement: "left"
                }, {
                  default: w(() => [
                    p("button", {
                      type: "button",
                      class: G(["btn btn-link", { "font-weight-bold": Ve + 1 === q.value }]),
                      onClick: (Ne) => pe(Ve + 1),
                      style: xi(we.value[Ve].style)
                    }, E(ge(Ie[0])), 15, Bw)
                  ]),
                  _: 2
                }, 1032, ["name", "value"])
              ]))), 256))
            ])) : b("", !0)
          ])
        ])) : b("", !0)
      ]),
      footer: w(() => [
        O(Pw, {
          id: re(a) + "-footer",
          tableLabel: X.value,
          errorMessage: D.value,
          saveDisabledMessage: $.value,
          saveDraftDisabledMessage: S.value,
          onCancel: Ce,
          onSaveDraft: de,
          onSave: ye
        }, {
          default: w(() => [
            p("div", xw, [
              B.value ? (u(), c("div", qw, [
                O(it, {
                  onClick: ae[1] || (ae[1] = (Ie) => pe(q.value - 1)),
                  disabled: q.value <= 1,
                  class: "mr-2 pr-3"
                }, {
                  default: w(() => [...ae[4] || (ae[4] = [
                    p("i", {
                      class: G("fas fa-fw fa-chevron-left")
                    }, null, -1),
                    N(" Previous ", -1)
                  ])]),
                  _: 1
                }, 8, ["disabled"]),
                O(it, {
                  onClick: ae[2] || (ae[2] = (Ie) => pe(q.value + 1)),
                  disabled: q.value >= H.value.length,
                  class: "pl-3"
                }, {
                  default: w(() => [...ae[5] || (ae[5] = [
                    N(" Next ", -1),
                    p("i", {
                      class: G("fas fa-fw fa-chevron-right")
                    }, null, -1)
                  ])]),
                  _: 1
                }, 8, ["disabled"])
              ])) : b("", !0)
            ])
          ]),
          _: 1
        }, 8, ["id", "tableLabel", "errorMessage", "saveDisabledMessage", "saveDraftDisabledMessage"])
      ]),
      _: 1
    }, 8, ["title", "show"]));
  }
}), Nr = /* @__PURE__ */ P(Vw, [["__scopeId", "data-v-6f6bd0fd"]]), Ql = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nr
}, Symbol.toStringTag, { value: "Module" })), jw = {
  directives: {
    clickOutside: Xi.directive
  },
  props: {
    buttonText: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      required: !1,
      default: () => !1
    }
  },
  methods: {
    closeSelf(e) {
      this.$refs.HtmlDropdownMain.removeAttribute("open");
    }
  },
  computed: {
    buttonstateClass() {
      return this.active ? "bg-secondary text-white" : "border border-secondary";
    },
    containerstateClass() {
      return this.active ? "text-dark" : "";
    }
  }
};
function Hw(e, n, t, i, o, r) {
  const s = zn("click-outside");
  return u(), c("details", {
    class: G(["dropdown-button p-0", r.buttonstateClass]),
    ref: "HtmlDropdownMain"
  }, [
    p("summary", null, [
      N(E(t.buttonText) + " ", 1),
      j(e.$slots, "counter", {}, void 0, !0),
      n[2] || (n[2] = p("span", { class: "fa-solid fa-caret-down" }, null, -1))
    ]),
    tt((u(), c("div", null, [
      p("div", {
        class: G(["dropdown bg-white", r.containerstateClass]),
        onClick: n[0] || (n[0] = ve(() => {
        }, ["stop"]))
      }, [
        j(e.$slots, "default", {}, void 0, !0)
      ], 2),
      p("div", {
        class: "close",
        onClick: n[1] || (n[1] = (...a) => r.closeSelf && r.closeSelf(...a))
      })
    ])), [
      [s, r.closeSelf]
    ])
  ], 2);
}
const nk = /* @__PURE__ */ P(jw, [["render", Hw], ["__scopeId", "data-v-49b9263b"]]), Gw = {}, Qw = { style: { display: "flex", "align-self": "flex-end" } };
function $w(e, n, t, i, o, r) {
  return u(), c("div", Qw, [
    p("label", null, [
      j(e.$slots, "default")
    ])
  ]);
}
const ik = /* @__PURE__ */ P(Gw, [["render", $w]]), Jw = {
  name: "Info",
  data() {
    return {
      show: !1
    };
  }
}, zw = { class: "tooltip-inner" };
function Ww(e, n, t, i, o, r) {
  return u(), c("div", null, [
    p("span", {
      onMouseenter: n[0] || (n[0] = (s) => o.show = !0),
      onMouseleave: n[1] || (n[1] = (s) => o.show = !1)
    }, [...n[2] || (n[2] = [
      p("i", { class: "fa fa-question-circle text-primary" }, null, -1)
    ])], 32),
    p("div", {
      class: G(["tooltip bs-tooltip-top", { show: o.show }])
    }, [
      p("span", zw, [
        p("span", null, [
          j(e.$slots, "default")
        ])
      ]),
      n[3] || (n[3] = p("span", { class: "arrow" }, null, -1))
    ], 2)
  ]);
}
const ok = /* @__PURE__ */ P(Jw, [["render", Ww]]), Yw = {
  name: "InfoPopover",
  props: {
    boldText: {
      type: Boolean,
      default: !1
    },
    faIcon: {
      type: String,
      default: "fa-question-circle"
    },
    textColor: {
      type: String,
      default: "text-info"
    },
    iconBeforeLabel: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    popoverPlacement: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      isActive: !1
    };
  },
  computed: {
    placementClass() {
      return `tooltip-${this.popoverPlacement}`;
    }
  },
  methods: {
    activateTooltip() {
      this.updateTooltipPlacement(), this.isActive = !0;
    },
    deactivateTooltip() {
      this.isActive = !1;
    },
    updateTooltipPlacement() {
      if (!this.$refs.tooltipTrigger || !this.$refs.tooltipContent)
        return;
      const e = this.$refs.tooltipTrigger.getBoundingClientRect(), n = this.$refs.tooltipContent.getBoundingClientRect(), t = this.calculatePlacementStyle(
        e,
        n
      );
      Object.assign(this.$refs.tooltipContent.style, t);
    },
    calculatePlacementStyle(e, n) {
      const t = {};
      switch (this.popoverPlacement) {
        case "right":
          t.left = `${e.right + window.scrollX + 8}px`, t.top = `${e.top + window.scrollY - (n.height - e.height) / 2}px`;
          break;
        case "left":
          t.right = `${window.innerWidth - e.left + window.scrollX - 8}px`, t.top = `${e.top + window.scrollY - (n.height - e.height) / 2}px`;
          break;
        case "bottom":
          t.top = `${e.bottom + window.scrollY + 8}px`, t.left = `${e.left + window.scrollX - (n.width - e.width) / 2}px`;
          break;
        default:
          t.top = `${e.top - n.height - 8 + window.scrollY}px`, t.left = `${e.left + window.scrollX - (n.width - e.width) / 2}px`;
          break;
      }
      return t;
    }
  }
}, Xw = { key: 0 }, Zw = { key: 1 };
function eC(e, n, t, i, o, r) {
  return u(), c("span", {
    class: G({ "font-weight-bold": t.boldText })
  }, [
    p("div", {
      class: "w3tooltip",
      tabindex: "0",
      onClick: n[0] || (n[0] = ve(() => {
      }, ["prevent"])),
      onMouseenter: n[1] || (n[1] = (...s) => r.activateTooltip && r.activateTooltip(...s)),
      onMouseleave: n[2] || (n[2] = (...s) => r.deactivateTooltip && r.deactivateTooltip(...s)),
      onFocus: n[3] || (n[3] = (...s) => r.activateTooltip && r.activateTooltip(...s)),
      onBlur: n[4] || (n[4] = (...s) => r.deactivateTooltip && r.deactivateTooltip(...s)),
      ref: "tooltipTrigger"
    }, [
      t.label && !t.iconBeforeLabel ? (u(), c("span", Xw, E(t.label), 1)) : b("", !0),
      p("span", {
        class: G(["fa d-inline-block", [
          t.label ? t.iconBeforeLabel ? "mr-1" : "ml-1" : "",
          t.faIcon,
          t.textColor
        ]]),
        "aria-hidden": "true"
      }, null, 2),
      t.label && t.iconBeforeLabel ? (u(), c("span", Zw, E(t.label), 1)) : b("", !0)
    ], 544),
    (u(), k(vu, { to: "body" }, [
      p("span", {
        class: G(["tooltiptext", [r.placementClass, { active: o.isActive }]]),
        ref: "tooltipContent"
      }, [
        j(e.$slots, "default", {}, void 0, !0)
      ], 2)
    ]))
  ], 2);
}
const rk = /* @__PURE__ */ P(Yw, [["render", eC], ["__scopeId", "data-v-b1569d5a"]]), tC = {
  extends: ke,
  components: {
    FormGroup: Te,
    MessageError: At
  },
  props: {
    options: { type: Array, required: !0 },
    noOptionsProvidedMessage: { type: String, default: "No options provided" }
  },
  methods: {
    updateModelValue: function(e) {
      this.$emit("update:modelValue", e == "" ? null : e);
    }
  }
}, nC = ["id", "modelValue", "readonly"], iC = ["selected"], oC = ["value", "selected"], rC = ["id", "value"];
function sC(e, n, t, i, o, r) {
  const s = K("MessageError"), a = K("FormGroup");
  return u(), k(a, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      !t.options || !t.options.length ? (u(), k(s, { key: 0 }, {
        default: w(() => [
          N(E(t.noOptionsProvidedMessage), 1)
        ]),
        _: 1
      })) : e.readonly ? (u(), c("input", {
        key: 2,
        id: e.id,
        class: "form-control",
        type: "text",
        readonly: "",
        value: e.modelValue
      }, null, 8, rC)) : (u(), c("select", {
        key: 1,
        id: e.id,
        modelValue: e.modelValue,
        readonly: e.readonly,
        class: "form-control",
        onChange: n[0] || (n[0] = (l) => r.updateModelValue(l.target.value))
      }, [
        e.required ? b("", !0) : (u(), c("option", {
          key: 0,
          value: "",
          selected: e.modelValue === void 0 || e.modelValue === null
        }, E(e.placeholder), 9, iC)),
        (u(!0), c(ie, null, se(t.options, (l, d) => (u(), c("option", {
          key: d + l,
          value: l,
          selected: e.modelValue == l
        }, E(l), 9, oC))), 128))
      ], 40, nC))
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const xn = /* @__PURE__ */ P(tC, [["render", sC]]), aC = {
  directives: {
    clickOutside: Xi.directive
  },
  extends: ke,
  components: {
    IconAction: Rt
  },
  props: {
    options: Array
  },
  data() {
    return {
      focus: !1
    };
  },
  methods: {
    select(e) {
      this.toggleFocus(), this.$emit("update:modelValue", e);
    },
    toggleFocus() {
      this.focus = !this.focus;
    }
  }
}, lC = {
  key: 0,
  class: "dropdown show"
}, uC = { class: "dropdown-menu show" }, dC = ["onClick"];
function cC(e, n, t, i, o, r) {
  const s = K("IconAction"), a = zn("click-outside");
  return u(), c("span", null, [
    o.focus ? tt((u(), c("span", lC, [
      p("span", uC, [
        e.required ? b("", !0) : (u(), c("button", {
          class: "btn btn-link dropdown-item",
          key: "empty-option",
          onClick: n[0] || (n[0] = ve((l) => r.select(void 0), ["prevent"]))
        }, "   ")),
        (u(!0), c(ie, null, se(t.options, (l) => (u(), c("button", {
          class: G(["btn btn-link dropdown-item", { "text-primary": e.modelValue === l }]),
          key: l,
          onClick: ve((d) => r.select(l), ["prevent"])
        }, E(l), 11, dC))), 128))
      ])
    ])), [
      [a, r.toggleFocus]
    ]) : b("", !0),
    p("span", {
      onClick: n[1] || (n[1] = (...l) => r.toggleFocus && r.toggleFocus(...l)),
      onMouseover: n[2] || (n[2] = (l) => e.hover = !0),
      onMouseleave: n[3] || (n[3] = (l) => e.hover = !1),
      class: "inline-select"
    }, [
      N(E(e.modelValue) + " ", 1),
      O(s, {
        icon: "pencil-alt",
        class: "hoverIcon"
      })
    ], 32)
  ]);
}
const sk = /* @__PURE__ */ P(aC, [["render", cC], ["__scopeId", "data-v-25a3f2e9"]]), fC = {
  extends: ke,
  //gives us 'options'
  components: {
    InputSelect: xn,
    InputText: ri,
    FormGroup: Te,
    InputGroup: Qe
  },
  props: {
    locales: {
      type: Array,
      default: () => ["en"]
    }
  },
  data() {
    return {
      localeSelect: void 0
      //for selecting locale
    };
  },
  mounted() {
    const e = Array.isArray(this.modelValue) ? We(this.modelValue) : [{ locale: "en", value: "" }], n = pC(this.locales, e);
    this.$emit("update:modelValue", n);
  }
};
function pC(e, n) {
  let t = [...n];
  return e.forEach((i) => {
    i && !n.find((o) => o.locale === i) && t.push({ locale: i, value: "" }), n.find((o) => o.locale === "en") || t.push({ locale: i, value: "en" });
  }), t;
}
const hC = { class: "table table-bordered table-sm mb-0" }, mC = {
  key: 0,
  class: "pt-0 td-shrink text-right"
}, AC = { class: "p-0" };
function gC(e, n, t, i, o, r) {
  const s = K("InputText"), a = K("InputGroup"), l = K("FormGroup");
  return u(), k(l, {
    id: e.id,
    label: e.label,
    required: e.required,
    description: e.description,
    errorMessage: e.errorMessage
  }, {
    default: w(() => [
      O(a, null, {
        default: w(() => [
          p("table", hC, [
            (u(!0), c(ie, null, se(e.modelValue, (d, f) => (u(), c("tr", null, [
              e.modelValue.length > 1 ? (u(), c("td", mC, E(d.locale) + ": ", 1)) : b("", !0),
              p("td", AC, [
                O(s, {
                  id: e.id + ":" + d.locale,
                  modelValue: e.modelValue[f].value,
                  "onUpdate:modelValue": (g) => e.modelValue[f].value = g,
                  class: "mb-0",
                  onInput: n[0] || (n[0] = () => {
                  })
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
              ])
            ]))), 256))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "label", "required", "description", "errorMessage"]);
}
const ak = /* @__PURE__ */ P(fC, [["render", gC]]), yC = {
  props: {
    text: {
      type: String,
      required: !0
    }
  }
}, KC = { class: "tooltip-component" }, bC = { class: "tooltip-text px-2" };
function vC(e, n, t, i, o, r) {
  return u(), c("div", KC, [
    j(e.$slots, "default", {}, () => [
      n[0] || (n[0] = N(" Default ", -1))
    ], !0),
    p("div", bC, E(t.text), 1)
  ]);
}
const lk = /* @__PURE__ */ P(yC, [["render", vC], ["__scopeId", "data-v-fa2001de"]]);
function Br(e) {
  return wu() ? (Cu(e), !0) : !1;
}
function qn(e) {
  return typeof e == "function" ? e() : re(e);
}
const $l = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const wC = Object.prototype.toString, CC = (e) => wC.call(e) === "[object Object]", Ni = () => {
}, Jo = /* @__PURE__ */ RC();
function RC() {
  var e, n;
  return $l && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((n = window?.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
const js = {
  mounted: "mounted",
  unmounted: "unmounted"
};
function FC(...e) {
  if (e.length !== 1)
    return Ru(...e);
  const n = e[0];
  return typeof n == "function" ? Fu(ku(() => ({ get: n, set: Ni }))) : fe(n);
}
function Pn(e) {
  var n;
  const t = qn(e);
  return (n = t?.$el) != null ? n : t;
}
const Jl = $l ? window : void 0;
function Si(...e) {
  let n, t, i, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, i, o] = e, n = Jl) : [n, t, i, o] = e, !n)
    return Ni;
  Array.isArray(t) || (t = [t]), Array.isArray(i) || (i = [i]);
  const r = [], s = () => {
    r.forEach((f) => f()), r.length = 0;
  }, a = (f, g, A, R) => (f.addEventListener(g, A, R), () => f.removeEventListener(g, A, R)), l = Xt(
    () => [Pn(n), qn(o)],
    ([f, g]) => {
      if (s(), !f)
        return;
      const A = CC(g) ? { ...g } : g;
      r.push(
        ...t.flatMap((R) => i.map((F) => a(f, R, F, A)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    l(), s();
  };
  return Br(d), d;
}
let Hs = !1;
function Gs(e, n, t = {}) {
  const { window: i = Jl, ignore: o = [], capture: r = !0, detectIframe: s = !1 } = t;
  if (!i)
    return;
  Jo && !Hs && (Hs = !0, Array.from(i.document.body.children).forEach((A) => A.addEventListener("click", Ni)), i.document.documentElement.addEventListener("click", Ni));
  let a = !0;
  const l = (A) => o.some((R) => {
    if (typeof R == "string")
      return Array.from(i.document.querySelectorAll(R)).some((F) => F === A.target || A.composedPath().includes(F));
    {
      const F = Pn(R);
      return F && (A.target === F || A.composedPath().includes(F));
    }
  }), f = [
    Si(i, "click", (A) => {
      const R = Pn(e);
      if (!(!R || R === A.target || A.composedPath().includes(R))) {
        if (A.detail === 0 && (a = !l(A)), !a) {
          a = !0;
          return;
        }
        n(A);
      }
    }, { passive: !0, capture: r }),
    Si(i, "pointerdown", (A) => {
      const R = Pn(e);
      a = !l(A) && !!(R && !A.composedPath().includes(R));
    }, { passive: !0 }),
    s && Si(i, "blur", (A) => {
      setTimeout(() => {
        var R;
        const F = Pn(e);
        ((R = i.document.activeElement) == null ? void 0 : R.tagName) === "IFRAME" && !F?.contains(i.document.activeElement) && n(A);
      }, 0);
    })
  ].filter(Boolean);
  return () => f.forEach((A) => A());
}
const kC = {
  [js.mounted](e, n) {
    const t = !n.modifiers.bubble;
    if (typeof n.value == "function")
      e.__onClickOutside_stop = Gs(e, n.value, { capture: t });
    else {
      const [i, o] = n.value;
      e.__onClickOutside_stop = Gs(e, i, Object.assign({ capture: t }, o));
    }
  },
  [js.unmounted](e) {
    e.__onClickOutside_stop();
  }
};
function Eo(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function zl(e) {
  const n = window.getComputedStyle(e);
  if (n.overflowX === "scroll" || n.overflowY === "scroll" || n.overflowX === "auto" && e.clientWidth < e.scrollWidth || n.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !t || t.tagName === "BODY" ? !1 : zl(t);
  }
}
function UC(e) {
  const n = e || window.event, t = n.target;
  return zl(t) ? !1 : n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}
const gi = /* @__PURE__ */ new WeakMap();
function EC(e, n = !1) {
  const t = fe(n);
  let i = null, o;
  Xt(FC(e), (a) => {
    const l = Eo(qn(a));
    if (l) {
      const d = l;
      gi.get(d) || gi.set(d, o), t.value && (d.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const a = Eo(qn(e));
    !a || t.value || (Jo && (i = Si(
      a,
      "touchmove",
      (l) => {
        UC(l);
      },
      { passive: !1 }
    )), a.style.overflow = "hidden", t.value = !0);
  }, s = () => {
    var a;
    const l = Eo(qn(e));
    !l || !t.value || (Jo && i?.(), l.style.overflow = (a = gi.get(l)) != null ? a : "", gi.delete(l), t.value = !1);
  };
  return Br(s), xe({
    get() {
      return t.value;
    },
    set(a) {
      a ? r() : s();
    }
  });
}
function SC() {
  let e = !1;
  const n = fe(!1);
  return (t, i) => {
    if (n.value = i.value, e)
      return;
    e = !0;
    const o = EC(t, i.value);
    Xt(n, (r) => o.value = r);
  };
}
SC();
const TC = {
  name: "Breadcrumb",
  components: {
    InputSearch: Ir,
    RouterLink: Tu
  },
  directives: {
    "on-click-outside": kC
  },
  props: {
    /* list of crumbs, map of  {'label':'url'} */
    crumbs: Object,
    /* list of dropdown, map of  {'label':'url'} */
    dropdown: Object,
    useRouterLink: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showDropdown: !1,
      dropdownSearch: ""
    };
  },
  computed: {
    lastKey() {
      return Object.keys(this.crumbs)[Object.keys(this.crumbs).length - 1];
    },
    dropdownFiltered() {
      return this.dropdownSearch ? Object.fromEntries(
        Object.entries(this.dropdown).filter(
          ([e, n]) => e.toLowerCase().includes(this.dropdownSearch.toLowerCase())
        )
      ) : this.dropdown;
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
  }
}, IC = { "aria-label": "breadcrumb" }, DC = { class: "breadcrumb" }, OC = {
  key: 0,
  class: "router-link"
}, _C = {
  key: 0,
  "aria-current": "page"
}, PC = {
  key: 1,
  class: "atag"
}, MC = {
  key: 0,
  "aria-current": "page"
}, LC = ["href"], NC = { class: "dropdown" }, BC = { key: 0 }, xC = {
  key: 0,
  class: "router-link"
}, qC = {
  key: 1,
  class: "atag"
}, VC = ["href"], jC = { key: 2 };
function HC(e, n, t, i, o, r) {
  const s = K("router-link"), a = K("InputSearch"), l = zn("on-click-outside");
  return u(), c("nav", IC, [
    p("ol", DC, [
      (u(!0), c(ie, null, se(t.crumbs, (d, f, g) => (u(), c("li", {
        key: f,
        class: G(["breadcrumb-item", { active: f === r.lastKey }])
      }, [
        t.useRouterLink ? (u(), c("span", OC, [
          f === r.lastKey ? (u(), c("a", _C, E(f), 1)) : (u(), k(s, {
            key: 1,
            to: d
          }, {
            default: w(() => [
              N(E(f), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        ])) : (u(), c("span", PC, [
          f === r.lastKey ? (u(), c("a", MC, E(f), 1)) : (u(), c("a", {
            key: 1,
            href: d
          }, E(f), 9, LC))
        ])),
        p("span", NC, [
          t.dropdown && g === 0 ? (u(), c("span", BC, [
            p("i", {
              class: "text-primary dropdown-toggle dropdown-toggle-split pr-0",
              onClick: n[0] || (n[0] = (...A) => r.toggleDropdown && r.toggleDropdown(...A))
            }),
            tt((u(), c("div", {
              class: G(["dropdown-menu", { show: o.showDropdown }])
            }, [
              O(a, {
                id: "breadcrumb-dropdown-search",
                modelValue: o.dropdownSearch,
                "onUpdate:modelValue": n[1] || (n[1] = (A) => o.dropdownSearch = A),
                isClearBtnShown: !0,
                isEmitOnType: !0
              }, null, 8, ["modelValue"]),
              t.useRouterLink ? (u(), c("span", xC, [
                (u(!0), c(ie, null, se(r.dropdownFiltered, (A, R, F) => (u(), k(s, {
                  class: "dropdown-item text-primary",
                  to: A,
                  key: `${F}_routerlink`
                }, {
                  default: w(() => [
                    N(E(R), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))), 128))
              ])) : (u(), c("span", qC, [
                (u(!0), c(ie, null, se(r.dropdownFiltered, (A, R, F) => (u(), c("a", {
                  class: "dropdown-item text-primary",
                  href: A,
                  key: F
                }, E(R), 9, VC))), 128))
              ])),
              Object.keys(r.dropdownFiltered).length === 0 ? (u(), c("span", jC, " nothing found ")) : b("", !0)
            ], 2)), [
              [
                l,
                () => {
                  o.showDropdown = !1;
                }
              ]
            ])
          ])) : b("", !0)
        ])
      ], 2))), 128))
    ])
  ]);
}
const GC = /* @__PURE__ */ P(TC, [["render", HC]]);
function QC() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function $C(e, n) {
  return typeof e == "string" ? (void 0)(e, n) : typeof e == "object" && e !== null ? e : {};
}
function JC(e, n) {
  return typeof n > "u" && (n = !e || e[0] !== "{" && e[0] !== "[" && e[0] !== '"'), !n;
}
function Qs(e, n) {
  n === void 0 && (n = {});
  var t = zC(e);
  if (JC(t, n.doNotParse))
    try {
      return JSON.parse(t);
    } catch {
    }
  return e;
}
function zC(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
var $t = function() {
  return $t = Object.assign || function(e) {
    for (var n, t = 1, i = arguments.length; t < i; t++) {
      n = arguments[t];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, $t.apply(this, arguments);
}, WC = (
  /** @class */
  (function() {
    function e(n, t) {
      var i = this;
      this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.cookies = $C(n, t), new Promise(function() {
        i.HAS_DOCUMENT_COOKIE = QC();
      }).catch(function() {
      });
    }
    return e.prototype._updateBrowserValues = function(n) {
      this.HAS_DOCUMENT_COOKIE && (this.cookies = (void 0)(document.cookie, n));
    }, e.prototype._emitChange = function(n) {
      for (var t = 0; t < this.changeListeners.length; ++t)
        this.changeListeners[t](n);
    }, e.prototype.get = function(n, t, i) {
      return t === void 0 && (t = {}), this._updateBrowserValues(i), Qs(this.cookies[n], t);
    }, e.prototype.getAll = function(n, t) {
      n === void 0 && (n = {}), this._updateBrowserValues(t);
      var i = {};
      for (var o in this.cookies)
        i[o] = Qs(this.cookies[o], n);
      return i;
    }, e.prototype.set = function(n, t, i) {
      var o;
      typeof t == "object" && (t = JSON.stringify(t)), this.cookies = $t($t({}, this.cookies), (o = {}, o[n] = t, o)), this.HAS_DOCUMENT_COOKIE && (document.cookie = (void 0)(n, t, i)), this._emitChange({ name: n, value: t, options: i });
    }, e.prototype.remove = function(n, t) {
      var i = t = $t($t({}, t), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
      this.cookies = $t({}, this.cookies), delete this.cookies[n], this.HAS_DOCUMENT_COOKIE && (document.cookie = (void 0)(n, "", i)), this._emitChange({ name: n, value: void 0, options: t });
    }, e.prototype.addChangeListener = function(n) {
      this.changeListeners.push(n);
    }, e.prototype.removeChangeListener = function(n) {
      var t = this.changeListeners.indexOf(n);
      t >= 0 && this.changeListeners.splice(t, 1);
    }, e;
  })()
);
function YC(e, { doNotParse: n = !1, autoUpdateDependencies: t = !1 } = {}, i = new WC()) {
  const o = t ? [...e || []] : e;
  let r = i.getAll({ doNotParse: !0 });
  const s = fe(0), a = () => {
    const l = i.getAll({ doNotParse: !0 });
    XC(
      o || null,
      l,
      r
    ) && s.value++, r = l;
  };
  return i.addChangeListener(a), Br(() => {
    i.removeChangeListener(a);
  }), {
    /**
     * Reactive get cookie by name. If **autoUpdateDependencies = true** then it will update watching dependencies
     */
    get: (...l) => (t && o && !o.includes(l[0]) && o.push(l[0]), s.value, i.get(l[0], { doNotParse: n, ...l[1] })),
    /**
     * Reactive get all cookies
     */
    getAll: (...l) => (s.value, i.getAll({ doNotParse: n, ...l[0] })),
    set: (...l) => i.set(...l),
    remove: (...l) => i.remove(...l),
    addChangeListener: (...l) => i.addChangeListener(...l),
    removeChangeListener: (...l) => i.removeChangeListener(...l)
  };
}
function XC(e, n, t) {
  if (!e)
    return !0;
  for (const i of e)
    if (n[i] !== t[i])
      return !0;
  return !1;
}
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const zo = (e) => typeof e == "function", ZC = Object.prototype.toString, e0 = (e) => ZC.call(e), So = (e) => e0(e) === "[object Object]";
function Wo(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function $s(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    n && (i = i.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Yo(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? $s(Object(t), !0).forEach(function(i) {
      Wo(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $s(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
var t0 = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new Promise(function(i, o) {
    if (!(typeof document > "u")) {
      var r = document.head || document.getElementsByTagName("head")[0], s = document.createElement("script");
      if (s.async = !0, s.src = n, s.defer = t.defer, t.preconnectOrigin) {
        var a = document.createElement("link");
        a.href = t.preconnectOrigin, a.rel = "preconnect", r.appendChild(a);
      }
      r.appendChild(s), s.onload = i, s.onerror = o;
    }
  });
}, n0 = function e(n) {
  for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
    i[o - 1] = arguments[o];
  if (!i.length)
    return n;
  var r = i.shift();
  if (!(!So(n) || !So(r))) {
    for (var s in r)
      So(r[s]) ? (n[s] || Object.assign(n, Wo({}, s, {})), e(n[s], r[s])) : Object.assign(n, Wo({}, s, r[s]));
    return e.apply(void 0, [n].concat(i));
  }
}, si = function() {
  return !(typeof window > "u" || typeof document > "u");
}, Js = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  !si() || process.env.NODE_ENV === "production" || t && console.warn("[vue-gtag] ".concat(n));
}, i0 = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Js('Missing "appName" property inside the plugin options.', n.app_name == null), Js('Missing "name" property in the route.', n.screen_name == null), n;
};
function o0() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", t = e.split("/"), i = n.split("/");
  return t[0] === "" && n[n.length - 1] === "/" && t.shift(), i.join("/") + t.join("/");
}
var r0 = function() {
  return {
    bootstrap: !0,
    onReady: null,
    onError: null,
    onBeforeTrack: null,
    onAfterTrack: null,
    pageTrackerTemplate: null,
    customResourceURL: "https://www.googletagmanager.com/gtag/js",
    customPreconnectOrigin: "https://www.googletagmanager.com",
    deferScriptLoad: !1,
    pageTrackerExcludedRoutes: [],
    pageTrackerEnabled: !0,
    enabled: !0,
    disableScriptLoad: !1,
    pageTrackerScreenviewEnabled: !1,
    appName: null,
    pageTrackerUseFullPath: !1,
    pageTrackerPrependBase: !0,
    pageTrackerSkipSamePath: !0,
    globalDataLayerName: "dataLayer",
    globalObjectName: "gtag",
    defaultGroupName: "default",
    includes: null,
    config: {
      id: null,
      params: {
        send_page_view: !1
      }
    }
  };
}, Wl = {}, s0 = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = r0();
  Wl = n0(t, n);
}, St = function() {
  return Wl;
}, Xo = (function() {
  var e, n = St(), t = n.globalObjectName;
  !si() || typeof window[t] > "u" || (e = window)[t].apply(e, arguments);
}), zs = function(n, t) {
  si() && (window["ga-disable-".concat(n)] = t);
}, a0 = (function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, n = St(), t = n.config, i = n.includes;
  zs(t.id, e), Array.isArray(i) && i.forEach(function(o) {
    return zs(o.id, e);
  });
}), l0 = (function() {
  a0(!0);
}), u0, xr = function() {
  return u0;
}, Yl = (function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = St(), i = t.includes, o = t.defaultGroupName;
  n.send_to == null && Array.isArray(i) && i.length && (n.send_to = i.map(function(r) {
    return r.id;
  }).concat(o)), Xo("event", e, n);
}), d0 = (function(e) {
  if (si()) {
    var n;
    if (typeof e == "string")
      n = {
        page_path: e
      };
    else if (e.path || e.fullPath) {
      var t = St(), i = t.pageTrackerUseFullPath, o = t.pageTrackerPrependBase, r = xr(), s = r && r.options.base, a = i ? e.fullPath : e.path;
      n = Yo(Yo({}, e.name && {
        page_title: e.name
      }), {}, {
        page_path: o ? o0(a, s) : a
      });
    } else
      n = e;
    n.page_location == null && (n.page_location = window.location.href), n.send_page_view == null && (n.send_page_view = !0), Yl("page_view", n);
  }
}), c0 = (function(e) {
  var n = St(), t = n.appName;
  if (e) {
    var i;
    typeof e == "string" ? i = {
      screen_name: e
    } : i = e, i.app_name = i.app_name || t, Yl("screen_view", i);
  }
}), f0 = (function() {
  if (si()) {
    var e = St(), n = e.enabled, t = e.globalObjectName, i = e.globalDataLayerName;
    return window[t] == null && (window[i] = window[i] || [], window[t] = function() {
      window[i].push(arguments);
    }), window[t]("js", /* @__PURE__ */ new Date()), n || l0(), window[t];
  }
}), Ws = function(n) {
  return Yo({
    send_page_view: !1
  }, n);
}, Xl = (function() {
  var e = St(), n = e.config, t = e.includes;
  Xo("config", n.id, Ws(n.params)), Array.isArray(t) && t.forEach(function(i) {
    Xo("config", i.id, Ws(i.params));
  });
}), Ys = (function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = St(), i = t.appName, o = t.pageTrackerTemplate, r = t.pageTrackerScreenviewEnabled, s = t.pageTrackerSkipSamePath;
  if (!(s && e.path === n.path)) {
    var a = e;
    if (zo(o) ? a = o(e, n) : r && (a = i0({
      app_name: i,
      screen_name: e.name
    })), r) {
      c0(a);
      return;
    }
    d0(a);
  }
}), Xs = function(n) {
  var t = St(), i = t.pageTrackerExcludedRoutes;
  return i.includes(n.path) || i.includes(n.name);
}, p0 = (function() {
  var e = St(), n = e.onBeforeTrack, t = e.onAfterTrack, i = xr();
  i.isReady().then(function() {
    Ti().then(function() {
      var o = i.currentRoute;
      Xl(), !Xs(o.value) && Ys(o.value);
    }), i.afterEach(function(o, r) {
      Ti().then(function() {
        Xs(o) || (zo(n) && n(o, r), Ys(o, r), zo(t) && t(o, r));
      });
    });
  });
}), h0 = (function() {
  var e = St(), n = e.onReady, t = e.onError, i = e.globalObjectName, o = e.globalDataLayerName, r = e.config, s = e.customResourceURL, a = e.customPreconnectOrigin, l = e.deferScriptLoad, d = e.pageTrackerEnabled, f = e.disableScriptLoad, g = !!(d && xr());
  if (f0(), g ? p0() : Xl(), !f)
    return t0("".concat(s, "?id=").concat(r.id, "&l=").concat(o), {
      preconnectOrigin: a,
      defer: l
    }).then(function() {
      n && n(window[i]);
    }).catch(function(A) {
      return t && t(A), A;
    });
});
const m0 = {
  name: "GTag",
  props: {
    tagId: {
      type: String,
      required: !0
    }
  },
  methods: {
    enablePlugin(e) {
      s0({
        config: { id: e }
      }), h0().then((n) => {
        console.log("start analytics for tagId: " + e);
      });
    }
  },
  async mounted() {
    this.enablePlugin(this.tagId);
  }
};
function A0(e, n, t, i, o, r) {
  return u(), c("div");
}
const g0 = /* @__PURE__ */ P(m0, [["render", A0]]), y0 = ["innerHTML"], K0 = { key: 1 }, b0 = {
  __name: "CookieWall",
  props: {
    title: {
      type: String,
      default: "Would you like a cookie?"
    },
    acceptLabel: {
      type: String,
      default: "Accept"
    },
    rejectLabel: {
      type: String,
      default: "No thanks"
    },
    analyticsId: {
      type: String
    },
    htmlContentString: {
      type: String | null,
      default: null
    }
  },
  emits: ["acceptCookie"],
  setup(e, { emit: n }) {
    const t = YC(["mg_allow_analytics"]), i = n;
    let o = fe(!1);
    const r = xe(() => t.get("mg_allow_analytics") === void 0), s = {
      path: "/",
      maxAge: 1704085200,
      // one year,
      httpOnly: !1
    };
    function a() {
      t.set("mg_allow_analytics", !0, s), i("acceptCookie", !0), window.location.reload();
    }
    function l() {
      t.set("mg_allow_analytics", !1, s), i("acceptCookie", !1);
    }
    function d() {
      o.value = !0, i("acceptCookie", void 0);
    }
    const f = xe(() => t.get("mg_allow_analytics") === !0);
    return (g, A) => (u(), c(ie, null, [
      O(Et, {
        title: e.title,
        onClose: d,
        show: r.value && !re(o)
      }, {
        body: w(() => [
          e.htmlContentString ? (u(), c("div", {
            key: 0,
            innerHTML: e.htmlContentString
          }, null, 8, y0)) : (u(), c("div", K0, [...A[0] || (A[0] = [
            p("p", null, ' We use cookies and similar technologies to enhance your browsing experience, analyze website traffic, and personalize content. By clicking "Accept," you consent to the use of cookies. ', -1),
            p("p", null, " We value your privacy and are committed to protecting your personal information. Our use of cookies is solely for improving your experience on our website and ensuring its functionality. We do not sell or share your data with third parties. ", -1)
          ])]))
        ]),
        footer: w(() => [
          O(mt, { onClick: l }, {
            default: w(() => [
              N(E(e.rejectLabel), 1)
            ]),
            _: 1
          }),
          O(it, { onClick: a }, {
            default: w(() => [
              N(E(e.acceptLabel), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "show"]),
      f.value ? (u(), k(g0, {
        key: 0,
        tagId: e.analyticsId
      }, null, 8, ["tagId"])) : b("", !0)
    ], 64));
  }
}, v0 = {
  components: {
    IconAction: Rt
  },
  props: {
    /** Title that is shown on the card (optional) */
    title: String,
    /** If the cared should be collapsed **/
    collapse: { type: Boolean, default: !1 }
  },
  data: function() {
    return {
      fullscreen: !1,
      collapsed: !0
    };
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen;
    },
    toggleCollapse() {
      this.collapse && (this.collapsed = !this.collapsed);
    }
  },
  computed: {
    bodyheight() {
      if (this.$refs.header && this.fullscreen) {
        let e = this.$refs.header.clientHeight, n = this.$refs.footer.clientHeight;
        return `height: calc(100vh - ${e + n}px)`;
      }
      return "";
    }
  }
}, w0 = { key: 0 };
function C0(e, n, t, i, o, r) {
  const s = K("IconAction");
  return u(), c("div", {
    class: G(["card", { "card-fullscreen": e.fullscreen }])
  }, [
    p("div", {
      ref: "header",
      class: "card-header text-center",
      onClick: n[0] || (n[0] = (...a) => r.toggleCollapse && r.toggleCollapse(...a))
    }, [
      t.title ? (u(), c("h4", w0, E(t.title), 1)) : b("", !0),
      j(e.$slots, "header", {}, void 0, !0),
      t.collapse ? b("", !0) : (u(), k(s, {
        key: 1,
        class: "card-fullscreen-icon",
        icon: e.fullscreen ? "compress" : "expand",
        onClick: r.toggle
      }, null, 8, ["icon", "onClick"]))
    ], 512),
    !this.collapse || !e.collapsed ? (u(), c("div", {
      key: 0,
      class: "card-body",
      style: xi(r.bodyheight)
    }, [
      j(e.$slots, "default", {}, void 0, !0)
    ], 4)) : b("", !0)
  ], 2);
}
const uk = /* @__PURE__ */ P(v0, [["render", C0], ["__scopeId", "data-v-adf17920"]]), R0 = {}, F0 = { class: "text-center" };
function k0(e, n) {
  return u(), c("div", F0, [
    n[0] || (n[0] = Uu('<div data-v-3d70bd30> This database was created using the <a href="http://molgenis.org" data-v-3d70bd30>MOLGENIS</a>  <a href="http://github.com/molgenis/molgenis-emx2" data-v-3d70bd30> molgenis-emx2 </a> open source software (license: <a href="https://github.com/molgenis/molgenis-emx2/blob/master/LICENSE" data-v-3d70bd30> LGPLv3 </a> ). </div><div data-v-3d70bd30> Please cite <a href="https://www.ncbi.nlm.nih.gov/pubmed/30165396" data-v-3d70bd30> Van der Velde et al (2018) </a> or <a href="https://www.ncbi.nlm.nih.gov/pubmed/21210979" data-v-3d70bd30> Swertz et al (2010) </a> on use. </div>', 2)),
    j(e.$slots, "default", {}, void 0, !0)
  ]);
}
const U0 = /* @__PURE__ */ P(R0, [["render", k0], ["__scopeId", "data-v-3d70bd30"]]), E0 = {
  components: {
    ButtonDropdown: Lr
  },
  props: {
    /** the navbar items in format {name:'name', href:'href',role:[], submenu:[]}.
     * If href is null then you will return to baseURL.
     * Href is prefixed with 'baseURL' unless startwith 'http' or '/'.
     * If role then menu items are filtered based on session.roles.
     * Submenu is optional
     */
    items: Array,
    /** logo to show*/
    logo: String,
    /** session information, so we can check role permissions */
    session: Object,
    /** prefix for relative href. Will default to schema name, i.e. first directory in path, e.g. "/pet store/ */
    baseURL: {
      type: String,
      default: () => {
        let e = window.location.pathname.split("/")[1];
        return "/" + (e ? e + "/" : "");
      }
    }
  },
  data: function() {
    return {
      toggleMenuBar: !1
    };
  },
  computed: {
    permittedItems() {
      return this.items.filter(this.permitted);
    },
    homeUrl() {
      const e = (t) => t.find((i) => {
        if (i.href)
          return i;
        if (i.submenu)
          return e(i.submenu.filter(this.permitted));
      }), n = e(this.permittedItems);
      return n ? this.addBaseUrl(n.href) : this.baseURL;
    }
  },
  methods: {
    addBaseUrl(e) {
      return e && (e.startsWith("http://") || e.startsWith("https://") || e.startsWith("/") || e.startsWith("..")) ? e : this.baseURL + (e || "");
    },
    navigate(e) {
      return window.location.href = e, e.includes("#") && window.location.reload(!0), !1;
    },
    permitted(e) {
      return !e.role || this.session?.admin || e.role === "Signed in" && this.session?.email !== "anonymous" ? !0 : this.session?.roles?.includes(e.role);
    }
  }
}, S0 = { class: "navbar bg-primary navbar-expand-lg navbar-dark" }, T0 = {
  key: 0,
  class: "navbar-brand",
  href: "/"
}, I0 = ["src"], D0 = {
  key: 0,
  class: "navbar-nav"
}, O0 = ["href", "target", "onClick"], _0 = ["href", "target", "onClick"];
function P0(e, n, t, i, o, r) {
  const s = K("ButtonDropdown");
  return u(), c("nav", S0, [
    p("button", {
      class: "navbar-toggler",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNav",
      "aria-controls": "navbarNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation",
      onClick: n[0] || (n[0] = (a) => e.toggleMenuBar = !e.toggleMenuBar)
    }, [...n[1] || (n[1] = [
      p("span", { class: "navbar-toggler-icon" }, null, -1)
    ])]),
    t.logo ? (u(), c("a", T0, [
      p("img", {
        src: t.logo,
        alt: "brand-logo",
        height: "30"
      }, null, 8, I0)
    ])) : b("", !0),
    p("div", {
      class: G(["collapse navbar-collapse", { show: e.toggleMenuBar }]),
      id: "navbarNav"
    }, [
      t.items ? (u(), c("ul", D0, [
        (u(!0), c(ie, null, se(r.permittedItems, (a) => (u(), c("li", {
          key: a.label,
          class: G(["nav-item", {
            active: a.active,
            dropdown: a.submenu
          }])
        }, [
          a.submenu && a.submenu.length > 0 ? (u(), k(s, {
            key: 0,
            class: "nav-item",
            label: a.label,
            icon: "caret-down",
            isMenuItem: !0
          }, {
            default: w(() => [
              (u(!0), c(ie, null, se(a.submenu, (l) => (u(), c("a", {
                class: "dropdown-item",
                href: r.addBaseUrl(l.href),
                key: l.label,
                target: l.newWindow ? "_blank" : "_self",
                onClick: (d) => r.navigate(r.addBaseUrl(l.href))
              }, E(l.label), 9, O0))), 128))
            ]),
            _: 2
          }, 1032, ["label"])) : (u(), c("a", {
            key: 1,
            class: "nav-link",
            href: r.addBaseUrl(a.href),
            target: a.newWindow ? "_blank" : "_self",
            onClick: (l) => r.navigate(r.addBaseUrl(a.href))
          }, E(a.label), 9, _0))
        ], 2))), 128))
      ])) : b("", !0)
    ], 2),
    j(e.$slots, "default")
  ]);
}
const M0 = /* @__PURE__ */ P(E0, [["render", P0]]), L0 = { style: { "background-color": "#f4f4f4" } }, N0 = { style: { "min-height": "calc(100vh - 70px)" } }, B0 = {
  class: "container-fluid p-3",
  style: { "padding-bottom": "50px" }
}, x0 = { key: 0 }, q0 = ["innerHTML"], V0 = { key: 0 }, j0 = ["href"], H0 = { key: 0 }, dk = /* @__PURE__ */ Se({
  __name: "Molgenis",
  props: {
    title: {},
    menuItems: { default: () => [] },
    showCrumbs: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "error"],
  setup(e, { emit: n }) {
    const t = [
      {
        label: "Tables",
        href: "tables",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Schema",
        href: "schema",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Up/Download",
        href: "updownload",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Reports",
        href: "reports",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Jobs & Scripts",
        href: "tasks",
        role: "Manager",
        submenu: []
      },
      {
        label: "Graphql",
        href: "graphql-playground",
        role: "Viewer",
        submenu: []
      },
      {
        label: "Settings",
        href: "settings",
        role: "Manager",
        submenu: []
      },
      {
        label: "Help",
        href: "docs",
        role: "Viewer",
        submenu: []
      }
    ], i = e, o = fe([]);
    i.menuItems.length ? o.value = y(i.menuItems) : o.value = y(t);
    const r = n, s = fe(null), a = xe(() => {
      const T = s.value?.manifest;
      return T?.SpecificationVersion?.includes("SNAPSHOT") ? `https://github.com/molgenis/molgenis-emx2/commit/${T.ImplementationVersion}` : `https://github.com/molgenis/molgenis-emx2/releases/tag/${T?.SpecificationVersion}`;
    }), l = fe(null), d = fe(Date.now()), f = fe(null), g = fe(null), A = xe(() => {
      let T = {
        "list all databases": "/apps/central/"
      };
      return s.value?.schemas && s.value.schemas.sort(
        (v, I) => v.localeCompare(I, void 0, { sensitivity: "base" })
      ).forEach((v) => {
        T[v] = "/" + v + "/index";
      }), T;
    }), R = xe(() => {
      let T = {};
      if (window && location) {
        let v = decodeURI(
          window.location.pathname.replace(location.search, "")
        ).split("/"), I = "/";
        if (window.location.pathname != "/apps/central/") {
          let M = "index";
          v.forEach((D) => {
            D !== "" && (I += D + "/", T[D] = I + M, M = "");
          });
        }
        v = decodeURI(location?.hash?.split("?")[0]).substr(1).split("/"), I += "#", v.forEach((M) => {
          M !== "" && (I += "/" + M, T[M] = I);
        });
      }
      return T;
    }), F = xe(() => l.value ?? "/apps/molgenis-components/assets/img/molgenis_logo_white.png");
    Xt(
      s,
      (T) => {
        T?.settings?.logoURL && (l.value = T.settings.logoURL);
        const v = T?.settings?.additionalJs;
        if (v)
          try {
            eval?.(`(function() {"use strict"; ${v}})()`);
          } catch (I) {
            console.log(I);
          }
        !i.menuItems.length && T?.settings?.menu && (o.value = T.settings.menu), r("update:modelValue", T);
      },
      { deep: !0 }
    ), Xt(
      () => i.menuItems,
      (T) => {
        T.length ? o.value = y(T) : o.value = y(t);
      }
    );
    function y(T) {
      const v = window?.location?.pathname.split("/")?.filter(Boolean)[0];
      if (!v || v === "apps")
        return T;
      function I(D) {
        let V = `/${v}/${D}`, q = V.indexOf("#");
        return q !== -1 && V.substring(q - 1, q) !== "/" && (V = V.substring(0, q) + "/" + V.substring(q, V?.length)), q = V.indexOf("#"), q !== -1 || V.endsWith("/") ? V : V + "/";
      }
      return T.map((D) => (D.href = I(D.href), D.submenu = D.submenu.map((V) => (V.href = I(V.href), V)), D));
    }
    return oa(async () => {
      const v = await nt.newClient().fetchSettings(), I = v.find(
        (D) => D.key === "ANALYTICS_ID"
      );
      f.value = I ? I.value : null;
      const M = v.find(
        (D) => D.key === "ANALYTICS_COOKIE_WALL_CONTENT"
      );
      g.value = M ? M.value : null;
    }), (T, v) => (u(), c("div", L0, [
      T.$slots.banner ? j(T.$slots, "banner", { key: 0 }) : b("", !0),
      f.value ? (u(), k(b0, {
        key: 1,
        analyticsId: f.value,
        htmlContentString: g.value
      }, null, 8, ["analyticsId", "htmlContentString"])) : b("", !0),
      p("div", N0, [
        O(M0, {
          logo: F.value,
          active: "My search",
          items: o.value,
          session: s.value ?? void 0
        }, {
          default: w(() => [
            (u(), k(DA, {
              modelValue: s.value,
              "onUpdate:modelValue": v[0] || (v[0] = (I) => s.value = I),
              key: d.value,
              onError: v[1] || (v[1] = (I) => T.$emit("error", I))
            }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }, 8, ["logo", "items", "session"]),
        e.showCrumbs && Object.keys(R.value).length > 1 ? (u(), k(GC, {
          key: 0,
          crumbs: R.value,
          dropdown: A.value
        }, null, 8, ["crumbs", "dropdown"])) : b("", !0),
        p("main", B0, [
          e.title ? (u(), c("h1", x0, E(e.title), 1)) : b("", !0),
          j(T.$slots, "default")
        ])
      ]),
      p("footer", null, [
        s.value?.settings?.additionalFooterHtml ? (u(), c("div", {
          key: 0,
          innerHTML: s.value?.settings?.additionalFooterHtml
        }, null, 8, q0)) : b("", !0),
        T.$slots.footer ? j(T.$slots, "footer", { key: 1 }) : (u(), k(U0, { key: 2 }, {
          default: w(() => [
            s.value?.manifest ? (u(), c("span", V0, [
              v[2] || (v[2] = N(" Software version: ", -1)),
              p("a", { href: a.value }, E(s.value.manifest.SpecificationVersion), 9, j0),
              N(" (git:" + E(s.value.manifest.ImplementationVersion) + "). ", 1),
              s.value.manifest.DatabaseVersion ? (u(), c("span", H0, " Database version: " + E(s.value.manifest.DatabaseVersion) + ". ", 1)) : b("", !0)
            ])) : b("", !0)
          ]),
          _: 1
        }))
      ])
    ]));
  }
}), G0 = {
  components: { ButtonAlt: mt },
  props: {
    title: { type: String, default: "debug" }
  },
  data() {
    return { show: !1 };
  },
  computed: {
    showLabel() {
      return "show " + this.title;
    },
    hideLabel() {
      return "hide " + this.title;
    }
  }
}, Q0 = { key: 0 };
function $0(e, n, t, i, o, r) {
  const s = K("ButtonAlt");
  return o.show ? (u(), c("div", Q0, [
    O(s, {
      onClick: n[0] || (n[0] = (a) => o.show = !1)
    }, {
      default: w(() => [
        N(E(r.hideLabel), 1)
      ]),
      _: 1
    }),
    j(e.$slots, "default")
  ])) : (u(), k(s, {
    key: 1,
    onClick: n[1] || (n[1] = (a) => o.show = !0)
  }, {
    default: w(() => [
      N(E(r.showLabel) + " ", 1),
      n[2] || (n[2] = p("br", null, null, -1))
    ]),
    _: 1
  }));
}
const ck = /* @__PURE__ */ P(G0, [["render", $0]]), J0 = {
  props: {
    open: {
      type: Boolean,
      required: !1,
      default: () => !1
    },
    bodyClass: {
      type: String,
      required: !1
    }
  },
  watch: {
    open(e) {
      e ? (this.$refs.modal.setAttribute("open", ""), document.getElementsByTagName("body")[0].style.overflow = "hidden") : (this.$refs.modal.removeAttribute("open"), document.getElementsByTagName("body")[0].style.removeProperty("overflow"));
    }
  }
}, z0 = { ref: "modal" }, W0 = { class: "d-flex pt-4" };
function Y0(e, n, t, i, o, r) {
  return u(), c("dialog", z0, [
    p("article", {
      class: G(["border border-black bg-white p-2", t.bodyClass])
    }, [
      j(e.$slots, "default", {}, void 0, !0),
      j(e.$slots, "modal-footer", {}, () => [
        p("div", W0, [
          p("button", {
            class: "btn btn-primary",
            onClick: n[0] || (n[0] = (s) => e.$emit("save"))
          }, "Save"),
          p("button", {
            class: "btn btn-dark ml-auto",
            onClick: n[1] || (n[1] = (s) => e.$emit("close"))
          }, " Cancel ")
        ])
      ], !0)
    ], 2)
  ], 512);
}
const fk = /* @__PURE__ */ P(J0, [["render", Y0], ["__scopeId", "data-v-32fc409a"]]), X0 = { class: "tabs-header row justify-content-start" }, Z0 = ["onClick"], eR = { class: "tabs-content" }, tR = /* @__PURE__ */ Se({
  __name: "Tabs",
  props: {
    tabIds: {}
  },
  setup(e) {
    const n = fe(e.tabIds[0]);
    function t(i) {
      n.value = i;
    }
    return (i, o) => (u(), c("div", null, [
      p("ul", X0, [
        (u(!0), c(ie, null, se(e.tabIds, (r) => (u(), c("li", {
          key: r,
          class: G(["tabs-item", { selected: n.value === r }]),
          onClick: (s) => t(r)
        }, [
          j(i.$slots, `${r}-header`, {}, void 0, !0)
        ], 10, Z0))), 128)),
        o[0] || (o[0] = p("li", { class: "filler-line col" }, null, -1))
      ]),
      (u(!0), c(ie, null, se(e.tabIds, (r) => tt((u(), c("div", eR, [
        j(i.$slots, `${r}-body`, {}, void 0, !0)
      ], 512)), [
        [Bi, r === n.value]
      ])), 256))
    ]));
  }
}), pk = /* @__PURE__ */ P(tR, [["__scopeId", "data-v-22817d43"]]), nR = {
  props: {
    row: Object,
    template: String
  },
  render() {
    const e = {
      template: `<div>${this.template}</div>`,
      data: () => ({
        row: this.row
      })
    };
    return ta(e);
  }
}, iR = {
  name: "TableStickyHeaders",
  props: {
    columns: Array,
    rows: Array,
    data: Object
  }
}, oR = {
  role: "region",
  class: "border border-light"
}, rR = { class: "table table-sm bg-white table-bordered table-hover" }, sR = { class: "rotated-title" };
function aR(e, n, t, i, o, r) {
  return u(), c("div", oR, [
    p("table", rR, [
      p("thead", null, [
        p("tr", null, [
          n[0] || (n[0] = p("th", null, null, -1)),
          (u(!0), c(ie, null, se(t.columns, (s, a) => (u(), c("th", {
            key: `head-${a}`
          }, [
            p("div", sR, [
              p("span", null, [
                j(e.$slots, "column", { value: s }, () => [
                  N(E(s), 1)
                ], !0)
              ])
            ])
          ]))), 128))
        ])
      ]),
      p("tbody", null, [
        (u(!0), c(ie, null, se(t.rows, (s, a) => (u(), c("tr", {
          key: `tr-${a}`
        }, [
          p("th", null, [
            j(e.$slots, "row", { value: s }, () => [
              N(E(s), 1)
            ], !0)
          ]),
          (u(!0), c(ie, null, se(t.columns, (l, d) => (u(), c("td", {
            key: `td-${d}`
          }, [
            j(e.$slots, "cell", {
              value: t.data[s][l]
            }, () => [
              N(E(t.data[s][l]), 1)
            ], !0)
          ]))), 128))
        ]))), 128))
      ])
    ])
  ]);
}
const lR = /* @__PURE__ */ P(iR, [["render", aR], ["__scopeId", "data-v-877018ce"]]), uR = {
  key: 1,
  class: "alert alert-warning"
}, dR = {
  key: 2,
  class: "border d-inline-block p-2 bg-white"
}, cR = { class: "aggregate-options" }, fR = { key: 0 }, pR = { key: 1 }, hR = {
  key: 0,
  class: "alert alert-danger"
}, mR = {
  key: 1,
  class: "alert alert-warning"
}, AR = {
  key: 0,
  class: "text-center text-black-50"
}, gR = { key: 1 }, yR = { key: 2 }, KR = /* @__PURE__ */ Se({
  __name: "AggregateTable",
  props: {
    canView: { type: Boolean },
    schemaId: {},
    allColumns: {},
    tableId: {},
    minimumValue: { default: 1 },
    graphqlFilter: { default: () => ({}) }
  },
  setup(e) {
    const n = ["INT", "LONG", "DECIMAL"], t = e, i = fe(""), o = fe(""), r = fe([]), s = fe(!1), a = fe("count"), l = fe(
      t.allColumns.find((x) => n.includes(x.columnType))?.id || ""
    ), d = fe([]), f = fe([]), g = fe({}), A = fe(!1), R = fe(void 0), F = fe(nt.newClient(t.schemaId)), y = xe(() => t.allColumns.filter((x) => n.includes(x.columnType)).map((x) => x.id)), T = xe(() => t.allColumns.reduce((x, $) => (x[$.id] = $, x), {}));
    V();
    async function v() {
      if (s.value = !0, R.value = void 0, d.value = [], f.value = [], g.value = {}, a.value === "sum" && !l.value) {
        s.value = !1;
        return;
      }
      const x = await I(
        T.value[o.value]
      ), $ = await I(
        T.value[i.value]
      );
      F.value.fetchAggregateData(
        t.tableId,
        {
          id: i.value,
          column: $
        },
        {
          id: o.value,
          column: x
        },
        t.graphqlFilter,
        a.value === "sum" ? "_sum" : "count",
        l.value
      ).then((z) => {
        z && z[t.tableId + "_groupBy"] ? (z[t.tableId + "_groupBy"].forEach(
          (X) => M(X)
        ), A.value = !f.value.length) : A.value = !0, s.value = !1;
      }).catch((z) => {
        R.value = z, s.value = !1;
      });
    }
    async function I(x) {
      if (x.columnType.startsWith("ONTOLOGY"))
        return "name";
      if (x.columnType === "REFBACK") {
        const he = await F.value.getPrimaryKeyFields(
          t.schemaId,
          t.tableId
        );
        return `${x.refBackId} { ${he.join(",")} }`;
      }
      const $ = x.refSchemaId || t.schemaId, z = x.refTableId || t.tableId, X = await F.value.getPrimaryKeyFields($, z);
      if (X.length)
        return X.join(",");
      throw new Error(
        `Could not determine primary key for column ${x.id} in table ${z}`
      );
    }
    function M(x) {
      const $ = T.value[o.value], z = T.value[i.value], X = D(z, x), he = D($, x), Ae = a.value === "sum" ? x._sum[l.value] : x[a.value];
      g.value[he] ? g.value[he][X] = Ae : g.value[he] = { [X]: Ae }, f.value.includes(X) || f.value.push(X), d.value.includes(he) || d.value.push(he);
    }
    function D(x, $) {
      const z = $[x.id];
      return z ? x.columnType === "REFBACK" ? z[x.refBackId]?.name || "not specified" : z?.name || "not specified" : "not specified";
    }
    function V() {
      t.allColumns.length > 0 && (r.value = q(
        t.allColumns,
        t.canView
      )), r.value?.length && (i.value = r.value[0], o.value = r.value[1] || r.value[0], v());
    }
    function q(x, $) {
      return x.filter((z) => z.columnType.startsWith("REF") && $ || z.columnType.startsWith("ONTOLOGY") || z.columnType === "RADIO" && $).map((z) => z.id);
    }
    return (x, $) => {
      const z = K("Spinner");
      return u(), c("div", null, [
        s.value ? (u(), k(z, {
          key: 0,
          class: "m-3"
        })) : r.value.length === 0 ? (u(), c("div", uR, " Not enough input to create an aggregate table. Need at least 1 column with permission that can be used as group by. ")) : (u(), c("div", dR, [
          p("div", cR, [
            p("table", null, [
              p("tbody", null, [
                p("tr", null, [
                  $[4] || ($[4] = p("td", null, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3",
                      for: "aggregate-column-select"
                    }, " Column: ")
                  ], -1)),
                  p("td", null, [
                    O(xn, {
                      class: "mb-0",
                      id: "aggregate-column-select",
                      modelValue: i.value,
                      "onUpdate:modelValue": [
                        $[0] || ($[0] = (X) => i.value = X),
                        v
                      ],
                      options: r.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                p("tr", null, [
                  $[5] || ($[5] = p("td", null, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0",
                      for: "aggregate-row-select"
                    }, " Row: ")
                  ], -1)),
                  p("td", null, [
                    O(xn, {
                      class: "mb-2",
                      id: "aggregate-row-select",
                      modelValue: o.value,
                      "onUpdate:modelValue": [
                        $[1] || ($[1] = (X) => o.value = X),
                        v
                      ],
                      options: r.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                y.value.length ? (u(), c("tr", fR, [
                  $[6] || ($[6] = p("td", { class: "align-top" }, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3 pt-0",
                      for: "aggregate-column-select"
                    }, " Aggregate function: ")
                  ], -1)),
                  p("td", null, [
                    O(Fr, {
                      id: "input-radio-2",
                      modelValue: a.value,
                      "onUpdate:modelValue": [
                        $[2] || ($[2] = (X) => a.value = X),
                        v
                      ],
                      options: ["count", "sum"],
                      isClearable: !1
                    }, null, 8, ["modelValue"])
                  ])
                ])) : b("", !0),
                a.value === "sum" ? (u(), c("tr", pR, [
                  $[7] || ($[7] = p("td", { class: "align-top" }, [
                    p("label", {
                      class: "mx-2 col-form-label form-group mb-0 mr-3 pt-0",
                      for: "aggregate-column-select"
                    }, " Summation field: ")
                  ], -1)),
                  p("td", null, [
                    O(xn, {
                      class: "mb-2",
                      id: "aggregate-row-select",
                      modelValue: l.value,
                      "onUpdate:modelValue": [
                        $[3] || ($[3] = (X) => l.value = X),
                        v
                      ],
                      options: y.value,
                      required: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])) : b("", !0)
              ])
            ])
          ]),
          R.value ? (u(), c("div", hR, E(R.value), 1)) : A.value ? (u(), c("div", mR, " No results found ")) : (u(), k(lR, {
            key: 2,
            columns: f.value,
            rows: d.value,
            data: g.value,
            class: "mb-n3"
          }, {
            column: w((X) => [
              N(E(X.value), 1)
            ]),
            row: w((X) => [
              N(E(X.value), 1)
            ]),
            cell: w((X) => [
              X.value ? X.value < e.minimumValue ? (u(), c("div", gR, "﹤" + E(e.minimumValue), 1)) : (u(), c("div", yR, E(X.value), 1)) : (u(), c("div", AR, "-"))
            ]),
            _: 1
          }, 8, ["columns", "rows", "data"]))
        ]))
      ]);
    };
  }
}), bR = Se({
  name: "SubTask",
  props: {
    task: {
      type: Object,
      required: !0
    }
  },
  computed: {
    color() {
      switch (this.task.status) {
        case "COMPLETED":
          return "text-success";
        case "ERROR":
          return "text-danger";
        case "WARNING":
          return "text-warning";
        case "SKIPPED":
          return "text-muted";
        default:
          return "text-primary";
      }
    },
    icon() {
      switch (this.task.status) {
        case "COMPLETED":
          return "fa-check";
        case "ERROR":
          return "fa-times";
        case "WARNING":
          return "fa-exclamation-circle";
        case "SKIPPED":
          return "fa-check";
        case "RUNNING":
          return "fa-spinner fa-spin";
        default:
          return "fa-question";
      }
    }
  }
}), vR = { class: "fa-ul" };
function wR(e, n, t, i, o, r) {
  const s = K("SubTask", !0);
  return u(), c("ul", vR, [
    e.task ? (u(), c("li", {
      key: 0,
      class: G(e.color)
    }, [
      p("i", {
        class: G(["fa-li fa", e.icon])
      }, null, 2),
      N(" " + E(e.task.description) + " ", 1),
      (u(!0), c(ie, null, se(e.task.subTasks, (a, l) => (u(), k(s, {
        task: a,
        key: l
      }, null, 8, ["task"]))), 128))
    ], 2)) : b("", !0)
  ]);
}
const CR = /* @__PURE__ */ P(bR, [["render", wR]]), RR = Se({
  name: "Task",
  components: {
    SubTask: CR,
    Spinner: Ut
  },
  props: {
    taskId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      task: null,
      loading: !0,
      error: !1,
      timeoutId: null,
      isMonitoring: !1
    };
  },
  methods: {
    async startMonitorTask() {
      for (this.isMonitoring = !0; this.isMonitoring && (!this.error && !this.task || this.task && !["COMPLETED", "ERROR", "CANCELLED"].includes(this.task.status)); ) {
        const e = `{
          _tasks(id:"${this.taskId}")
          {
            id, description, status, subTasks
            {
              id, description, status, subTasks
              {
                id, description, status, subTasks
                {
                  id, description, status, subTasks
                    {
                      id, description, status
                    }
                }
              }
            }
          }
        }`;
        Ge("graphql", e).then((n) => {
          this.task = n._tasks[0], this.$emit("taskUpdated", this.task), this.loading = !1;
        }).catch((n) => {
          console.log(JSON.stringify(n)), this.error = n, this.loading = !1;
        }), await new Promise((n) => {
          this.timeoutId = setTimeout(n, 500);
        });
      }
    }
  },
  created() {
    this.startMonitorTask();
  },
  beforeUnmount() {
    this.isMonitoring = !1, this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
}), FR = { key: 2 };
function kR(e, n, t, i, o, r) {
  const s = K("Spinner"), a = K("SubTask");
  return u(), c("div", null, [
    e.loading ? (u(), k(s, { key: 0 })) : e.task ? (u(), k(a, {
      key: 1,
      task: e.task
    }, null, 8, ["task"])) : (u(), c("span", FR, "Task with id = '" + E(e.taskId) + "' not found", 1))
  ]);
}
const Zl = /* @__PURE__ */ P(RR, [["render", kR]]), UR = {
  props: {
    row: Object,
    col: Object
  },
  components: {
    HyperlinkDisplay: Sr,
    EmailDisplay: Er,
    FileDisplay: Nl
  },
  methods: {
    applyJsTemplate: nn,
    getValue(e, n) {
      return this.getRefLabel(e) ? nn(n[e.id], this.getRefLabel(e)) : n[e.id];
    },
    getRefLabel(e) {
      return e.refLabel ? e.refLabel : e.refLabelDefault;
    }
  }
}, ER = { key: 0 }, SR = { key: 2 }, TR = { key: 1 }, IR = { key: 3 };
function DR(e, n, t, i, o, r) {
  const s = K("HyperlinkDisplay"), a = K("EmailDisplay"), l = K("FileDisplay");
  return t.row[t.col.id] && Array.isArray(t.row[t.col.id]) ? (u(), c("span", ER, [
    (u(!0), c(ie, null, se(t.row[t.col.id], (d, f) => (u(), c("span", {
      key: f,
      class: "pr-1"
    }, [
      t.col.columnType === "HYPERLINK_ARRAY" ? (u(), k(s, {
        key: 0,
        data: d
      }, null, 8, ["data"])) : t.col.columnType === "EMAIL_ARRAY" ? (u(), k(a, {
        key: 1,
        data: d
      }, null, 8, ["data"])) : (u(), c("span", SR, E(r.getRefLabel(t.col) ? r.applyJsTemplate(d, r.getRefLabel(t.col)) : d), 1))
    ]))), 128))
  ])) : t.row[t.col.id] ? (u(), c("span", TR, [
    t.col.columnType === "HYPERLINK" ? (u(), k(s, {
      key: 0,
      data: t.row[t.col.id]
    }, null, 8, ["data"])) : t.col.columnType === "EMAIL" ? (u(), k(a, {
      key: 1,
      data: t.row[t.col.id]
    }, null, 8, ["data"])) : t.col.columnType === "FILE" ? (u(), k(l, {
      key: 2,
      data: t.row[t.col.id],
      metadata: t.col
    }, null, 8, ["data", "metadata"])) : (u(), c("span", IR, E(r.getValue(t.col, t.row)), 1))
  ])) : b("", !0);
}
const OR = /* @__PURE__ */ P(UR, [["render", DR]]), _R = {
  components: {
    RenderValue: OR,
    RowButton: sn,
    VueTemplate: nR
  },
  props: {
    columns: Array,
    tableId: String,
    row: Object,
    template: String,
    canUpdate: Boolean,
    canDelete: Boolean
  },
  methods: {
    getKey(e) {
      let n = {};
      return this.columns.filter((t) => t.key == 1).map((t) => n[t.id] = e[t.id]), n;
    },
    showItem(e, n) {
      return n.showColumn && e[n.id] && n.id != "mg_tableclass";
    }
  }
}, PR = { class: "card" }, MR = { class: "card-text" }, LR = { class: "float-right" }, NR = { key: 1 }, BR = {
  key: 0,
  class: "pr-3 pb-1"
}, xR = {
  key: 1,
  class: "pl-3"
};
function qR(e, n, t, i, o, r) {
  const s = K("RowButton"), a = K("VueTemplate"), l = K("RenderValue");
  return u(), c("div", PR, [
    p("div", {
      class: "card-body",
      onClick: n[4] || (n[4] = (d) => e.$emit("click", t.row))
    }, [
      p("div", MR, [
        p("span", LR, [
          t.canUpdate ? (u(), k(s, {
            key: 0,
            type: "edit",
            class: "d-inline",
            tableId: t.tableId,
            pkey: r.getKey(t.row),
            onClose: n[0] || (n[0] = (d) => e.$emit("reload")),
            onEdit: n[1] || (n[1] = (d) => e.$emit("edit", t.row))
          }, null, 8, ["tableId", "pkey"])) : b("", !0),
          t.canDelete ? (u(), k(s, {
            key: 1,
            type: "delete",
            class: "mt-0",
            tableId: t.tableId,
            pkey: r.getKey(t.row),
            onClose: n[2] || (n[2] = (d) => e.$emit("reload")),
            onDelete: n[3] || (n[3] = (d) => e.$emit("delete", t.row))
          }, null, 8, ["tableId", "pkey"])) : b("", !0)
        ]),
        t.template ? (u(), k(a, {
          key: 0,
          template: t.template,
          row: t.row
        }, null, 8, ["template", "row"])) : (u(), c("dl", NR, [
          (u(!0), c(ie, null, se(t.columns, (d) => (u(), c(ie, {
            key: d.id
          }, [
            r.showItem(t.row, d) ? (u(), c(ie, { key: 0 }, [
              r.showItem(t.row, d) ? (u(), c("dt", BR, E(d.label), 1)) : b("", !0),
              r.showItem(t.row, d) ? (u(), c("dd", xR, [
                O(l, {
                  col: d,
                  row: t.row
                }, null, 8, ["col", "row"])
              ])) : b("", !0)
            ], 64)) : b("", !0)
          ], 64))), 128))
        ]))
      ])
    ])
  ]);
}
const VR = /* @__PURE__ */ P(_R, [["render", qR], ["__scopeId", "data-v-cc98901e"]]), jR = Se({
  name: "RecordCards",
  components: { RowCard: VR },
  props: {
    id: { type: String, required: !0 },
    data: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
    tableId: { type: String, required: !0 },
    canUpdate: { type: Boolean, default: !1 },
    canDelete: { type: Boolean, default: !1 },
    template: { type: String, required: !1 }
  }
}), HR = {
  key: 0,
  class: "alert alert-warning"
};
function GR(e, n, t, i, o, r) {
  const s = K("RowCard");
  return u(), c("div", null, [
    e.data.length ? (u(!0), c(ie, { key: 1 }, se(e.data, (a, l) => (u(), k(s, {
      key: e.id + "-" + l,
      row: a,
      columns: e.columns,
      tableId: e.tableId,
      canUpdate: e.canUpdate,
      canDelete: e.canDelete,
      template: e.template,
      onReload: n[0] || (n[0] = (d) => e.$emit("reload")),
      onEdit: n[1] || (n[1] = (d) => e.$emit("edit", d)),
      onDelete: n[2] || (n[2] = (d) => e.$emit("delete", d)),
      onClick: n[3] || (n[3] = (d) => e.$emit("click", d))
    }, null, 8, ["row", "columns", "tableId", "canUpdate", "canDelete", "template"]))), 128)) : (u(), c("div", HR, "No results found"))
  ]);
}
const QR = /* @__PURE__ */ P(jR, [["render", GR]]), $R = { class: "mb-4" }, JR = { class: "ml-1" }, zR = { class: "table table-sm mb-2" }, WR = { class: "key border-right" }, YR = ["onClick"], XR = {
  key: 0,
  class: "text-black-50"
}, ZR = { key: 0 }, eF = { key: 0 }, tF = { key: 1 }, nF = { key: 0 }, iF = { key: 1 }, oF = /* @__PURE__ */ Se({
  __name: "RefTable",
  props: {
    reference: {},
    tableId: {},
    schema: {},
    showDataOwner: { type: Boolean },
    startsCollapsed: { type: Boolean }
  },
  emits: ["refCellClicked"],
  setup(e, { emit: n }) {
    const t = e, { reference: i, startsCollapsed: o } = Wn(t), r = n;
    let s = xe(() => f(i.value)), a = xe(() => Object.keys(s.value).length > 5);
    const l = fe({});
    t.tableId && t.schema && nt.newClient(t.schema).convertRowToPrimaryKey(i.value, t.tableId).then((y) => {
      l.value = y;
    });
    let d = fe(o.value && a.value);
    function f(F) {
      const y = { ...F };
      return delete y.mg_insertedBy, delete y.mg_insertedOn, delete y.mg_updatedBy, delete y.mg_updatedOn, delete y.mg_draft, delete y.metadata, y;
    }
    function g(F) {
      const y = i.value.metadata;
      if (A(y) && y.columns)
        return y.columns.find((T) => T.id === F) || {};
      throw "Error: Metadata for RefTable not found";
    }
    function A(F) {
      return F.id !== void 0;
    }
    function R(F) {
      const y = i.value, T = y.metadata.columns?.find((v) => v.id === F);
      T && _i(T.columnType) && r("refCellClicked", {
        refColumn: T,
        refTableRow: y
      });
    }
    return (F, y) => (u(), c("div", $R, [
      p("h5", JR, [
        l.value ? (u(), k(Ur, {
          key: 0,
          data: l.value,
          metadata: re(i).metadata,
          class: "mr-1"
        }, null, 8, ["data", "metadata"])) : b("", !0),
        re(a) ? (u(), c("button", {
          key: 1,
          class: "btn p-0 m-0 btn-outline-primary border-0 ml-auto float-right",
          onClick: y[0] || (y[0] = (T) => Ii(d) ? d.value = !re(d) : d = !re(d))
        }, [
          p("i", {
            class: G(`fas fa-fw fa-angle-${re(d) ? "up" : "down"}`)
          }, null, 2)
        ])) : b("", !0)
      ]),
      p("div", null, [
        p("div", {
          class: G({ "collapsed-table": re(d) })
        }, [
          p("table", zR, [
            (u(!0), c(ie, null, se(re(s), (T, v) => (u(), c("tr", null, [
              p("td", WR, E(v), 1),
              p("td", {
                onClick: (I) => R(v),
                class: G({
                  refType: re(_i)(g(v).columnType)
                })
              }, [
                O(Bl, {
                  data: T,
                  metadata: g(v)
                }, null, 8, ["data", "metadata"])
              ], 10, YR)
            ]))), 256))
          ])
        ], 2),
        re(d) ? (u(), c("div", {
          key: 0,
          class: "collapsed-tag border-top rounded-bottom mb-3",
          onClick: y[1] || (y[1] = (T) => Ii(d) ? d.value = !1 : d = !1)
        }, [...y[2] || (y[2] = [
          p("small", { class: "px-3 link-color" }, " Show all records... ", -1)
        ])])) : b("", !0)
      ]),
      e.showDataOwner ? (u(), c("small", XR, [
        re(i).mg_insertedBy ? (u(), c("div", ZR, [
          N(" Inserted by '" + E(re(i).mg_insertedBy) + "' ", 1),
          re(i).mg_insertedOn ? (u(), c("span", eF, " On " + E(new Date(re(i).mg_insertedOn).toLocaleString()), 1)) : b("", !0)
        ])) : b("", !0),
        re(i).mg_updatedBy ? (u(), c("div", tF, [
          N(" Updated by '" + E(re(i).mg_updatedBy) + "' ", 1),
          re(i).mg_updatedOn ? (u(), c("span", nF, " On " + E(new Date(re(i).mg_updatedOn).toLocaleString()), 1)) : b("", !0)
        ])) : b("", !0)
      ])) : b("", !0),
      re(i).mg_draft ? (u(), c("div", iF, [...y[3] || (y[3] = [
        p("span", { class: "badge badge-secondary" }, "Draft", -1)
      ])])) : b("", !0)
    ]));
  }
}), rF = /* @__PURE__ */ P(oF, [["__scopeId", "data-v-029d60a6"]]), sF = {
  class: "modal-dialog modal-dialog-scrollable",
  role: "document"
}, aF = { class: "modal-content" }, lF = { class: "modal-header" }, uF = { class: "modal-title" }, dF = { class: "modal-body bg-light" }, cF = { class: "modal-footer" }, fF = /* @__PURE__ */ Se({
  __name: "SideModal",
  props: {
    label: {},
    isCloseButtonShown: { type: Boolean, default: !0 },
    isVisible: { type: Boolean, default: !0 }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = e, { isVisible: i } = Wn(t);
    let o = fe(!1);
    s(), Xt(i, () => {
      s();
    });
    const r = n;
    Eu(() => {
      document?.addEventListener && document.addEventListener("keydown", a);
    }), Su(() => {
      document?.removeEventListener && document.removeEventListener("keydown", a);
    });
    function s() {
      setTimeout(() => {
        o.value = i.value;
      });
    }
    function a(d) {
      d.key === "Escape" && l();
    }
    function l() {
      o.value = !1, setTimeout(() => {
        r("onClose");
      }, 200);
    }
    return (d, f) => (u(), c("div", {
      class: G(["modal fade", { show: re(o) }])
    }, [
      p("div", sF, [
        p("div", aF, [
          p("div", lF, [
            p("h5", uF, E(e.label), 1),
            e.isCloseButtonShown ? (u(), c("button", {
              key: 0,
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: ve(l, ["prevent"])
            }, [...f[0] || (f[0] = [
              p("span", { "aria-hidden": "true" }, "×", -1)
            ])])) : b("", !0)
          ]),
          p("div", dF, [
            j(d.$slots, "default", {}, void 0, !0)
          ]),
          p("div", cF, [
            j(d.$slots, "footer", { close: l }, void 0, !0)
          ])
        ])
      ])
    ], 2));
  }
}), pF = /* @__PURE__ */ P(fF, [["__scopeId", "data-v-0cf264cb"]]), hF = { key: 0 }, mF = { key: 1 }, AF = { key: 1 }, gF = /* @__PURE__ */ Se({
  __name: "RefSideModal",
  props: {
    column: {},
    rows: { default: () => [] },
    schema: {},
    showDataOwner: { type: Boolean, default: !1 }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = e, { column: i, rows: o } = Wn(t), r = n;
    let s = fe(!0), a = fe([]), l = fe("");
    d(o.value, i.value.refTableId), Xt([i, o], () => {
      d(o.value, i.value.refTableId);
    });
    async function d(R, F, y) {
      const T = y || i.value.refSchemaId || t.schema;
      T && F && (l.value = "", s.value = !0, a.value = await f(T, R, F), s.value = !1);
    }
    async function f(R, F, y) {
      let T = [];
      const v = nt.newClient(R), I = await v.fetchTableMetaData(y);
      for (const M of F) {
        const V = await ni(M, y, R);
        let q = await v.fetchRowData(y, V, 2).catch(A);
        q.metadata = I, T.push(q);
      }
      return T;
    }
    async function g({
      refColumn: R,
      refTableRow: F
    }) {
      const y = R.refTableId, T = R.refSchemaId || i.value.refSchemaId || t.schema;
      if (y && T) {
        const v = [F[R.id]].flat();
        d(v, y, T);
      } else
        l.value = "Failed to load reference data";
    }
    function A(R) {
      l.value = `Failed to load reference data, because: ${R.message}`;
    }
    return (R, F) => (u(), k(pF, {
      label: re(i).label,
      isVisible: !0,
      onOnClose: F[0] || (F[0] = (y) => r("onClose"))
    }, {
      footer: w((y) => [
        O(it, {
          onClick: (T) => y.close()
        }, {
          default: w(() => [...F[1] || (F[1] = [
            N("Close", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: w(() => [
        re(s) ? (u(), c("div", hF, [
          O(Ut)
        ])) : (u(), c("div", mF, [
          re(l) ? (u(), k(At, { key: 0 }, {
            default: w(() => [
              N(E(re(l)), 1)
            ]),
            _: 1
          })) : b("", !0),
          re(a).length ? b("", !0) : (u(), c("div", AF, " The selected reference was not found in the database ")),
          (u(!0), c(ie, null, se(re(a), (y) => (u(), c("div", null, [
            O(rF, {
              reference: y,
              showDataOwner: e.showDataOwner,
              startsCollapsed: re(a).length > 1,
              tableId: re(i).refTableId,
              schemaId: re(i).refSchemaId || t.schema,
              onRefCellClicked: g
            }, null, 8, ["reference", "showDataOwner", "startsCollapsed", "tableId", "schemaId"])
          ]))), 256))
        ]))
      ]),
      _: 1
    }, 8, ["label"]));
  }
}), yF = {
  components: {
    IconAction: Rt,
    ButtonAlt: mt,
    LayoutModal: Et
  },
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expand: !1
    };
  },
  methods: {
    flattenObject: An,
    deselect(e) {
      let n = this.selection;
      n.splice(e, 1), this.$emit("update:selection", n);
    },
    clear() {
      let e = this.selection;
      e.splice(0, e.length), this.$emit("update:selection", e);
    },
    toggle() {
      this.expand = !this.expand;
    }
  },
  emits: ["update:selection"]
}, KF = {
  key: 0,
  class: "badge badge-pill badge-danger",
  style: { top: "-7px", left: "-7px" }
}, bF = { key: 0 };
function vF(e, n, t, i, o, r) {
  const s = K("ButtonAlt"), a = K("IconAction"), l = K("LayoutModal");
  return u(), c("div", null, [
    O(s, { onClick: r.toggle }, {
      default: w(() => [
        n[1] || (n[1] = N(" Selection ", -1)),
        n[2] || (n[2] = p("i", { class: "fa fa-lg fa-check-square-o" }, null, -1)),
        t.selection && t.selection.filter((d) => d != null).length > 0 ? (u(), c("span", KF, E(Array.isArray(t.selection) ? t.selection.filter((d) => d != null).length : 0), 1)) : b("", !0)
      ]),
      _: 1
    }, 8, ["onClick"]),
    o.expand ? (u(), k(l, {
      key: 0,
      onClose: n[0] || (n[0] = (d) => o.expand = !1),
      title: "Show selection"
    }, {
      body: w(() => [
        !Array.isArray(t.selection) || t.selection.filter((d) => d != null).length == 0 ? (u(), c("span", bF, " No items selected ")) : (u(!0), c(ie, { key: 1 }, se(t.selection.filter((d) => d != null), (d, f) => (u(), c("span", {
          class: "btn-outline-primary btn-sm mr-2",
          key: JSON.stringify(d)
        }, [
          N(E(r.flattenObject(d)) + " ", 1),
          O(a, {
            icon: "times",
            onClick: (g) => r.deselect(f)
          }, null, 8, ["onClick"])
        ]))), 128))
      ]),
      footer: w(() => [
        Array.isArray(t.selection) && t.selection.length > 0 ? (u(), k(s, {
          key: 0,
          onClick: r.clear
        }, {
          default: w(() => [...n[3] || (n[3] = [
            N(" clear selection ", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])) : b("", !0)
      ]),
      _: 1
    })) : b("", !0)
  ]);
}
const wF = /* @__PURE__ */ P(yF, [["render", vF]]), CF = {
  components: { ButtonAlt: mt, ButtonDropdown: Lr, IconAction: Rt },
  props: {
    label: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    },
    columns: Array,
    exclude: {
      type: Array,
      default: () => []
    },
    checkAttribute: String,
    defaultValue: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    value(e) {
      return e[this.checkAttribute] == null ? this.defaultValue : e[this.checkAttribute];
    },
    change(e, n) {
      let t = JSON.parse(JSON.stringify(this.columns));
      t[e][this.checkAttribute] = n, this.$emit("update:columns", t);
    },
    hideAll(e) {
      let n = JSON.parse(JSON.stringify(this.columns));
      for (var t in n)
        (e && !n[t].id.startsWith("mg_") || !e && n[t].id.startsWith("mg_")) && (n[t][this.checkAttribute] = !1);
      this.$emit("update:columns", n);
    },
    showAll(e) {
      let n = JSON.parse(JSON.stringify(this.columns));
      for (var t in n)
        (e && !n[t].id.startsWith("mg_") || !e && n[t].id.startsWith("mg_")) && (n[t][this.checkAttribute] = !0);
      this.$emit("update:columns", n);
    }
  },
  emits: ["update:columns"]
}, RF = {
  class: "px-4 py-3",
  style: { "min-width": "15rem" }
}, FF = { key: 0 }, kF = {
  key: 0,
  class: "ml-0"
}, UF = {
  key: 1,
  class: "form-check"
}, EF = ["checked", "onInput", "id"], SF = ["for"];
function TF(e, n, t, i, o, r) {
  const s = K("IconAction"), a = K("ButtonAlt"), l = K("ButtonDropdown");
  return u(), k(l, {
    icon: t.icon,
    label: t.label
  }, {
    default: w((d) => [
      p("form", RF, [
        O(s, {
          icon: "times",
          onClick: d.close,
          class: "float-right"
        }, null, 8, ["onClick"]),
        p("h6", null, E(t.label), 1),
        p("b", null, [
          n[6] || (n[6] = N(" data ( ", -1)),
          O(a, {
            class: "pl-0",
            onClick: n[0] || (n[0] = (f) => r.showAll(!0))
          }, {
            default: w(() => [...n[4] || (n[4] = [
              N("all", -1)
            ])]),
            _: 1
          }),
          O(a, {
            class: "p-0",
            onClick: n[1] || (n[1] = (f) => r.hideAll(!0))
          }, {
            default: w(() => [...n[5] || (n[5] = [
              N("none", -1)
            ])]),
            _: 1
          }),
          n[7] || (n[7] = N(" ) ", -1))
        ]),
        (u(!0), c(ie, null, se(t.columns, (f, g) => (u(), c("div", { key: g }, [
          t.exclude.length == 0 || !t.exclude.includes(f.columnType) ? (u(), c("span", FF, [
            f.id == "mg_draft" ? (u(), c("b", kF, [
              n[10] || (n[10] = N(" metadata ( ", -1)),
              O(a, {
                class: "pl-0",
                onClick: n[2] || (n[2] = (A) => r.showAll(!1))
              }, {
                default: w(() => [...n[8] || (n[8] = [
                  N("all", -1)
                ])]),
                _: 1
              }),
              O(a, {
                class: "p-0",
                onClick: n[3] || (n[3] = (A) => r.hideAll(!1))
              }, {
                default: w(() => [...n[9] || (n[9] = [
                  N("none", -1)
                ])]),
                _: 1
              }),
              n[11] || (n[11] = N(" ) ", -1))
            ])) : b("", !0),
            f.columnType != "HEADING" ? (u(), c("div", UF, [
              p("input", {
                class: "form-check-input",
                type: "checkbox",
                checked: f[t.checkAttribute] == null ? t.defaultValue : f[t.checkAttribute],
                onInput: ve((A) => r.change(g, !f[t.checkAttribute]), ["prevent"]),
                id: f.id
              }, null, 40, EF),
              p("label", {
                class: "form-check-label",
                for: f.id
              }, E(f.label), 9, SF)
            ])) : b("", !0)
          ])) : b("", !0)
        ]))), 128))
      ])
    ]),
    _: 1
  }, 8, ["icon", "label"]);
}
const IF = /* @__PURE__ */ P(CF, [["render", TF]]), DF = {
  name: "TableSettings",
  components: {
    Spinner: Ut,
    MessageError: At,
    MessageSuccess: Fn,
    IconAction: Rt,
    InputText: ri,
    ButtonAction: it,
    LayoutModal: Et,
    ButtonAlt: mt
  },
  props: {
    schemaId: {
      type: String,
      required: !1
    },
    tableMetadata: { type: Object, required: !0 }
  },
  data() {
    return {
      show: !1,
      graphqlError: null,
      success: null,
      loading: !1
    };
  },
  computed: {
    cardTemplate() {
      return this.tableMetadata.settings?.filter((e) => e.key === "cardTemplate").map((e) => e.value)[0];
    },
    recordTemplate() {
      return this.tableMetadata.settings?.filter((e) => e.key === "recordTemplate").map((e) => e.value)[0];
    }
  },
  methods: {
    emitCardTemplate(e) {
      this.tableMetadata.settings || (this.tableMetadata.settings = []), this.tableMetadata.settings = this.tableMetadata.settings.filter(
        (n) => n.key !== "cardTemplate"
      ), this.tableMetadata.settings.push({ key: "cardTemplate", value: e });
    },
    emitRecordTemplate(e) {
      this.tableMetadata.settings || (this.tableMetadata.settings = []), this.tableMetadata.settings = this.tableMetadata.settings.filter(
        (n) => n.key !== "recordTemplate"
      ), this.tableMetadata.settings.push({ key: "recordTemplate", value: e });
    },
    async saveSettings() {
      this.loading = !0, this.graphqlError = null, this.success = null;
      const e = this.tableMetadata.settings.map((t) => ({
        tableId: this.tableMetadata.id,
        key: t.key,
        value: t.value
      })), n = await Ge(
        this.schemaId ? "/" + this.schemaId + "/graphql" : "graphql",
        "mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}",
        { settings: e }
      ).catch((t) => {
        this.graphqlError = t.errors[0].message;
      });
      this.success = n.change.message, this.loading = !1, this.$emit("update:settings");
    }
  },
  created() {
    this.tableMetadata && !this.tableMetadata.settings && (this.tableMetadata.settings = []);
  },
  emits: ["update:settings"]
}, OF = { key: 3 };
function _F(e, n, t, i, o, r) {
  const s = K("IconAction"), a = K("MessageSuccess"), l = K("MessageError"), d = K("Spinner"), f = K("InputText"), g = K("ButtonAlt"), A = K("ButtonAction"), R = K("LayoutModal");
  return o.show ? (u(), k(R, {
    key: 1,
    title: "Table Settings",
    onClose: n[2] || (n[2] = (F) => o.show = !1),
    show: o.show
  }, {
    body: w(() => [
      o.success ? (u(), k(a, { key: 0 }, {
        default: w(() => [
          N(E(o.success), 1)
        ]),
        _: 1
      })) : b("", !0),
      o.graphqlError ? (u(), k(l, { key: 1 }, {
        default: w(() => [
          N(E(o.graphqlError), 1)
        ]),
        _: 1
      })) : b("", !0),
      o.loading ? (u(), k(d, { key: 2 })) : (u(), c("form", OF, [
        n[5] || (n[5] = p("p", null, [
          N(" The data is in variable 'row'. For example, "),
          p("tt", null, "{{ row }}"),
          N(" will show all values available. "),
          p("tt", null, "{{ row.name }}"),
          N(" will get the 'name' column ")
        ], -1)),
        O(f, {
          id: "table-settings-card-template",
          name: "cardTemplate",
          label: "cardTemplate",
          modelValue: r.cardTemplate,
          "onUpdate:modelValue": r.emitCardTemplate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        O(f, {
          id: "table-settings-record-template",
          name: "recordTemplate",
          label: "recordTemplate",
          modelValue: r.recordTemplate,
          "onUpdate:modelValue": r.emitRecordTemplate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        O(g, {
          onClick: n[1] || (n[1] = (F) => o.show = !1)
        }, {
          default: w(() => [...n[3] || (n[3] = [
            N("Close", -1)
          ])]),
          _: 1
        }),
        O(A, { onClick: r.saveSettings }, {
          default: w(() => [...n[4] || (n[4] = [
            N("Save settings", -1)
          ])]),
          _: 1
        }, 8, ["onClick"])
      ]))
    ]),
    _: 1
  }, 8, ["show"])) : (u(), k(s, {
    key: 0,
    icon: "cog",
    onClick: n[0] || (n[0] = (F) => o.show = !0)
  }));
}
const PF = /* @__PURE__ */ P(DF, [["render", _F]]), zt = {
  TABLE: "table",
  CARDS: "cards",
  RECORD: "record",
  AGGREGATE: "aggregate"
}, MF = {
  table: { id: zt.TABLE, label: "Table", icon: "th" },
  cards: { id: zt.CARDS, label: "Card", icon: "list-alt" },
  record: {
    id: zt.RECORD,
    label: "Record",
    icon: "th-list",
    limitOverride: 1
  },
  aggregate: {
    id: zt.AGGREGATE,
    label: "Aggregate",
    icon: "object-group"
  }
}, LF = {
  name: "TableExplorer",
  components: {
    LayoutModal: Et,
    Task: Zl,
    ShowHide: IF,
    Pagination: xl,
    ButtonAlt: mt,
    ButtonDropdown: Lr,
    IconAction: Rt,
    IconDanger: Rr,
    InputSearch: Ir,
    InputSelect: xn,
    MessageError: At,
    SelectionBox: wF,
    Spinner: Ut,
    TableMolgenis: Tr,
    FilterSidebar: hv,
    FilterWells: vv,
    RecordCards: QR,
    RowButton: sn,
    TableSettings: PF,
    EditModal: Nr,
    ConfirmModal: Dr,
    AggregateTable: KR,
    RefSideModal: gF
  },
  data() {
    return {
      cardTemplate: "",
      client: null,
      columns: [],
      count: 0,
      dataRows: [],
      editMode: "add",
      // add, edit, clone
      editRowPrimaryKey: void 0,
      graphqlError: "",
      taskId: "",
      taskDone: !1,
      success: !1,
      isDeleteAllModalShown: !1,
      isTaskModalShown: !1,
      isDeleteModalShown: !1,
      cascadeDeleteMsg: "",
      isEditModalShown: !1,
      limit: this.showLimit,
      loading: !1,
      order: this.showOrder,
      orderByColumn: this.showOrderBy,
      page: this.showPage,
      recordTemplate: "",
      searchTerms: "",
      selectedItems: [],
      tableMetadata: null,
      view: this.canView ? this.showView : zt.AGGREGATE,
      refSideModalProps: void 0
    };
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      default: () => ""
    },
    showSelect: {
      type: Boolean,
      default: () => !1
    },
    showHeader: {
      type: Boolean,
      default: () => !0
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    },
    showView: {
      type: String,
      default: zt.TABLE
    },
    showPage: {
      type: Number,
      default: 1
    },
    showLimit: {
      type: Number,
      default: 10
    },
    urlConditions: {
      type: Object,
      default: () => ({})
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    showOrderBy: {
      type: String,
      required: !1
    },
    showOrder: {
      type: String,
      default: () => "ASC"
    },
    canView: {
      type: Boolean,
      default: () => !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    canInsert: {
      type: Boolean,
      default: () => !1
    },
    canUpdate: {
      type: Boolean,
      default: () => !1
    },
    canDelete: {
      type: Boolean,
      default: () => !1
    },
    canManage: {
      type: Boolean,
      default: () => !1
    },
    isRowLevel: {
      type: Boolean,
      default: () => !1
    },
    userRoles: {
      type: Array,
      default: () => []
    },
    tablePermissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    View() {
      return zt;
    },
    ViewButtons() {
      return MF;
    },
    filterCount() {
      return this.columns?.filter((e) => e.showFilter).length || 0;
    },
    graphqlFilter() {
      let e = this.filter;
      const n = (t) => {
        this.graphqlError = t;
      };
      return hf(e, this.columns, n);
    },
    rowsWithComputed() {
      return this.tableMetadata ? el(this.dataRows, this.tableMetadata) : [];
    }
  },
  methods: {
    convertRowToPrimaryKey: dn,
    rowMatchesUserRole(e) {
      const n = e.mg_roles || [];
      return this.userRoles.some((t) => n.includes(t));
    },
    canEditRow(e) {
      return this.canUpdate && (!this.isRowLevel || this.rowMatchesUserRole(e));
    },
    canDeleteRow(e) {
      return this.canDelete && (!this.isRowLevel || this.rowMatchesUserRole(e));
    },
    canCloneRow(e) {
      return this.canInsert && (!this.isRowLevel || this.rowMatchesUserRole(e));
    },
    setSearchTerms(e) {
      this.searchTerms = e, this.$emit("searchTerms", e), this.reload();
    },
    taskUpdated(e) {
      ["COMPLETED", "ERROR"].includes(e.status) && (this.success = !0, this.taskDone = !0, this.reload());
    },
    async handleRowAction(e, n) {
      this.editMode = e, this.editRowPrimaryKey = await n, this.isEditModalShown = !0;
    },
    handleModalClose() {
      this.isEditModalShown = !1, this.reload();
    },
    async handleDeleteRowRequest(e) {
      this.editRowPrimaryKey = await e;
      const n = await this.client.fetchCascadeDeleteMsg(this.tableId).catch((t) => (this.handleError(t), ""));
      this.cascadeDeleteMsg = n, this.isDeleteModalShown = !0;
    },
    async handleExecuteDelete() {
      this.isDeleteModalShown = !1, this.cascadeDeleteMsg = "", await this.client?.deleteRow(this.editRowPrimaryKey, this.tableId).catch(this.handleError) && this.reload();
    },
    async handelExecuteDeleteAll() {
      await this.client.deleteAllTableData(this.tableMetadata?.id).then((e) => {
        e.data.data.truncate.taskId ? (this.taskId = e.data.data.truncate.taskId, this.isTaskModalShown = !0, this.isDeleteAllModalShown = !1) : (this.success = e.data.data.truncate.message, this.loading = !1);
      }).catch((e) => {
        this.isDeleteAllModalShown = !1, this.handleError(e);
      });
    },
    handleCellClick(e) {
      const { column: n, cellValue: t } = e, i = [t].flat();
      _i(n?.columnType) && (this.refSideModalProps = {
        column: n,
        rows: i
      });
    },
    setView(e) {
      this.view = e.id, e.limitOverride ? this.limit = e.limitOverride : this.limit = this.showLimit, this.page = 1, this.$emit("updateShowView", e.id, this.limit), this.reload();
    },
    onColumnClick(e) {
      const n = this.orderByColumn;
      let t = this.order;
      n !== e.id ? t = "ASC" : t === "ASC" ? t = "DESC" : t = "ASC", this.order = t, this.orderByColumn = e.id, this.$emit("updateShowOrder", {
        direction: t,
        column: e.id
      }), this.reload();
    },
    emitColumns(e) {
      this.columns = e, this.$emit("updateShowColumns", Zs(this.columns, "showColumn"));
    },
    emitFilters(e) {
      this.columns = e, this.$emit("updateShowFilters", Zs(e, "showFilter"));
    },
    emitConditions() {
      this.page = 1, this.$emit("updateConditions", this.columns), this.reload();
    },
    setPage(e) {
      this.page = e, this.$emit("updateShowPage", e), this.reload();
    },
    setLimit(e) {
      this.limit = parseInt(e), (!Number.isInteger(this.limit) || this.limit < 1) && (this.limit = 20), this.page = 1, this.$emit("updateShowLimit", e), this.reload();
    },
    handleError(e) {
      if (Array.isArray(e?.response?.data?.errors)) {
        const n = e.response.data.errors[0].message;
        n.includes("FieldUndefined") ? this.graphqlError = "This table contains a reference to data you don't have permission to view. Contact your administrator to request access." : this.graphqlError = n;
      } else
        this.graphqlError = e;
      this.loading = !1;
    },
    setTableMetadata(e) {
      this.columns = e.columns.map((n) => {
        const t = this.showColumns.length ? this.showColumns.includes(n.id) : !n.id.startsWith("mg_"), i = NF(
          n.columnType,
          this.urlConditions[n.id]
        );
        return {
          ...n,
          showColumn: t,
          showFilter: this.showFilters.includes(n.id),
          conditions: i
        };
      }), e.settings?.forEach((n) => {
        n.key === "cardTemplate" ? this.cardTemplate = n.value : n.key === "recordTemplate" && (this.recordTemplate = n.value);
      }), this.tableMetadata = e;
    },
    async reloadMetadata() {
      this.client = nt.newClient(this.schemaId);
      const e = await this.client.fetchTableMetaData(this.tableId).catch(this.handleError);
      this.setTableMetadata(e), this.canView && this.reload();
    },
    async reload() {
      if (!this.canView) return;
      this.loading = !0, this.graphqlError = "";
      const e = this.limit * (this.page - 1), n = this.orderByColumn ? { [this.orderByColumn]: this.order } : {}, t = await this.client.fetchTableData(this.tableId, {
        limit: this.limit,
        offset: e,
        filter: this.graphqlFilter,
        searchTerms: this.searchTerms,
        orderby: n
      }).catch(this.handleError);
      this.dataRows = t[this.tableId], this.count = t[this.tableId + "_agg"].count, this.loading = !1;
    }
  },
  mounted: async function() {
    await this.reloadMetadata();
  },
  emits: [
    "updateShowFilters",
    "rowClick",
    "updateShowLimit",
    "updateShowPage",
    "updateConditions",
    "updateShowColumns",
    "updateShowOrder",
    "updateShowView",
    "searchTerms"
  ]
};
function Zs(e, n) {
  return e.filter(
    (t) => (
      //@ts-ignore TODO: remove column input modification in TableMolgenis
      t[n] && t.columnType !== "HEADING" && t.columnType !== "SECTION"
    )
  ).map((t) => t.id);
}
function NF(e, n) {
  if (n)
    switch (e) {
      case "REF":
      case "REF_ARRAY":
      case "REFBACK":
      case "ONTOLOGY":
      case "ONTOLOGY_ARRAY":
      case "RADIO":
      case "SELECT":
      case "MULTISELECT":
      case "CHECKBOX":
        return JSON.parse(n);
      case "DATE":
      case "DATETIME":
      case "INT":
      case "LONG":
      case "DECIMAL":
        return n.split(",").map((t) => t.split(".."));
      default:
        return n.split(",");
    }
  else
    return [];
}
const BF = { key: 0 }, xF = { key: 1 }, qF = { key: 2 }, VF = { class: "btn-toolbar mb-3" }, jF = { class: "btn-group" }, HF = {
  class: "px-4 py-3",
  style: { "min-width": "15rem" }
}, GF = { key: 0 }, QF = { key: 0 }, $F = { key: 2 }, JF = ["onClick"], zF = {
  key: 2,
  class: "btn-group m-0"
}, WF = {
  key: 3,
  class: "btn-group"
}, YF = { class: "d-flex" }, XF = {
  key: 0,
  class: "col-3 pl-0"
}, ZF = { key: 0 }, e1 = { key: 1 };
function t1(e, n, t, i, o, r) {
  const s = K("MessageError"), a = K("ShowHide"), l = K("IconAction"), d = K("ButtonAlt"), f = K("ButtonDropdown"), g = K("InputSearch"), A = K("Pagination"), R = K("InputSelect"), F = K("SelectionBox"), y = K("TableSettings"), T = K("IconDanger"), v = K("FilterSidebar"), I = K("FilterWells"), M = K("Spinner"), D = K("AggregateTable"), V = K("RecordCards"), q = K("RowButton"), x = K("TableMolgenis"), $ = K("EditModal"), z = K("ConfirmModal"), X = K("Task"), he = K("LayoutModal"), Ae = K("RefSideModal");
  return o.tableMetadata ? (u(), c("div", BF, [
    o.graphqlError ? (u(), k(s, { key: 0 }, {
      default: w(() => [
        N(E(o.graphqlError), 1)
      ]),
      _: 1
    })) : b("", !0),
    t.showHeader && o.tableMetadata ? (u(), c("h1", xF, E(o.tableMetadata.label), 1)) : b("", !0),
    t.showHeader && o.tableMetadata ? (u(), c("p", qF, E(o.tableMetadata.label), 1)) : b("", !0),
    p("div", VF, [
      p("div", jF, [
        O(a, {
          columns: o.columns,
          "onUpdate:columns": r.emitFilters,
          checkAttribute: "showFilter",
          exclude: ["HEADING", "FILE", "SECTION"],
          label: "filters",
          icon: "filter"
        }, null, 8, ["columns", "onUpdate:columns"]),
        o.view !== r.View.AGGREGATE ? (u(), k(a, {
          key: 0,
          columns: o.columns,
          "onUpdate:columns": r.emitColumns,
          checkAttribute: "showColumn",
          exclude: ["HEADING", "SECTION"],
          label: "columns",
          icon: "columns",
          id: "showColumn",
          defaultValue: !0
        }, null, 8, ["columns", "onUpdate:columns"])) : b("", !0),
        t.canView ? (u(), k(f, {
          key: 1,
          label: "download",
          icon: "download"
        }, {
          default: w((H) => [
            p("form", HF, [
              O(l, {
                icon: "times",
                onClick: H.close,
                class: "float-right"
              }, null, 8, ["onClick"]),
              n[33] || (n[33] = p("h6", null, "download", -1)),
              p("div", null, [
                p("div", null, [
                  n[20] || (n[20] = p("span", { class: "fixed-width" }, "zip", -1)),
                  O(d, {
                    href: "/" + t.schemaId + "/api/zip/" + t.tableId
                  }, {
                    default: w(() => [...n[19] || (n[19] = [
                      N(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ]),
                p("div", null, [
                  n[24] || (n[24] = p("span", { class: "fixed-width" }, "csv", -1)),
                  O(d, {
                    href: "/" + t.schemaId + "/api/csv/" + t.tableId
                  }, {
                    default: w(() => [...n[21] || (n[21] = [
                      N(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"]),
                  Object.keys(r.graphqlFilter).length > 0 ? (u(), c("span", GF, [
                    n[23] || (n[23] = N(" | ", -1)),
                    O(d, {
                      href: "/" + t.schemaId + "/api/csv/" + t.tableId + "?filter=" + JSON.stringify(r.graphqlFilter)
                    }, {
                      default: w(() => [...n[22] || (n[22] = [
                        N(" filtered rows ", -1)
                      ])]),
                      _: 1
                    }, 8, ["href"])
                  ])) : b("", !0)
                ]),
                p("div", null, [
                  n[28] || (n[28] = p("span", { class: "fixed-width" }, "excel", -1)),
                  O(d, {
                    href: "/" + t.schemaId + "/api/excel/" + t.tableId
                  }, {
                    default: w(() => [...n[25] || (n[25] = [
                      N("all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"]),
                  Object.keys(r.graphqlFilter).length > 0 ? (u(), c("span", QF, [
                    n[27] || (n[27] = N(" | ", -1)),
                    O(d, {
                      href: "/" + t.schemaId + "/api/excel/" + t.tableId + "?filter=" + JSON.stringify(r.graphqlFilter)
                    }, {
                      default: w(() => [...n[26] || (n[26] = [
                        N(" filtered rows ", -1)
                      ])]),
                      _: 1
                    }, 8, ["href"])
                  ])) : b("", !0)
                ]),
                p("div", null, [
                  n[30] || (n[30] = p("span", { class: "fixed-width" }, "jsonld", -1)),
                  O(d, {
                    href: "/" + t.schemaId + "/api/jsonld/" + t.tableId
                  }, {
                    default: w(() => [...n[29] || (n[29] = [
                      N(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ]),
                p("div", null, [
                  n[32] || (n[32] = p("span", { class: "fixed-width" }, "ttl", -1)),
                  O(d, {
                    href: "/" + t.schemaId + "/api/ttl/" + t.tableId
                  }, {
                    default: w(() => [...n[31] || (n[31] = [
                      N(" all rows ", -1)
                    ])]),
                    _: 1
                  }, 8, ["href"])
                ])
              ])
            ])
          ]),
          _: 1
        })) : b("", !0),
        t.canView ? (u(), c("span", $F, [
          O(f, {
            closeOnClick: !0,
            label: r.ViewButtons[o.view].label,
            icon: r.ViewButtons[o.view].icon
          }, {
            default: w(() => [
              (u(!0), c(ie, null, se(r.ViewButtons, (H) => (u(), c("div", {
                class: "dropdown-item",
                onClick: (we) => r.setView(H),
                role: "button"
              }, [
                p("i", {
                  class: G(["fas fa-fw", "fa-" + H.icon])
                }, null, 2),
                N(" " + E(H.label), 1)
              ], 8, JF))), 256))
            ]),
            _: 1
          }, 8, ["label", "icon"])
        ])) : b("", !0)
      ]),
      t.canView ? (u(), k(g, {
        key: 0,
        class: "mx-1 inline-form-group",
        id: "explorer-table-search" + Date.now(),
        modelValue: o.searchTerms,
        "onUpdate:modelValue": n[0] || (n[0] = (H) => r.setSearchTerms(H))
      }, null, 8, ["id", "modelValue"])) : b("", !0),
      o.view !== r.View.AGGREGATE ? (u(), k(A, {
        key: 1,
        modelValue: o.page,
        "onUpdate:modelValue": n[1] || (n[1] = (H) => r.setPage(H)),
        limit: o.limit,
        count: o.count
      }, null, 8, ["modelValue", "limit", "count"])) : b("", !0),
      o.view !== r.View.RECORD && o.view !== r.View.AGGREGATE ? (u(), c("div", zF, [
        n[34] || (n[34] = p("span", { class: "btn" }, "Rows per page:", -1)),
        O(R, {
          id: "explorer-table-page-limit-select",
          modelValue: o.limit,
          options: [10, 20, 50, 100],
          clear: !1,
          required: !0,
          "onUpdate:modelValue": n[2] || (n[2] = (H) => r.setLimit(H)),
          class: "mb-0"
        }, null, 8, ["modelValue"]),
        t.showSelect ? (u(), k(F, {
          key: 0,
          selection: o.selectedItems,
          "onUpdate:selection": n[3] || (n[3] = (H) => o.selectedItems = H)
        }, null, 8, ["selection"])) : b("", !0)
      ])) : b("", !0),
      t.canManage ? (u(), c("div", WF, [
        o.tableMetadata ? (u(), k(y, {
          key: 0,
          tableMetadata: o.tableMetadata,
          schemaId: t.schemaId,
          "onUpdate:settings": r.reloadMetadata
        }, null, 8, ["tableMetadata", "schemaId", "onUpdate:settings"])) : b("", !0),
        O(T, {
          icon: "bomb",
          onClick: n[4] || (n[4] = (H) => o.isDeleteAllModalShown = !0)
        }, {
          default: w(() => [...n[35] || (n[35] = [
            N(" Delete All ", -1)
          ])]),
          _: 1
        })
      ])) : b("", !0)
    ]),
    p("div", YF, [
      r.filterCount ? (u(), c("div", XF, [
        O(v, {
          filters: o.columns,
          onUpdateFilters: r.emitConditions,
          schemaId: t.schemaId
        }, null, 8, ["filters", "onUpdateFilters", "schemaId"])
      ])) : b("", !0),
      p("div", {
        class: G(["flex-grow-1 pr-0 pl-0", r.filterCount ? "col-9" : "col-12"])
      }, [
        O(I, {
          filters: o.columns,
          onUpdateFilters: r.emitConditions,
          class: "border-top pt-3 pb-3"
        }, null, 8, ["filters", "onUpdateFilters"]),
        o.loading ? (u(), c("div", ZF, [
          O(M)
        ])) : b("", !0),
        o.loading ? b("", !0) : (u(), c("div", e1, [
          o.view === r.View.AGGREGATE ? (u(), k(D, {
            key: 0,
            canView: t.canView,
            allColumns: o.columns,
            tableId: t.tableId,
            schemaId: t.schemaId,
            minimumValue: 1,
            graphqlFilter: r.graphqlFilter
          }, null, 8, ["canView", "allColumns", "tableId", "schemaId", "graphqlFilter"])) : b("", !0),
          o.view === r.View.CARDS ? (u(), k(V, {
            key: 1,
            class: "card-columns",
            id: "cards",
            data: r.rowsWithComputed,
            columns: o.columns,
            tableId: t.tableId,
            canUpdate: t.canUpdate,
            canDelete: t.canDelete,
            template: o.cardTemplate,
            onClick: n[5] || (n[5] = (H) => e.$emit("rowClick", H)),
            onReload: r.reload,
            onEdit: n[6] || (n[6] = (H) => r.handleRowAction(
              "edit",
              r.convertRowToPrimaryKey(H, o.tableMetadata.id, t.schemaId)
            )),
            onDelete: n[7] || (n[7] = (H) => r.handleDeleteRowRequest(
              r.convertRowToPrimaryKey(H, o.tableMetadata.id, t.schemaId)
            ))
          }, null, 8, ["data", "columns", "tableId", "canUpdate", "canDelete", "template", "onReload"])) : b("", !0),
          o.view === r.View.RECORD ? (u(), k(V, {
            key: 2,
            id: "records",
            data: r.rowsWithComputed,
            columns: o.columns,
            tableId: t.tableId,
            canEdit: t.canEdit,
            template: o.recordTemplate,
            onClick: n[8] || (n[8] = (H) => e.$emit("rowClick", H)),
            onReload: r.reload,
            onEdit: n[9] || (n[9] = (H) => r.handleRowAction(
              "edit",
              r.convertRowToPrimaryKey(H, o.tableMetadata.id, t.schemaId)
            )),
            onDelete: n[10] || (n[10] = (H) => r.handleDeleteRowRequest(
              r.convertRowToPrimaryKey(H, o.tableMetadata.id, t.schemaId)
            ))
          }, null, 8, ["data", "columns", "tableId", "canEdit", "template", "onReload"])) : b("", !0),
          o.view === r.View.TABLE ? (u(), k(x, {
            key: 3,
            schemaId: t.schemaId,
            selection: o.selectedItems,
            "onUpdate:selection": n[12] || (n[12] = (H) => o.selectedItems = H),
            columns: o.columns,
            "onUpdate:columns": n[13] || (n[13] = (H) => o.columns = H),
            "table-metadata": o.tableMetadata,
            data: r.rowsWithComputed,
            showSelect: t.showSelect,
            onColumnClick: r.onColumnClick,
            onRowClick: n[14] || (n[14] = (H) => e.$emit("rowClick", H)),
            onCellClick: r.handleCellClick
          }, {
            header: w(() => [
              p("label", null, E(o.count) + " records found", 1)
            ]),
            rowcolheader: w(() => [
              t.canInsert ? (u(), k(q, {
                key: 0,
                type: "add",
                tableId: t.tableId,
                schemaId: t.schemaId,
                onAdd: n[11] || (n[11] = (H) => r.handleRowAction("add")),
                class: "d-inline p-0"
              }, null, 8, ["tableId", "schemaId"])) : b("", !0),
              j(e.$slots, "rowcolheader", {}, void 0, !0)
            ]),
            colheader: w((H) => [
              H.col && o.orderByColumn === H.col.id ? (u(), k(l, {
                key: 0,
                icon: o.order === "ASC" ? "sort-alpha-down" : "sort-alpha-up",
                class: "d-inline p-0"
              }, null, 8, ["icon"])) : b("", !0)
            ]),
            rowheader: w((H) => [
              r.canEditRow(H.row) ? (u(), k(q, {
                key: 0,
                type: "edit",
                onEdit: (we) => r.handleRowAction(
                  "edit",
                  r.convertRowToPrimaryKey(
                    H.row,
                    o.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onEdit"])) : b("", !0),
              r.canCloneRow(H.row) ? (u(), k(q, {
                key: 1,
                type: "clone",
                onClone: (we) => r.handleRowAction(
                  "clone",
                  r.convertRowToPrimaryKey(
                    H.row,
                    o.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onClone"])) : b("", !0),
              r.canDeleteRow(H.row) ? (u(), k(q, {
                key: 2,
                type: "delete",
                onDelete: (we) => r.handleDeleteRowRequest(
                  r.convertRowToPrimaryKey(
                    H.row,
                    o.tableMetadata.id,
                    t.schemaId
                  )
                )
              }, null, 8, ["onDelete"])) : b("", !0),
              j(e.$slots, "rowheader", {
                row: H.row,
                metadata: o.tableMetadata,
                rowKey: r.convertRowToPrimaryKey(
                  H.row,
                  o.tableMetadata.id,
                  t.schemaId
                )
              }, void 0, !0)
            ]),
            _: 3
          }, 8, ["schemaId", "selection", "columns", "table-metadata", "data", "showSelect", "onColumnClick", "onCellClick"])) : b("", !0)
        ]))
      ], 2)
    ]),
    o.isEditModalShown ? (u(), k($, {
      key: 3,
      isModalShown: !0,
      id: t.tableId + "-edit-modal",
      tableId: t.tableId,
      tableLabel: o.tableMetadata.label,
      pkey: o.editRowPrimaryKey,
      clone: o.editMode === "clone",
      schemaId: t.schemaId,
      tablePermissions: t.tablePermissions,
      onClose: r.handleModalClose,
      "apply-default-values": o.editMode === "add"
    }, null, 8, ["id", "tableId", "tableLabel", "pkey", "clone", "schemaId", "tablePermissions", "onClose", "apply-default-values"])) : b("", !0),
    o.isDeleteModalShown ? (u(), k(z, {
      key: 4,
      title: "Delete from " + o.tableMetadata.label,
      actionLabel: "Delete",
      actionType: "danger",
      tableId: t.tableId,
      tableLabel: o.tableMetadata.label,
      pkey: o.editRowPrimaryKey,
      additionalMsg: o.cascadeDeleteMsg,
      onClose: n[15] || (n[15] = (H) => o.isDeleteModalShown = !1),
      onConfirmed: r.handleExecuteDelete
    }, null, 8, ["title", "tableId", "tableLabel", "pkey", "additionalMsg", "onConfirmed"])) : b("", !0),
    o.isDeleteAllModalShown ? (u(), k(z, {
      key: 5,
      title: "Truncate " + o.tableMetadata.label,
      actionLabel: "Truncate",
      actionType: "danger",
      tableId: t.tableId,
      tableLabel: o.tableMetadata.label,
      onClose: n[16] || (n[16] = (H) => o.isDeleteAllModalShown = !1),
      onConfirmed: r.handelExecuteDeleteAll
    }, {
      default: w(() => [
        p("p", null, [
          n[36] || (n[36] = N(" Truncate ", -1)),
          p("strong", null, E(o.tableMetadata.label), 1)
        ]),
        p("p", null, " Are you sure that you want to delete ALL rows in table '" + E(o.tableMetadata.label) + "'? ", 1)
      ]),
      _: 1
    }, 8, ["title", "tableId", "tableLabel", "onConfirmed"])) : b("", !0),
    o.isTaskModalShown ? (u(), k(he, {
      key: 6,
      title: "Truncating table",
      onClose: n[17] || (n[17] = (H) => o.isTaskModalShown = !1)
    }, {
      body: w(() => [
        O(X, {
          taskId: o.taskId,
          onTaskUpdated: r.taskUpdated
        }, null, 8, ["taskId", "onTaskUpdated"])
      ]),
      _: 1
    })) : b("", !0),
    o.refSideModalProps ? (u(), k(Ae, {
      key: 7,
      column: o.refSideModalProps.column,
      rows: o.refSideModalProps.rows,
      schema: t.schemaId,
      onOnClose: n[18] || (n[18] = (H) => o.refSideModalProps = void 0),
      showDataOwner: t.canManage
    }, null, 8, ["column", "rows", "schema", "showDataOwner"])) : b("", !0)
  ])) : b("", !0);
}
const n1 = /* @__PURE__ */ P(LF, [["render", t1], ["__scopeId", "data-v-230d9b3b"]]), i1 = {
  name: "RoutedTableExplorer",
  components: {
    TableExplorer: n1
  },
  data() {
    return {
      allColumns: []
    };
  },
  props: {
    tableId: {
      type: String,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    },
    canView: {
      type: Boolean,
      default: () => !0
    },
    canEdit: {
      type: Boolean,
      default: () => !1
    },
    canInsert: {
      type: Boolean,
      default: () => !1
    },
    canUpdate: {
      type: Boolean,
      default: () => !1
    },
    canDelete: {
      type: Boolean,
      default: () => !1
    },
    canManage: {
      type: Boolean,
      default: () => !1
    },
    isRowLevel: {
      type: Boolean,
      default: () => !1
    },
    userRoles: {
      type: Array,
      default: () => []
    },
    tablePermissions: {
      type: Array,
      default: () => []
    },
    showOrderBy: {
      type: String,
      default: ""
    },
    showOrder: {
      type: String,
      default: "ASC"
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getOrderBy() {
      return this.$route.query._orderBy ? this.$route.query._orderBy : this.showOrderBy;
    },
    getOrder() {
      return this.$route.query._order ? this.$route.query._order : this.showOrder;
    },
    getColumns() {
      return this.$route.query._col ? Array.isArray(this.$route.query._col) ? this.$route.query._col : this.$route.query._col.split(",") : We(this.showColumns);
    },
    getFilters() {
      return this.$route.query._filter ? Array.isArray(this.$route.query._filter) ? this.$route.query._filter : this.$route.query._filter.split(",") : We(this.showFilters);
    },
    getPage() {
      return this.$route.query._page ? parseInt(this.$route.query._page) : 1;
    },
    getLimit() {
      return this.$route.query._limit ? parseInt(this.$route.query._limit) : 20;
    },
    getView() {
      return this.$route.query._view ? this.$route.query._view : "table";
    },
    getConditions() {
      let e = {};
      return Object.keys(this.$route.query).forEach((n) => {
        n.startsWith("_") || (e[n] = this.$route.query[n]);
      }), e;
    },
    updatePage(e) {
      const n = Object.assign({}, this.$route.query);
      n._page = e, this.updateRoute(n);
    },
    updateOrder(e) {
      const n = Object.assign({}, this.$route.query);
      n._order = e.direction, n._orderBy = e.column, this.updateRoute(n);
    },
    updateView(e, n) {
      const t = Object.assign({}, this.$route.query);
      t._view = e, t._limit = n, delete t._page, this.updateRoute(t);
    },
    updateLimit(e) {
      const n = Object.assign({}, this.$route.query);
      n._limit = e, delete n._page, this.updateRoute(n);
    },
    updateColumns(e) {
      const n = Object.assign({}, this.$route.query);
      e.length ? n._col = e.join(",") : delete n._col, this.updateRoute(n);
    },
    updateAllColumns(e) {
      this.allColumns = e;
    },
    updateFilters(e) {
      const n = Object.assign({}, this.$route.query);
      e.length > 0 ? n._filter = e.join(",") : delete n._filter, this.updateRoute(n);
    },
    updateConditions(e) {
      let n = Object.assign({}, this.$route.query);
      delete n._page, e.forEach((t) => {
        const i = t.conditions;
        if (i?.length)
          switch (t.columnType) {
            case "REF":
            case "REF_ARRAY":
            case "REFBACK":
            case "ONTOLOGY":
            case "ONTOLOGY_ARRAY":
            case "RADIO":
            case "SELECT":
            case "MULTISELECT":
            case "CHECKBOX":
              n[t.id] = JSON.stringify(i);
              break;
            case "DATE":
            case "DATETIME":
            case "INT":
            case "LONG":
            case "DECIMAL":
              const o = i.map((r) => r.join("..")).join(",");
              o !== ".." ? n[t.id] = o : delete n[t.id];
              break;
            default:
              n[t.id] = i.join(",");
          }
        else
          delete n[t.id];
      }), this.updateRoute(n);
    },
    updateRoute(e) {
      JSON.stringify(e) !== JSON.stringify(this.$route.query) && this.$router.push({ query: e });
    }
  },
  emits: ["rowClick"]
};
function o1(e, n, t, i, o, r) {
  const s = K("TableExplorer");
  return u(), c("div", null, [
    O(s, {
      tableId: t.tableId,
      schemaId: t.schemaId,
      canView: t.canView,
      canEdit: t.canEdit,
      canInsert: t.canInsert,
      canUpdate: t.canUpdate,
      canDelete: t.canDelete,
      canManage: t.canManage,
      isRowLevel: t.isRowLevel,
      userRoles: t.userRoles,
      tablePermissions: t.tablePermissions,
      onUpdateConditions: r.updateConditions,
      onUpdateShowColumns: r.updateColumns,
      onUpdateShowFilters: r.updateFilters,
      onUpdateShowPage: r.updatePage,
      onUpdateShowLimit: r.updateLimit,
      onUpdateShowOrder: r.updateOrder,
      onUpdateShowView: r.updateView,
      showView: r.getView(),
      showColumns: r.getColumns(),
      showFilters: r.getFilters(),
      urlConditions: r.getConditions(),
      showPage: r.getPage(),
      showLimit: r.getLimit(),
      showOrderBy: r.getOrderBy(),
      showOrder: r.getOrder(),
      onRowClick: n[0] || (n[0] = (a) => e.$emit("rowClick", a))
    }, {
      rowcolheader: w(() => [
        j(e.$slots, "rowcolheader")
      ]),
      rowheader: w((a) => [
        j(e.$slots, "rowheader", {
          row: a.row,
          metadata: a.metadata,
          rowKey: a.rowKey
        })
      ]),
      _: 3
    }, 8, ["tableId", "schemaId", "canView", "canEdit", "canInsert", "canUpdate", "canDelete", "canManage", "isRowLevel", "userRoles", "tablePermissions", "onUpdateConditions", "onUpdateShowColumns", "onUpdateShowFilters", "onUpdateShowPage", "onUpdateShowLimit", "onUpdateShowOrder", "onUpdateShowView", "showView", "showColumns", "showFilters", "urlConditions", "showPage", "showLimit", "showOrderBy", "showOrder"])
  ]);
}
const hk = /* @__PURE__ */ P(i1, [["render", o1]]), r1 = {
  name: "RowButtonClone",
  components: { RowButton: sn, EditModal: Nr },
  props: {
    id: {
      type: String,
      required: !0
    },
    tableId: {
      type: String,
      required: !0
    },
    pkey: {
      type: Object,
      required: !0
    },
    schemaId: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      isModalShown: !1
    };
  },
  methods: {
    handleClose() {
      this.isModalShown = !1, this.$emit("close");
    }
  }
};
function s1(e, n, t, i, o, r) {
  const s = K("RowButton"), a = K("EditModal");
  return u(), c("div", null, [
    O(s, {
      type: "clone",
      onClone: n[0] || (n[0] = (l) => o.isModalShown = !0)
    }),
    o.isModalShown ? (u(), k(a, {
      key: 0,
      id: t.id + "edit-modal",
      tableId: t.tableId,
      pkey: t.pkey,
      clone: !0,
      isModalShown: o.isModalShown,
      schemaId: t.schemaId,
      onClose: r.handleClose
    }, null, 8, ["id", "tableId", "pkey", "isModalShown", "schemaId", "onClose"])) : b("", !0)
  ]);
}
const mk = /* @__PURE__ */ P(r1, [["render", s1]]), a1 = {
  props: {
    /** the column names */
    columns: Array,
    /** list of rows matching column names */
    rows: Array,
    /** set to create select boxes that will yield this columns value when selected. */
    selectColumn: String,
    /** default value */
    defaultValue: Array
  },
  data: function() {
    return {
      selectedItems: []
    };
  },
  created() {
    Array.isArray(this.defaultValue) ? this.selectedItems = this.defaultValue : this.defaultValue !== null ? this.selectedItems.push(this.defaultValue) : this.selectedItems = [];
  },
  computed: {
    tableHover() {
      return this.selectColumn;
    },
    hasColheader() {
      return this.selectColumn || !!this.$slots.colheader || !!this.$slots.rowheader;
    }
  },
  methods: {
    flattenObject(e) {
      let n = "";
      return e && e.length > 0 && typeof e == "object" ? (Object.keys(e).forEach((t) => {
        e[t] === null || (typeof e[t] == "object" ? n += this.flattenObject(e[t]) : n += " " + e[t]);
      }), n.replace(/^\./, "")) : e;
    },
    isSelected(e) {
      return this.selectedItems !== null && this.selectedItems.includes(e[this.selectColumn]);
    },
    toggleSelect(e) {
      this.isSelected(e) ? (this.selectedItems = this.selectedItems.filter(
        (n) => n !== e[this.selectColumn]
      ), this.$emit("deselect", e[this.selectColumn])) : (this.selectedItems.push(e[this.selectColumn]), this.$emit("select", e[this.selectColumn])), this.$emit("update:modelValue", this.selectedItems);
    },
    onRowClick(e) {
      this.$emit("rowClick", e);
    }
  }
}, l1 = { class: "table-responsive" }, u1 = {
  key: 0,
  scope: "col",
  style: { width: "1px" }
}, d1 = { key: 0 }, c1 = { style: { display: "flex" } }, f1 = ["checked", "onClick"], p1 = ["onClick"], h1 = {
  key: 0,
  class: "list-unstyled"
}, m1 = { key: 1 };
function A1(e, n, t, i, o, r) {
  return u(), c("div", l1, [
    p("table", {
      class: G(["table table-bordered", { "table-hover": r.tableHover }])
    }, [
      p("thead", null, [
        p("tr", null, [
          r.hasColheader ? (u(), c("th", u1, [
            j(e.$slots, "colheader", {}, void 0, !0)
          ])) : b("", !0),
          (u(!0), c(ie, null, se(t.columns, (s) => (u(), c("th", {
            key: s,
            scope: "col"
          }, E(s), 1))), 128))
        ])
      ]),
      p("tbody", null, [
        (u(!0), c(ie, null, se(t.rows, (s) => (u(), c("tr", {
          key: JSON.stringify(s)
        }, [
          r.hasColheader ? (u(), c("td", d1, [
            p("div", c1, [
              t.selectColumn ? (u(), c("input", {
                key: 0,
                class: "form-check form-check-inline mr-1",
                type: "checkbox",
                checked: r.isSelected(s),
                onClick: ve((a) => r.toggleSelect(s), ["stop"])
              }, null, 8, f1)) : b("", !0),
              j(e.$slots, "rowheader", { row: s }, void 0, !0)
            ])
          ])) : b("", !0),
          (u(!0), c(ie, null, se(t.columns, (a) => (u(), c("td", {
            key: a,
            onClick: (l) => r.onRowClick(s),
            style: { cursor: "pointer" }
          }, [
            Array.isArray(s[a]) ? (u(), c("ul", h1, [
              (u(!0), c(ie, null, se(s[a], (l, d) => (u(), c("li", { key: d }, E(l), 1))), 128))
            ])) : s[a] !== void 0 ? (u(), c("span", m1, E(r.flattenObject(s[a])), 1)) : b("", !0)
          ], 8, p1))), 128))
        ]))), 128))
      ])
    ], 2)
  ]);
}
const Ak = /* @__PURE__ */ P(a1, [["render", A1], ["__scopeId", "data-v-3297a3f0"]]), g1 = Se({
  name: "TaskList",
  components: {
    MessageError: At
  },
  data() {
    return {
      loading: !1,
      tasks: [],
      error: null
    };
  },
  methods: {
    retrieveTasks() {
      this.loading = !0, this.error = null, Ge("graphql", "{_tasks{id,description,status}}").then((e) => {
        this.tasks = e._tasks, this.loading = !1;
      }).catch((e) => {
        Array.isArray(e.response.errors) ? this.error = e.response.errors[0].message : this.error = e, this.loading = !1;
      });
    }
  },
  mounted() {
    this.retrieveTasks();
  }
}), y1 = { class: "table table-bordered" }, K1 = ["onClick"];
function b1(e, n, t, i, o, r) {
  const s = K("MessageError");
  return u(), c("div", null, [
    e.error ? (u(), k(s, { key: 0 }, {
      default: w(() => [
        N(E(e.error), 1)
      ]),
      _: 1
    })) : b("", !0),
    p("table", y1, [
      n[0] || (n[0] = p("thead", null, [
        p("th", { scope: "col" }, "Task Description"),
        p("th", null, "Task Status")
      ], -1)),
      p("tbody", null, [
        (u(!0), c(ie, null, se(e.tasks, (a) => (u(), c("tr", {
          key: a.id
        }, [
          p("td", null, [
            p("button", {
              onClick: ve((l) => e.$emit("select", a.id), ["prevent", "stop"]),
              type: "button",
              class: "btn btn-link"
            }, E(a.description), 9, K1)
          ]),
          p("td", null, E(a.status), 1)
        ]))), 128))
      ])
    ])
  ]);
}
const v1 = /* @__PURE__ */ P(g1, [["render", b1]]), w1 = Se({
  name: "TaskManager",
  components: { Task: Zl, TaskList: v1, IconAction: Rt },
  data() {
    return {
      selectedTaskId: null
    };
  },
  methods: {
    selectTask(e) {
      this.selectedTaskId = e;
    },
    clearSelection() {
      this.selectedTaskId = null;
    }
  }
}), C1 = { key: 0 }, R1 = { key: 1 };
function F1(e, n, t, i, o, r) {
  const s = K("IconAction"), a = K("Task"), l = K("TaskList");
  return u(), c("div", null, [
    e.selectedTaskId ? (u(), c("span", C1, [
      p("span", {
        onClick: n[0] || (n[0] = (...d) => e.clearSelection && e.clearSelection(...d))
      }, [
        O(s, { icon: "angle-left" }),
        n[1] || (n[1] = N(" Back to task list ", -1))
      ]),
      n[2] || (n[2] = p("h1", null, "Task details", -1)),
      O(a, { taskId: e.selectedTaskId }, null, 8, ["taskId"])
    ])) : (u(), c("div", R1, [
      n[3] || (n[3] = p("h1", null, "Task list", -1)),
      O(l, { onSelect: e.selectTask }, null, 8, ["onSelect"])
    ]))
  ]);
}
const gk = /* @__PURE__ */ P(w1, [["render", F1]]);
export {
  KR as AggregateTable,
  pt as ArrayInput,
  GC as Breadcrumb,
  it as ButtonAction,
  mt as ButtonAlt,
  Mb as ButtonDanger,
  Lr as ButtonDropdown,
  Ji as ButtonOutline,
  Xm as ButtonSubmit,
  nt as Client,
  Dr as ConfirmModal,
  z1 as ContactDisplay,
  b0 as CookieWall,
  Bl as DataDisplayCell,
  Nr as EditModal,
  Er as EmailDisplay,
  Nl as FileDisplay,
  zg as FilterContainer,
  dv as FilterInput,
  hv as FilterSidebar,
  Pl as FilterWell,
  vv as FilterWells,
  Te as FormGroup,
  Uw as FormInput,
  tA as FormMolgenis,
  g0 as GTag,
  ig as GridBlock,
  nk as HtmlDropdown,
  Sr as HyperlinkDisplay,
  Rt as IconAction,
  ik as IconBar,
  Rr as IconDanger,
  W1 as ImageCard,
  Y1 as ImageDisplay,
  ok as Info,
  rk as InfoPopover,
  $v as InlineInput,
  zi as InputBoolean,
  sA as InputCheckbox,
  Wi as InputDate,
  Yi as InputDateTime,
  Or as InputDecimal,
  Vl as InputEmail,
  Hl as InputFile,
  Qe as InputGroup,
  $o as InputHeading,
  jl as InputHyperlink,
  _r as InputInt,
  ww as InputJson,
  Pr as InputLong,
  Li as InputOntology,
  AK as InputOntologySubtree,
  Ar as InputPassword,
  Fr as InputRadio,
  Tl as InputRangeDate,
  Sy as InputRangeDateTime,
  By as InputRangeDecimal,
  Jy as InputRangeInt,
  iK as InputRangeLong,
  Gl as InputRefBack,
  Ui as InputRefList,
  Ei as InputRefSelect,
  Ir as InputSearch,
  xn as InputSelect,
  sk as InputSelectInplace,
  kt as InputString,
  ri as InputText,
  ak as InputTextLocalized,
  X1 as KeyValueBlock,
  uk as LayoutCard,
  hA as LayoutForm,
  Et as LayoutModal,
  Z1 as LinksList,
  nb as ListDisplay,
  FA as LocaleSwitch,
  At as MessageError,
  Fn as MessageSuccess,
  pw as MessageWarning,
  dk as Molgenis,
  Gm as MolgenisAccount,
  U0 as MolgenisFooter,
  M0 as MolgenisMenu,
  DA as MolgenisSession,
  cA as MolgenisSignin,
  gA as MolgenisSignup,
  Ur as ObjectDisplay,
  ek as PageHeader,
  xl as Pagination,
  xA as PersonDetails,
  J1 as QueryEMX2,
  Fl as ReadMore,
  hk as RoutedTableExplorer,
  sn as RowButton,
  Ml as RowButtonAdd,
  mk as RowButtonClone,
  Gb as RowButtonDelete,
  Ob as RowButtonEdit,
  Dw as RowEdit,
  Pw as RowEditFooter,
  IF as ShowHide,
  ck as ShowMore,
  fk as SimpleModal,
  Ut as Spinner,
  Ll as StringDisplay,
  CR as SubTask,
  tk as TableDisplay,
  n1 as TableExplorer,
  Tr as TableMolgenis,
  Ak as TableSimple,
  lR as TableStickyHeaders,
  pk as Tabs,
  Zl as Task,
  v1 as TaskList,
  gk as TaskManager,
  xK as TextDisplay,
  Vm as TokenManager,
  vn as Tooltip,
  lk as TooltipComponent,
  nR as VueTemplate,
  nn as applyJsTemplate,
  Lt as constants,
  We as deepClone,
  An as flattenObject,
  Xc as getRowErrors,
  Hc as privacyConstants,
  Ge as request
};
